/* eslint-disable */
/* tslint:disable */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Dimension: { input: any; output: any; }
  HexColor: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Quality: { input: any; output: any; }
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/alertBanner) */
export type ContentfulAlertBanner = ContentfulEntry & Contentful_Node & {
  __typename?: 'AlertBanner';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulAlertBannerLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
  text?: Maybe<ContentfulAlertBannerText>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/alertBanner) */
export type ContentfulAlertBannerInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/alertBanner) */
export type ContentfulAlertBannerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/alertBanner) */
export type ContentfulAlertBannerLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/alertBanner) */
export type ContentfulAlertBannerTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/alertBanner) */
export type ContentfulAlertBannerTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulAlertBannerCollection = {
  __typename?: 'AlertBannerCollection';
  items: Array<Maybe<ContentfulAlertBanner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulAlertBannerCursorCollection = {
  __typename?: 'AlertBannerCursorCollection';
  items: Array<Maybe<ContentfulAlertBanner>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulAlertBannerFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulAlertBannerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulAlertBannerFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulAlertBannerLinkingCollections = {
  __typename?: 'AlertBannerLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  mainHeaderCollection?: Maybe<ContentfulMainHeaderCollection>;
  mainHeaderCursorCollection?: Maybe<ContentfulMainHeaderCursorCollection>;
};


export type ContentfulAlertBannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAlertBannerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAlertBannerLinkingCollectionsMainHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulAlertBannerLinkingCollectionsMainHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAlertBannerLinkingCollectionsMainHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulAlertBannerLinkingCollectionsMainHeaderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulAlertBannerLinkingCollectionsMainHeaderCollectionOrder =
  | 'background_ASC'
  | 'background_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'logoHeightDesktop_ASC'
  | 'logoHeightDesktop_DESC'
  | 'logoHeightMobile_ASC'
  | 'logoHeightMobile_DESC'
  | 'logoWidthDesktop_ASC'
  | 'logoWidthDesktop_DESC'
  | 'logoWidthMobile_ASC'
  | 'logoWidthMobile_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textColorOption_ASC'
  | 'textColorOption_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulAlertBannerLinkingCollectionsMainHeaderCursorCollectionOrder =
  | 'background_ASC'
  | 'background_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'logoHeightDesktop_ASC'
  | 'logoHeightDesktop_DESC'
  | 'logoHeightMobile_ASC'
  | 'logoHeightMobile_DESC'
  | 'logoWidthDesktop_ASC'
  | 'logoWidthDesktop_DESC'
  | 'logoWidthMobile_ASC'
  | 'logoWidthMobile_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textColorOption_ASC'
  | 'textColorOption_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulAlertBannerOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulAlertBannerText = {
  __typename?: 'AlertBannerText';
  json: Scalars['JSON']['output'];
  links: ContentfulAlertBannerTextLinks;
};

export type ContentfulAlertBannerTextAssets = {
  __typename?: 'AlertBannerTextAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulAlertBannerTextEntries = {
  __typename?: 'AlertBannerTextEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulAlertBannerTextLinks = {
  __typename?: 'AlertBannerTextLinks';
  assets: ContentfulAlertBannerTextAssets;
  entries: ContentfulAlertBannerTextEntries;
  resources: ContentfulAlertBannerTextResources;
};

export type ContentfulAlertBannerTextResources = {
  __typename?: 'AlertBannerTextResources';
  block: Array<ContentfulAlertBannerTextResourcesBlock>;
  hyperlink: Array<ContentfulAlertBannerTextResourcesHyperlink>;
  inline: Array<ContentfulAlertBannerTextResourcesInline>;
};

export type ContentfulAlertBannerTextResourcesBlock = ContentfulResourceLink & {
  __typename?: 'AlertBannerTextResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulAlertBannerTextResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'AlertBannerTextResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulAlertBannerTextResourcesInline = ContentfulResourceLink & {
  __typename?: 'AlertBannerTextResourcesInline';
  sys: ContentfulResourceSys;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type ContentfulAsset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<ContentfulAssetLinkingCollections>;
  size?: Maybe<Scalars['Int']['output']>;
  sys: ContentfulSys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type ContentfulAssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type ContentfulAssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type ContentfulAssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type ContentfulAssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type ContentfulAssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type ContentfulAssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type ContentfulAssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type ContentfulAssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  transform?: InputMaybe<ContentfulImageTransformOptions>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type ContentfulAssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulAssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<ContentfulAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulAssetCursorCollection = {
  __typename?: 'AssetCursorCollection';
  items: Array<Maybe<ContentfulAsset>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulAssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulAssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulAssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  size_not?: InputMaybe<Scalars['Int']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  width_gt?: InputMaybe<Scalars['Int']['input']>;
  width_gte?: InputMaybe<Scalars['Int']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt?: InputMaybe<Scalars['Int']['input']>;
  width_lte?: InputMaybe<Scalars['Int']['input']>;
  width_not?: InputMaybe<Scalars['Int']['input']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ContentfulAssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  cardCollection?: Maybe<ContentfulCardCollection>;
  cardCursorCollection?: Maybe<ContentfulCardCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  findAStoreCollection?: Maybe<ContentfulFindAStoreCollection>;
  findAStoreCursorCollection?: Maybe<ContentfulFindAStoreCursorCollection>;
  footerCollection?: Maybe<ContentfulFooterCollection>;
  footerCursorCollection?: Maybe<ContentfulFooterCursorCollection>;
  imageWithFocalPointCollection?: Maybe<ContentfulImageWithFocalPointCollection>;
  imageWithFocalPointCursorCollection?: Maybe<ContentfulImageWithFocalPointCursorCollection>;
  mainHeaderCollection?: Maybe<ContentfulMainHeaderCollection>;
  mainHeaderCursorCollection?: Maybe<ContentfulMainHeaderCursorCollection>;
  mainMenuItemCollection?: Maybe<ContentfulMainMenuItemCollection>;
  mainMenuItemCursorCollection?: Maybe<ContentfulMainMenuItemCursorCollection>;
  navQuickLinkItemCollection?: Maybe<ContentfulNavQuickLinkItemCollection>;
  navQuickLinkItemCursorCollection?: Maybe<ContentfulNavQuickLinkItemCursorCollection>;
  placeholderCheckoutPaymentsCollection?: Maybe<ContentfulPlaceholderCheckoutPaymentsCollection>;
  placeholderCheckoutPaymentsCursorCollection?: Maybe<ContentfulPlaceholderCheckoutPaymentsCursorCollection>;
  scrollerItemCollection?: Maybe<ContentfulScrollerItemCollection>;
  scrollerItemCursorCollection?: Maybe<ContentfulScrollerItemCursorCollection>;
  selectorLinkCollection?: Maybe<ContentfulSelectorLinkCollection>;
  selectorLinkCursorCollection?: Maybe<ContentfulSelectorLinkCursorCollection>;
  seoConfigurationCollection?: Maybe<ContentfulSeoConfigurationCollection>;
  seoConfigurationCursorCollection?: Maybe<ContentfulSeoConfigurationCursorCollection>;
  serviceItemCollection?: Maybe<ContentfulServiceItemCollection>;
  serviceItemCursorCollection?: Maybe<ContentfulServiceItemCursorCollection>;
  simpleFooterCollection?: Maybe<ContentfulSimpleFooterCollection>;
  simpleFooterCursorCollection?: Maybe<ContentfulSimpleFooterCursorCollection>;
  sliderProductsAutomaticCollection?: Maybe<ContentfulSliderProductsAutomaticCollection>;
  sliderProductsAutomaticCursorCollection?: Maybe<ContentfulSliderProductsAutomaticCursorCollection>;
  sliderProductsManualCollection?: Maybe<ContentfulSliderProductsManualCollection>;
  sliderProductsManualCursorCollection?: Maybe<ContentfulSliderProductsManualCursorCollection>;
};


export type ContentfulAssetLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsFindAStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsFindAStoreCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsImageWithFocalPointCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsImageWithFocalPointCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsMainHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsMainHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsMainMenuItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsMainMenuItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsNavQuickLinkItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsNavQuickLinkItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsPlaceholderCheckoutPaymentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsPlaceholderCheckoutPaymentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsScrollerItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsScrollerItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsSelectorLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsSelectorLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsSeoConfigurationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsSeoConfigurationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsServiceItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsServiceItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsSimpleFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsSimpleFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsSliderProductsAutomaticCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsSliderProductsAutomaticCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsSliderProductsManualCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAssetLinkingCollectionsSliderProductsManualCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulAssetOrder =
  | 'contentType_ASC'
  | 'contentType_DESC'
  | 'fileName_ASC'
  | 'fileName_DESC'
  | 'height_ASC'
  | 'height_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'width_ASC'
  | 'width_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/automaticCollectionGroup) */
export type ContentfulAutomaticCollectionGroup = ContentfulEntry & Contentful_Node & {
  __typename?: 'AutomaticCollectionGroup';
  _id: Scalars['ID']['output'];
  algoliaFacetFilters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  algoliaRuleName?: Maybe<Scalars['String']['output']>;
  collection?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulAutomaticCollectionGroupLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  maximumNumberOfProducts?: Maybe<Scalars['Int']['output']>;
  sortBy?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/automaticCollectionGroup) */
export type ContentfulAutomaticCollectionGroupAlgoliaFacetFiltersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/automaticCollectionGroup) */
export type ContentfulAutomaticCollectionGroupAlgoliaRuleNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/automaticCollectionGroup) */
export type ContentfulAutomaticCollectionGroupCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/automaticCollectionGroup) */
export type ContentfulAutomaticCollectionGroupInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/automaticCollectionGroup) */
export type ContentfulAutomaticCollectionGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/automaticCollectionGroup) */
export type ContentfulAutomaticCollectionGroupLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/automaticCollectionGroup) */
export type ContentfulAutomaticCollectionGroupMaximumNumberOfProductsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/automaticCollectionGroup) */
export type ContentfulAutomaticCollectionGroupSortByArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulAutomaticCollectionGroupCollection = {
  __typename?: 'AutomaticCollectionGroupCollection';
  items: Array<Maybe<ContentfulAutomaticCollectionGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulAutomaticCollectionGroupCursorCollection = {
  __typename?: 'AutomaticCollectionGroupCursorCollection';
  items: Array<Maybe<ContentfulAutomaticCollectionGroup>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulAutomaticCollectionGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulAutomaticCollectionGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulAutomaticCollectionGroupFilter>>>;
  algoliaFacetFilters_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  algoliaFacetFilters_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  algoliaFacetFilters_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  algoliaFacetFilters_exists?: InputMaybe<Scalars['Boolean']['input']>;
  algoliaRuleName?: InputMaybe<Scalars['String']['input']>;
  algoliaRuleName_contains?: InputMaybe<Scalars['String']['input']>;
  algoliaRuleName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  algoliaRuleName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  algoliaRuleName_not?: InputMaybe<Scalars['String']['input']>;
  algoliaRuleName_not_contains?: InputMaybe<Scalars['String']['input']>;
  algoliaRuleName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collection?: InputMaybe<Scalars['String']['input']>;
  collection_contains?: InputMaybe<Scalars['String']['input']>;
  collection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  collection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collection_not?: InputMaybe<Scalars['String']['input']>;
  collection_not_contains?: InputMaybe<Scalars['String']['input']>;
  collection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maximumNumberOfProducts?: InputMaybe<Scalars['Int']['input']>;
  maximumNumberOfProducts_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maximumNumberOfProducts_gt?: InputMaybe<Scalars['Int']['input']>;
  maximumNumberOfProducts_gte?: InputMaybe<Scalars['Int']['input']>;
  maximumNumberOfProducts_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maximumNumberOfProducts_lt?: InputMaybe<Scalars['Int']['input']>;
  maximumNumberOfProducts_lte?: InputMaybe<Scalars['Int']['input']>;
  maximumNumberOfProducts_not?: InputMaybe<Scalars['Int']['input']>;
  maximumNumberOfProducts_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortBy_contains?: InputMaybe<Scalars['String']['input']>;
  sortBy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy_not?: InputMaybe<Scalars['String']['input']>;
  sortBy_not_contains?: InputMaybe<Scalars['String']['input']>;
  sortBy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulAutomaticCollectionGroupLinkingCollections = {
  __typename?: 'AutomaticCollectionGroupLinkingCollections';
  collectionGroupCollection?: Maybe<ContentfulCollectionGroupCollection>;
  collectionGroupCursorCollection?: Maybe<ContentfulCollectionGroupCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulAutomaticCollectionGroupLinkingCollectionsCollectionGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulAutomaticCollectionGroupLinkingCollectionsCollectionGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAutomaticCollectionGroupLinkingCollectionsCollectionGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulAutomaticCollectionGroupLinkingCollectionsCollectionGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAutomaticCollectionGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulAutomaticCollectionGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulAutomaticCollectionGroupLinkingCollectionsCollectionGroupCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulAutomaticCollectionGroupLinkingCollectionsCollectionGroupCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulAutomaticCollectionGroupOrder =
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collection_ASC'
  | 'collection_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'maximumNumberOfProducts_ASC'
  | 'maximumNumberOfProducts_DESC'
  | 'sortBy_ASC'
  | 'sortBy_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBanner = ContentfulEntry & Contentful_Node & {
  __typename?: 'Banner';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  heading?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ContentfulImageWithFocalPoint>;
  imagePosition?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulBannerLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  text?: Maybe<ContentfulBannerText>;
  textAlignment?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlText?: Maybe<Scalars['String']['output']>;
  urlType?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerImagePositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerSubHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerUrlTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/banner) */
export type ContentfulBannerUrlTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulBannerCollection = {
  __typename?: 'BannerCollection';
  items: Array<Maybe<ContentfulBanner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulBannerCursorCollection = {
  __typename?: 'BannerCursorCollection';
  items: Array<Maybe<ContentfulBanner>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulBannerFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulBannerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulBannerFilter>>>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>;
  imagePosition?: InputMaybe<Scalars['String']['input']>;
  imagePosition_contains?: InputMaybe<Scalars['String']['input']>;
  imagePosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imagePosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imagePosition_not?: InputMaybe<Scalars['String']['input']>;
  imagePosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  imagePosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  subHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  urlText_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText_not?: InputMaybe<Scalars['String']['input']>;
  urlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlType?: InputMaybe<Scalars['String']['input']>;
  urlType_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlType_not?: InputMaybe<Scalars['String']['input']>;
  urlType_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHero = ContentfulEntry & Contentful_Node & {
  __typename?: 'BannerHero';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  image?: Maybe<ContentfulImageWithFocalPoint>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulBannerHeroLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleSeoTag?: Maybe<Scalars['String']['output']>;
  titleStyle?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlText?: Maybe<Scalars['String']['output']>;
  urlType?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroTitleSeoTagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroTitleStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroUrlTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/bannerHero) */
export type ContentfulBannerHeroUrlTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulBannerHeroCollection = {
  __typename?: 'BannerHeroCollection';
  items: Array<Maybe<ContentfulBannerHero>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulBannerHeroCursorCollection = {
  __typename?: 'BannerHeroCursorCollection';
  items: Array<Maybe<ContentfulBannerHero>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulBannerHeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulBannerHeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulBannerHeroFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  image?: InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleSeoTag?: InputMaybe<Scalars['String']['input']>;
  titleSeoTag_contains?: InputMaybe<Scalars['String']['input']>;
  titleSeoTag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleSeoTag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleSeoTag_not?: InputMaybe<Scalars['String']['input']>;
  titleSeoTag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleSeoTag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleStyle?: InputMaybe<Scalars['String']['input']>;
  titleStyle_contains?: InputMaybe<Scalars['String']['input']>;
  titleStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleStyle_not?: InputMaybe<Scalars['String']['input']>;
  titleStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  urlText_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText_not?: InputMaybe<Scalars['String']['input']>;
  urlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlType?: InputMaybe<Scalars['String']['input']>;
  urlType_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlType_not?: InputMaybe<Scalars['String']['input']>;
  urlType_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulBannerHeroLinkingCollections = {
  __typename?: 'BannerHeroLinkingCollections';
  collectionGroupCollection?: Maybe<ContentfulCollectionGroupCollection>;
  collectionGroupCursorCollection?: Maybe<ContentfulCollectionGroupCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulBannerHeroLinkingCollectionsCollectionGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerHeroLinkingCollectionsCollectionGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerHeroLinkingCollectionsCollectionGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerHeroLinkingCollectionsCollectionGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerHeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerHeroLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulBannerHeroLinkingCollectionsCollectionGroupCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBannerHeroLinkingCollectionsCollectionGroupCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBannerHeroOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleSeoTag_ASC'
  | 'titleSeoTag_DESC'
  | 'titleStyle_ASC'
  | 'titleStyle_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type ContentfulBannerLinkingCollections = {
  __typename?: 'BannerLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  liveStoryContentType?: Maybe<ContentfulLiveStoryContentType>;
  liveStoryContentTypeCollection?: Maybe<ContentfulLiveStoryContentTypeCollection>;
  liveStoryContentTypeCursorCollection?: Maybe<ContentfulLiveStoryContentTypeCursorCollection>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulBannerLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsPageBoutiqueDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBannerLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulBannerLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulBannerLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulBannerLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulBannerLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulBannerLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBannerLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBannerLinkingCollectionsPageBoutiqueDetailCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBannerLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBannerLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulBannerLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulBannerLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBannerLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBannerLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulBannerLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulBannerOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'imagePosition_ASC'
  | 'imagePosition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type ContentfulBannerText = {
  __typename?: 'BannerText';
  json: Scalars['JSON']['output'];
  links: ContentfulBannerTextLinks;
};

export type ContentfulBannerTextAssets = {
  __typename?: 'BannerTextAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulBannerTextEntries = {
  __typename?: 'BannerTextEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulBannerTextLinks = {
  __typename?: 'BannerTextLinks';
  assets: ContentfulBannerTextAssets;
  entries: ContentfulBannerTextEntries;
  resources: ContentfulBannerTextResources;
};

export type ContentfulBannerTextResources = {
  __typename?: 'BannerTextResources';
  block: Array<ContentfulBannerTextResourcesBlock>;
  hyperlink: Array<ContentfulBannerTextResourcesHyperlink>;
  inline: Array<ContentfulBannerTextResourcesInline>;
};

export type ContentfulBannerTextResourcesBlock = ContentfulResourceLink & {
  __typename?: 'BannerTextResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulBannerTextResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'BannerTextResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulBannerTextResourcesInline = ContentfulResourceLink & {
  __typename?: 'BannerTextResourcesInline';
  sys: ContentfulResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/breadcrumb) */
export type ContentfulBreadcrumb = ContentfulEntry & Contentful_Node & {
  __typename?: 'Breadcrumb';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulBreadcrumbLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/breadcrumb) */
export type ContentfulBreadcrumbInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/breadcrumb) */
export type ContentfulBreadcrumbLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/breadcrumb) */
export type ContentfulBreadcrumbLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/breadcrumb) */
export type ContentfulBreadcrumbStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulBreadcrumbCollection = {
  __typename?: 'BreadcrumbCollection';
  items: Array<Maybe<ContentfulBreadcrumb>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulBreadcrumbCursorCollection = {
  __typename?: 'BreadcrumbCursorCollection';
  items: Array<Maybe<ContentfulBreadcrumb>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulBreadcrumbFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  style_contains?: InputMaybe<Scalars['String']['input']>;
  style_exists?: InputMaybe<Scalars['Boolean']['input']>;
  style_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  style_not?: InputMaybe<Scalars['String']['input']>;
  style_not_contains?: InputMaybe<Scalars['String']['input']>;
  style_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulBreadcrumbLinkingCollections = {
  __typename?: 'BreadcrumbLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulBreadcrumbLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBreadcrumbLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBreadcrumbLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBreadcrumbLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBreadcrumbLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBreadcrumbLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBreadcrumbLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBreadcrumbLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBreadcrumbLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulBreadcrumbLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulBreadcrumbLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulBreadcrumbLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulBreadcrumbLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBreadcrumbLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBreadcrumbLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBreadcrumbLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulBreadcrumbLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulBreadcrumbLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulBreadcrumbOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'style_ASC'
  | 'style_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCard = ContentfulEntry & Contentful_Node & {
  __typename?: 'Card';
  _id: Scalars['ID']['output'];
  backgroundAlignment?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['JSON']['output']>;
  backgroundPosition?: Maybe<Scalars['String']['output']>;
  contentAlignment?: Maybe<Scalars['String']['output']>;
  contentMaxWidth?: Maybe<Scalars['String']['output']>;
  contentOption?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  countdown?: Maybe<Scalars['Boolean']['output']>;
  countdownToDatetime?: Maybe<Scalars['DateTime']['output']>;
  entryEffect?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<ContentfulAsset>;
  id?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulCardLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  media?: Maybe<ContentfulImageWithFocalPoint>;
  mediaAnimationEffect?: Maybe<Scalars['String']['output']>;
  openUrl2InNewTab?: Maybe<Scalars['Boolean']['output']>;
  openUrlInNewTab?: Maybe<Scalars['Boolean']['output']>;
  saleorProductSku?: Maybe<Scalars['String']['output']>;
  showMore?: Maybe<Scalars['Boolean']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  text?: Maybe<ContentfulCardText>;
  text2?: Maybe<ContentfulCardText2>;
  textAlignment?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<ContentfulHeading>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  url1AriaLabel?: Maybe<Scalars['String']['output']>;
  url1EventType?: Maybe<Scalars['String']['output']>;
  url2?: Maybe<Scalars['String']['output']>;
  url2AriaLabel?: Maybe<Scalars['String']['output']>;
  url2EventType?: Maybe<Scalars['String']['output']>;
  url2Text?: Maybe<Scalars['String']['output']>;
  url2Trigger?: Maybe<ContentfulEvent>;
  url2Type?: Maybe<Scalars['String']['output']>;
  urlDirection?: Maybe<Scalars['String']['output']>;
  urlPosition?: Maybe<Scalars['String']['output']>;
  urlText?: Maybe<Scalars['String']['output']>;
  urlTrigger?: Maybe<ContentfulEvent>;
  urlType?: Maybe<Scalars['String']['output']>;
  visibleInDesktop?: Maybe<Scalars['Boolean']['output']>;
  visibleInMobile?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardBackgroundAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardBackgroundPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardContentAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardContentMaxWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardContentOptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardCountdownArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardCountdownToDatetimeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardEntryEffectArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardMediaAnimationEffectArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardOpenUrl2InNewTabArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardOpenUrlInNewTabArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardSaleorProductSkuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardShowMoreArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardSubHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardText2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardTextColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrl1AriaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrl1EventTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrl2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrl2AriaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrl2EventTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrl2TextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrl2TriggerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulEventFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrl2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrlDirectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrlPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrlTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrlTriggerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulEventFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardUrlTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardVisibleInDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/card) */
export type ContentfulCardVisibleInMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCardCollection = {
  __typename?: 'CardCollection';
  items: Array<Maybe<ContentfulCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulCardCursorCollection = {
  __typename?: 'CardCursorCollection';
  items: Array<Maybe<ContentfulCard>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCardFilter>>>;
  backgroundAlignment?: InputMaybe<Scalars['String']['input']>;
  backgroundAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundAlignment_not?: InputMaybe<Scalars['String']['input']>;
  backgroundAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundPosition?: InputMaybe<Scalars['String']['input']>;
  backgroundPosition_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundPosition_not?: InputMaybe<Scalars['String']['input']>;
  backgroundPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlignment?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlignment_not?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth_not?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentOption?: InputMaybe<Scalars['String']['input']>;
  contentOption_contains?: InputMaybe<Scalars['String']['input']>;
  contentOption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentOption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentOption_not?: InputMaybe<Scalars['String']['input']>;
  contentOption_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentOption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  countdown?: InputMaybe<Scalars['Boolean']['input']>;
  countdownToDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countdownToDatetime_gt?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_gte?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  countdownToDatetime_lt?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_lte?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_not?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  countdown_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countdown_not?: InputMaybe<Scalars['Boolean']['input']>;
  entryEffect?: InputMaybe<Scalars['Boolean']['input']>;
  entryEffect_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryEffect_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>;
  mediaAnimationEffect?: InputMaybe<Scalars['String']['input']>;
  mediaAnimationEffect_contains?: InputMaybe<Scalars['String']['input']>;
  mediaAnimationEffect_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaAnimationEffect_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaAnimationEffect_not?: InputMaybe<Scalars['String']['input']>;
  mediaAnimationEffect_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaAnimationEffect_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrl2InNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openUrl2InNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrl2InNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  saleorProductSku?: InputMaybe<Scalars['String']['input']>;
  saleorProductSku_contains?: InputMaybe<Scalars['String']['input']>;
  saleorProductSku_exists?: InputMaybe<Scalars['Boolean']['input']>;
  saleorProductSku_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  saleorProductSku_not?: InputMaybe<Scalars['String']['input']>;
  saleorProductSku_not_contains?: InputMaybe<Scalars['String']['input']>;
  saleorProductSku_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showMore?: InputMaybe<Scalars['Boolean']['input']>;
  showMore_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showMore_not?: InputMaybe<Scalars['Boolean']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  subHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text2_contains?: InputMaybe<Scalars['String']['input']>;
  text2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text2_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  textColor_contains?: InputMaybe<Scalars['String']['input']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textColor_not?: InputMaybe<Scalars['String']['input']>;
  textColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<ContentfulCfHeadingNestedFilter>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url1ariaLabel?: InputMaybe<Scalars['String']['input']>;
  url1ariaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  url1ariaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url1ariaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url1ariaLabel_not?: InputMaybe<Scalars['String']['input']>;
  url1ariaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  url1ariaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url1eventType?: InputMaybe<Scalars['String']['input']>;
  url1eventType_contains?: InputMaybe<Scalars['String']['input']>;
  url1eventType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url1eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url1eventType_not?: InputMaybe<Scalars['String']['input']>;
  url1eventType_not_contains?: InputMaybe<Scalars['String']['input']>;
  url1eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2?: InputMaybe<Scalars['String']['input']>;
  url2Text?: InputMaybe<Scalars['String']['input']>;
  url2Text_contains?: InputMaybe<Scalars['String']['input']>;
  url2Text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2Text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2Text_not?: InputMaybe<Scalars['String']['input']>;
  url2Text_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2Text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2Trigger?: InputMaybe<ContentfulCfEventNestedFilter>;
  url2Trigger_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2Type?: InputMaybe<Scalars['String']['input']>;
  url2Type_contains?: InputMaybe<Scalars['String']['input']>;
  url2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2Type_not?: InputMaybe<Scalars['String']['input']>;
  url2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2_contains?: InputMaybe<Scalars['String']['input']>;
  url2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2_not?: InputMaybe<Scalars['String']['input']>;
  url2_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2ariaLabel?: InputMaybe<Scalars['String']['input']>;
  url2ariaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  url2ariaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2ariaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2ariaLabel_not?: InputMaybe<Scalars['String']['input']>;
  url2ariaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2ariaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2eventType?: InputMaybe<Scalars['String']['input']>;
  url2eventType_contains?: InputMaybe<Scalars['String']['input']>;
  url2eventType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2eventType_not?: InputMaybe<Scalars['String']['input']>;
  url2eventType_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlDirection?: InputMaybe<Scalars['String']['input']>;
  urlDirection_contains?: InputMaybe<Scalars['String']['input']>;
  urlDirection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlDirection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlDirection_not?: InputMaybe<Scalars['String']['input']>;
  urlDirection_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlDirection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlPosition?: InputMaybe<Scalars['String']['input']>;
  urlPosition_contains?: InputMaybe<Scalars['String']['input']>;
  urlPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlPosition_not?: InputMaybe<Scalars['String']['input']>;
  urlPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  urlText_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText_not?: InputMaybe<Scalars['String']['input']>;
  urlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlTrigger?: InputMaybe<ContentfulCfEventNestedFilter>;
  urlTrigger_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlType?: InputMaybe<Scalars['String']['input']>;
  urlType_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlType_not?: InputMaybe<Scalars['String']['input']>;
  urlType_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibleInDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCardLinkingCollections = {
  __typename?: 'CardLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  contentGroupCollection?: Maybe<ContentfulContentGroupCollection>;
  contentGroupCursorCollection?: Maybe<ContentfulContentGroupCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  gridCollection?: Maybe<ContentfulGridCollection>;
  gridCursorCollection?: Maybe<ContentfulGridCursorCollection>;
  heroSliderCollection?: Maybe<ContentfulHeroSliderCollection>;
  heroSliderCursorCollection?: Maybe<ContentfulHeroSliderCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  navQuickLinksWithBannerCollection?: Maybe<ContentfulNavQuickLinksWithBannerCollection>;
  navQuickLinksWithBannerCursorCollection?: Maybe<ContentfulNavQuickLinksWithBannerCursorCollection>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
  placeholderCollection?: Maybe<ContentfulPlaceholderCollection>;
  placeholderCursorCollection?: Maybe<ContentfulPlaceholderCursorCollection>;
  searchOverlayCollection?: Maybe<ContentfulSearchOverlayCollection>;
  searchOverlayCursorCollection?: Maybe<ContentfulSearchOverlayCursorCollection>;
};


export type ContentfulCardLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsContentGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsContentGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsContentGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsContentGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsHeroSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsHeroSliderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsHeroSliderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsHeroSliderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsNavQuickLinksWithBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsNavQuickLinksWithBannerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsNavQuickLinksWithBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsNavQuickLinksWithBannerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPageBoutiqueDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPlaceholderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPlaceholderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsPlaceholderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsPlaceholderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsSearchOverlayCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsSearchOverlayCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCardLinkingCollectionsSearchOverlayCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardLinkingCollectionsSearchOverlayCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCardLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulCardLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulCardLinkingCollectionsContentGroupCollectionOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsContentGroupCursorCollectionOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulCardLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulCardLinkingCollectionsGridCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulCardLinkingCollectionsGridCursorCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulCardLinkingCollectionsHeroSliderCollectionOrder =
  | 'autoslideDurationMs_ASC'
  | 'autoslideDurationMs_DESC'
  | 'autoslide_ASC'
  | 'autoslide_DESC'
  | 'fixToTop_ASC'
  | 'fixToTop_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulCardLinkingCollectionsHeroSliderCursorCollectionOrder =
  | 'autoslideDurationMs_ASC'
  | 'autoslideDurationMs_DESC'
  | 'autoslide_ASC'
  | 'autoslide_DESC'
  | 'fixToTop_ASC'
  | 'fixToTop_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulCardLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsNavQuickLinksWithBannerCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsNavQuickLinksWithBannerCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsPageBoutiqueDetailCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulCardLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulCardLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulCardLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulCardLinkingCollectionsPlaceholderCollectionOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'videoUrl_ASC'
  | 'videoUrl_DESC';

export type ContentfulCardLinkingCollectionsPlaceholderCursorCollectionOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'videoUrl_ASC'
  | 'videoUrl_DESC';

export type ContentfulCardLinkingCollectionsSearchOverlayCollectionOrder =
  | 'displayRetailers_ASC'
  | 'displayRetailers_DESC'
  | 'searchBox_ASC'
  | 'searchBox_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardLinkingCollectionsSearchOverlayCursorCollectionOrder =
  | 'displayRetailers_ASC'
  | 'displayRetailers_DESC'
  | 'searchBox_ASC'
  | 'searchBox_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCardOrder =
  | 'backgroundAlignment_ASC'
  | 'backgroundAlignment_DESC'
  | 'backgroundPosition_ASC'
  | 'backgroundPosition_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'contentOption_ASC'
  | 'contentOption_DESC'
  | 'countdownToDatetime_ASC'
  | 'countdownToDatetime_DESC'
  | 'countdown_ASC'
  | 'countdown_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAnimationEffect_ASC'
  | 'mediaAnimationEffect_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'saleorProductSku_ASC'
  | 'saleorProductSku_DESC'
  | 'showMore_ASC'
  | 'showMore_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1ariaLabel_ASC'
  | 'url1ariaLabel_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Text_ASC'
  | 'url2Text_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2ariaLabel_ASC'
  | 'url2ariaLabel_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulCardText = {
  __typename?: 'CardText';
  json: Scalars['JSON']['output'];
  links: ContentfulCardTextLinks;
};

export type ContentfulCardText2 = {
  __typename?: 'CardText2';
  json: Scalars['JSON']['output'];
  links: ContentfulCardText2Links;
};

export type ContentfulCardText2Assets = {
  __typename?: 'CardText2Assets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulCardText2Entries = {
  __typename?: 'CardText2Entries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulCardText2Links = {
  __typename?: 'CardText2Links';
  assets: ContentfulCardText2Assets;
  entries: ContentfulCardText2Entries;
  resources: ContentfulCardText2Resources;
};

export type ContentfulCardText2Resources = {
  __typename?: 'CardText2Resources';
  block: Array<ContentfulCardText2ResourcesBlock>;
  hyperlink: Array<ContentfulCardText2ResourcesHyperlink>;
  inline: Array<ContentfulCardText2ResourcesInline>;
};

export type ContentfulCardText2ResourcesBlock = ContentfulResourceLink & {
  __typename?: 'CardText2ResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulCardText2ResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'CardText2ResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulCardText2ResourcesInline = ContentfulResourceLink & {
  __typename?: 'CardText2ResourcesInline';
  sys: ContentfulResourceSys;
};

export type ContentfulCardTextAssets = {
  __typename?: 'CardTextAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulCardTextEntries = {
  __typename?: 'CardTextEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulCardTextLinks = {
  __typename?: 'CardTextLinks';
  assets: ContentfulCardTextAssets;
  entries: ContentfulCardTextEntries;
  resources: ContentfulCardTextResources;
};

export type ContentfulCardTextResources = {
  __typename?: 'CardTextResources';
  block: Array<ContentfulCardTextResourcesBlock>;
  hyperlink: Array<ContentfulCardTextResourcesHyperlink>;
  inline: Array<ContentfulCardTextResourcesInline>;
};

export type ContentfulCardTextResourcesBlock = ContentfulResourceLink & {
  __typename?: 'CardTextResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulCardTextResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'CardTextResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulCardTextResourcesInline = ContentfulResourceLink & {
  __typename?: 'CardTextResourcesInline';
  sys: ContentfulResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroup) */
export type ContentfulCollectionGroup = ContentfulEntry & Contentful_Node & {
  __typename?: 'CollectionGroup';
  _id: Scalars['ID']['output'];
  banner?: Maybe<ContentfulBannerHero>;
  contentfulMetadata: ContentfulContentfulMetadata;
  endImage?: Maybe<ContentfulCollectionGroupEndImage>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulCollectionGroupLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  productReferences?: Maybe<ContentfulCollectionGroupProductReferences>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroup) */
export type ContentfulCollectionGroupBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulBannerHeroFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroup) */
export type ContentfulCollectionGroupEndImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCollectionGroupEndImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroup) */
export type ContentfulCollectionGroupInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroup) */
export type ContentfulCollectionGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroup) */
export type ContentfulCollectionGroupLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroup) */
export type ContentfulCollectionGroupProductReferencesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroup) */
export type ContentfulCollectionGroupTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCollectionGroupCollection = {
  __typename?: 'CollectionGroupCollection';
  items: Array<Maybe<ContentfulCollectionGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulCollectionGroupCursorCollection = {
  __typename?: 'CollectionGroupCursorCollection';
  items: Array<Maybe<ContentfulCollectionGroup>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroupEndImage) */
export type ContentfulCollectionGroupEndImage = ContentfulEntry & Contentful_Node & {
  __typename?: 'CollectionGroupEndImage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  endImage?: Maybe<ContentfulImageWithFocalPoint>;
  endImageLinkType?: Maybe<Scalars['String']['output']>;
  endImageUrl?: Maybe<Scalars['String']['output']>;
  endImageUrlText?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulCollectionGroupEndImageLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroupEndImage) */
export type ContentfulCollectionGroupEndImageEndImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroupEndImage) */
export type ContentfulCollectionGroupEndImageEndImageLinkTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroupEndImage) */
export type ContentfulCollectionGroupEndImageEndImageUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroupEndImage) */
export type ContentfulCollectionGroupEndImageEndImageUrlTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroupEndImage) */
export type ContentfulCollectionGroupEndImageInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroupEndImage) */
export type ContentfulCollectionGroupEndImageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionGroupEndImage) */
export type ContentfulCollectionGroupEndImageLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCollectionGroupEndImageCollection = {
  __typename?: 'CollectionGroupEndImageCollection';
  items: Array<Maybe<ContentfulCollectionGroupEndImage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulCollectionGroupEndImageCursorCollection = {
  __typename?: 'CollectionGroupEndImageCursorCollection';
  items: Array<Maybe<ContentfulCollectionGroupEndImage>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulCollectionGroupEndImageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupEndImageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupEndImageFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  endImage?: InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>;
  endImageLinkType?: InputMaybe<Scalars['String']['input']>;
  endImageLinkType_contains?: InputMaybe<Scalars['String']['input']>;
  endImageLinkType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  endImageLinkType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImageLinkType_not?: InputMaybe<Scalars['String']['input']>;
  endImageLinkType_not_contains?: InputMaybe<Scalars['String']['input']>;
  endImageLinkType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImageUrl?: InputMaybe<Scalars['String']['input']>;
  endImageUrlText?: InputMaybe<Scalars['String']['input']>;
  endImageUrlText_contains?: InputMaybe<Scalars['String']['input']>;
  endImageUrlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  endImageUrlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImageUrlText_not?: InputMaybe<Scalars['String']['input']>;
  endImageUrlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  endImageUrlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  endImageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  endImageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImageUrl_not?: InputMaybe<Scalars['String']['input']>;
  endImageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  endImageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCollectionGroupEndImageLinkingCollections = {
  __typename?: 'CollectionGroupEndImageLinkingCollections';
  collectionGroupCollection?: Maybe<ContentfulCollectionGroupCollection>;
  collectionGroupCursorCollection?: Maybe<ContentfulCollectionGroupCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulCollectionGroupEndImageLinkingCollectionsCollectionGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupEndImageLinkingCollectionsCollectionGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCollectionGroupEndImageLinkingCollectionsCollectionGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupEndImageLinkingCollectionsCollectionGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCollectionGroupEndImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCollectionGroupEndImageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCollectionGroupEndImageLinkingCollectionsCollectionGroupCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCollectionGroupEndImageLinkingCollectionsCollectionGroupCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCollectionGroupEndImageOrder =
  | 'endImageLinkType_ASC'
  | 'endImageLinkType_DESC'
  | 'endImageUrlText_ASC'
  | 'endImageUrlText_DESC'
  | 'endImageUrl_ASC'
  | 'endImageUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulCollectionGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupFilter>>>;
  banner?: InputMaybe<ContentfulCfBannerHeroNestedFilter>;
  banner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  endImage?: InputMaybe<ContentfulCfCollectionGroupEndImageNestedFilter>;
  endImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productReferences_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCollectionGroupLinkingCollections = {
  __typename?: 'CollectionGroupLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
};


export type ContentfulCollectionGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCollectionGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCollectionGroupLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCollectionGroupLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCollectionGroupLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCollectionGroupLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCollectionGroupOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulCollectionGroupProductReferences = ContentfulAutomaticCollectionGroup | ContentfulManualCollectionGroupProductReferences;

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionItem) */
export type ContentfulCollectionItem = ContentfulEntry & Contentful_Node & {
  __typename?: 'CollectionItem';
  _id: Scalars['ID']['output'];
  collectionName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  image?: Maybe<ContentfulImageWithFocalPoint>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulCollectionItemLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  saleorCollection?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionItem) */
export type ContentfulCollectionItemCollectionNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionItem) */
export type ContentfulCollectionItemImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionItem) */
export type ContentfulCollectionItemInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionItem) */
export type ContentfulCollectionItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionItem) */
export type ContentfulCollectionItemLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/collectionItem) */
export type ContentfulCollectionItemSaleorCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCollectionItemCollection = {
  __typename?: 'CollectionItemCollection';
  items: Array<Maybe<ContentfulCollectionItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulCollectionItemCursorCollection = {
  __typename?: 'CollectionItemCursorCollection';
  items: Array<Maybe<ContentfulCollectionItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulCollectionItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCollectionItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCollectionItemFilter>>>;
  collectionName?: InputMaybe<Scalars['String']['input']>;
  collectionName_contains?: InputMaybe<Scalars['String']['input']>;
  collectionName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  collectionName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collectionName_not?: InputMaybe<Scalars['String']['input']>;
  collectionName_not_contains?: InputMaybe<Scalars['String']['input']>;
  collectionName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  image?: InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  saleorCollection?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_contains?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  saleorCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  saleorCollection_not?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCollectionItemLinkingCollections = {
  __typename?: 'CollectionItemLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  heroProductListingCollection?: Maybe<ContentfulHeroProductListingCollection>;
  heroProductListingCursorCollection?: Maybe<ContentfulHeroProductListingCursorCollection>;
};


export type ContentfulCollectionItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCollectionItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCollectionItemLinkingCollectionsHeroProductListingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionItemLinkingCollectionsHeroProductListingCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulCollectionItemLinkingCollectionsHeroProductListingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionItemLinkingCollectionsHeroProductListingCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCollectionItemLinkingCollectionsHeroProductListingCollectionOrder =
  | 'backgroundColorOpacity_ASC'
  | 'backgroundColorOpacity_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'headingNumberOfColoredWords_ASC'
  | 'headingNumberOfColoredWords_DESC'
  | 'headingSeoTag_ASC'
  | 'headingSeoTag_DESC'
  | 'headingStyle_ASC'
  | 'headingStyle_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'showBreadcrumbs_ASC'
  | 'showBreadcrumbs_DESC'
  | 'showFilters_ASC'
  | 'showFilters_DESC'
  | 'subheaderIsCapitalized_ASC'
  | 'subheaderIsCapitalized_DESC'
  | 'subheading_ASC'
  | 'subheading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textBelowMedia_ASC'
  | 'textBelowMedia_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'url2text_ASC'
  | 'url2text_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulCollectionItemLinkingCollectionsHeroProductListingCursorCollectionOrder =
  | 'backgroundColorOpacity_ASC'
  | 'backgroundColorOpacity_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'headingNumberOfColoredWords_ASC'
  | 'headingNumberOfColoredWords_DESC'
  | 'headingSeoTag_ASC'
  | 'headingSeoTag_DESC'
  | 'headingStyle_ASC'
  | 'headingStyle_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'showBreadcrumbs_ASC'
  | 'showBreadcrumbs_DESC'
  | 'showFilters_ASC'
  | 'showFilters_DESC'
  | 'subheaderIsCapitalized_ASC'
  | 'subheaderIsCapitalized_DESC'
  | 'subheading_ASC'
  | 'subheading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textBelowMedia_ASC'
  | 'textBelowMedia_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'url2text_ASC'
  | 'url2text_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulCollectionItemOrder =
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/conditionalComponent) */
export type ContentfulConditionalComponent = ContentfulEntry & Contentful_Node & {
  __typename?: 'ConditionalComponent';
  _id: Scalars['ID']['output'];
  contentCollection?: Maybe<ContentfulConditionalComponentContentCollection>;
  contentCursorCollection?: Maybe<ContentfulConditionalComponentContentCursorCollection>;
  contentfulMetadata: ContentfulContentfulMetadata;
  displayOnEmptyCondition?: Maybe<Scalars['String']['output']>;
  displayOnLoggedInCondition?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulConditionalComponentLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/conditionalComponent) */
export type ContentfulConditionalComponentContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulConditionalComponentContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/conditionalComponent) */
export type ContentfulConditionalComponentContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulConditionalComponentContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/conditionalComponent) */
export type ContentfulConditionalComponentDisplayOnEmptyConditionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/conditionalComponent) */
export type ContentfulConditionalComponentDisplayOnLoggedInConditionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/conditionalComponent) */
export type ContentfulConditionalComponentInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/conditionalComponent) */
export type ContentfulConditionalComponentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/conditionalComponent) */
export type ContentfulConditionalComponentLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulConditionalComponentCollection = {
  __typename?: 'ConditionalComponentCollection';
  items: Array<Maybe<ContentfulConditionalComponent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulConditionalComponentContentCollection = {
  __typename?: 'ConditionalComponentContentCollection';
  items: Array<Maybe<ContentfulConditionalComponentContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulConditionalComponentContentCursorCollection = {
  __typename?: 'ConditionalComponentContentCursorCollection';
  items: Array<Maybe<ContentfulConditionalComponentContentItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulConditionalComponentContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulConditionalComponentContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulConditionalComponentContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulConditionalComponentContentItem = ContentfulBanner | ContentfulBreadcrumb | ContentfulCard | ContentfulContentGroup | ContentfulFaqWrap | ContentfulFindAStore | ContentfulFreeTextContent | ContentfulGrid | ContentfulHeading | ContentfulHeroSlider | ContentfulNavQuickLinks | ContentfulPlaceholder | ContentfulPlaceholderCheckoutPayments | ContentfulPlaceholderService | ContentfulPlaceholderStores | ContentfulProductCard | ContentfulServicesCollection | ContentfulSliderProductsManual;

export type ContentfulConditionalComponentCursorCollection = {
  __typename?: 'ConditionalComponentCursorCollection';
  items: Array<Maybe<ContentfulConditionalComponent>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulConditionalComponentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulConditionalComponentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulConditionalComponentFilter>>>;
  content?: InputMaybe<ContentfulCfcontentMultiTypeNestedFilter>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  displayOnEmptyCondition?: InputMaybe<Scalars['String']['input']>;
  displayOnEmptyCondition_contains?: InputMaybe<Scalars['String']['input']>;
  displayOnEmptyCondition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnEmptyCondition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayOnEmptyCondition_not?: InputMaybe<Scalars['String']['input']>;
  displayOnEmptyCondition_not_contains?: InputMaybe<Scalars['String']['input']>;
  displayOnEmptyCondition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayOnLoggedInCondition?: InputMaybe<Scalars['String']['input']>;
  displayOnLoggedInCondition_contains?: InputMaybe<Scalars['String']['input']>;
  displayOnLoggedInCondition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnLoggedInCondition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayOnLoggedInCondition_not?: InputMaybe<Scalars['String']['input']>;
  displayOnLoggedInCondition_not_contains?: InputMaybe<Scalars['String']['input']>;
  displayOnLoggedInCondition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulConditionalComponentLinkingCollections = {
  __typename?: 'ConditionalComponentLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulConditionalComponentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulConditionalComponentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulConditionalComponentLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulConditionalComponentLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulConditionalComponentLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulConditionalComponentLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulConditionalComponentLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulConditionalComponentLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulConditionalComponentOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contactUs) */
export type ContentfulContactUs = ContentfulEntry & Contentful_Node & {
  __typename?: 'ContactUs';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  email?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<ContentfulHeading>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulContactUsLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contactUs) */
export type ContentfulContactUsEmailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contactUs) */
export type ContentfulContactUsHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contactUs) */
export type ContentfulContactUsInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contactUs) */
export type ContentfulContactUsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contactUs) */
export type ContentfulContactUsLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contactUs) */
export type ContentfulContactUsPhoneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contactUs) */
export type ContentfulContactUsTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulContactUsCollection = {
  __typename?: 'ContactUsCollection';
  items: Array<Maybe<ContentfulContactUs>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulContactUsCursorCollection = {
  __typename?: 'ContactUsCursorCollection';
  items: Array<Maybe<ContentfulContactUs>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulContactUsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulContactUsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulContactUsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_contains?: InputMaybe<Scalars['String']['input']>;
  email_exists?: InputMaybe<Scalars['Boolean']['input']>;
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_not?: InputMaybe<Scalars['String']['input']>;
  email_not_contains?: InputMaybe<Scalars['String']['input']>;
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading?: InputMaybe<ContentfulCfHeadingNestedFilter>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_contains?: InputMaybe<Scalars['String']['input']>;
  phone_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone_not?: InputMaybe<Scalars['String']['input']>;
  phone_not_contains?: InputMaybe<Scalars['String']['input']>;
  phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulContactUsLinkingCollections = {
  __typename?: 'ContactUsLinkingCollections';
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulContactUsLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsPageBoutiqueDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContactUsLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulContactUsLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulContactUsLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulContactUsLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContactUsLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContactUsLinkingCollectionsPageBoutiqueDetailCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContactUsLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContactUsLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulContactUsLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulContactUsLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContactUsLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContactUsLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContactUsLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContactUsLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulContactUsLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulContactUsOrder =
  | 'email_ASC'
  | 'email_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'phone_ASC'
  | 'phone_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contentGroup) */
export type ContentfulContentGroup = ContentfulEntry & Contentful_Node & {
  __typename?: 'ContentGroup';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  id?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  itemsCollection?: Maybe<ContentfulContentGroupItemsCollection>;
  itemsCursorCollection?: Maybe<ContentfulContentGroupItemsCursorCollection>;
  linkedFrom?: Maybe<ContentfulContentGroupLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contentGroup) */
export type ContentfulContentGroupIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contentGroup) */
export type ContentfulContentGroupInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contentGroup) */
export type ContentfulContentGroupItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulContentGroupItemsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contentGroup) */
export type ContentfulContentGroupItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulContentGroupItemsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contentGroup) */
export type ContentfulContentGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contentGroup) */
export type ContentfulContentGroupLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/contentGroup) */
export type ContentfulContentGroupTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulContentGroupCollection = {
  __typename?: 'ContentGroupCollection';
  items: Array<Maybe<ContentfulContentGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulContentGroupCursorCollection = {
  __typename?: 'ContentGroupCursorCollection';
  items: Array<Maybe<ContentfulContentGroup>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulContentGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulContentGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulContentGroupFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  items?: InputMaybe<ContentfulCfitemsMultiTypeNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulContentGroupItemsCollection = {
  __typename?: 'ContentGroupItemsCollection';
  items: Array<Maybe<ContentfulContentGroupItemsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulContentGroupItemsCursorCollection = {
  __typename?: 'ContentGroupItemsCursorCollection';
  items: Array<Maybe<ContentfulContentGroupItemsItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulContentGroupItemsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulContentGroupItemsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulContentGroupItemsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulContentGroupItemsItem = ContentfulCard | ContentfulGrid | ContentfulImageWithFocalPoint | ContentfulPlaceholderService | ContentfulProductCard;

export type ContentfulContentGroupLinkingCollections = {
  __typename?: 'ContentGroupLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  gridCollection?: Maybe<ContentfulGridCollection>;
  gridCursorCollection?: Maybe<ContentfulGridCursorCollection>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulContentGroupLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsPageBoutiqueDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulContentGroupLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulContentGroupLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulContentGroupLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulContentGroupLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulContentGroupLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulContentGroupLinkingCollectionsGridCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulContentGroupLinkingCollectionsGridCursorCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulContentGroupLinkingCollectionsPageBoutiqueDetailCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContentGroupLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContentGroupLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulContentGroupLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulContentGroupLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContentGroupLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContentGroupLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContentGroupLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContentGroupLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulContentGroupLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulContentGroupOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<ContentfulTaxonomyConcept>>;
  tags: Array<Maybe<ContentfulContentfulTag>>;
};

export type ContentfulContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<ContentfulContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ContentfulCursorPages = {
  __typename?: 'CursorPages';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/defaultLayout) */
export type ContentfulDefaultLayout = ContentfulEntry & Contentful_Node & {
  __typename?: 'DefaultLayout';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  footer?: Maybe<ContentfulFooter>;
  header?: Maybe<ContentfulMainHeader>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulDefaultLayoutLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  search?: Maybe<ContentfulSearchOverlay>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/defaultLayout) */
export type ContentfulDefaultLayoutFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFooterFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/defaultLayout) */
export type ContentfulDefaultLayoutHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainHeaderFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/defaultLayout) */
export type ContentfulDefaultLayoutInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/defaultLayout) */
export type ContentfulDefaultLayoutLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/defaultLayout) */
export type ContentfulDefaultLayoutLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/defaultLayout) */
export type ContentfulDefaultLayoutSearchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSearchOverlayFilter>;
};

export type ContentfulDefaultLayoutCollection = {
  __typename?: 'DefaultLayoutCollection';
  items: Array<Maybe<ContentfulDefaultLayout>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulDefaultLayoutCursorCollection = {
  __typename?: 'DefaultLayoutCursorCollection';
  items: Array<Maybe<ContentfulDefaultLayout>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulDefaultLayoutFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulDefaultLayoutFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulDefaultLayoutFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  footer?: InputMaybe<ContentfulCfFooterNestedFilter>;
  footer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header?: InputMaybe<ContentfulCfMainHeaderNestedFilter>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<ContentfulCfSearchOverlayNestedFilter>;
  search_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulDefaultLayoutLinkingCollections = {
  __typename?: 'DefaultLayoutLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulDefaultLayoutLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulDefaultLayoutLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulDefaultLayoutOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPage = ContentfulEntry & Contentful_Node & {
  __typename?: 'DetailPage';
  _id: Scalars['ID']['output'];
  contentCollection?: Maybe<ContentfulDetailPageContentCollection>;
  contentCursorCollection?: Maybe<ContentfulDetailPageContentCursorCollection>;
  contentfulMetadata: ContentfulContentfulMetadata;
  default?: Maybe<Scalars['Boolean']['output']>;
  footer?: Maybe<ContentfulFooter>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulDetailPageLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  mainHeader?: Maybe<ContentfulMainHeader>;
  model?: Maybe<Scalars['String']['output']>;
  seoConfiguration?: Maybe<ContentfulSeoConfiguration>;
  seoConfigurationOverride?: Maybe<ContentfulSeoConfiguration>;
  strapSkus?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
  watchCollection?: Maybe<Scalars['String']['output']>;
  watchSkus?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDetailPageContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDetailPageContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageDefaultArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFooterFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageMainHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainHeaderFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageModelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageSeoConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageSeoConfigurationOverrideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageStrapSkusArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageWatchCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/detailPage) */
export type ContentfulDetailPageWatchSkusArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulDetailPageCollection = {
  __typename?: 'DetailPageCollection';
  items: Array<Maybe<ContentfulDetailPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulDetailPageContentCollection = {
  __typename?: 'DetailPageContentCollection';
  items: Array<Maybe<ContentfulDetailPageContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulDetailPageContentCursorCollection = {
  __typename?: 'DetailPageContentCursorCollection';
  items: Array<Maybe<ContentfulDetailPageContentItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulDetailPageContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulDetailPageContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulDetailPageContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulDetailPageContentItem = ContentfulBanner | ContentfulCard | ContentfulContactUs | ContentfulContentGroup | ContentfulFaqWrap | ContentfulFindAStore | ContentfulGrid | ContentfulPlaceholder | ContentfulPlaceholderModelStory | ContentfulPlaceholderProductDetails | ContentfulPlaceholderStores | ContentfulServicesCollection | ContentfulSliderProductsAutomatic | ContentfulSliderProductsManual;

export type ContentfulDetailPageCursorCollection = {
  __typename?: 'DetailPageCursorCollection';
  items: Array<Maybe<ContentfulDetailPage>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulDetailPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulDetailPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulDetailPageFilter>>>;
  content?: InputMaybe<ContentfulCfcontentMultiTypeNestedFilter>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  default_exists?: InputMaybe<Scalars['Boolean']['input']>;
  default_not?: InputMaybe<Scalars['Boolean']['input']>;
  footer?: InputMaybe<ContentfulCfFooterNestedFilter>;
  footer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mainHeader?: InputMaybe<ContentfulCfMainHeaderNestedFilter>;
  mainHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  model_contains?: InputMaybe<Scalars['String']['input']>;
  model_exists?: InputMaybe<Scalars['Boolean']['input']>;
  model_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  model_not?: InputMaybe<Scalars['String']['input']>;
  model_not_contains?: InputMaybe<Scalars['String']['input']>;
  model_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoConfiguration?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  strapSkus_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strapSkus_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strapSkus_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strapSkus_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  watchCollection?: InputMaybe<Scalars['String']['input']>;
  watchCollection_contains?: InputMaybe<Scalars['String']['input']>;
  watchCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  watchCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  watchCollection_not?: InputMaybe<Scalars['String']['input']>;
  watchCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  watchCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  watchSkus_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  watchSkus_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  watchSkus_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  watchSkus_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulDetailPageLinkingCollections = {
  __typename?: 'DetailPageLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulDetailPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulDetailPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulDetailPageOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/dictionary) */
export type ContentfulDictionary = ContentfulEntry & Contentful_Node & {
  __typename?: 'Dictionary';
  _id: Scalars['ID']['output'];
  contentCollection?: Maybe<ContentfulDictionaryContentCollection>;
  contentCursorCollection?: Maybe<ContentfulDictionaryContentCursorCollection>;
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulDictionaryLinkingCollections>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/dictionary) */
export type ContentfulDictionaryContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDictionaryItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/dictionary) */
export type ContentfulDictionaryContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDictionaryItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/dictionary) */
export type ContentfulDictionaryInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/dictionary) */
export type ContentfulDictionaryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulDictionaryCollection = {
  __typename?: 'DictionaryCollection';
  items: Array<Maybe<ContentfulDictionary>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulDictionaryContentCollection = {
  __typename?: 'DictionaryContentCollection';
  items: Array<Maybe<ContentfulDictionaryItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulDictionaryContentCollectionOrder =
  | 'key_ASC'
  | 'key_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulDictionaryContentCursorCollection = {
  __typename?: 'DictionaryContentCursorCollection';
  items: Array<Maybe<ContentfulDictionaryItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulDictionaryContentCursorCollectionOrder =
  | 'key_ASC'
  | 'key_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulDictionaryCursorCollection = {
  __typename?: 'DictionaryCursorCollection';
  items: Array<Maybe<ContentfulDictionary>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulDictionaryFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulDictionaryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulDictionaryFilter>>>;
  content?: InputMaybe<ContentfulCfDictionaryItemNestedFilter>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/dictionaryItem) */
export type ContentfulDictionaryItem = ContentfulEntry & Contentful_Node & {
  __typename?: 'DictionaryItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  key?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulDictionaryItemLinkingCollections>;
  sys: ContentfulSys;
  value?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/dictionaryItem) */
export type ContentfulDictionaryItemKeyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/dictionaryItem) */
export type ContentfulDictionaryItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/dictionaryItem) */
export type ContentfulDictionaryItemValueArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulDictionaryItemCollection = {
  __typename?: 'DictionaryItemCollection';
  items: Array<Maybe<ContentfulDictionaryItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulDictionaryItemCursorCollection = {
  __typename?: 'DictionaryItemCursorCollection';
  items: Array<Maybe<ContentfulDictionaryItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulDictionaryItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulDictionaryItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulDictionaryItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_contains?: InputMaybe<Scalars['String']['input']>;
  key_exists?: InputMaybe<Scalars['Boolean']['input']>;
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  key_not?: InputMaybe<Scalars['String']['input']>;
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_exists?: InputMaybe<Scalars['Boolean']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulDictionaryItemLinkingCollections = {
  __typename?: 'DictionaryItemLinkingCollections';
  dictionaryCollection?: Maybe<ContentfulDictionaryCollection>;
  dictionaryCursorCollection?: Maybe<ContentfulDictionaryCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulDictionaryItemLinkingCollectionsDictionaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryItemLinkingCollectionsDictionaryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulDictionaryItemLinkingCollectionsDictionaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryItemLinkingCollectionsDictionaryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulDictionaryItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulDictionaryItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulDictionaryItemLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryItemLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulDictionaryItemLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryItemLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulDictionaryItemLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryItemLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulDictionaryItemLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryItemLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulDictionaryItemLinkingCollectionsDictionaryCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulDictionaryItemLinkingCollectionsDictionaryCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulDictionaryItemLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulDictionaryItemLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulDictionaryItemLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulDictionaryItemLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulDictionaryItemOrder =
  | 'key_ASC'
  | 'key_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulDictionaryLinkingCollections = {
  __typename?: 'DictionaryLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulDictionaryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulDictionaryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulDictionaryOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulEntry = {
  contentfulMetadata: ContentfulContentfulMetadata;
  sys: ContentfulSys;
};

export type ContentfulEntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<ContentfulEntry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulEntryCursorCollection = {
  __typename?: 'EntryCursorCollection';
  items: Array<Maybe<ContentfulEntry>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulEntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulEntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulEntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulEntryOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/event) */
export type ContentfulEvent = ContentfulEntry & Contentful_Node & {
  __typename?: 'Event';
  _id: Scalars['ID']['output'];
  campaignName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  description?: Maybe<ContentfulEventDescription>;
  eventId?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulEventLinkingCollections>;
  sfId?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/event) */
export type ContentfulEventCampaignNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/event) */
export type ContentfulEventDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/event) */
export type ContentfulEventEventIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/event) */
export type ContentfulEventLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/event) */
export type ContentfulEventSfIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/event) */
export type ContentfulEventTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/event) */
export type ContentfulEventTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulEventCollection = {
  __typename?: 'EventCollection';
  items: Array<Maybe<ContentfulEvent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulEventCursorCollection = {
  __typename?: 'EventCursorCollection';
  items: Array<Maybe<ContentfulEvent>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulEventDescription = {
  __typename?: 'EventDescription';
  json: Scalars['JSON']['output'];
  links: ContentfulEventDescriptionLinks;
};

export type ContentfulEventDescriptionAssets = {
  __typename?: 'EventDescriptionAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulEventDescriptionEntries = {
  __typename?: 'EventDescriptionEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulEventDescriptionLinks = {
  __typename?: 'EventDescriptionLinks';
  assets: ContentfulEventDescriptionAssets;
  entries: ContentfulEventDescriptionEntries;
  resources: ContentfulEventDescriptionResources;
};

export type ContentfulEventDescriptionResources = {
  __typename?: 'EventDescriptionResources';
  block: Array<ContentfulEventDescriptionResourcesBlock>;
  hyperlink: Array<ContentfulEventDescriptionResourcesHyperlink>;
  inline: Array<ContentfulEventDescriptionResourcesInline>;
};

export type ContentfulEventDescriptionResourcesBlock = ContentfulResourceLink & {
  __typename?: 'EventDescriptionResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulEventDescriptionResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'EventDescriptionResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulEventDescriptionResourcesInline = ContentfulResourceLink & {
  __typename?: 'EventDescriptionResourcesInline';
  sys: ContentfulResourceSys;
};

export type ContentfulEventFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulEventFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulEventFilter>>>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  campaignName_contains?: InputMaybe<Scalars['String']['input']>;
  campaignName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  campaignName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignName_not?: InputMaybe<Scalars['String']['input']>;
  campaignName_not_contains?: InputMaybe<Scalars['String']['input']>;
  campaignName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  eventId_contains?: InputMaybe<Scalars['String']['input']>;
  eventId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eventId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventId_not?: InputMaybe<Scalars['String']['input']>;
  eventId_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sfId?: InputMaybe<Scalars['String']['input']>;
  sfId_contains?: InputMaybe<Scalars['String']['input']>;
  sfId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sfId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sfId_not?: InputMaybe<Scalars['String']['input']>;
  sfId_not_contains?: InputMaybe<Scalars['String']['input']>;
  sfId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulEventLinkingCollections = {
  __typename?: 'EventLinkingCollections';
  cardCollection?: Maybe<ContentfulCardCollection>;
  cardCursorCollection?: Maybe<ContentfulCardCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  navQuickLinkItemCollection?: Maybe<ContentfulNavQuickLinkItemCollection>;
  navQuickLinkItemCursorCollection?: Maybe<ContentfulNavQuickLinkItemCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
};


export type ContentfulEventLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulEventLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulEventLinkingCollectionsCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulEventLinkingCollectionsCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulEventLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulEventLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulEventLinkingCollectionsNavQuickLinkItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulEventLinkingCollectionsNavQuickLinkItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulEventLinkingCollectionsNavQuickLinkItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulEventLinkingCollectionsNavQuickLinkItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulEventLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulEventLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulEventLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulEventLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulEventLinkingCollectionsCardCollectionOrder =
  | 'backgroundAlignment_ASC'
  | 'backgroundAlignment_DESC'
  | 'backgroundPosition_ASC'
  | 'backgroundPosition_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'contentOption_ASC'
  | 'contentOption_DESC'
  | 'countdownToDatetime_ASC'
  | 'countdownToDatetime_DESC'
  | 'countdown_ASC'
  | 'countdown_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAnimationEffect_ASC'
  | 'mediaAnimationEffect_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'saleorProductSku_ASC'
  | 'saleorProductSku_DESC'
  | 'showMore_ASC'
  | 'showMore_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1ariaLabel_ASC'
  | 'url1ariaLabel_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Text_ASC'
  | 'url2Text_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2ariaLabel_ASC'
  | 'url2ariaLabel_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulEventLinkingCollectionsCardCursorCollectionOrder =
  | 'backgroundAlignment_ASC'
  | 'backgroundAlignment_DESC'
  | 'backgroundPosition_ASC'
  | 'backgroundPosition_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'contentOption_ASC'
  | 'contentOption_DESC'
  | 'countdownToDatetime_ASC'
  | 'countdownToDatetime_DESC'
  | 'countdown_ASC'
  | 'countdown_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAnimationEffect_ASC'
  | 'mediaAnimationEffect_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'saleorProductSku_ASC'
  | 'saleorProductSku_DESC'
  | 'showMore_ASC'
  | 'showMore_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1ariaLabel_ASC'
  | 'url1ariaLabel_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Text_ASC'
  | 'url2Text_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2ariaLabel_ASC'
  | 'url2ariaLabel_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulEventLinkingCollectionsNavQuickLinkItemCollectionOrder =
  | 'Url_ASC'
  | 'Url_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'disableNavigationScrollToTop_ASC'
  | 'disableNavigationScrollToTop_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'topLabelText_ASC'
  | 'topLabelText_DESC'
  | 'urlTarget_ASC'
  | 'urlTarget_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC';

export type ContentfulEventLinkingCollectionsNavQuickLinkItemCursorCollectionOrder =
  | 'Url_ASC'
  | 'Url_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'disableNavigationScrollToTop_ASC'
  | 'disableNavigationScrollToTop_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'topLabelText_ASC'
  | 'topLabelText_DESC'
  | 'urlTarget_ASC'
  | 'urlTarget_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC';

export type ContentfulEventLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulEventLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulEventOrder =
  | 'campaignName_ASC'
  | 'campaignName_DESC'
  | 'eventId_ASC'
  | 'eventId_DESC'
  | 'sfId_ASC'
  | 'sfId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionItem) */
export type ContentfulExhibitionItem = ContentfulEntry & Contentful_Node & {
  __typename?: 'ExhibitionItem';
  _id: Scalars['ID']['output'];
  boutiqueId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulExhibitionItemLinkingCollections>;
  media?: Maybe<ContentfulImageWithFocalPoint>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionItem) */
export type ContentfulExhibitionItemBoutiqueIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionItem) */
export type ContentfulExhibitionItemEndDateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionItem) */
export type ContentfulExhibitionItemInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionItem) */
export type ContentfulExhibitionItemLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionItem) */
export type ContentfulExhibitionItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionItem) */
export type ContentfulExhibitionItemMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionItem) */
export type ContentfulExhibitionItemStartDateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulExhibitionItemCollection = {
  __typename?: 'ExhibitionItemCollection';
  items: Array<Maybe<ContentfulExhibitionItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulExhibitionItemCursorCollection = {
  __typename?: 'ExhibitionItemCursorCollection';
  items: Array<Maybe<ContentfulExhibitionItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulExhibitionItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulExhibitionItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulExhibitionItemFilter>>>;
  boutiqueId?: InputMaybe<Scalars['String']['input']>;
  boutiqueId_contains?: InputMaybe<Scalars['String']['input']>;
  boutiqueId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  boutiqueId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  boutiqueId_not?: InputMaybe<Scalars['String']['input']>;
  boutiqueId_not_contains?: InputMaybe<Scalars['String']['input']>;
  boutiqueId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media?: InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulExhibitionItemLinkingCollections = {
  __typename?: 'ExhibitionItemLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  exhibitionListCollection?: Maybe<ContentfulExhibitionListCollection>;
  exhibitionListCursorCollection?: Maybe<ContentfulExhibitionListCursorCollection>;
};


export type ContentfulExhibitionItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulExhibitionItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulExhibitionItemLinkingCollectionsExhibitionListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulExhibitionItemLinkingCollectionsExhibitionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulExhibitionItemLinkingCollectionsExhibitionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulExhibitionItemLinkingCollectionsExhibitionListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulExhibitionItemLinkingCollectionsExhibitionListCollectionOrder =
  | 'categoryTitleSeoTag_ASC'
  | 'categoryTitleSeoTag_DESC'
  | 'categoryTitleStyle_ASC'
  | 'categoryTitleStyle_DESC'
  | 'categoryTitle_ASC'
  | 'categoryTitle_DESC'
  | 'exhibitionListLabel_ASC'
  | 'exhibitionListLabel_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'loadMoreLabel_ASC'
  | 'loadMoreLabel_DESC'
  | 'pastExhibitionsLabel_ASC'
  | 'pastExhibitionsLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulExhibitionItemLinkingCollectionsExhibitionListCursorCollectionOrder =
  | 'categoryTitleSeoTag_ASC'
  | 'categoryTitleSeoTag_DESC'
  | 'categoryTitleStyle_ASC'
  | 'categoryTitleStyle_DESC'
  | 'categoryTitle_ASC'
  | 'categoryTitle_DESC'
  | 'exhibitionListLabel_ASC'
  | 'exhibitionListLabel_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'loadMoreLabel_ASC'
  | 'loadMoreLabel_DESC'
  | 'pastExhibitionsLabel_ASC'
  | 'pastExhibitionsLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulExhibitionItemOrder =
  | 'boutiqueId_ASC'
  | 'boutiqueId_DESC'
  | 'endDate_ASC'
  | 'endDate_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'startDate_ASC'
  | 'startDate_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionList = ContentfulEntry & Contentful_Node & {
  __typename?: 'ExhibitionList';
  _id: Scalars['ID']['output'];
  categoryDescription?: Maybe<Scalars['String']['output']>;
  categoryTitle?: Maybe<Scalars['String']['output']>;
  categoryTitleSeoTag?: Maybe<Scalars['String']['output']>;
  categoryTitleStyle?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  exhibitionItemsCollection?: Maybe<ContentfulExhibitionListExhibitionItemsCollection>;
  exhibitionItemsCursorCollection?: Maybe<ContentfulExhibitionListExhibitionItemsCursorCollection>;
  exhibitionListLabel?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulExhibitionListLinkingCollections>;
  loadMoreLabel?: Maybe<Scalars['String']['output']>;
  pastExhibitionsLabel?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListCategoryDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListCategoryTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListCategoryTitleSeoTagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListCategoryTitleStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListExhibitionItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulExhibitionListExhibitionItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulExhibitionItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListExhibitionItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulExhibitionListExhibitionItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulExhibitionItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListExhibitionListLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListLoadMoreLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/exhibitionList) */
export type ContentfulExhibitionListPastExhibitionsLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulExhibitionListCollection = {
  __typename?: 'ExhibitionListCollection';
  items: Array<Maybe<ContentfulExhibitionList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulExhibitionListCursorCollection = {
  __typename?: 'ExhibitionListCursorCollection';
  items: Array<Maybe<ContentfulExhibitionList>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulExhibitionListExhibitionItemsCollection = {
  __typename?: 'ExhibitionListExhibitionItemsCollection';
  items: Array<Maybe<ContentfulExhibitionItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulExhibitionListExhibitionItemsCollectionOrder =
  | 'boutiqueId_ASC'
  | 'boutiqueId_DESC'
  | 'endDate_ASC'
  | 'endDate_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'startDate_ASC'
  | 'startDate_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulExhibitionListExhibitionItemsCursorCollection = {
  __typename?: 'ExhibitionListExhibitionItemsCursorCollection';
  items: Array<Maybe<ContentfulExhibitionItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulExhibitionListExhibitionItemsCursorCollectionOrder =
  | 'boutiqueId_ASC'
  | 'boutiqueId_DESC'
  | 'endDate_ASC'
  | 'endDate_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'startDate_ASC'
  | 'startDate_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulExhibitionListFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulExhibitionListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulExhibitionListFilter>>>;
  categoryDescription?: InputMaybe<Scalars['String']['input']>;
  categoryDescription_contains?: InputMaybe<Scalars['String']['input']>;
  categoryDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  categoryDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryDescription_not?: InputMaybe<Scalars['String']['input']>;
  categoryDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  categoryDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryTitle?: InputMaybe<Scalars['String']['input']>;
  categoryTitleSeoTag?: InputMaybe<Scalars['String']['input']>;
  categoryTitleSeoTag_contains?: InputMaybe<Scalars['String']['input']>;
  categoryTitleSeoTag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  categoryTitleSeoTag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryTitleSeoTag_not?: InputMaybe<Scalars['String']['input']>;
  categoryTitleSeoTag_not_contains?: InputMaybe<Scalars['String']['input']>;
  categoryTitleSeoTag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryTitleStyle?: InputMaybe<Scalars['String']['input']>;
  categoryTitleStyle_contains?: InputMaybe<Scalars['String']['input']>;
  categoryTitleStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  categoryTitleStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryTitleStyle_not?: InputMaybe<Scalars['String']['input']>;
  categoryTitleStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  categoryTitleStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  categoryTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  categoryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryTitle_not?: InputMaybe<Scalars['String']['input']>;
  categoryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  categoryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  exhibitionItems?: InputMaybe<ContentfulCfExhibitionItemNestedFilter>;
  exhibitionItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  exhibitionListLabel?: InputMaybe<Scalars['String']['input']>;
  exhibitionListLabel_contains?: InputMaybe<Scalars['String']['input']>;
  exhibitionListLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  exhibitionListLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exhibitionListLabel_not?: InputMaybe<Scalars['String']['input']>;
  exhibitionListLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  exhibitionListLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loadMoreLabel?: InputMaybe<Scalars['String']['input']>;
  loadMoreLabel_contains?: InputMaybe<Scalars['String']['input']>;
  loadMoreLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadMoreLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loadMoreLabel_not?: InputMaybe<Scalars['String']['input']>;
  loadMoreLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  loadMoreLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pastExhibitionsLabel?: InputMaybe<Scalars['String']['input']>;
  pastExhibitionsLabel_contains?: InputMaybe<Scalars['String']['input']>;
  pastExhibitionsLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pastExhibitionsLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pastExhibitionsLabel_not?: InputMaybe<Scalars['String']['input']>;
  pastExhibitionsLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  pastExhibitionsLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulExhibitionListLinkingCollections = {
  __typename?: 'ExhibitionListLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
};


export type ContentfulExhibitionListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulExhibitionListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulExhibitionListLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulExhibitionListLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulExhibitionListLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulExhibitionListLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulExhibitionListLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulExhibitionListLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulExhibitionListOrder =
  | 'categoryTitleSeoTag_ASC'
  | 'categoryTitleSeoTag_DESC'
  | 'categoryTitleStyle_ASC'
  | 'categoryTitleStyle_DESC'
  | 'categoryTitle_ASC'
  | 'categoryTitle_DESC'
  | 'exhibitionListLabel_ASC'
  | 'exhibitionListLabel_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'loadMoreLabel_ASC'
  | 'loadMoreLabel_DESC'
  | 'pastExhibitionsLabel_ASC'
  | 'pastExhibitionsLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqCategories) */
export type ContentfulFaqCategories = ContentfulEntry & Contentful_Node & {
  __typename?: 'FaqCategories';
  _id: Scalars['ID']['output'];
  categoryLabel?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  faqWrapsCollection?: Maybe<ContentfulFaqCategoriesFaqWrapsCollection>;
  faqWrapsCursorCollection?: Maybe<ContentfulFaqCategoriesFaqWrapsCursorCollection>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulFaqCategoriesLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqCategories) */
export type ContentfulFaqCategoriesCategoryLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqCategories) */
export type ContentfulFaqCategoriesFaqWrapsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqCategoriesFaqWrapsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFaqWrapFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqCategories) */
export type ContentfulFaqCategoriesFaqWrapsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqCategoriesFaqWrapsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFaqWrapFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqCategories) */
export type ContentfulFaqCategoriesInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqCategories) */
export type ContentfulFaqCategoriesLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqCategories) */
export type ContentfulFaqCategoriesLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFaqCategoriesCollection = {
  __typename?: 'FaqCategoriesCollection';
  items: Array<Maybe<ContentfulFaqCategories>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulFaqCategoriesCursorCollection = {
  __typename?: 'FaqCategoriesCursorCollection';
  items: Array<Maybe<ContentfulFaqCategories>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulFaqCategoriesFaqWrapsCollection = {
  __typename?: 'FaqCategoriesFaqWrapsCollection';
  items: Array<Maybe<ContentfulFaqWrap>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulFaqCategoriesFaqWrapsCollectionOrder =
  | 'collapse_ASC'
  | 'collapse_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqCategoriesFaqWrapsCursorCollection = {
  __typename?: 'FaqCategoriesFaqWrapsCursorCollection';
  items: Array<Maybe<ContentfulFaqWrap>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulFaqCategoriesFaqWrapsCursorCollectionOrder =
  | 'collapse_ASC'
  | 'collapse_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqCategoriesFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulFaqCategoriesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulFaqCategoriesFilter>>>;
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  categoryLabel_contains?: InputMaybe<Scalars['String']['input']>;
  categoryLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  categoryLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryLabel_not?: InputMaybe<Scalars['String']['input']>;
  categoryLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  categoryLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  faqWraps?: InputMaybe<ContentfulCfFaqWrapNestedFilter>;
  faqWrapsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulFaqCategoriesLinkingCollections = {
  __typename?: 'FaqCategoriesLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
};


export type ContentfulFaqCategoriesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqCategoriesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqCategoriesLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqCategoriesLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqCategoriesLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqCategoriesLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFaqCategoriesLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFaqCategoriesLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFaqCategoriesOrder =
  | 'categoryLabel_ASC'
  | 'categoryLabel_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqItem) */
export type ContentfulFaqItem = ContentfulEntry & Contentful_Node & {
  __typename?: 'FaqItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  faqAnswer?: Maybe<ContentfulFaqItemFaqAnswer>;
  faqQuestion?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulFaqItemLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqItem) */
export type ContentfulFaqItemFaqAnswerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqItem) */
export type ContentfulFaqItemFaqQuestionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqItem) */
export type ContentfulFaqItemInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqItem) */
export type ContentfulFaqItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqItem) */
export type ContentfulFaqItemLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFaqItemCollection = {
  __typename?: 'FaqItemCollection';
  items: Array<Maybe<ContentfulFaqItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulFaqItemCursorCollection = {
  __typename?: 'FaqItemCursorCollection';
  items: Array<Maybe<ContentfulFaqItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulFaqItemFaqAnswer = {
  __typename?: 'FaqItemFaqAnswer';
  json: Scalars['JSON']['output'];
  links: ContentfulFaqItemFaqAnswerLinks;
};

export type ContentfulFaqItemFaqAnswerAssets = {
  __typename?: 'FaqItemFaqAnswerAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulFaqItemFaqAnswerEntries = {
  __typename?: 'FaqItemFaqAnswerEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulFaqItemFaqAnswerLinks = {
  __typename?: 'FaqItemFaqAnswerLinks';
  assets: ContentfulFaqItemFaqAnswerAssets;
  entries: ContentfulFaqItemFaqAnswerEntries;
  resources: ContentfulFaqItemFaqAnswerResources;
};

export type ContentfulFaqItemFaqAnswerResources = {
  __typename?: 'FaqItemFaqAnswerResources';
  block: Array<ContentfulFaqItemFaqAnswerResourcesBlock>;
  hyperlink: Array<ContentfulFaqItemFaqAnswerResourcesHyperlink>;
  inline: Array<ContentfulFaqItemFaqAnswerResourcesInline>;
};

export type ContentfulFaqItemFaqAnswerResourcesBlock = ContentfulResourceLink & {
  __typename?: 'FaqItemFaqAnswerResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulFaqItemFaqAnswerResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'FaqItemFaqAnswerResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulFaqItemFaqAnswerResourcesInline = ContentfulResourceLink & {
  __typename?: 'FaqItemFaqAnswerResourcesInline';
  sys: ContentfulResourceSys;
};

export type ContentfulFaqItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulFaqItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulFaqItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  faqAnswer_contains?: InputMaybe<Scalars['String']['input']>;
  faqAnswer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  faqAnswer_not_contains?: InputMaybe<Scalars['String']['input']>;
  faqQuestion?: InputMaybe<Scalars['String']['input']>;
  faqQuestion_contains?: InputMaybe<Scalars['String']['input']>;
  faqQuestion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  faqQuestion_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faqQuestion_not?: InputMaybe<Scalars['String']['input']>;
  faqQuestion_not_contains?: InputMaybe<Scalars['String']['input']>;
  faqQuestion_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulFaqItemLinkingCollections = {
  __typename?: 'FaqItemLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  faqWrapCollection?: Maybe<ContentfulFaqWrapCollection>;
  faqWrapCursorCollection?: Maybe<ContentfulFaqWrapCursorCollection>;
};


export type ContentfulFaqItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqItemLinkingCollectionsFaqWrapCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqItemLinkingCollectionsFaqWrapCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqItemLinkingCollectionsFaqWrapCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqItemLinkingCollectionsFaqWrapCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFaqItemLinkingCollectionsFaqWrapCollectionOrder =
  | 'collapse_ASC'
  | 'collapse_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqItemLinkingCollectionsFaqWrapCursorCollectionOrder =
  | 'collapse_ASC'
  | 'collapse_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqItemOrder =
  | 'faqQuestion_ASC'
  | 'faqQuestion_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqWrap) */
export type ContentfulFaqWrap = ContentfulEntry & Contentful_Node & {
  __typename?: 'FaqWrap';
  _id: Scalars['ID']['output'];
  collapse?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  faqListCollection?: Maybe<ContentfulFaqWrapFaqListCollection>;
  faqListCursorCollection?: Maybe<ContentfulFaqWrapFaqListCursorCollection>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulFaqWrapLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
  title?: Maybe<ContentfulHeading>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqWrap) */
export type ContentfulFaqWrapCollapseArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqWrap) */
export type ContentfulFaqWrapFaqListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapFaqListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFaqItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqWrap) */
export type ContentfulFaqWrapFaqListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapFaqListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFaqItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqWrap) */
export type ContentfulFaqWrapInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqWrap) */
export type ContentfulFaqWrapLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqWrap) */
export type ContentfulFaqWrapLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/faqWrap) */
export type ContentfulFaqWrapTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};

export type ContentfulFaqWrapCollection = {
  __typename?: 'FaqWrapCollection';
  items: Array<Maybe<ContentfulFaqWrap>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulFaqWrapCursorCollection = {
  __typename?: 'FaqWrapCursorCollection';
  items: Array<Maybe<ContentfulFaqWrap>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulFaqWrapFaqListCollection = {
  __typename?: 'FaqWrapFaqListCollection';
  items: Array<Maybe<ContentfulFaqItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulFaqWrapFaqListCollectionOrder =
  | 'faqQuestion_ASC'
  | 'faqQuestion_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqWrapFaqListCursorCollection = {
  __typename?: 'FaqWrapFaqListCursorCollection';
  items: Array<Maybe<ContentfulFaqItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulFaqWrapFaqListCursorCollectionOrder =
  | 'faqQuestion_ASC'
  | 'faqQuestion_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqWrapFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapFilter>>>;
  collapse?: InputMaybe<Scalars['Boolean']['input']>;
  collapse_exists?: InputMaybe<Scalars['Boolean']['input']>;
  collapse_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  faqList?: InputMaybe<ContentfulCfFaqItemNestedFilter>;
  faqListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<ContentfulCfHeadingNestedFilter>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFaqWrapLinkingCollections = {
  __typename?: 'FaqWrapLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  faqCategoriesCollection?: Maybe<ContentfulFaqCategoriesCollection>;
  faqCategoriesCursorCollection?: Maybe<ContentfulFaqCategoriesCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulFaqWrapLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsFaqCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsFaqCategoriesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsFaqCategoriesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsFaqCategoriesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsPageBoutiqueDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFaqWrapLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFaqWrapLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqWrapLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqWrapLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulFaqWrapLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulFaqWrapLinkingCollectionsFaqCategoriesCollectionOrder =
  | 'categoryLabel_ASC'
  | 'categoryLabel_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqWrapLinkingCollectionsFaqCategoriesCursorCollectionOrder =
  | 'categoryLabel_ASC'
  | 'categoryLabel_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqWrapLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFaqWrapLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFaqWrapLinkingCollectionsPageBoutiqueDetailCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFaqWrapLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFaqWrapLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqWrapLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqWrapLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFaqWrapLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFaqWrapLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqWrapLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFaqWrapOrder =
  | 'collapse_ASC'
  | 'collapse_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/findAStore) */
export type ContentfulFindAStore = ContentfulEntry & Contentful_Node & {
  __typename?: 'FindAStore';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  cardImage?: Maybe<ContentfulAsset>;
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulFindAStoreLinkingCollections>;
  longImage?: Maybe<ContentfulAsset>;
  sys: ContentfulSys;
  text?: Maybe<ContentfulFindAStoreText>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlText?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/findAStore) */
export type ContentfulFindAStoreBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/findAStore) */
export type ContentfulFindAStoreCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/findAStore) */
export type ContentfulFindAStoreInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/findAStore) */
export type ContentfulFindAStoreLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/findAStore) */
export type ContentfulFindAStoreLongImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/findAStore) */
export type ContentfulFindAStoreTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/findAStore) */
export type ContentfulFindAStoreTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/findAStore) */
export type ContentfulFindAStoreUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/findAStore) */
export type ContentfulFindAStoreUrlTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFindAStoreCollection = {
  __typename?: 'FindAStoreCollection';
  items: Array<Maybe<ContentfulFindAStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulFindAStoreCursorCollection = {
  __typename?: 'FindAStoreCursorCollection';
  items: Array<Maybe<ContentfulFindAStore>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulFindAStoreFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  urlText_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText_not?: InputMaybe<Scalars['String']['input']>;
  urlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulFindAStoreLinkingCollections = {
  __typename?: 'FindAStoreLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
  placeholderStoresCollection?: Maybe<ContentfulPlaceholderStoresCollection>;
  placeholderStoresCursorCollection?: Maybe<ContentfulPlaceholderStoresCursorCollection>;
};


export type ContentfulFindAStoreLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsPageBoutiqueDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsPlaceholderStoresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsPlaceholderStoresCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFindAStoreLinkingCollectionsPlaceholderStoresCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreLinkingCollectionsPlaceholderStoresCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFindAStoreLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFindAStoreLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFindAStoreLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulFindAStoreLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulFindAStoreLinkingCollectionsPageBoutiqueDetailCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFindAStoreLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFindAStoreLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFindAStoreLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFindAStoreLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFindAStoreLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFindAStoreLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFindAStoreLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFindAStoreLinkingCollectionsPlaceholderStoresCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyewearAvailable_ASC'
  | 'eyewearAvailable_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'numberOfStores_ASC'
  | 'numberOfStores_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFindAStoreLinkingCollectionsPlaceholderStoresCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyewearAvailable_ASC'
  | 'eyewearAvailable_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'numberOfStores_ASC'
  | 'numberOfStores_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFindAStoreOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type ContentfulFindAStoreText = {
  __typename?: 'FindAStoreText';
  json: Scalars['JSON']['output'];
  links: ContentfulFindAStoreTextLinks;
};

export type ContentfulFindAStoreTextAssets = {
  __typename?: 'FindAStoreTextAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulFindAStoreTextEntries = {
  __typename?: 'FindAStoreTextEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulFindAStoreTextLinks = {
  __typename?: 'FindAStoreTextLinks';
  assets: ContentfulFindAStoreTextAssets;
  entries: ContentfulFindAStoreTextEntries;
  resources: ContentfulFindAStoreTextResources;
};

export type ContentfulFindAStoreTextResources = {
  __typename?: 'FindAStoreTextResources';
  block: Array<ContentfulFindAStoreTextResourcesBlock>;
  hyperlink: Array<ContentfulFindAStoreTextResourcesHyperlink>;
  inline: Array<ContentfulFindAStoreTextResourcesInline>;
};

export type ContentfulFindAStoreTextResourcesBlock = ContentfulResourceLink & {
  __typename?: 'FindAStoreTextResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulFindAStoreTextResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'FindAStoreTextResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulFindAStoreTextResourcesInline = ContentfulResourceLink & {
  __typename?: 'FindAStoreTextResourcesInline';
  sys: ContentfulResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooter = ContentfulEntry & Contentful_Node & {
  __typename?: 'Footer';
  _id: Scalars['ID']['output'];
  contactLinkAriaLabel?: Maybe<Scalars['String']['output']>;
  contactLinkText?: Maybe<Scalars['String']['output']>;
  contactLinkUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  copyrightText?: Maybe<Scalars['String']['output']>;
  displayContactInformation?: Maybe<Scalars['Boolean']['output']>;
  displayNewsletterSubscribe?: Maybe<Scalars['Boolean']['output']>;
  displayRegionSelector?: Maybe<Scalars['Boolean']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulFooterLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  logo?: Maybe<ContentfulAsset>;
  logoHeightDesktop?: Maybe<Scalars['Int']['output']>;
  logoHeightMobile?: Maybe<Scalars['Int']['output']>;
  logoLink?: Maybe<Scalars['String']['output']>;
  logoWidthDesktop?: Maybe<Scalars['Int']['output']>;
  logoWidthMobile?: Maybe<Scalars['Int']['output']>;
  menuItemsCollection?: Maybe<ContentfulFooterMenuItemsCollection>;
  menuItemsCursorCollection?: Maybe<ContentfulFooterMenuItemsCursorCollection>;
  regionSelectorLabel?: Maybe<Scalars['String']['output']>;
  secondaryMenuItemsCollection?: Maybe<ContentfulFooterSecondaryMenuItemsCollection>;
  secondaryMenuItemsCursorCollection?: Maybe<ContentfulFooterSecondaryMenuItemsCursorCollection>;
  socialFacebookUrl?: Maybe<Scalars['String']['output']>;
  socialInstagramUrl?: Maybe<Scalars['String']['output']>;
  socialLineUrl?: Maybe<Scalars['String']['output']>;
  socialNetworkLabel?: Maybe<Scalars['String']['output']>;
  socialPinterestUrl?: Maybe<Scalars['String']['output']>;
  socialStravaUrl?: Maybe<Scalars['String']['output']>;
  socialTiktokUrl?: Maybe<Scalars['String']['output']>;
  socialXTwitterUrl?: Maybe<Scalars['String']['output']>;
  socialYoutubeUrl?: Maybe<Scalars['String']['output']>;
  subscribeToNewsletterText?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterContactLinkAriaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterContactLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterContactLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterCopyrightTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterDisplayContactInformationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterDisplayNewsletterSubscribeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterDisplayRegionSelectorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterLogoHeightDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterLogoHeightMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterLogoLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterLogoWidthDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterLogoWidthMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterMenuItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterMenuItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainMenuItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterMenuItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterMenuItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainMenuItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterRegionSelectorLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSecondaryMenuItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterSecondaryMenuItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainMenuItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSecondaryMenuItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterSecondaryMenuItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainMenuItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSocialFacebookUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSocialInstagramUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSocialLineUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSocialNetworkLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSocialPinterestUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSocialStravaUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSocialTiktokUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSocialXTwitterUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSocialYoutubeUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterSubscribeToNewsletterTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/footer) */
export type ContentfulFooterTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFooterCollection = {
  __typename?: 'FooterCollection';
  items: Array<Maybe<ContentfulFooter>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulFooterCursorCollection = {
  __typename?: 'FooterCursorCollection';
  items: Array<Maybe<ContentfulFooter>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulFooterFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulFooterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulFooterFilter>>>;
  contactLinkAriaLabel?: InputMaybe<Scalars['String']['input']>;
  contactLinkAriaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkAriaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactLinkAriaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLinkAriaLabel_not?: InputMaybe<Scalars['String']['input']>;
  contactLinkAriaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkAriaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLinkText?: InputMaybe<Scalars['String']['input']>;
  contactLinkText_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactLinkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLinkText_not?: InputMaybe<Scalars['String']['input']>;
  contactLinkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLinkUrl?: InputMaybe<Scalars['String']['input']>;
  contactLinkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLinkUrl_not?: InputMaybe<Scalars['String']['input']>;
  contactLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  copyrightText?: InputMaybe<Scalars['String']['input']>;
  copyrightText_contains?: InputMaybe<Scalars['String']['input']>;
  copyrightText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copyrightText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copyrightText_not?: InputMaybe<Scalars['String']['input']>;
  copyrightText_not_contains?: InputMaybe<Scalars['String']['input']>;
  copyrightText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayContactInformation?: InputMaybe<Scalars['Boolean']['input']>;
  displayContactInformation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayContactInformation_not?: InputMaybe<Scalars['Boolean']['input']>;
  displayNewsletterSubscribe?: InputMaybe<Scalars['Boolean']['input']>;
  displayNewsletterSubscribe_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayNewsletterSubscribe_not?: InputMaybe<Scalars['Boolean']['input']>;
  displayRegionSelector?: InputMaybe<Scalars['Boolean']['input']>;
  displayRegionSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayRegionSelector_not?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightDesktop?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightMobile?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_not?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoLink?: InputMaybe<Scalars['String']['input']>;
  logoLink_contains?: InputMaybe<Scalars['String']['input']>;
  logoLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoLink_not?: InputMaybe<Scalars['String']['input']>;
  logoLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  logoLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoWidthDesktop?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoWidthDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthMobile?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoWidthMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_not?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  menuItems?: InputMaybe<ContentfulCfMainMenuItemNestedFilter>;
  menuItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  regionSelectorLabel?: InputMaybe<Scalars['String']['input']>;
  regionSelectorLabel_contains?: InputMaybe<Scalars['String']['input']>;
  regionSelectorLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  regionSelectorLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regionSelectorLabel_not?: InputMaybe<Scalars['String']['input']>;
  regionSelectorLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  regionSelectorLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryMenuItems?: InputMaybe<ContentfulCfMainMenuItemNestedFilter>;
  secondaryMenuItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialFacebookUrl?: InputMaybe<Scalars['String']['input']>;
  socialFacebookUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialFacebookUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialFacebookUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialFacebookUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialFacebookUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialFacebookUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialInstagramUrl?: InputMaybe<Scalars['String']['input']>;
  socialInstagramUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialInstagramUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialInstagramUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialInstagramUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialInstagramUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialInstagramUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialLineUrl?: InputMaybe<Scalars['String']['input']>;
  socialLineUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialLineUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialLineUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialLineUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialLineUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialLineUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialNetworkLabel?: InputMaybe<Scalars['String']['input']>;
  socialNetworkLabel_contains?: InputMaybe<Scalars['String']['input']>;
  socialNetworkLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetworkLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialNetworkLabel_not?: InputMaybe<Scalars['String']['input']>;
  socialNetworkLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialNetworkLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialPinterestUrl?: InputMaybe<Scalars['String']['input']>;
  socialPinterestUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialPinterestUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialPinterestUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialPinterestUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialPinterestUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialPinterestUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialStravaUrl?: InputMaybe<Scalars['String']['input']>;
  socialStravaUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialStravaUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialStravaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialStravaUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialStravaUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialStravaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialTiktokUrl?: InputMaybe<Scalars['String']['input']>;
  socialTiktokUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialTiktokUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialTiktokUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialTiktokUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialTiktokUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialTiktokUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialXTwitterUrl?: InputMaybe<Scalars['String']['input']>;
  socialXTwitterUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialXTwitterUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialXTwitterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialXTwitterUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialXTwitterUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialXTwitterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialYoutubeUrl?: InputMaybe<Scalars['String']['input']>;
  socialYoutubeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialYoutubeUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialYoutubeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialYoutubeUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialYoutubeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialYoutubeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscribeToNewsletterText?: InputMaybe<Scalars['String']['input']>;
  subscribeToNewsletterText_contains?: InputMaybe<Scalars['String']['input']>;
  subscribeToNewsletterText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subscribeToNewsletterText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscribeToNewsletterText_not?: InputMaybe<Scalars['String']['input']>;
  subscribeToNewsletterText_not_contains?: InputMaybe<Scalars['String']['input']>;
  subscribeToNewsletterText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulFooterLinkingCollections = {
  __typename?: 'FooterLinkingCollections';
  defaultLayoutCollection?: Maybe<ContentfulDefaultLayoutCollection>;
  defaultLayoutCursorCollection?: Maybe<ContentfulDefaultLayoutCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
};


export type ContentfulFooterLinkingCollectionsDefaultLayoutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterLinkingCollectionsDefaultLayoutCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFooterLinkingCollectionsDefaultLayoutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterLinkingCollectionsDefaultLayoutCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFooterLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFooterLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFooterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFooterLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFooterLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFooterLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFooterLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFooterLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFooterLinkingCollectionsDefaultLayoutCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFooterLinkingCollectionsDefaultLayoutCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFooterLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulFooterLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulFooterLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFooterLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFooterLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFooterLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFooterMenuItemsCollection = {
  __typename?: 'FooterMenuItemsCollection';
  items: Array<Maybe<ContentfulMainMenuItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulFooterMenuItemsCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulFooterMenuItemsCursorCollection = {
  __typename?: 'FooterMenuItemsCursorCollection';
  items: Array<Maybe<ContentfulMainMenuItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulFooterMenuItemsCursorCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulFooterOrder =
  | 'contactLinkAriaLabel_ASC'
  | 'contactLinkAriaLabel_DESC'
  | 'contactLinkText_ASC'
  | 'contactLinkText_DESC'
  | 'contactLinkUrl_ASC'
  | 'contactLinkUrl_DESC'
  | 'copyrightText_ASC'
  | 'copyrightText_DESC'
  | 'displayContactInformation_ASC'
  | 'displayContactInformation_DESC'
  | 'displayNewsletterSubscribe_ASC'
  | 'displayNewsletterSubscribe_DESC'
  | 'displayRegionSelector_ASC'
  | 'displayRegionSelector_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'logoHeightDesktop_ASC'
  | 'logoHeightDesktop_DESC'
  | 'logoHeightMobile_ASC'
  | 'logoHeightMobile_DESC'
  | 'logoLink_ASC'
  | 'logoLink_DESC'
  | 'logoWidthDesktop_ASC'
  | 'logoWidthDesktop_DESC'
  | 'logoWidthMobile_ASC'
  | 'logoWidthMobile_DESC'
  | 'regionSelectorLabel_ASC'
  | 'regionSelectorLabel_DESC'
  | 'socialFacebookUrl_ASC'
  | 'socialFacebookUrl_DESC'
  | 'socialInstagramUrl_ASC'
  | 'socialInstagramUrl_DESC'
  | 'socialLineUrl_ASC'
  | 'socialLineUrl_DESC'
  | 'socialNetworkLabel_ASC'
  | 'socialNetworkLabel_DESC'
  | 'socialPinterestUrl_ASC'
  | 'socialPinterestUrl_DESC'
  | 'socialStravaUrl_ASC'
  | 'socialStravaUrl_DESC'
  | 'socialTiktokUrl_ASC'
  | 'socialTiktokUrl_DESC'
  | 'socialXTwitterUrl_ASC'
  | 'socialXTwitterUrl_DESC'
  | 'socialYoutubeUrl_ASC'
  | 'socialYoutubeUrl_DESC'
  | 'subscribeToNewsletterText_ASC'
  | 'subscribeToNewsletterText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFooterSecondaryMenuItemsCollection = {
  __typename?: 'FooterSecondaryMenuItemsCollection';
  items: Array<Maybe<ContentfulMainMenuItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulFooterSecondaryMenuItemsCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulFooterSecondaryMenuItemsCursorCollection = {
  __typename?: 'FooterSecondaryMenuItemsCursorCollection';
  items: Array<Maybe<ContentfulMainMenuItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulFooterSecondaryMenuItemsCursorCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/freeTextContent) */
export type ContentfulFreeTextContent = ContentfulEntry & Contentful_Node & {
  __typename?: 'FreeTextContent';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulFreeTextContentLinkingCollections>;
  sys: ContentfulSys;
  textContent?: Maybe<ContentfulFreeTextContentTextContent>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/freeTextContent) */
export type ContentfulFreeTextContentInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/freeTextContent) */
export type ContentfulFreeTextContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/freeTextContent) */
export type ContentfulFreeTextContentTextContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFreeTextContentCollection = {
  __typename?: 'FreeTextContentCollection';
  items: Array<Maybe<ContentfulFreeTextContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulFreeTextContentCursorCollection = {
  __typename?: 'FreeTextContentCursorCollection';
  items: Array<Maybe<ContentfulFreeTextContent>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulFreeTextContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  textContent_contains?: InputMaybe<Scalars['String']['input']>;
  textContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textContent_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type ContentfulFreeTextContentLinkingCollections = {
  __typename?: 'FreeTextContentLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  gridCollection?: Maybe<ContentfulGridCollection>;
  gridCursorCollection?: Maybe<ContentfulGridCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulFreeTextContentLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentLinkingCollectionsGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentLinkingCollectionsGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulFreeTextContentLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulFreeTextContentLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFreeTextContentLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFreeTextContentLinkingCollectionsGridCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulFreeTextContentLinkingCollectionsGridCursorCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulFreeTextContentLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFreeTextContentLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFreeTextContentLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFreeTextContentLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulFreeTextContentLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFreeTextContentLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFreeTextContentOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulFreeTextContentTextContent = {
  __typename?: 'FreeTextContentTextContent';
  json: Scalars['JSON']['output'];
  links: ContentfulFreeTextContentTextContentLinks;
};

export type ContentfulFreeTextContentTextContentAssets = {
  __typename?: 'FreeTextContentTextContentAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulFreeTextContentTextContentEntries = {
  __typename?: 'FreeTextContentTextContentEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulFreeTextContentTextContentLinks = {
  __typename?: 'FreeTextContentTextContentLinks';
  assets: ContentfulFreeTextContentTextContentAssets;
  entries: ContentfulFreeTextContentTextContentEntries;
  resources: ContentfulFreeTextContentTextContentResources;
};

export type ContentfulFreeTextContentTextContentResources = {
  __typename?: 'FreeTextContentTextContentResources';
  block: Array<ContentfulFreeTextContentTextContentResourcesBlock>;
  hyperlink: Array<ContentfulFreeTextContentTextContentResourcesHyperlink>;
  inline: Array<ContentfulFreeTextContentTextContentResourcesInline>;
};

export type ContentfulFreeTextContentTextContentResourcesBlock = ContentfulResourceLink & {
  __typename?: 'FreeTextContentTextContentResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulFreeTextContentTextContentResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'FreeTextContentTextContentResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulFreeTextContentTextContentResourcesInline = ContentfulResourceLink & {
  __typename?: 'FreeTextContentTextContentResourcesInline';
  sys: ContentfulResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGrid = ContentfulEntry & Contentful_Node & {
  __typename?: 'Grid';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['JSON']['output']>;
  col?: Maybe<Scalars['String']['output']>;
  colForMobile?: Maybe<Scalars['String']['output']>;
  colGap?: Maybe<Scalars['String']['output']>;
  contentAlignment?: Maybe<Scalars['String']['output']>;
  contentCollection?: Maybe<ContentfulGridContentCollection>;
  contentCursorCollection?: Maybe<ContentfulGridContentCursorCollection>;
  contentfulMetadata: ContentfulContentfulMetadata;
  entryEffect?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  isSlider?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ContentfulGridLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  maxWidth?: Maybe<Scalars['String']['output']>;
  paddingBottom?: Maybe<Scalars['String']['output']>;
  paddingTop?: Maybe<Scalars['String']['output']>;
  reverseDisplayOrderForMobile?: Maybe<Scalars['Boolean']['output']>;
  rowGap?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  visibleInDesktop?: Maybe<Scalars['Boolean']['output']>;
  visibleInMobile?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridColArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridColForMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridColGapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridContentAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulGridContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulGridContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridEntryEffectArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridIsSliderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridMaxWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridPaddingBottomArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridPaddingTopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridReverseDisplayOrderForMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridRowGapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridVisibleInDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/grid) */
export type ContentfulGridVisibleInMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulGridCollection = {
  __typename?: 'GridCollection';
  items: Array<Maybe<ContentfulGrid>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulGridContentCollection = {
  __typename?: 'GridContentCollection';
  items: Array<Maybe<ContentfulGridContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulGridContentCursorCollection = {
  __typename?: 'GridContentCursorCollection';
  items: Array<Maybe<ContentfulGridContentItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulGridContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulGridContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulGridContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulGridContentItem = ContentfulCard | ContentfulContentGroup | ContentfulFreeTextContent | ContentfulHeading | ContentfulImageWithFocalPoint | ContentfulProductCard | ContentfulSliderProductsManual;

export type ContentfulGridCursorCollection = {
  __typename?: 'GridCursorCollection';
  items: Array<Maybe<ContentfulGrid>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulGridFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulGridFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulGridFilter>>>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  col?: InputMaybe<Scalars['String']['input']>;
  colForMobile?: InputMaybe<Scalars['String']['input']>;
  colForMobile_contains?: InputMaybe<Scalars['String']['input']>;
  colForMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  colForMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colForMobile_not?: InputMaybe<Scalars['String']['input']>;
  colForMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  colForMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colGap?: InputMaybe<Scalars['String']['input']>;
  colGap_contains?: InputMaybe<Scalars['String']['input']>;
  colGap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  colGap_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colGap_not?: InputMaybe<Scalars['String']['input']>;
  colGap_not_contains?: InputMaybe<Scalars['String']['input']>;
  colGap_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  col_contains?: InputMaybe<Scalars['String']['input']>;
  col_exists?: InputMaybe<Scalars['Boolean']['input']>;
  col_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  col_not?: InputMaybe<Scalars['String']['input']>;
  col_not_contains?: InputMaybe<Scalars['String']['input']>;
  col_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<ContentfulCfcontentMultiTypeNestedFilter>;
  contentAlignment?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlignment_not?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  entryEffect?: InputMaybe<Scalars['Boolean']['input']>;
  entryEffect_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryEffect_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSlider?: InputMaybe<Scalars['Boolean']['input']>;
  isSlider_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isSlider_not?: InputMaybe<Scalars['Boolean']['input']>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maxWidth?: InputMaybe<Scalars['String']['input']>;
  maxWidth_contains?: InputMaybe<Scalars['String']['input']>;
  maxWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maxWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxWidth_not?: InputMaybe<Scalars['String']['input']>;
  maxWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  maxWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paddingBottom?: InputMaybe<Scalars['String']['input']>;
  paddingBottom_contains?: InputMaybe<Scalars['String']['input']>;
  paddingBottom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  paddingBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paddingBottom_not?: InputMaybe<Scalars['String']['input']>;
  paddingBottom_not_contains?: InputMaybe<Scalars['String']['input']>;
  paddingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paddingTop?: InputMaybe<Scalars['String']['input']>;
  paddingTop_contains?: InputMaybe<Scalars['String']['input']>;
  paddingTop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  paddingTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paddingTop_not?: InputMaybe<Scalars['String']['input']>;
  paddingTop_not_contains?: InputMaybe<Scalars['String']['input']>;
  paddingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reverseDisplayOrderForMobile?: InputMaybe<Scalars['Boolean']['input']>;
  reverseDisplayOrderForMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reverseDisplayOrderForMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  rowGap?: InputMaybe<Scalars['String']['input']>;
  rowGap_contains?: InputMaybe<Scalars['String']['input']>;
  rowGap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  rowGap_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rowGap_not?: InputMaybe<Scalars['String']['input']>;
  rowGap_not_contains?: InputMaybe<Scalars['String']['input']>;
  rowGap_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  visibleInDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulGridLinkingCollections = {
  __typename?: 'GridLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  contentGroupCollection?: Maybe<ContentfulContentGroupCollection>;
  contentGroupCursorCollection?: Maybe<ContentfulContentGroupCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulGridLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsContentGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridLinkingCollectionsContentGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsContentGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridLinkingCollectionsContentGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulGridLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulGridLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulGridLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulGridLinkingCollectionsContentGroupCollectionOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulGridLinkingCollectionsContentGroupCursorCollectionOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulGridLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulGridLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulGridLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulGridLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulGridLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulGridLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulGridOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heading) */
export type ContentfulHeading = ContentfulEntry & Contentful_Node & {
  __typename?: 'Heading';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  headingSeoTag?: Maybe<Scalars['String']['output']>;
  headingType?: Maybe<Scalars['String']['output']>;
  headingVariation?: Maybe<Scalars['String']['output']>;
  highlightColor?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulHeadingLinkingCollections>;
  mainColor?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  text?: Maybe<Scalars['String']['output']>;
  textAlignment?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heading) */
export type ContentfulHeadingHeadingSeoTagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heading) */
export type ContentfulHeadingHeadingTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heading) */
export type ContentfulHeadingHeadingVariationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heading) */
export type ContentfulHeadingHighlightColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heading) */
export type ContentfulHeadingLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heading) */
export type ContentfulHeadingMainColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heading) */
export type ContentfulHeadingTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heading) */
export type ContentfulHeadingTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulHeadingCollection = {
  __typename?: 'HeadingCollection';
  items: Array<Maybe<ContentfulHeading>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulHeadingCursorCollection = {
  __typename?: 'HeadingCursorCollection';
  items: Array<Maybe<ContentfulHeading>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulHeadingFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulHeadingFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulHeadingFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  headingSeoTag?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_contains?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSeoTag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingSeoTag_not?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingType?: InputMaybe<Scalars['String']['input']>;
  headingType_contains?: InputMaybe<Scalars['String']['input']>;
  headingType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingType_not?: InputMaybe<Scalars['String']['input']>;
  headingType_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingVariation?: InputMaybe<Scalars['String']['input']>;
  headingVariation_contains?: InputMaybe<Scalars['String']['input']>;
  headingVariation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingVariation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingVariation_not?: InputMaybe<Scalars['String']['input']>;
  headingVariation_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingVariation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  highlightColor?: InputMaybe<Scalars['String']['input']>;
  highlightColor_contains?: InputMaybe<Scalars['String']['input']>;
  highlightColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  highlightColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  highlightColor_not?: InputMaybe<Scalars['String']['input']>;
  highlightColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  highlightColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainColor?: InputMaybe<Scalars['String']['input']>;
  mainColor_contains?: InputMaybe<Scalars['String']['input']>;
  mainColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mainColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainColor_not?: InputMaybe<Scalars['String']['input']>;
  mainColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  mainColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulHeadingLinkingCollections = {
  __typename?: 'HeadingLinkingCollections';
  cardCollection?: Maybe<ContentfulCardCollection>;
  cardCursorCollection?: Maybe<ContentfulCardCursorCollection>;
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  contactUsCollection?: Maybe<ContentfulContactUsCollection>;
  contactUsCursorCollection?: Maybe<ContentfulContactUsCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  faqWrapCollection?: Maybe<ContentfulFaqWrapCollection>;
  faqWrapCursorCollection?: Maybe<ContentfulFaqWrapCursorCollection>;
  gridCollection?: Maybe<ContentfulGridCollection>;
  gridCursorCollection?: Maybe<ContentfulGridCursorCollection>;
  heroProductListingCollection?: Maybe<ContentfulHeroProductListingCollection>;
  heroProductListingCursorCollection?: Maybe<ContentfulHeroProductListingCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
  placeholderModelStoryCollection?: Maybe<ContentfulPlaceholderModelStoryCollection>;
  placeholderModelStoryCursorCollection?: Maybe<ContentfulPlaceholderModelStoryCursorCollection>;
  placeholderServiceCollection?: Maybe<ContentfulPlaceholderServiceCollection>;
  placeholderServiceCursorCollection?: Maybe<ContentfulPlaceholderServiceCursorCollection>;
  placeholderStoresCollection?: Maybe<ContentfulPlaceholderStoresCollection>;
  placeholderStoresCursorCollection?: Maybe<ContentfulPlaceholderStoresCursorCollection>;
  servicesCollectionCollection?: Maybe<ContentfulServicesCollectionCollection>;
  servicesCollectionCursorCollection?: Maybe<ContentfulServicesCollectionCursorCollection>;
  sliderProductsManualCollection?: Maybe<ContentfulSliderProductsManualCollection>;
  sliderProductsManualCursorCollection?: Maybe<ContentfulSliderProductsManualCursorCollection>;
};


export type ContentfulHeadingLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsContactUsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsContactUsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsContactUsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsContactUsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsFaqWrapCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsFaqWrapCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsFaqWrapCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsFaqWrapCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsHeroProductListingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsHeroProductListingCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsHeroProductListingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsHeroProductListingCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPlaceholderModelStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPlaceholderModelStoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPlaceholderModelStoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPlaceholderModelStoryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPlaceholderServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPlaceholderServiceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPlaceholderServiceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPlaceholderServiceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPlaceholderStoresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPlaceholderStoresCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsPlaceholderStoresCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsPlaceholderStoresCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsServicesCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsServicesCollectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsServicesCollectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsServicesCollectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsSliderProductsManualCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsSliderProductsManualCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeadingLinkingCollectionsSliderProductsManualCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingLinkingCollectionsSliderProductsManualCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulHeadingLinkingCollectionsCardCollectionOrder =
  | 'backgroundAlignment_ASC'
  | 'backgroundAlignment_DESC'
  | 'backgroundPosition_ASC'
  | 'backgroundPosition_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'contentOption_ASC'
  | 'contentOption_DESC'
  | 'countdownToDatetime_ASC'
  | 'countdownToDatetime_DESC'
  | 'countdown_ASC'
  | 'countdown_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAnimationEffect_ASC'
  | 'mediaAnimationEffect_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'saleorProductSku_ASC'
  | 'saleorProductSku_DESC'
  | 'showMore_ASC'
  | 'showMore_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1ariaLabel_ASC'
  | 'url1ariaLabel_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Text_ASC'
  | 'url2Text_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2ariaLabel_ASC'
  | 'url2ariaLabel_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulHeadingLinkingCollectionsCardCursorCollectionOrder =
  | 'backgroundAlignment_ASC'
  | 'backgroundAlignment_DESC'
  | 'backgroundPosition_ASC'
  | 'backgroundPosition_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'contentOption_ASC'
  | 'contentOption_DESC'
  | 'countdownToDatetime_ASC'
  | 'countdownToDatetime_DESC'
  | 'countdown_ASC'
  | 'countdown_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAnimationEffect_ASC'
  | 'mediaAnimationEffect_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'saleorProductSku_ASC'
  | 'saleorProductSku_DESC'
  | 'showMore_ASC'
  | 'showMore_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1ariaLabel_ASC'
  | 'url1ariaLabel_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Text_ASC'
  | 'url2Text_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2ariaLabel_ASC'
  | 'url2ariaLabel_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulHeadingLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeadingLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeadingLinkingCollectionsContactUsCollectionOrder =
  | 'email_ASC'
  | 'email_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'phone_ASC'
  | 'phone_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsContactUsCursorCollectionOrder =
  | 'email_ASC'
  | 'email_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'phone_ASC'
  | 'phone_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsFaqWrapCollectionOrder =
  | 'collapse_ASC'
  | 'collapse_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeadingLinkingCollectionsFaqWrapCursorCollectionOrder =
  | 'collapse_ASC'
  | 'collapse_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeadingLinkingCollectionsGridCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulHeadingLinkingCollectionsGridCursorCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulHeadingLinkingCollectionsHeroProductListingCollectionOrder =
  | 'backgroundColorOpacity_ASC'
  | 'backgroundColorOpacity_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'headingNumberOfColoredWords_ASC'
  | 'headingNumberOfColoredWords_DESC'
  | 'headingSeoTag_ASC'
  | 'headingSeoTag_DESC'
  | 'headingStyle_ASC'
  | 'headingStyle_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'showBreadcrumbs_ASC'
  | 'showBreadcrumbs_DESC'
  | 'showFilters_ASC'
  | 'showFilters_DESC'
  | 'subheaderIsCapitalized_ASC'
  | 'subheaderIsCapitalized_DESC'
  | 'subheading_ASC'
  | 'subheading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textBelowMedia_ASC'
  | 'textBelowMedia_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'url2text_ASC'
  | 'url2text_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulHeadingLinkingCollectionsHeroProductListingCursorCollectionOrder =
  | 'backgroundColorOpacity_ASC'
  | 'backgroundColorOpacity_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'headingNumberOfColoredWords_ASC'
  | 'headingNumberOfColoredWords_DESC'
  | 'headingSeoTag_ASC'
  | 'headingSeoTag_DESC'
  | 'headingStyle_ASC'
  | 'headingStyle_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'showBreadcrumbs_ASC'
  | 'showBreadcrumbs_DESC'
  | 'showFilters_ASC'
  | 'showFilters_DESC'
  | 'subheaderIsCapitalized_ASC'
  | 'subheaderIsCapitalized_DESC'
  | 'subheading_ASC'
  | 'subheading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textBelowMedia_ASC'
  | 'textBelowMedia_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'url2text_ASC'
  | 'url2text_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulHeadingLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeadingLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeadingLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeadingLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeadingLinkingCollectionsPlaceholderModelStoryCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAlignment_ASC'
  | 'mediaAlignment_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsPlaceholderModelStoryCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAlignment_ASC'
  | 'mediaAlignment_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsPlaceholderServiceCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsPlaceholderServiceCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsPlaceholderStoresCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyewearAvailable_ASC'
  | 'eyewearAvailable_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'numberOfStores_ASC'
  | 'numberOfStores_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsPlaceholderStoresCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyewearAvailable_ASC'
  | 'eyewearAvailable_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'numberOfStores_ASC'
  | 'numberOfStores_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsServicesCollectionCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeadingLinkingCollectionsServicesCollectionCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeadingLinkingCollectionsSliderProductsManualCollectionOrder =
  | 'ctaAriaLabel_ASC'
  | 'ctaAriaLabel_DESC'
  | 'ctaStyle_ASC'
  | 'ctaStyle_DESC'
  | 'ctaText_ASC'
  | 'ctaText_DESC'
  | 'ctaUrl_ASC'
  | 'ctaUrl_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'showCta_ASC'
  | 'showCta_DESC'
  | 'showLabel_ASC'
  | 'showLabel_DESC'
  | 'showName_ASC'
  | 'showName_DESC'
  | 'showPrice_ASC'
  | 'showPrice_DESC'
  | 'showWishlist_ASC'
  | 'showWishlist_DESC'
  | 'slidesPerViewForMobile_ASC'
  | 'slidesPerViewForMobile_DESC'
  | 'slidesPerView_ASC'
  | 'slidesPerView_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingLinkingCollectionsSliderProductsManualCursorCollectionOrder =
  | 'ctaAriaLabel_ASC'
  | 'ctaAriaLabel_DESC'
  | 'ctaStyle_ASC'
  | 'ctaStyle_DESC'
  | 'ctaText_ASC'
  | 'ctaText_DESC'
  | 'ctaUrl_ASC'
  | 'ctaUrl_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'showCta_ASC'
  | 'showCta_DESC'
  | 'showLabel_ASC'
  | 'showLabel_DESC'
  | 'showName_ASC'
  | 'showName_DESC'
  | 'showPrice_ASC'
  | 'showPrice_DESC'
  | 'showWishlist_ASC'
  | 'showWishlist_DESC'
  | 'slidesPerViewForMobile_ASC'
  | 'slidesPerViewForMobile_DESC'
  | 'slidesPerView_ASC'
  | 'slidesPerView_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeadingOrder =
  | 'headingSeoTag_ASC'
  | 'headingSeoTag_DESC'
  | 'headingType_ASC'
  | 'headingType_DESC'
  | 'headingVariation_ASC'
  | 'headingVariation_DESC'
  | 'highlightColor_ASC'
  | 'highlightColor_DESC'
  | 'mainColor_ASC'
  | 'mainColor_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'text_ASC'
  | 'text_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListing = ContentfulEntry & Contentful_Node & {
  __typename?: 'HeroProductListing';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['JSON']['output']>;
  backgroundColorOpacity?: Maybe<Scalars['String']['output']>;
  collectionItemsCollection?: Maybe<ContentfulHeroProductListingCollectionItemsCollection>;
  collectionItemsCursorCollection?: Maybe<ContentfulHeroProductListingCollectionItemsCursorCollection>;
  contentAlignment?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  heading?: Maybe<Scalars['String']['output']>;
  headingNumberOfColoredWords?: Maybe<Scalars['Int']['output']>;
  headingSeoTag?: Maybe<Scalars['String']['output']>;
  headingStyle?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulHeroProductListingLinkingCollections>;
  media?: Maybe<ContentfulImageWithFocalPoint>;
  openUrl2InNewTab?: Maybe<Scalars['Boolean']['output']>;
  openUrlInNewTab?: Maybe<Scalars['Boolean']['output']>;
  showBreadcrumbs?: Maybe<Scalars['Boolean']['output']>;
  showFilters?: Maybe<Scalars['Boolean']['output']>;
  subheader?: Maybe<Scalars['String']['output']>;
  subheaderIsCapitalized?: Maybe<Scalars['Boolean']['output']>;
  subheading?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  text?: Maybe<ContentfulHeroProductListingText>;
  textAlignment?: Maybe<Scalars['String']['output']>;
  textBelowMedia?: Maybe<Scalars['Boolean']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<ContentfulHeading>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  url1EventType?: Maybe<Scalars['String']['output']>;
  url2?: Maybe<Scalars['String']['output']>;
  url2EventType?: Maybe<Scalars['String']['output']>;
  url2Text?: Maybe<Scalars['String']['output']>;
  url2Type?: Maybe<Scalars['String']['output']>;
  urlDirection?: Maybe<Scalars['String']['output']>;
  urlPosition?: Maybe<Scalars['String']['output']>;
  urlText?: Maybe<Scalars['String']['output']>;
  urlType?: Maybe<Scalars['String']['output']>;
  visibleInDesktop?: Maybe<Scalars['Boolean']['output']>;
  visibleInMobile?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingBackgroundColorOpacityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingCollectionItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroProductListingCollectionItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCollectionItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingCollectionItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroProductListingCollectionItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCollectionItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingContentAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingHeadingNumberOfColoredWordsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingHeadingSeoTagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingHeadingStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingOpenUrl2InNewTabArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingOpenUrlInNewTabArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingShowBreadcrumbsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingShowFiltersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingSubheaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingSubheaderIsCapitalizedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingSubheadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingTextBelowMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingTextColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingUrl1EventTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingUrl2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingUrl2EventTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingUrl2TextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingUrl2TypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingUrlDirectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingUrlPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingUrlTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingUrlTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingVisibleInDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroProductListing) */
export type ContentfulHeroProductListingVisibleInMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulHeroProductListingCollection = {
  __typename?: 'HeroProductListingCollection';
  items: Array<Maybe<ContentfulHeroProductListing>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulHeroProductListingCollectionItemsCollection = {
  __typename?: 'HeroProductListingCollectionItemsCollection';
  items: Array<Maybe<ContentfulCollectionItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulHeroProductListingCollectionItemsCollectionOrder =
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeroProductListingCollectionItemsCursorCollection = {
  __typename?: 'HeroProductListingCollectionItemsCursorCollection';
  items: Array<Maybe<ContentfulCollectionItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulHeroProductListingCollectionItemsCursorCollectionOrder =
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeroProductListingCursorCollection = {
  __typename?: 'HeroProductListingCursorCollection';
  items: Array<Maybe<ContentfulHeroProductListing>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulHeroProductListingFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulHeroProductListingFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulHeroProductListingFilter>>>;
  backgroundColorOpacity?: InputMaybe<Scalars['String']['input']>;
  backgroundColorOpacity_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColorOpacity_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColorOpacity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColorOpacity_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColorOpacity_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColorOpacity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  collectionItems?: InputMaybe<ContentfulCfCollectionItemNestedFilter>;
  collectionItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlignment?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlignment_not?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  heading?: InputMaybe<Scalars['String']['input']>;
  headingNumberOfColoredWords?: InputMaybe<Scalars['Int']['input']>;
  headingNumberOfColoredWords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingNumberOfColoredWords_gt?: InputMaybe<Scalars['Int']['input']>;
  headingNumberOfColoredWords_gte?: InputMaybe<Scalars['Int']['input']>;
  headingNumberOfColoredWords_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  headingNumberOfColoredWords_lt?: InputMaybe<Scalars['Int']['input']>;
  headingNumberOfColoredWords_lte?: InputMaybe<Scalars['Int']['input']>;
  headingNumberOfColoredWords_not?: InputMaybe<Scalars['Int']['input']>;
  headingNumberOfColoredWords_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  headingSeoTag?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_contains?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSeoTag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingSeoTag_not?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingStyle?: InputMaybe<Scalars['String']['input']>;
  headingStyle_contains?: InputMaybe<Scalars['String']['input']>;
  headingStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingStyle_not?: InputMaybe<Scalars['String']['input']>;
  headingStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media?: InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrl2InNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openUrl2InNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrl2InNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  showBreadcrumbs?: InputMaybe<Scalars['Boolean']['input']>;
  showBreadcrumbs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showBreadcrumbs_not?: InputMaybe<Scalars['Boolean']['input']>;
  showFilters?: InputMaybe<Scalars['Boolean']['input']>;
  showFilters_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showFilters_not?: InputMaybe<Scalars['Boolean']['input']>;
  subheader?: InputMaybe<Scalars['String']['input']>;
  subheaderIsCapitalized?: InputMaybe<Scalars['Boolean']['input']>;
  subheaderIsCapitalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheaderIsCapitalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  subheader_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheader_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheader_not?: InputMaybe<Scalars['String']['input']>;
  subheader_not_contains?: InputMaybe<Scalars['String']['input']>;
  subheader_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  subheading_contains?: InputMaybe<Scalars['String']['input']>;
  subheading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subheading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheading_not?: InputMaybe<Scalars['String']['input']>;
  subheading_not_contains?: InputMaybe<Scalars['String']['input']>;
  subheading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textBelowMedia?: InputMaybe<Scalars['Boolean']['input']>;
  textBelowMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textBelowMedia_not?: InputMaybe<Scalars['Boolean']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  textColor_contains?: InputMaybe<Scalars['String']['input']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textColor_not?: InputMaybe<Scalars['String']['input']>;
  textColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<ContentfulCfHeadingNestedFilter>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url1eventType?: InputMaybe<Scalars['String']['input']>;
  url1eventType_contains?: InputMaybe<Scalars['String']['input']>;
  url1eventType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url1eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url1eventType_not?: InputMaybe<Scalars['String']['input']>;
  url1eventType_not_contains?: InputMaybe<Scalars['String']['input']>;
  url1eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2?: InputMaybe<Scalars['String']['input']>;
  url2Type?: InputMaybe<Scalars['String']['input']>;
  url2Type_contains?: InputMaybe<Scalars['String']['input']>;
  url2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2Type_not?: InputMaybe<Scalars['String']['input']>;
  url2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2_contains?: InputMaybe<Scalars['String']['input']>;
  url2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2_not?: InputMaybe<Scalars['String']['input']>;
  url2_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2eventType?: InputMaybe<Scalars['String']['input']>;
  url2eventType_contains?: InputMaybe<Scalars['String']['input']>;
  url2eventType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2eventType_not?: InputMaybe<Scalars['String']['input']>;
  url2eventType_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2text?: InputMaybe<Scalars['String']['input']>;
  url2text_contains?: InputMaybe<Scalars['String']['input']>;
  url2text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2text_not?: InputMaybe<Scalars['String']['input']>;
  url2text_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlDirection?: InputMaybe<Scalars['String']['input']>;
  urlDirection_contains?: InputMaybe<Scalars['String']['input']>;
  urlDirection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlDirection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlDirection_not?: InputMaybe<Scalars['String']['input']>;
  urlDirection_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlDirection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlPosition?: InputMaybe<Scalars['String']['input']>;
  urlPosition_contains?: InputMaybe<Scalars['String']['input']>;
  urlPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlPosition_not?: InputMaybe<Scalars['String']['input']>;
  urlPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  urlText_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText_not?: InputMaybe<Scalars['String']['input']>;
  urlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlType?: InputMaybe<Scalars['String']['input']>;
  urlType_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlType_not?: InputMaybe<Scalars['String']['input']>;
  urlType_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibleInDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulHeroProductListingLinkingCollections = {
  __typename?: 'HeroProductListingLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
};


export type ContentfulHeroProductListingLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroProductListingLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroProductListingLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroProductListingLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroProductListingLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroProductListingLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulHeroProductListingLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeroProductListingLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeroProductListingOrder =
  | 'backgroundColorOpacity_ASC'
  | 'backgroundColorOpacity_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'headingNumberOfColoredWords_ASC'
  | 'headingNumberOfColoredWords_DESC'
  | 'headingSeoTag_ASC'
  | 'headingSeoTag_DESC'
  | 'headingStyle_ASC'
  | 'headingStyle_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'showBreadcrumbs_ASC'
  | 'showBreadcrumbs_DESC'
  | 'showFilters_ASC'
  | 'showFilters_DESC'
  | 'subheaderIsCapitalized_ASC'
  | 'subheaderIsCapitalized_DESC'
  | 'subheading_ASC'
  | 'subheading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textBelowMedia_ASC'
  | 'textBelowMedia_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'url2text_ASC'
  | 'url2text_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulHeroProductListingText = {
  __typename?: 'HeroProductListingText';
  json: Scalars['JSON']['output'];
  links: ContentfulHeroProductListingTextLinks;
};

export type ContentfulHeroProductListingTextAssets = {
  __typename?: 'HeroProductListingTextAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulHeroProductListingTextEntries = {
  __typename?: 'HeroProductListingTextEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulHeroProductListingTextLinks = {
  __typename?: 'HeroProductListingTextLinks';
  assets: ContentfulHeroProductListingTextAssets;
  entries: ContentfulHeroProductListingTextEntries;
  resources: ContentfulHeroProductListingTextResources;
};

export type ContentfulHeroProductListingTextResources = {
  __typename?: 'HeroProductListingTextResources';
  block: Array<ContentfulHeroProductListingTextResourcesBlock>;
  hyperlink: Array<ContentfulHeroProductListingTextResourcesHyperlink>;
  inline: Array<ContentfulHeroProductListingTextResourcesInline>;
};

export type ContentfulHeroProductListingTextResourcesBlock = ContentfulResourceLink & {
  __typename?: 'HeroProductListingTextResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulHeroProductListingTextResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'HeroProductListingTextResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulHeroProductListingTextResourcesInline = ContentfulResourceLink & {
  __typename?: 'HeroProductListingTextResourcesInline';
  sys: ContentfulResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroSlider) */
export type ContentfulHeroSlider = ContentfulEntry & Contentful_Node & {
  __typename?: 'HeroSlider';
  _id: Scalars['ID']['output'];
  autoslide?: Maybe<Scalars['Boolean']['output']>;
  autoslideDurationMs?: Maybe<Scalars['Int']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  fixToTop?: Maybe<Scalars['Boolean']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulHeroSliderLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  slidesCollection?: Maybe<ContentfulHeroSliderSlidesCollection>;
  slidesCursorCollection?: Maybe<ContentfulHeroSliderSlidesCursorCollection>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroSlider) */
export type ContentfulHeroSliderAutoslideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroSlider) */
export type ContentfulHeroSliderAutoslideDurationMsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroSlider) */
export type ContentfulHeroSliderFixToTopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroSlider) */
export type ContentfulHeroSliderInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroSlider) */
export type ContentfulHeroSliderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroSlider) */
export type ContentfulHeroSliderLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroSlider) */
export type ContentfulHeroSliderSlidesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderSlidesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/heroSlider) */
export type ContentfulHeroSliderSlidesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderSlidesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCardFilter>;
};

export type ContentfulHeroSliderCollection = {
  __typename?: 'HeroSliderCollection';
  items: Array<Maybe<ContentfulHeroSlider>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulHeroSliderCursorCollection = {
  __typename?: 'HeroSliderCursorCollection';
  items: Array<Maybe<ContentfulHeroSlider>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulHeroSliderFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderFilter>>>;
  autoslide?: InputMaybe<Scalars['Boolean']['input']>;
  autoslideDurationMs?: InputMaybe<Scalars['Int']['input']>;
  autoslideDurationMs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  autoslideDurationMs_gt?: InputMaybe<Scalars['Int']['input']>;
  autoslideDurationMs_gte?: InputMaybe<Scalars['Int']['input']>;
  autoslideDurationMs_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  autoslideDurationMs_lt?: InputMaybe<Scalars['Int']['input']>;
  autoslideDurationMs_lte?: InputMaybe<Scalars['Int']['input']>;
  autoslideDurationMs_not?: InputMaybe<Scalars['Int']['input']>;
  autoslideDurationMs_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  autoslide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  autoslide_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  fixToTop?: InputMaybe<Scalars['Boolean']['input']>;
  fixToTop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fixToTop_not?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slides?: InputMaybe<ContentfulCfCardNestedFilter>;
  slidesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulHeroSliderLinkingCollections = {
  __typename?: 'HeroSliderLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
};


export type ContentfulHeroSliderLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroSliderLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroSliderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroSliderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroSliderLinkingCollectionsPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderLinkingCollectionsPageBoutiqueDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroSliderLinkingCollectionsPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroSliderLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroSliderLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroSliderLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulHeroSliderLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulHeroSliderLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeroSliderLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeroSliderLinkingCollectionsPageBoutiqueDetailCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeroSliderLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeroSliderLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeroSliderLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeroSliderLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeroSliderLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulHeroSliderOrder =
  | 'autoslideDurationMs_ASC'
  | 'autoslideDurationMs_DESC'
  | 'autoslide_ASC'
  | 'autoslide_DESC'
  | 'fixToTop_ASC'
  | 'fixToTop_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulHeroSliderSlidesCollection = {
  __typename?: 'HeroSliderSlidesCollection';
  items: Array<Maybe<ContentfulCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulHeroSliderSlidesCollectionOrder =
  | 'backgroundAlignment_ASC'
  | 'backgroundAlignment_DESC'
  | 'backgroundPosition_ASC'
  | 'backgroundPosition_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'contentOption_ASC'
  | 'contentOption_DESC'
  | 'countdownToDatetime_ASC'
  | 'countdownToDatetime_DESC'
  | 'countdown_ASC'
  | 'countdown_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAnimationEffect_ASC'
  | 'mediaAnimationEffect_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'saleorProductSku_ASC'
  | 'saleorProductSku_DESC'
  | 'showMore_ASC'
  | 'showMore_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1ariaLabel_ASC'
  | 'url1ariaLabel_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Text_ASC'
  | 'url2Text_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2ariaLabel_ASC'
  | 'url2ariaLabel_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulHeroSliderSlidesCursorCollection = {
  __typename?: 'HeroSliderSlidesCursorCollection';
  items: Array<Maybe<ContentfulCard>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulHeroSliderSlidesCursorCollectionOrder =
  | 'backgroundAlignment_ASC'
  | 'backgroundAlignment_DESC'
  | 'backgroundPosition_ASC'
  | 'backgroundPosition_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'contentOption_ASC'
  | 'contentOption_DESC'
  | 'countdownToDatetime_ASC'
  | 'countdownToDatetime_DESC'
  | 'countdown_ASC'
  | 'countdown_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAnimationEffect_ASC'
  | 'mediaAnimationEffect_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'saleorProductSku_ASC'
  | 'saleorProductSku_DESC'
  | 'showMore_ASC'
  | 'showMore_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1ariaLabel_ASC'
  | 'url1ariaLabel_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Text_ASC'
  | 'url2Text_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2ariaLabel_ASC'
  | 'url2ariaLabel_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/iframe) */
export type ContentfulIframe = ContentfulEntry & Contentful_Node & {
  __typename?: 'Iframe';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  hasScrollbar?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulIframeLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  maxWidth?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  url?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/iframe) */
export type ContentfulIframeHasScrollbarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/iframe) */
export type ContentfulIframeHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/iframe) */
export type ContentfulIframeInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/iframe) */
export type ContentfulIframeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/iframe) */
export type ContentfulIframeLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/iframe) */
export type ContentfulIframeMaxWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/iframe) */
export type ContentfulIframeUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulIframeCollection = {
  __typename?: 'IframeCollection';
  items: Array<Maybe<ContentfulIframe>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulIframeCursorCollection = {
  __typename?: 'IframeCursorCollection';
  items: Array<Maybe<ContentfulIframe>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulIframeFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulIframeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulIframeFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  hasScrollbar?: InputMaybe<Scalars['Boolean']['input']>;
  hasScrollbar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasScrollbar_not?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  height_contains?: InputMaybe<Scalars['String']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height_not?: InputMaybe<Scalars['String']['input']>;
  height_not_contains?: InputMaybe<Scalars['String']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maxWidth?: InputMaybe<Scalars['String']['input']>;
  maxWidth_contains?: InputMaybe<Scalars['String']['input']>;
  maxWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maxWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxWidth_not?: InputMaybe<Scalars['String']['input']>;
  maxWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  maxWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulIframeLinkingCollections = {
  __typename?: 'IframeLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
};


export type ContentfulIframeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulIframeLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulIframeLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulIframeLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulIframeLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulIframeLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulIframeLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulIframeLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulIframeOrder =
  | 'hasScrollbar_ASC'
  | 'hasScrollbar_DESC'
  | 'height_ASC'
  | 'height_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type ContentfulImageFormat =
  /** AVIF image format. */
  | 'AVIF'
  /** JPG image format. */
  | 'JPG'
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  | 'JPG_PROGRESSIVE'
  /** PNG image format */
  | 'PNG'
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  | 'PNG8'
  /** WebP image format. */
  | 'WEBP';

export type ContentfulImageResizeFocus =
  /** Focus the resizing on the bottom. */
  | 'BOTTOM'
  /** Focus the resizing on the bottom left. */
  | 'BOTTOM_LEFT'
  /** Focus the resizing on the bottom right. */
  | 'BOTTOM_RIGHT'
  /** Focus the resizing on the center. */
  | 'CENTER'
  /** Focus the resizing on the largest face. */
  | 'FACE'
  /** Focus the resizing on the area containing all the faces. */
  | 'FACES'
  /** Focus the resizing on the left. */
  | 'LEFT'
  /** Focus the resizing on the right. */
  | 'RIGHT'
  /** Focus the resizing on the top. */
  | 'TOP'
  /** Focus the resizing on the top left. */
  | 'TOP_LEFT'
  /** Focus the resizing on the top right. */
  | 'TOP_RIGHT';

export type ContentfulImageResizeStrategy =
  /** Crops a part of the original image to fit into the specified dimensions. */
  | 'CROP'
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  | 'FILL'
  /** Resizes the image to fit into the specified dimensions. */
  | 'FIT'
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  | 'PAD'
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  | 'SCALE'
  /** Creates a thumbnail from the image. */
  | 'THUMB';

export type ContentfulImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ContentfulImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ContentfulImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ContentfulImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPoint = ContentfulEntry & Contentful_Node & {
  __typename?: 'ImageWithFocalPoint';
  _id: Scalars['ID']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  focalPoint?: Maybe<Scalars['JSON']['output']>;
  image?: Maybe<ContentfulAsset>;
  imageMobile?: Maybe<ContentfulAsset>;
  imageOnHover?: Maybe<ContentfulAsset>;
  imageOnHoverMobile?: Maybe<ContentfulAsset>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulImageWithFocalPointLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
  url?: Maybe<Scalars['String']['output']>;
  video?: Maybe<ContentfulAsset>;
  videoMobile?: Maybe<ContentfulAsset>;
  videoPlayOption?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointAltArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointFocalPointArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointImageOnHoverArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointImageOnHoverMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointVideoMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/imageWithFocalPoint) */
export type ContentfulImageWithFocalPointVideoPlayOptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulImageWithFocalPointCollection = {
  __typename?: 'ImageWithFocalPointCollection';
  items: Array<Maybe<ContentfulImageWithFocalPoint>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulImageWithFocalPointCursorCollection = {
  __typename?: 'ImageWithFocalPointCursorCollection';
  items: Array<Maybe<ContentfulImageWithFocalPoint>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulImageWithFocalPointFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointFilter>>>;
  alt?: InputMaybe<Scalars['String']['input']>;
  alt_contains?: InputMaybe<Scalars['String']['input']>;
  alt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alt_not?: InputMaybe<Scalars['String']['input']>;
  alt_not_contains?: InputMaybe<Scalars['String']['input']>;
  alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  focalPoint_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageOnHoverMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageOnHover_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoPlayOption?: InputMaybe<Scalars['String']['input']>;
  videoPlayOption_contains?: InputMaybe<Scalars['String']['input']>;
  videoPlayOption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoPlayOption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoPlayOption_not?: InputMaybe<Scalars['String']['input']>;
  videoPlayOption_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoPlayOption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulImageWithFocalPointLinkingCollections = {
  __typename?: 'ImageWithFocalPointLinkingCollections';
  bannerCollection?: Maybe<ContentfulBannerCollection>;
  bannerCursorCollection?: Maybe<ContentfulBannerCursorCollection>;
  bannerHeroCollection?: Maybe<ContentfulBannerHeroCollection>;
  bannerHeroCursorCollection?: Maybe<ContentfulBannerHeroCursorCollection>;
  cardCollection?: Maybe<ContentfulCardCollection>;
  cardCursorCollection?: Maybe<ContentfulCardCursorCollection>;
  collectionGroupEndImageCollection?: Maybe<ContentfulCollectionGroupEndImageCollection>;
  collectionGroupEndImageCursorCollection?: Maybe<ContentfulCollectionGroupEndImageCursorCollection>;
  collectionItemCollection?: Maybe<ContentfulCollectionItemCollection>;
  collectionItemCursorCollection?: Maybe<ContentfulCollectionItemCursorCollection>;
  contentGroupCollection?: Maybe<ContentfulContentGroupCollection>;
  contentGroupCursorCollection?: Maybe<ContentfulContentGroupCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  exhibitionItemCollection?: Maybe<ContentfulExhibitionItemCollection>;
  exhibitionItemCursorCollection?: Maybe<ContentfulExhibitionItemCursorCollection>;
  gridCollection?: Maybe<ContentfulGridCollection>;
  gridCursorCollection?: Maybe<ContentfulGridCursorCollection>;
  heroProductListingCollection?: Maybe<ContentfulHeroProductListingCollection>;
  heroProductListingCursorCollection?: Maybe<ContentfulHeroProductListingCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsBannerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsBannerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsBannerHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsBannerHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsBannerHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsBannerHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsCollectionGroupEndImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsCollectionGroupEndImageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsCollectionGroupEndImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsCollectionGroupEndImageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsCollectionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsCollectionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsCollectionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsCollectionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsContentGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsContentGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsContentGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsContentGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsExhibitionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsExhibitionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsExhibitionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsExhibitionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsHeroProductListingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsHeroProductListingCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsHeroProductListingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsHeroProductListingCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulImageWithFocalPointLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulImageWithFocalPointLinkingCollectionsBannerCollectionOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'imagePosition_ASC'
  | 'imagePosition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsBannerCursorCollectionOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'imagePosition_ASC'
  | 'imagePosition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsBannerHeroCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleSeoTag_ASC'
  | 'titleSeoTag_DESC'
  | 'titleStyle_ASC'
  | 'titleStyle_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsBannerHeroCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleSeoTag_ASC'
  | 'titleSeoTag_DESC'
  | 'titleStyle_ASC'
  | 'titleStyle_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsCardCollectionOrder =
  | 'backgroundAlignment_ASC'
  | 'backgroundAlignment_DESC'
  | 'backgroundPosition_ASC'
  | 'backgroundPosition_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'contentOption_ASC'
  | 'contentOption_DESC'
  | 'countdownToDatetime_ASC'
  | 'countdownToDatetime_DESC'
  | 'countdown_ASC'
  | 'countdown_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAnimationEffect_ASC'
  | 'mediaAnimationEffect_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'saleorProductSku_ASC'
  | 'saleorProductSku_DESC'
  | 'showMore_ASC'
  | 'showMore_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1ariaLabel_ASC'
  | 'url1ariaLabel_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Text_ASC'
  | 'url2Text_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2ariaLabel_ASC'
  | 'url2ariaLabel_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsCardCursorCollectionOrder =
  | 'backgroundAlignment_ASC'
  | 'backgroundAlignment_DESC'
  | 'backgroundPosition_ASC'
  | 'backgroundPosition_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'contentOption_ASC'
  | 'contentOption_DESC'
  | 'countdownToDatetime_ASC'
  | 'countdownToDatetime_DESC'
  | 'countdown_ASC'
  | 'countdown_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAnimationEffect_ASC'
  | 'mediaAnimationEffect_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'saleorProductSku_ASC'
  | 'saleorProductSku_DESC'
  | 'showMore_ASC'
  | 'showMore_DESC'
  | 'subHeading_ASC'
  | 'subHeading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1ariaLabel_ASC'
  | 'url1ariaLabel_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Text_ASC'
  | 'url2Text_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2ariaLabel_ASC'
  | 'url2ariaLabel_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsCollectionGroupEndImageCollectionOrder =
  | 'endImageLinkType_ASC'
  | 'endImageLinkType_DESC'
  | 'endImageUrlText_ASC'
  | 'endImageUrlText_DESC'
  | 'endImageUrl_ASC'
  | 'endImageUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsCollectionGroupEndImageCursorCollectionOrder =
  | 'endImageLinkType_ASC'
  | 'endImageLinkType_DESC'
  | 'endImageUrlText_ASC'
  | 'endImageUrlText_DESC'
  | 'endImageUrl_ASC'
  | 'endImageUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsCollectionItemCollectionOrder =
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsCollectionItemCursorCollectionOrder =
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsContentGroupCollectionOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsContentGroupCursorCollectionOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsExhibitionItemCollectionOrder =
  | 'boutiqueId_ASC'
  | 'boutiqueId_DESC'
  | 'endDate_ASC'
  | 'endDate_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'startDate_ASC'
  | 'startDate_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsExhibitionItemCursorCollectionOrder =
  | 'boutiqueId_ASC'
  | 'boutiqueId_DESC'
  | 'endDate_ASC'
  | 'endDate_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'startDate_ASC'
  | 'startDate_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsGridCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsGridCursorCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsHeroProductListingCollectionOrder =
  | 'backgroundColorOpacity_ASC'
  | 'backgroundColorOpacity_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'headingNumberOfColoredWords_ASC'
  | 'headingNumberOfColoredWords_DESC'
  | 'headingSeoTag_ASC'
  | 'headingSeoTag_DESC'
  | 'headingStyle_ASC'
  | 'headingStyle_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'showBreadcrumbs_ASC'
  | 'showBreadcrumbs_DESC'
  | 'showFilters_ASC'
  | 'showFilters_DESC'
  | 'subheaderIsCapitalized_ASC'
  | 'subheaderIsCapitalized_DESC'
  | 'subheading_ASC'
  | 'subheading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textBelowMedia_ASC'
  | 'textBelowMedia_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'url2text_ASC'
  | 'url2text_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsHeroProductListingCursorCollectionOrder =
  | 'backgroundColorOpacity_ASC'
  | 'backgroundColorOpacity_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'headingNumberOfColoredWords_ASC'
  | 'headingNumberOfColoredWords_DESC'
  | 'headingSeoTag_ASC'
  | 'headingSeoTag_DESC'
  | 'headingStyle_ASC'
  | 'headingStyle_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'openUrl2InNewTab_ASC'
  | 'openUrl2InNewTab_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'showBreadcrumbs_ASC'
  | 'showBreadcrumbs_DESC'
  | 'showFilters_ASC'
  | 'showFilters_DESC'
  | 'subheaderIsCapitalized_ASC'
  | 'subheaderIsCapitalized_DESC'
  | 'subheading_ASC'
  | 'subheading_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'textBelowMedia_ASC'
  | 'textBelowMedia_DESC'
  | 'textColor_ASC'
  | 'textColor_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url1eventType_ASC'
  | 'url1eventType_DESC'
  | 'url2Type_ASC'
  | 'url2Type_DESC'
  | 'url2_ASC'
  | 'url2_DESC'
  | 'url2eventType_ASC'
  | 'url2eventType_DESC'
  | 'url2text_ASC'
  | 'url2text_DESC'
  | 'urlDirection_ASC'
  | 'urlDirection_DESC'
  | 'urlPosition_ASC'
  | 'urlPosition_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC'
  | 'urlType_ASC'
  | 'urlType_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulImageWithFocalPointLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulImageWithFocalPointOrder =
  | 'alt_ASC'
  | 'alt_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'videoPlayOption_ASC'
  | 'videoPlayOption_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPage = ContentfulEntry & Contentful_Node & {
  __typename?: 'ListingPage';
  _id: Scalars['ID']['output'];
  algoliaCategoryId?: Maybe<Scalars['String']['output']>;
  algoliaRuleName?: Maybe<Scalars['String']['output']>;
  collectionName?: Maybe<Scalars['String']['output']>;
  contentCollection?: Maybe<ContentfulListingPageContentCollection>;
  contentCursorCollection?: Maybe<ContentfulListingPageContentCursorCollection>;
  contentfulMetadata: ContentfulContentfulMetadata;
  editorialPageName?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<ContentfulFooter>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulListingPageLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  mainHeader?: Maybe<ContentfulMainHeader>;
  saleorCollection?: Maybe<Scalars['String']['output']>;
  seoConfiguration?: Maybe<ContentfulSeoConfiguration>;
  seoConfigurationOverride?: Maybe<ContentfulSeoConfiguration>;
  strapMaterial?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageAlgoliaCategoryIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageAlgoliaRuleNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageCollectionNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulListingPageContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulListingPageContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageEditorialPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFooterFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageMainHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainHeaderFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageSaleorCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageSeoConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageSeoConfigurationOverrideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageStrapMaterialArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/listingPage) */
export type ContentfulListingPageTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulListingPageCollection = {
  __typename?: 'ListingPageCollection';
  items: Array<Maybe<ContentfulListingPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulListingPageContentCollection = {
  __typename?: 'ListingPageContentCollection';
  items: Array<Maybe<ContentfulListingPageContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulListingPageContentCursorCollection = {
  __typename?: 'ListingPageContentCursorCollection';
  items: Array<Maybe<ContentfulListingPageContentItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulListingPageContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulListingPageContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulListingPageContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulListingPageContentItem = ContentfulBanner | ContentfulCard | ContentfulCollectionGroup | ContentfulContactUs | ContentfulFaqWrap | ContentfulHeroProductListing | ContentfulPlaceholder | ContentfulPlaceholderStores | ContentfulServicesCollection | ContentfulSliderProductsAutomatic | ContentfulSliderProductsManual;

export type ContentfulListingPageCursorCollection = {
  __typename?: 'ListingPageCursorCollection';
  items: Array<Maybe<ContentfulListingPage>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulListingPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulListingPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulListingPageFilter>>>;
  algoliaCategoryId?: InputMaybe<Scalars['String']['input']>;
  algoliaCategoryId_contains?: InputMaybe<Scalars['String']['input']>;
  algoliaCategoryId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  algoliaCategoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  algoliaCategoryId_not?: InputMaybe<Scalars['String']['input']>;
  algoliaCategoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  algoliaCategoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  algoliaRuleName?: InputMaybe<Scalars['String']['input']>;
  algoliaRuleName_contains?: InputMaybe<Scalars['String']['input']>;
  algoliaRuleName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  algoliaRuleName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  algoliaRuleName_not?: InputMaybe<Scalars['String']['input']>;
  algoliaRuleName_not_contains?: InputMaybe<Scalars['String']['input']>;
  algoliaRuleName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collectionName?: InputMaybe<Scalars['String']['input']>;
  collectionName_contains?: InputMaybe<Scalars['String']['input']>;
  collectionName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  collectionName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collectionName_not?: InputMaybe<Scalars['String']['input']>;
  collectionName_not_contains?: InputMaybe<Scalars['String']['input']>;
  collectionName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<ContentfulCfcontentMultiTypeNestedFilter>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  editorialPageName?: InputMaybe<Scalars['String']['input']>;
  editorialPageName_contains?: InputMaybe<Scalars['String']['input']>;
  editorialPageName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  editorialPageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  editorialPageName_not?: InputMaybe<Scalars['String']['input']>;
  editorialPageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  editorialPageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  footer?: InputMaybe<ContentfulCfFooterNestedFilter>;
  footer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mainHeader?: InputMaybe<ContentfulCfMainHeaderNestedFilter>;
  mainHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  saleorCollection?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_contains?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  saleorCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  saleorCollection_not?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoConfiguration?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  strapMaterial?: InputMaybe<Scalars['String']['input']>;
  strapMaterial_contains?: InputMaybe<Scalars['String']['input']>;
  strapMaterial_exists?: InputMaybe<Scalars['Boolean']['input']>;
  strapMaterial_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strapMaterial_not?: InputMaybe<Scalars['String']['input']>;
  strapMaterial_not_contains?: InputMaybe<Scalars['String']['input']>;
  strapMaterial_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulListingPageLinkingCollections = {
  __typename?: 'ListingPageLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulListingPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulListingPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulListingPageOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulLiveStoryContentType = ContentfulEntry & Contentful_Node & {
  __typename?: 'LiveStoryContentType';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  coverImg?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulLiveStoryContentTypeLinkingCollections>;
  ssc?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/LIVE_STORY_CONTENT_TYPE) */
export type ContentfulLiveStoryContentTypeCoverImgArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/LIVE_STORY_CONTENT_TYPE) */
export type ContentfulLiveStoryContentTypeDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/LIVE_STORY_CONTENT_TYPE) */
export type ContentfulLiveStoryContentTypeIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/LIVE_STORY_CONTENT_TYPE) */
export type ContentfulLiveStoryContentTypeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/LIVE_STORY_CONTENT_TYPE) */
export type ContentfulLiveStoryContentTypeSscArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/LIVE_STORY_CONTENT_TYPE) */
export type ContentfulLiveStoryContentTypeTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/LIVE_STORY_CONTENT_TYPE) */
export type ContentfulLiveStoryContentTypeTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulLiveStoryContentTypeCollection = {
  __typename?: 'LiveStoryContentTypeCollection';
  items: Array<Maybe<ContentfulLiveStoryContentType>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulLiveStoryContentTypeCursorCollection = {
  __typename?: 'LiveStoryContentTypeCursorCollection';
  items: Array<Maybe<ContentfulLiveStoryContentType>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulLiveStoryContentTypeFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulLiveStoryContentTypeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulLiveStoryContentTypeFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  cover_img?: InputMaybe<Scalars['String']['input']>;
  cover_img_contains?: InputMaybe<Scalars['String']['input']>;
  cover_img_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cover_img_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cover_img_not?: InputMaybe<Scalars['String']['input']>;
  cover_img_not_contains?: InputMaybe<Scalars['String']['input']>;
  cover_img_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ssc?: InputMaybe<Scalars['String']['input']>;
  ssc_contains?: InputMaybe<Scalars['String']['input']>;
  ssc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ssc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ssc_not?: InputMaybe<Scalars['String']['input']>;
  ssc_not_contains?: InputMaybe<Scalars['String']['input']>;
  ssc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulLiveStoryContentTypeLinkingCollections = {
  __typename?: 'LiveStoryContentTypeLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
};


export type ContentfulLiveStoryContentTypeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulLiveStoryContentTypeLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulLiveStoryContentTypeLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulLiveStoryContentTypeLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulLiveStoryContentTypeLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulLiveStoryContentTypeLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulLiveStoryContentTypeLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulLiveStoryContentTypeLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulLiveStoryContentTypeOrder =
  | 'cover_img_ASC'
  | 'cover_img_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeader = ContentfulEntry & Contentful_Node & {
  __typename?: 'MainHeader';
  _id: Scalars['ID']['output'];
  alertBannerCollection?: Maybe<ContentfulMainHeaderAlertBannerCollection>;
  alertBannerCursorCollection?: Maybe<ContentfulMainHeaderAlertBannerCursorCollection>;
  background?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<ContentfulAsset>;
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulMainHeaderLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  logo?: Maybe<ContentfulAsset>;
  logoHeightDesktop?: Maybe<Scalars['Int']['output']>;
  logoHeightMobile?: Maybe<Scalars['Int']['output']>;
  logoWidthDesktop?: Maybe<Scalars['Int']['output']>;
  logoWidthMobile?: Maybe<Scalars['Int']['output']>;
  megamenu?: Maybe<ContentfulMegaMenu>;
  sys: ContentfulSys;
  textColorOption?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderAlertBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderAlertBannerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulAlertBannerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderAlertBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderAlertBannerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulAlertBannerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderLogoHeightDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderLogoHeightMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderLogoWidthDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderLogoWidthMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderMegamenuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMegaMenuFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderTextColorOptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainHeader) */
export type ContentfulMainHeaderTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMainHeaderAlertBannerCollection = {
  __typename?: 'MainHeaderAlertBannerCollection';
  items: Array<Maybe<ContentfulAlertBanner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulMainHeaderAlertBannerCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMainHeaderAlertBannerCursorCollection = {
  __typename?: 'MainHeaderAlertBannerCursorCollection';
  items: Array<Maybe<ContentfulAlertBanner>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulMainHeaderAlertBannerCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMainHeaderCollection = {
  __typename?: 'MainHeaderCollection';
  items: Array<Maybe<ContentfulMainHeader>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulMainHeaderCursorCollection = {
  __typename?: 'MainHeaderCursorCollection';
  items: Array<Maybe<ContentfulMainHeader>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulMainHeaderFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderFilter>>>;
  alertBanner?: InputMaybe<ContentfulCfAlertBannerNestedFilter>;
  alertBannerCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background?: InputMaybe<Scalars['String']['input']>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_contains?: InputMaybe<Scalars['String']['input']>;
  background_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_not?: InputMaybe<Scalars['String']['input']>;
  background_not_contains?: InputMaybe<Scalars['String']['input']>;
  background_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightDesktop?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightMobile?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_not?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthDesktop?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoWidthDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthMobile?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoWidthMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_not?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  megamenu?: InputMaybe<ContentfulCfMegaMenuNestedFilter>;
  megamenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  textColorOption?: InputMaybe<Scalars['String']['input']>;
  textColorOption_contains?: InputMaybe<Scalars['String']['input']>;
  textColorOption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textColorOption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textColorOption_not?: InputMaybe<Scalars['String']['input']>;
  textColorOption_not_contains?: InputMaybe<Scalars['String']['input']>;
  textColorOption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMainHeaderLinkingCollections = {
  __typename?: 'MainHeaderLinkingCollections';
  defaultLayoutCollection?: Maybe<ContentfulDefaultLayoutCollection>;
  defaultLayoutCursorCollection?: Maybe<ContentfulDefaultLayoutCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
};


export type ContentfulMainHeaderLinkingCollectionsDefaultLayoutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderLinkingCollectionsDefaultLayoutCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsDefaultLayoutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderLinkingCollectionsDefaultLayoutCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainHeaderLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMainHeaderLinkingCollectionsDefaultLayoutCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulMainHeaderLinkingCollectionsDefaultLayoutCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulMainHeaderLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulMainHeaderLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulMainHeaderLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMainHeaderLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMainHeaderLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMainHeaderLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMainHeaderLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMainHeaderLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMainHeaderOrder =
  | 'background_ASC'
  | 'background_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'logoHeightDesktop_ASC'
  | 'logoHeightDesktop_DESC'
  | 'logoHeightMobile_ASC'
  | 'logoHeightMobile_DESC'
  | 'logoWidthDesktop_ASC'
  | 'logoWidthDesktop_DESC'
  | 'logoWidthMobile_ASC'
  | 'logoWidthMobile_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textColorOption_ASC'
  | 'textColorOption_DESC'
  | 'type_ASC'
  | 'type_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItem = ContentfulEntry & Contentful_Node & {
  __typename?: 'MainMenuItem';
  _id: Scalars['ID']['output'];
  bottomLinkAriaLabel?: Maybe<Scalars['String']['output']>;
  bottomLinkLabel?: Maybe<Scalars['String']['output']>;
  bottomLinkUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  image?: Maybe<ContentfulAsset>;
  internalName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulMainMenuItemLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  openUrlInNewTab?: Maybe<Scalars['Boolean']['output']>;
  scrollerItemsCollection?: Maybe<ContentfulMainMenuItemScrollerItemsCollection>;
  scrollerItemsCursorCollection?: Maybe<ContentfulMainMenuItemScrollerItemsCursorCollection>;
  scrollerLabel?: Maybe<Scalars['String']['output']>;
  submenuItemsCollection?: Maybe<ContentfulMainMenuItemSubmenuItemsCollection>;
  submenuItemsCursorCollection?: Maybe<ContentfulMainMenuItemSubmenuItemsCursorCollection>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  visibleInDesktop?: Maybe<Scalars['Boolean']['output']>;
  visibleInMobile?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemBottomLinkAriaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemBottomLinkLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemBottomLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemOpenUrlInNewTabArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemScrollerItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemScrollerItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulScrollerItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemScrollerItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemScrollerItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulScrollerItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemScrollerLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemSubmenuItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemSubmenuItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainMenuItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemSubmenuItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemSubmenuItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainMenuItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemVisibleInDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/mainMenuItem) */
export type ContentfulMainMenuItemVisibleInMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMainMenuItemCollection = {
  __typename?: 'MainMenuItemCollection';
  items: Array<Maybe<ContentfulMainMenuItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulMainMenuItemCursorCollection = {
  __typename?: 'MainMenuItemCursorCollection';
  items: Array<Maybe<ContentfulMainMenuItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulMainMenuItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemFilter>>>;
  bottomLinkAriaLabel?: InputMaybe<Scalars['String']['input']>;
  bottomLinkAriaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkAriaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bottomLinkAriaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bottomLinkAriaLabel_not?: InputMaybe<Scalars['String']['input']>;
  bottomLinkAriaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkAriaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bottomLinkLabel?: InputMaybe<Scalars['String']['input']>;
  bottomLinkLabel_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bottomLinkLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bottomLinkLabel_not?: InputMaybe<Scalars['String']['input']>;
  bottomLinkLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bottomLinkUrl?: InputMaybe<Scalars['String']['input']>;
  bottomLinkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bottomLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bottomLinkUrl_not?: InputMaybe<Scalars['String']['input']>;
  bottomLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  scrollerItems?: InputMaybe<ContentfulCfScrollerItemNestedFilter>;
  scrollerItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scrollerLabel?: InputMaybe<Scalars['String']['input']>;
  scrollerLabel_contains?: InputMaybe<Scalars['String']['input']>;
  scrollerLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scrollerLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scrollerLabel_not?: InputMaybe<Scalars['String']['input']>;
  scrollerLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  scrollerLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submenuItems?: InputMaybe<ContentfulCfMainMenuItemNestedFilter>;
  submenuItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibleInDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMainMenuItemLinkingCollections = {
  __typename?: 'MainMenuItemLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  footerCollection?: Maybe<ContentfulFooterCollection>;
  footerCursorCollection?: Maybe<ContentfulFooterCursorCollection>;
  mainMenuItemCollection?: Maybe<ContentfulMainMenuItemCollection>;
  mainMenuItemCursorCollection?: Maybe<ContentfulMainMenuItemCursorCollection>;
  megaMenuCollection?: Maybe<ContentfulMegaMenuCollection>;
  megaMenuCursorCollection?: Maybe<ContentfulMegaMenuCursorCollection>;
};


export type ContentfulMainMenuItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainMenuItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainMenuItemLinkingCollectionsFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemLinkingCollectionsFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainMenuItemLinkingCollectionsFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemLinkingCollectionsFooterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainMenuItemLinkingCollectionsMainMenuItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemLinkingCollectionsMainMenuItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainMenuItemLinkingCollectionsMainMenuItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemLinkingCollectionsMainMenuItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainMenuItemLinkingCollectionsMegaMenuCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemLinkingCollectionsMegaMenuCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMainMenuItemLinkingCollectionsMegaMenuCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemLinkingCollectionsMegaMenuCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMainMenuItemLinkingCollectionsFooterCollectionOrder =
  | 'contactLinkAriaLabel_ASC'
  | 'contactLinkAriaLabel_DESC'
  | 'contactLinkText_ASC'
  | 'contactLinkText_DESC'
  | 'contactLinkUrl_ASC'
  | 'contactLinkUrl_DESC'
  | 'copyrightText_ASC'
  | 'copyrightText_DESC'
  | 'displayContactInformation_ASC'
  | 'displayContactInformation_DESC'
  | 'displayNewsletterSubscribe_ASC'
  | 'displayNewsletterSubscribe_DESC'
  | 'displayRegionSelector_ASC'
  | 'displayRegionSelector_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'logoHeightDesktop_ASC'
  | 'logoHeightDesktop_DESC'
  | 'logoHeightMobile_ASC'
  | 'logoHeightMobile_DESC'
  | 'logoLink_ASC'
  | 'logoLink_DESC'
  | 'logoWidthDesktop_ASC'
  | 'logoWidthDesktop_DESC'
  | 'logoWidthMobile_ASC'
  | 'logoWidthMobile_DESC'
  | 'regionSelectorLabel_ASC'
  | 'regionSelectorLabel_DESC'
  | 'socialFacebookUrl_ASC'
  | 'socialFacebookUrl_DESC'
  | 'socialInstagramUrl_ASC'
  | 'socialInstagramUrl_DESC'
  | 'socialLineUrl_ASC'
  | 'socialLineUrl_DESC'
  | 'socialNetworkLabel_ASC'
  | 'socialNetworkLabel_DESC'
  | 'socialPinterestUrl_ASC'
  | 'socialPinterestUrl_DESC'
  | 'socialStravaUrl_ASC'
  | 'socialStravaUrl_DESC'
  | 'socialTiktokUrl_ASC'
  | 'socialTiktokUrl_DESC'
  | 'socialXTwitterUrl_ASC'
  | 'socialXTwitterUrl_DESC'
  | 'socialYoutubeUrl_ASC'
  | 'socialYoutubeUrl_DESC'
  | 'subscribeToNewsletterText_ASC'
  | 'subscribeToNewsletterText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMainMenuItemLinkingCollectionsFooterCursorCollectionOrder =
  | 'contactLinkAriaLabel_ASC'
  | 'contactLinkAriaLabel_DESC'
  | 'contactLinkText_ASC'
  | 'contactLinkText_DESC'
  | 'contactLinkUrl_ASC'
  | 'contactLinkUrl_DESC'
  | 'copyrightText_ASC'
  | 'copyrightText_DESC'
  | 'displayContactInformation_ASC'
  | 'displayContactInformation_DESC'
  | 'displayNewsletterSubscribe_ASC'
  | 'displayNewsletterSubscribe_DESC'
  | 'displayRegionSelector_ASC'
  | 'displayRegionSelector_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'logoHeightDesktop_ASC'
  | 'logoHeightDesktop_DESC'
  | 'logoHeightMobile_ASC'
  | 'logoHeightMobile_DESC'
  | 'logoLink_ASC'
  | 'logoLink_DESC'
  | 'logoWidthDesktop_ASC'
  | 'logoWidthDesktop_DESC'
  | 'logoWidthMobile_ASC'
  | 'logoWidthMobile_DESC'
  | 'regionSelectorLabel_ASC'
  | 'regionSelectorLabel_DESC'
  | 'socialFacebookUrl_ASC'
  | 'socialFacebookUrl_DESC'
  | 'socialInstagramUrl_ASC'
  | 'socialInstagramUrl_DESC'
  | 'socialLineUrl_ASC'
  | 'socialLineUrl_DESC'
  | 'socialNetworkLabel_ASC'
  | 'socialNetworkLabel_DESC'
  | 'socialPinterestUrl_ASC'
  | 'socialPinterestUrl_DESC'
  | 'socialStravaUrl_ASC'
  | 'socialStravaUrl_DESC'
  | 'socialTiktokUrl_ASC'
  | 'socialTiktokUrl_DESC'
  | 'socialXTwitterUrl_ASC'
  | 'socialXTwitterUrl_DESC'
  | 'socialYoutubeUrl_ASC'
  | 'socialYoutubeUrl_DESC'
  | 'subscribeToNewsletterText_ASC'
  | 'subscribeToNewsletterText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMainMenuItemLinkingCollectionsMainMenuItemCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulMainMenuItemLinkingCollectionsMainMenuItemCursorCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulMainMenuItemLinkingCollectionsMegaMenuCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulMainMenuItemLinkingCollectionsMegaMenuCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulMainMenuItemOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulMainMenuItemScrollerItemsCollection = {
  __typename?: 'MainMenuItemScrollerItemsCollection';
  items: Array<Maybe<ContentfulScrollerItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulMainMenuItemScrollerItemsCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulMainMenuItemScrollerItemsCursorCollection = {
  __typename?: 'MainMenuItemScrollerItemsCursorCollection';
  items: Array<Maybe<ContentfulScrollerItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulMainMenuItemScrollerItemsCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulMainMenuItemSubmenuItemsCollection = {
  __typename?: 'MainMenuItemSubmenuItemsCollection';
  items: Array<Maybe<ContentfulMainMenuItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulMainMenuItemSubmenuItemsCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulMainMenuItemSubmenuItemsCursorCollection = {
  __typename?: 'MainMenuItemSubmenuItemsCursorCollection';
  items: Array<Maybe<ContentfulMainMenuItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulMainMenuItemSubmenuItemsCursorCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/manualCollectionGroupProductReferences) */
export type ContentfulManualCollectionGroupProductReferences = ContentfulEntry & Contentful_Node & {
  __typename?: 'ManualCollectionGroupProductReferences';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulManualCollectionGroupProductReferencesLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  manualProductReferences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/manualCollectionGroupProductReferences) */
export type ContentfulManualCollectionGroupProductReferencesInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/manualCollectionGroupProductReferences) */
export type ContentfulManualCollectionGroupProductReferencesLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/manualCollectionGroupProductReferences) */
export type ContentfulManualCollectionGroupProductReferencesLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/manualCollectionGroupProductReferences) */
export type ContentfulManualCollectionGroupProductReferencesManualProductReferencesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulManualCollectionGroupProductReferencesCollection = {
  __typename?: 'ManualCollectionGroupProductReferencesCollection';
  items: Array<Maybe<ContentfulManualCollectionGroupProductReferences>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulManualCollectionGroupProductReferencesCursorCollection = {
  __typename?: 'ManualCollectionGroupProductReferencesCursorCollection';
  items: Array<Maybe<ContentfulManualCollectionGroupProductReferences>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulManualCollectionGroupProductReferencesFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulManualCollectionGroupProductReferencesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulManualCollectionGroupProductReferencesFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  manualProductReferences_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  manualProductReferences_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  manualProductReferences_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  manualProductReferences_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulManualCollectionGroupProductReferencesLinkingCollections = {
  __typename?: 'ManualCollectionGroupProductReferencesLinkingCollections';
  collectionGroupCollection?: Maybe<ContentfulCollectionGroupCollection>;
  collectionGroupCursorCollection?: Maybe<ContentfulCollectionGroupCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulManualCollectionGroupProductReferencesLinkingCollectionsCollectionGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulManualCollectionGroupProductReferencesLinkingCollectionsCollectionGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulManualCollectionGroupProductReferencesLinkingCollectionsCollectionGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulManualCollectionGroupProductReferencesLinkingCollectionsCollectionGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulManualCollectionGroupProductReferencesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulManualCollectionGroupProductReferencesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulManualCollectionGroupProductReferencesLinkingCollectionsCollectionGroupCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulManualCollectionGroupProductReferencesLinkingCollectionsCollectionGroupCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulManualCollectionGroupProductReferencesOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/megaMenu) */
export type ContentfulMegaMenu = ContentfulEntry & Contentful_Node & {
  __typename?: 'MegaMenu';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulMegaMenuLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  menuItemsCollection?: Maybe<ContentfulMegaMenuMenuItemsCollection>;
  menuItemsCursorCollection?: Maybe<ContentfulMegaMenuMenuItemsCursorCollection>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/megaMenu) */
export type ContentfulMegaMenuInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/megaMenu) */
export type ContentfulMegaMenuLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/megaMenu) */
export type ContentfulMegaMenuLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/megaMenu) */
export type ContentfulMegaMenuMenuItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMegaMenuMenuItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainMenuItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/megaMenu) */
export type ContentfulMegaMenuMenuItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMegaMenuMenuItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainMenuItemFilter>;
};

export type ContentfulMegaMenuCollection = {
  __typename?: 'MegaMenuCollection';
  items: Array<Maybe<ContentfulMegaMenu>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulMegaMenuCursorCollection = {
  __typename?: 'MegaMenuCursorCollection';
  items: Array<Maybe<ContentfulMegaMenu>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulMegaMenuFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulMegaMenuFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulMegaMenuFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  menuItems?: InputMaybe<ContentfulCfMainMenuItemNestedFilter>;
  menuItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulMegaMenuLinkingCollections = {
  __typename?: 'MegaMenuLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  mainHeaderCollection?: Maybe<ContentfulMainHeaderCollection>;
  mainHeaderCursorCollection?: Maybe<ContentfulMainHeaderCursorCollection>;
};


export type ContentfulMegaMenuLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMegaMenuLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMegaMenuLinkingCollectionsMainHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMegaMenuLinkingCollectionsMainHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulMegaMenuLinkingCollectionsMainHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMegaMenuLinkingCollectionsMainHeaderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMegaMenuLinkingCollectionsMainHeaderCollectionOrder =
  | 'background_ASC'
  | 'background_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'logoHeightDesktop_ASC'
  | 'logoHeightDesktop_DESC'
  | 'logoHeightMobile_ASC'
  | 'logoHeightMobile_DESC'
  | 'logoWidthDesktop_ASC'
  | 'logoWidthDesktop_DESC'
  | 'logoWidthMobile_ASC'
  | 'logoWidthMobile_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textColorOption_ASC'
  | 'textColorOption_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMegaMenuLinkingCollectionsMainHeaderCursorCollectionOrder =
  | 'background_ASC'
  | 'background_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'logoHeightDesktop_ASC'
  | 'logoHeightDesktop_DESC'
  | 'logoHeightMobile_ASC'
  | 'logoHeightMobile_DESC'
  | 'logoWidthDesktop_ASC'
  | 'logoWidthDesktop_DESC'
  | 'logoWidthMobile_ASC'
  | 'logoWidthMobile_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'textColorOption_ASC'
  | 'textColorOption_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulMegaMenuMenuItemsCollection = {
  __typename?: 'MegaMenuMenuItemsCollection';
  items: Array<Maybe<ContentfulMainMenuItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulMegaMenuMenuItemsCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulMegaMenuMenuItemsCursorCollection = {
  __typename?: 'MegaMenuMenuItemsCursorCollection';
  items: Array<Maybe<ContentfulMainMenuItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulMegaMenuMenuItemsCursorCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulMegaMenuOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItem = ContentfulEntry & Contentful_Node & {
  __typename?: 'NavQuickLinkItem';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  disableNavigationScrollToTop?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulNavQuickLinkItemLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  media?: Maybe<ContentfulAsset>;
  sys: ContentfulSys;
  topLabelText?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlTarget?: Maybe<Scalars['String']['output']>;
  urlText?: Maybe<Scalars['String']['output']>;
  urlTrigger?: Maybe<ContentfulEvent>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemDisableNavigationScrollToTopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemTopLabelTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemUrlTargetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemUrlTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinkItem) */
export type ContentfulNavQuickLinkItemUrlTriggerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulEventFilter>;
};

export type ContentfulNavQuickLinkItemCollection = {
  __typename?: 'NavQuickLinkItemCollection';
  items: Array<Maybe<ContentfulNavQuickLinkItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulNavQuickLinkItemCursorCollection = {
  __typename?: 'NavQuickLinkItemCursorCollection';
  items: Array<Maybe<ContentfulNavQuickLinkItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulNavQuickLinkItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinkItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinkItemFilter>>>;
  Url?: InputMaybe<Scalars['String']['input']>;
  Url_contains?: InputMaybe<Scalars['String']['input']>;
  Url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  Url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Url_not?: InputMaybe<Scalars['String']['input']>;
  Url_not_contains?: InputMaybe<Scalars['String']['input']>;
  Url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  disableNavigationScrollToTop?: InputMaybe<Scalars['Boolean']['input']>;
  disableNavigationScrollToTop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableNavigationScrollToTop_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  topLabelText?: InputMaybe<Scalars['String']['input']>;
  topLabelText_contains?: InputMaybe<Scalars['String']['input']>;
  topLabelText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  topLabelText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topLabelText_not?: InputMaybe<Scalars['String']['input']>;
  topLabelText_not_contains?: InputMaybe<Scalars['String']['input']>;
  topLabelText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlTarget?: InputMaybe<Scalars['String']['input']>;
  urlTarget_contains?: InputMaybe<Scalars['String']['input']>;
  urlTarget_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlTarget_not?: InputMaybe<Scalars['String']['input']>;
  urlTarget_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  urlText_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText_not?: InputMaybe<Scalars['String']['input']>;
  urlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlTrigger?: InputMaybe<ContentfulCfEventNestedFilter>;
  urlTrigger_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulNavQuickLinkItemLinkingCollections = {
  __typename?: 'NavQuickLinkItemLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  navQuickLinksCollection?: Maybe<ContentfulNavQuickLinksCollection>;
  navQuickLinksCursorCollection?: Maybe<ContentfulNavQuickLinksCursorCollection>;
};


export type ContentfulNavQuickLinkItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinkItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinkItemLinkingCollectionsNavQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinkItemLinkingCollectionsNavQuickLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinkItemLinkingCollectionsNavQuickLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinkItemLinkingCollectionsNavQuickLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulNavQuickLinkItemLinkingCollectionsNavQuickLinksCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSticky_ASC'
  | 'isSticky_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinkItemLinkingCollectionsNavQuickLinksCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSticky_ASC'
  | 'isSticky_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinkItemOrder =
  | 'Url_ASC'
  | 'Url_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'disableNavigationScrollToTop_ASC'
  | 'disableNavigationScrollToTop_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'topLabelText_ASC'
  | 'topLabelText_DESC'
  | 'urlTarget_ASC'
  | 'urlTarget_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinks) */
export type ContentfulNavQuickLinks = ContentfulEntry & Contentful_Node & {
  __typename?: 'NavQuickLinks';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  isSticky?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ContentfulNavQuickLinksLinkingCollections>;
  linksCollection?: Maybe<ContentfulNavQuickLinksLinksCollection>;
  linksCursorCollection?: Maybe<ContentfulNavQuickLinksLinksCursorCollection>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinks) */
export type ContentfulNavQuickLinksBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinks) */
export type ContentfulNavQuickLinksInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinks) */
export type ContentfulNavQuickLinksIsStickyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinks) */
export type ContentfulNavQuickLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinks) */
export type ContentfulNavQuickLinksLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulNavQuickLinkItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinks) */
export type ContentfulNavQuickLinksLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulNavQuickLinkItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinks) */
export type ContentfulNavQuickLinksLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinks) */
export type ContentfulNavQuickLinksTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulNavQuickLinksCollection = {
  __typename?: 'NavQuickLinksCollection';
  items: Array<Maybe<ContentfulNavQuickLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulNavQuickLinksCursorCollection = {
  __typename?: 'NavQuickLinksCursorCollection';
  items: Array<Maybe<ContentfulNavQuickLinks>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulNavQuickLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSticky?: InputMaybe<Scalars['Boolean']['input']>;
  isSticky_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isSticky_not?: InputMaybe<Scalars['Boolean']['input']>;
  links?: InputMaybe<ContentfulCfNavQuickLinkItemNestedFilter>;
  linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulNavQuickLinksLinkingCollections = {
  __typename?: 'NavQuickLinksLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  navQuickLinksWithBannerCollection?: Maybe<ContentfulNavQuickLinksWithBannerCollection>;
  navQuickLinksWithBannerCursorCollection?: Maybe<ContentfulNavQuickLinksWithBannerCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulNavQuickLinksLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsNavQuickLinksWithBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsNavQuickLinksWithBannerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsNavQuickLinksWithBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsNavQuickLinksWithBannerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulNavQuickLinksLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsNavQuickLinksWithBannerCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsNavQuickLinksWithBannerCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulNavQuickLinksLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulNavQuickLinksLinksCollection = {
  __typename?: 'NavQuickLinksLinksCollection';
  items: Array<Maybe<ContentfulNavQuickLinkItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulNavQuickLinksLinksCollectionOrder =
  | 'Url_ASC'
  | 'Url_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'disableNavigationScrollToTop_ASC'
  | 'disableNavigationScrollToTop_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'topLabelText_ASC'
  | 'topLabelText_DESC'
  | 'urlTarget_ASC'
  | 'urlTarget_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC';

export type ContentfulNavQuickLinksLinksCursorCollection = {
  __typename?: 'NavQuickLinksLinksCursorCollection';
  items: Array<Maybe<ContentfulNavQuickLinkItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulNavQuickLinksLinksCursorCollectionOrder =
  | 'Url_ASC'
  | 'Url_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'disableNavigationScrollToTop_ASC'
  | 'disableNavigationScrollToTop_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'topLabelText_ASC'
  | 'topLabelText_DESC'
  | 'urlTarget_ASC'
  | 'urlTarget_DESC'
  | 'urlText_ASC'
  | 'urlText_DESC';

export type ContentfulNavQuickLinksOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSticky_ASC'
  | 'isSticky_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinksWithBanner) */
export type ContentfulNavQuickLinksWithBanner = ContentfulEntry & Contentful_Node & {
  __typename?: 'NavQuickLinksWithBanner';
  _id: Scalars['ID']['output'];
  card?: Maybe<ContentfulCard>;
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulNavQuickLinksWithBannerLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  navQuickLinks?: Maybe<ContentfulNavQuickLinks>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinksWithBanner) */
export type ContentfulNavQuickLinksWithBannerCardArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinksWithBanner) */
export type ContentfulNavQuickLinksWithBannerInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinksWithBanner) */
export type ContentfulNavQuickLinksWithBannerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinksWithBanner) */
export type ContentfulNavQuickLinksWithBannerLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinksWithBanner) */
export type ContentfulNavQuickLinksWithBannerNavQuickLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulNavQuickLinksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/navQuickLinksWithBanner) */
export type ContentfulNavQuickLinksWithBannerTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulNavQuickLinksWithBannerCollection = {
  __typename?: 'NavQuickLinksWithBannerCollection';
  items: Array<Maybe<ContentfulNavQuickLinksWithBanner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulNavQuickLinksWithBannerCursorCollection = {
  __typename?: 'NavQuickLinksWithBannerCursorCollection';
  items: Array<Maybe<ContentfulNavQuickLinksWithBanner>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulNavQuickLinksWithBannerFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksWithBannerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksWithBannerFilter>>>;
  card?: InputMaybe<ContentfulCfCardNestedFilter>;
  card_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navQuickLinks?: InputMaybe<ContentfulCfNavQuickLinksNestedFilter>;
  navQuickLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulNavQuickLinksWithBannerLinkingCollections = {
  __typename?: 'NavQuickLinksWithBannerLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
};


export type ContentfulNavQuickLinksWithBannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksWithBannerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksWithBannerLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksWithBannerLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksWithBannerLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksWithBannerLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksWithBannerLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksWithBannerLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulNavQuickLinksWithBannerLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksWithBannerLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulNavQuickLinksWithBannerLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinksWithBannerLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinksWithBannerLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinksWithBannerLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulNavQuickLinksWithBannerOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPage = ContentfulEntry & Contentful_Node & {
  __typename?: 'Page';
  _id: Scalars['ID']['output'];
  contentCollection?: Maybe<ContentfulPageContentCollection>;
  contentCursorCollection?: Maybe<ContentfulPageContentCursorCollection>;
  contentfulMetadata: ContentfulContentfulMetadata;
  enableSearch?: Maybe<Scalars['Boolean']['output']>;
  footer?: Maybe<ContentfulFooter>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPageLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  mainHeader?: Maybe<ContentfulMainHeader>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  seoConfiguration?: Maybe<ContentfulSeoConfiguration>;
  seoConfigurationOverride?: Maybe<ContentfulSeoConfiguration>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  simpleFooter?: Maybe<ContentfulSimpleFooter>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  tagsCollection?: Maybe<ContentfulPageTagsCollection>;
  tagsCursorCollection?: Maybe<ContentfulPageTagsCursorCollection>;
  thumbnail?: Maybe<ContentfulImageWithFocalPoint>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageEnableSearchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFooterFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageMainHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainHeaderFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPagePageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPagePublishDateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageSeoConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageSeoConfigurationOverrideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageShortDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageSimpleFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSimpleFooterFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageTagsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageTagsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDictionaryItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageTagsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageTagsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDictionaryItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageThumbnailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/page) */
export type ContentfulPageTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetail = ContentfulEntry & Contentful_Node & {
  __typename?: 'PageBoutiqueDetail';
  _id: Scalars['ID']['output'];
  contentCollection?: Maybe<ContentfulPageBoutiqueDetailContentCollection>;
  contentCursorCollection?: Maybe<ContentfulPageBoutiqueDetailContentCursorCollection>;
  contentfulMetadata: ContentfulContentfulMetadata;
  default?: Maybe<Scalars['Boolean']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPageBoutiqueDetailLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  seoConfiguration?: Maybe<ContentfulSeoConfiguration>;
  seoConfigurationOverride?: Maybe<ContentfulSeoConfiguration>;
  sys: ContentfulSys;
  trackingKey?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetailContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageBoutiqueDetailContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetailContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageBoutiqueDetailContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetailDefaultArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetailInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetailLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetailLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetailSeoConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetailSeoConfigurationOverrideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetailTrackingKeyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueDetail) */
export type ContentfulPageBoutiqueDetailTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPageBoutiqueDetailCollection = {
  __typename?: 'PageBoutiqueDetailCollection';
  items: Array<Maybe<ContentfulPageBoutiqueDetail>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageBoutiqueDetailContentCollection = {
  __typename?: 'PageBoutiqueDetailContentCollection';
  items: Array<Maybe<ContentfulPageBoutiqueDetailContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageBoutiqueDetailContentCursorCollection = {
  __typename?: 'PageBoutiqueDetailContentCursorCollection';
  items: Array<Maybe<ContentfulPageBoutiqueDetailContentItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageBoutiqueDetailContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueDetailContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueDetailContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPageBoutiqueDetailContentItem = ContentfulBanner | ContentfulCard | ContentfulContactUs | ContentfulContentGroup | ContentfulFaqWrap | ContentfulFindAStore | ContentfulHeroSlider | ContentfulPlaceholderBoutiqueDetail | ContentfulSliderProductsManual;

export type ContentfulPageBoutiqueDetailCursorCollection = {
  __typename?: 'PageBoutiqueDetailCursorCollection';
  items: Array<Maybe<ContentfulPageBoutiqueDetail>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageBoutiqueDetailFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueDetailFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueDetailFilter>>>;
  content?: InputMaybe<ContentfulCfcontentMultiTypeNestedFilter>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  default_exists?: InputMaybe<Scalars['Boolean']['input']>;
  default_not?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  trackingKey?: InputMaybe<Scalars['String']['input']>;
  trackingKey_contains?: InputMaybe<Scalars['String']['input']>;
  trackingKey_exists?: InputMaybe<Scalars['Boolean']['input']>;
  trackingKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trackingKey_not?: InputMaybe<Scalars['String']['input']>;
  trackingKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  trackingKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulPageBoutiqueDetailLinkingCollections = {
  __typename?: 'PageBoutiqueDetailLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulPageBoutiqueDetailLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPageBoutiqueDetailLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPageBoutiqueDetailOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueList = ContentfulEntry & Contentful_Node & {
  __typename?: 'PageBoutiqueList';
  _id: Scalars['ID']['output'];
  contentAboveBoutiquesCollection?: Maybe<ContentfulPageBoutiqueListContentAboveBoutiquesCollection>;
  contentAboveBoutiquesCursorCollection?: Maybe<ContentfulPageBoutiqueListContentAboveBoutiquesCursorCollection>;
  contentBelowBoutiquesCollection?: Maybe<ContentfulPageBoutiqueListContentBelowBoutiquesCollection>;
  contentBelowBoutiquesCursorCollection?: Maybe<ContentfulPageBoutiqueListContentBelowBoutiquesCursorCollection>;
  contentfulMetadata: ContentfulContentfulMetadata;
  countryCode?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPageBoutiqueListLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  seoConfiguration?: Maybe<ContentfulSeoConfiguration>;
  seoConfigurationOverride?: Maybe<ContentfulSeoConfiguration>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListContentAboveBoutiquesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageBoutiqueListContentAboveBoutiquesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListContentAboveBoutiquesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageBoutiqueListContentAboveBoutiquesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListContentBelowBoutiquesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageBoutiqueListContentBelowBoutiquesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListContentBelowBoutiquesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageBoutiqueListContentBelowBoutiquesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListCountryCodeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListDefaultArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListSeoConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageBoutiqueList) */
export type ContentfulPageBoutiqueListSeoConfigurationOverrideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};

export type ContentfulPageBoutiqueListCollection = {
  __typename?: 'PageBoutiqueListCollection';
  items: Array<Maybe<ContentfulPageBoutiqueList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageBoutiqueListContentAboveBoutiquesCollection = {
  __typename?: 'PageBoutiqueListContentAboveBoutiquesCollection';
  items: Array<Maybe<ContentfulPageBoutiqueListContentAboveBoutiquesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageBoutiqueListContentAboveBoutiquesCursorCollection = {
  __typename?: 'PageBoutiqueListContentAboveBoutiquesCursorCollection';
  items: Array<Maybe<ContentfulPageBoutiqueListContentAboveBoutiquesItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageBoutiqueListContentAboveBoutiquesFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueListContentAboveBoutiquesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueListContentAboveBoutiquesFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPageBoutiqueListContentAboveBoutiquesItem = ContentfulBanner | ContentfulCard | ContentfulContactUs | ContentfulContentGroup | ContentfulFaqWrap | ContentfulFindAStore | ContentfulFreeTextContent | ContentfulHeading | ContentfulHeroSlider | ContentfulNavQuickLinks | ContentfulPlaceholder | ContentfulPlaceholderCheckoutPayments | ContentfulPlaceholderStores | ContentfulProductCard | ContentfulServicesCollection | ContentfulSliderProductsManual;

export type ContentfulPageBoutiqueListContentBelowBoutiquesCollection = {
  __typename?: 'PageBoutiqueListContentBelowBoutiquesCollection';
  items: Array<Maybe<ContentfulPageBoutiqueListContentBelowBoutiquesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageBoutiqueListContentBelowBoutiquesCursorCollection = {
  __typename?: 'PageBoutiqueListContentBelowBoutiquesCursorCollection';
  items: Array<Maybe<ContentfulPageBoutiqueListContentBelowBoutiquesItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageBoutiqueListContentBelowBoutiquesFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueListContentBelowBoutiquesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueListContentBelowBoutiquesFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPageBoutiqueListContentBelowBoutiquesItem = ContentfulBanner | ContentfulCard | ContentfulContactUs | ContentfulContentGroup | ContentfulFaqWrap | ContentfulFindAStore | ContentfulFreeTextContent | ContentfulHeading | ContentfulHeroSlider | ContentfulNavQuickLinks | ContentfulPlaceholder | ContentfulPlaceholderCheckoutPayments | ContentfulPlaceholderStores | ContentfulProductCard | ContentfulServicesCollection | ContentfulSliderProductsManual;

export type ContentfulPageBoutiqueListCursorCollection = {
  __typename?: 'PageBoutiqueListCursorCollection';
  items: Array<Maybe<ContentfulPageBoutiqueList>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageBoutiqueListFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueListFilter>>>;
  contentAboveBoutiques?: InputMaybe<ContentfulCfcontentAboveBoutiquesMultiTypeNestedFilter>;
  contentAboveBoutiquesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentBelowBoutiques?: InputMaybe<ContentfulCfcontentBelowBoutiquesMultiTypeNestedFilter>;
  contentBelowBoutiquesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryCode_contains?: InputMaybe<Scalars['String']['input']>;
  countryCode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode_not?: InputMaybe<Scalars['String']['input']>;
  countryCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  countryCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  default_exists?: InputMaybe<Scalars['Boolean']['input']>;
  default_not?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPageBoutiqueListLinkingCollections = {
  __typename?: 'PageBoutiqueListLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulPageBoutiqueListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPageBoutiqueListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPageBoutiqueListOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPageCollection = {
  __typename?: 'PageCollection';
  items: Array<Maybe<ContentfulPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageContentCollection = {
  __typename?: 'PageContentCollection';
  items: Array<Maybe<ContentfulPageContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageContentCursorCollection = {
  __typename?: 'PageContentCursorCollection';
  items: Array<Maybe<ContentfulPageContentItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPageContentItem = ContentfulBanner | ContentfulBreadcrumb | ContentfulCard | ContentfulContactUs | ContentfulContentGroup | ContentfulEvent | ContentfulFaqWrap | ContentfulFindAStore | ContentfulFreeTextContent | ContentfulGrid | ContentfulHeading | ContentfulHeroSlider | ContentfulIframe | ContentfulLiveStoryContentType | ContentfulNavQuickLinks | ContentfulNavQuickLinksWithBanner | ContentfulPlaceholderHeader | ContentfulPlaceholderService | ContentfulPlaceholderStores | ContentfulProductCard | ContentfulServicesCollection | ContentfulSliderProductsManual;

export type ContentfulPageCursorCollection = {
  __typename?: 'PageCursorCollection';
  items: Array<Maybe<ContentfulPage>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaq = ContentfulEntry & Contentful_Node & {
  __typename?: 'PageExhibitionHistoriesFaq';
  _id: Scalars['ID']['output'];
  contentCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqContentCollection>;
  contentCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqContentCursorCollection>;
  contentfulMetadata: ContentfulContentfulMetadata;
  enableSearch?: Maybe<Scalars['Boolean']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPageExhibitionHistoriesFaqLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  mainHeader?: Maybe<ContentfulMainHeader>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  seoConfiguration?: Maybe<ContentfulSeoConfiguration>;
  seoConfigurationOverride?: Maybe<ContentfulSeoConfiguration>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  thumbnail?: Maybe<ContentfulImageWithFocalPoint>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageExhibitionHistoriesFaqContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageExhibitionHistoriesFaqContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqEnableSearchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqMainHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainHeaderFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqSeoConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqSeoConfigurationOverrideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqThumbnailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageExhibitionHistoriesFaq) */
export type ContentfulPageExhibitionHistoriesFaqTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPageExhibitionHistoriesFaqCollection = {
  __typename?: 'PageExhibitionHistoriesFaqCollection';
  items: Array<Maybe<ContentfulPageExhibitionHistoriesFaq>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageExhibitionHistoriesFaqContentCollection = {
  __typename?: 'PageExhibitionHistoriesFaqContentCollection';
  items: Array<Maybe<ContentfulPageExhibitionHistoriesFaqContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageExhibitionHistoriesFaqContentCursorCollection = {
  __typename?: 'PageExhibitionHistoriesFaqContentCursorCollection';
  items: Array<Maybe<ContentfulPageExhibitionHistoriesFaqContentItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageExhibitionHistoriesFaqContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageExhibitionHistoriesFaqContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageExhibitionHistoriesFaqContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPageExhibitionHistoriesFaqContentItem = ContentfulBreadcrumb | ContentfulCard | ContentfulContactUs | ContentfulContentGroup | ContentfulExhibitionList | ContentfulFaqCategories | ContentfulHeading | ContentfulNavQuickLinks | ContentfulNavQuickLinksWithBanner | ContentfulProductCard;

export type ContentfulPageExhibitionHistoriesFaqCursorCollection = {
  __typename?: 'PageExhibitionHistoriesFaqCursorCollection';
  items: Array<Maybe<ContentfulPageExhibitionHistoriesFaq>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageExhibitionHistoriesFaqFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageExhibitionHistoriesFaqFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageExhibitionHistoriesFaqFilter>>>;
  content?: InputMaybe<ContentfulCfcontentMultiTypeNestedFilter>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  enableSearch?: InputMaybe<Scalars['Boolean']['input']>;
  enableSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mainHeader?: InputMaybe<ContentfulCfMainHeaderNestedFilter>;
  mainHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoConfiguration?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  thumbnail?: InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>;
  thumbnail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulPageExhibitionHistoriesFaqLinkingCollections = {
  __typename?: 'PageExhibitionHistoriesFaqLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulPageExhibitionHistoriesFaqLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPageExhibitionHistoriesFaqLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPageExhibitionHistoriesFaqOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageFilter>>>;
  content?: InputMaybe<ContentfulCfcontentMultiTypeNestedFilter>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  enableSearch?: InputMaybe<Scalars['Boolean']['input']>;
  enableSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  footer?: InputMaybe<ContentfulCfFooterNestedFilter>;
  footer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mainHeader?: InputMaybe<ContentfulCfMainHeaderNestedFilter>;
  mainHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  seoConfiguration?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  simpleFooter?: InputMaybe<ContentfulCfSimpleFooterNestedFilter>;
  simpleFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  tags?: InputMaybe<ContentfulCfDictionaryItemNestedFilter>;
  tagsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail?: InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>;
  thumbnail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixed = ContentfulEntry & Contentful_Node & {
  __typename?: 'PageFixed';
  _id: Scalars['ID']['output'];
  bottomContentCollection?: Maybe<ContentfulPageFixedBottomContentCollection>;
  bottomContentCursorCollection?: Maybe<ContentfulPageFixedBottomContentCursorCollection>;
  contentfulMetadata: ContentfulContentfulMetadata;
  dictionaryCollection?: Maybe<ContentfulPageFixedDictionaryCollection>;
  dictionaryCursorCollection?: Maybe<ContentfulPageFixedDictionaryCursorCollection>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPageFixedLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  pinnedNewsCollection?: Maybe<ContentfulPageFixedPinnedNewsCollection>;
  pinnedNewsCursorCollection?: Maybe<ContentfulPageFixedPinnedNewsCursorCollection>;
  seoConfiguration?: Maybe<ContentfulSeoConfiguration>;
  seoConfigurationOverride?: Maybe<ContentfulSeoConfiguration>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  topContentCollection?: Maybe<ContentfulPageFixedTopContentCollection>;
  topContentCursorCollection?: Maybe<ContentfulPageFixedTopContentCursorCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedBottomContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageFixedBottomContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedBottomContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageFixedBottomContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedDictionaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageFixedDictionaryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDictionaryItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedDictionaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageFixedDictionaryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDictionaryItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedPinnedNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageFixedPinnedNewsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedPinnedNewsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageFixedPinnedNewsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedSeoConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedSeoConfigurationOverrideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedTopContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageFixedTopContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/pageFixed) */
export type ContentfulPageFixedTopContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageFixedTopContentFilter>;
};

export type ContentfulPageFixedBottomContentCollection = {
  __typename?: 'PageFixedBottomContentCollection';
  items: Array<Maybe<ContentfulPageFixedBottomContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageFixedBottomContentCursorCollection = {
  __typename?: 'PageFixedBottomContentCursorCollection';
  items: Array<Maybe<ContentfulPageFixedBottomContentItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageFixedBottomContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageFixedBottomContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageFixedBottomContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPageFixedBottomContentItem = ContentfulBanner | ContentfulBreadcrumb | ContentfulCard | ContentfulConditionalComponent | ContentfulContactUs | ContentfulContentGroup | ContentfulFaqWrap | ContentfulFindAStore | ContentfulFreeTextContent | ContentfulGrid | ContentfulHeading | ContentfulNavQuickLinks | ContentfulPlaceholder | ContentfulPlaceholderCheckoutPayments | ContentfulPlaceholderService | ContentfulPlaceholderStores | ContentfulProductCard | ContentfulServicesCollection | ContentfulSliderProductsManual;

export type ContentfulPageFixedCollection = {
  __typename?: 'PageFixedCollection';
  items: Array<Maybe<ContentfulPageFixed>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageFixedCursorCollection = {
  __typename?: 'PageFixedCursorCollection';
  items: Array<Maybe<ContentfulPageFixed>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageFixedDictionaryCollection = {
  __typename?: 'PageFixedDictionaryCollection';
  items: Array<Maybe<ContentfulDictionaryItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageFixedDictionaryCollectionOrder =
  | 'key_ASC'
  | 'key_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPageFixedDictionaryCursorCollection = {
  __typename?: 'PageFixedDictionaryCursorCollection';
  items: Array<Maybe<ContentfulDictionaryItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageFixedDictionaryCursorCollectionOrder =
  | 'key_ASC'
  | 'key_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPageFixedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageFixedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageFixedFilter>>>;
  bottomContent?: InputMaybe<ContentfulCfbottomContentMultiTypeNestedFilter>;
  bottomContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  dictionary?: InputMaybe<ContentfulCfDictionaryItemNestedFilter>;
  dictionaryCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pinnedNews?: InputMaybe<ContentfulCfPageNestedFilter>;
  pinnedNewsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride?: InputMaybe<ContentfulCfSeoConfigurationNestedFilter>;
  seoConfigurationOverride_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  topContent?: InputMaybe<ContentfulCftopContentMultiTypeNestedFilter>;
  topContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPageFixedLinkingCollections = {
  __typename?: 'PageFixedLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulPageFixedLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPageFixedLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPageFixedOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPageFixedPinnedNewsCollection = {
  __typename?: 'PageFixedPinnedNewsCollection';
  items: Array<Maybe<ContentfulPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageFixedPinnedNewsCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPageFixedPinnedNewsCursorCollection = {
  __typename?: 'PageFixedPinnedNewsCursorCollection';
  items: Array<Maybe<ContentfulPage>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageFixedPinnedNewsCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPageFixedTopContentCollection = {
  __typename?: 'PageFixedTopContentCollection';
  items: Array<Maybe<ContentfulPageFixedTopContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageFixedTopContentCursorCollection = {
  __typename?: 'PageFixedTopContentCursorCollection';
  items: Array<Maybe<ContentfulPageFixedTopContentItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageFixedTopContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPageFixedTopContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPageFixedTopContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPageFixedTopContentItem = ContentfulBanner | ContentfulBreadcrumb | ContentfulCard | ContentfulConditionalComponent | ContentfulContactUs | ContentfulContentGroup | ContentfulFaqWrap | ContentfulFindAStore | ContentfulFreeTextContent | ContentfulGrid | ContentfulHeading | ContentfulNavQuickLinks | ContentfulPlaceholder | ContentfulPlaceholderService | ContentfulPlaceholderStores | ContentfulProductCard | ContentfulServicesCollection | ContentfulSliderProductsManual;

export type ContentfulPageLinkingCollections = {
  __typename?: 'PageLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPageLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPageLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPageLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPageLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPageOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPageTagsCollection = {
  __typename?: 'PageTagsCollection';
  items: Array<Maybe<ContentfulDictionaryItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPageTagsCollectionOrder =
  | 'key_ASC'
  | 'key_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPageTagsCursorCollection = {
  __typename?: 'PageTagsCursorCollection';
  items: Array<Maybe<ContentfulDictionaryItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPageTagsCursorCollectionOrder =
  | 'key_ASC'
  | 'key_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholder) */
export type ContentfulPlaceholder = ContentfulEntry & Contentful_Node & {
  __typename?: 'Placeholder';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  heading?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPlaceholderLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  subtext?: Maybe<ContentfulPlaceholderSubtext>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  warrantyTakingCareOfYourWatch?: Maybe<ContentfulCard>;
  warrantyText?: Maybe<ContentfulCard>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholder) */
export type ContentfulPlaceholderHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholder) */
export type ContentfulPlaceholderInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholder) */
export type ContentfulPlaceholderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholder) */
export type ContentfulPlaceholderLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholder) */
export type ContentfulPlaceholderSubtextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholder) */
export type ContentfulPlaceholderTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholder) */
export type ContentfulPlaceholderVideoUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholder) */
export type ContentfulPlaceholderWarrantyTakingCareOfYourWatchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholder) */
export type ContentfulPlaceholderWarrantyTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCardFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderBoutiqueDetail) */
export type ContentfulPlaceholderBoutiqueDetail = ContentfulEntry & Contentful_Node & {
  __typename?: 'PlaceholderBoutiqueDetail';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPlaceholderBoutiqueDetailLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderBoutiqueDetail) */
export type ContentfulPlaceholderBoutiqueDetailInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderBoutiqueDetail) */
export type ContentfulPlaceholderBoutiqueDetailLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderBoutiqueDetail) */
export type ContentfulPlaceholderBoutiqueDetailLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderBoutiqueDetail) */
export type ContentfulPlaceholderBoutiqueDetailTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderBoutiqueDetailCollection = {
  __typename?: 'PlaceholderBoutiqueDetailCollection';
  items: Array<Maybe<ContentfulPlaceholderBoutiqueDetail>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPlaceholderBoutiqueDetailCursorCollection = {
  __typename?: 'PlaceholderBoutiqueDetailCursorCollection';
  items: Array<Maybe<ContentfulPlaceholderBoutiqueDetail>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPlaceholderBoutiqueDetailFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderBoutiqueDetailFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderBoutiqueDetailFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulPlaceholderBoutiqueDetailLinkingCollections = {
  __typename?: 'PlaceholderBoutiqueDetailLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
};


export type ContentfulPlaceholderBoutiqueDetailLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderBoutiqueDetailLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderBoutiqueDetailLinkingCollectionsPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderBoutiqueDetailLinkingCollectionsPageBoutiqueDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderBoutiqueDetailLinkingCollectionsPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderBoutiqueDetailLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderBoutiqueDetailLinkingCollectionsPageBoutiqueDetailCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderBoutiqueDetailLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderBoutiqueDetailOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderCheckoutPayments) */
export type ContentfulPlaceholderCheckoutPayments = ContentfulEntry & Contentful_Node & {
  __typename?: 'PlaceholderCheckoutPayments';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  ctaTel?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPlaceholderCheckoutPaymentsLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  paymentsMediaCollection?: Maybe<ContentfulAssetCollection>;
  paymentsMediaCursorCollection?: Maybe<ContentfulAssetCursorCollection>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderCheckoutPayments) */
export type ContentfulPlaceholderCheckoutPaymentsCtaTelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderCheckoutPayments) */
export type ContentfulPlaceholderCheckoutPaymentsCtaTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderCheckoutPayments) */
export type ContentfulPlaceholderCheckoutPaymentsInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderCheckoutPayments) */
export type ContentfulPlaceholderCheckoutPaymentsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderCheckoutPayments) */
export type ContentfulPlaceholderCheckoutPaymentsLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderCheckoutPayments) */
export type ContentfulPlaceholderCheckoutPaymentsPaymentsMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderCheckoutPayments) */
export type ContentfulPlaceholderCheckoutPaymentsPaymentsMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderCheckoutPaymentsCollection = {
  __typename?: 'PlaceholderCheckoutPaymentsCollection';
  items: Array<Maybe<ContentfulPlaceholderCheckoutPayments>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPlaceholderCheckoutPaymentsCursorCollection = {
  __typename?: 'PlaceholderCheckoutPaymentsCursorCollection';
  items: Array<Maybe<ContentfulPlaceholderCheckoutPayments>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPlaceholderCheckoutPaymentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderCheckoutPaymentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderCheckoutPaymentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  ctaTel?: InputMaybe<Scalars['String']['input']>;
  ctaTel_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTel_not?: InputMaybe<Scalars['String']['input']>;
  ctaTel_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  ctaText_contains?: InputMaybe<Scalars['String']['input']>;
  ctaText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaText_not?: InputMaybe<Scalars['String']['input']>;
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  paymentsMediaCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPlaceholderCheckoutPaymentsLinkingCollections = {
  __typename?: 'PlaceholderCheckoutPaymentsLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderCheckoutPaymentsLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderCheckoutPaymentsOrder =
  | 'ctaTel_ASC'
  | 'ctaTel_DESC'
  | 'ctaText_ASC'
  | 'ctaText_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderCollection = {
  __typename?: 'PlaceholderCollection';
  items: Array<Maybe<ContentfulPlaceholder>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPlaceholderCursorCollection = {
  __typename?: 'PlaceholderCursorCollection';
  items: Array<Maybe<ContentfulPlaceholder>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPlaceholderFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtext_contains?: InputMaybe<Scalars['String']['input']>;
  subtext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtext_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  videoUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  warrantyTakingCareOfYourWatch?: InputMaybe<ContentfulCfCardNestedFilter>;
  warrantyTakingCareOfYourWatch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  warrantyText?: InputMaybe<ContentfulCfCardNestedFilter>;
  warrantyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderHeader) */
export type ContentfulPlaceholderHeader = ContentfulEntry & Contentful_Node & {
  __typename?: 'PlaceholderHeader';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPlaceholderHeaderLinkingCollections>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderHeader) */
export type ContentfulPlaceholderHeaderInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderHeader) */
export type ContentfulPlaceholderHeaderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulPlaceholderHeaderCollection = {
  __typename?: 'PlaceholderHeaderCollection';
  items: Array<Maybe<ContentfulPlaceholderHeader>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPlaceholderHeaderCursorCollection = {
  __typename?: 'PlaceholderHeaderCursorCollection';
  items: Array<Maybe<ContentfulPlaceholderHeader>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPlaceholderHeaderFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderHeaderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderHeaderFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPlaceholderHeaderLinkingCollections = {
  __typename?: 'PlaceholderHeaderLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
};


export type ContentfulPlaceholderHeaderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderHeaderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderHeaderLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderHeaderLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderHeaderLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderHeaderLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderHeaderLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderHeaderLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderHeaderOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderLinkingCollections = {
  __typename?: 'PlaceholderLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulPlaceholderLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulPlaceholderLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulPlaceholderLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderModelStory) */
export type ContentfulPlaceholderModelStory = ContentfulEntry & Contentful_Node & {
  __typename?: 'PlaceholderModelStory';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPlaceholderModelStoryLinkingCollections>;
  mediaAlignment?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  title?: Maybe<ContentfulHeading>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderModelStory) */
export type ContentfulPlaceholderModelStoryBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderModelStory) */
export type ContentfulPlaceholderModelStoryInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderModelStory) */
export type ContentfulPlaceholderModelStoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderModelStory) */
export type ContentfulPlaceholderModelStoryMediaAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderModelStory) */
export type ContentfulPlaceholderModelStoryTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderModelStory) */
export type ContentfulPlaceholderModelStoryTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderModelStoryCollection = {
  __typename?: 'PlaceholderModelStoryCollection';
  items: Array<Maybe<ContentfulPlaceholderModelStory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPlaceholderModelStoryCursorCollection = {
  __typename?: 'PlaceholderModelStoryCursorCollection';
  items: Array<Maybe<ContentfulPlaceholderModelStory>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPlaceholderModelStoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderModelStoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderModelStoryFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaAlignment?: InputMaybe<Scalars['String']['input']>;
  mediaAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  mediaAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaAlignment_not?: InputMaybe<Scalars['String']['input']>;
  mediaAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<ContentfulCfHeadingNestedFilter>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulPlaceholderModelStoryLinkingCollections = {
  __typename?: 'PlaceholderModelStoryLinkingCollections';
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulPlaceholderModelStoryLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderModelStoryLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderModelStoryLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderModelStoryLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderModelStoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderModelStoryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderModelStoryLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulPlaceholderModelStoryLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulPlaceholderModelStoryOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'mediaAlignment_ASC'
  | 'mediaAlignment_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'videoUrl_ASC'
  | 'videoUrl_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderProductDetails) */
export type ContentfulPlaceholderProductDetails = ContentfulEntry & Contentful_Node & {
  __typename?: 'PlaceholderProductDetails';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPlaceholderProductDetailsLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  perksCollection?: Maybe<ContentfulPlaceholderProductDetailsPerksCollection>;
  perksCursorCollection?: Maybe<ContentfulPlaceholderProductDetailsPerksCursorCollection>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderProductDetails) */
export type ContentfulPlaceholderProductDetailsInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderProductDetails) */
export type ContentfulPlaceholderProductDetailsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderProductDetails) */
export type ContentfulPlaceholderProductDetailsLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderProductDetails) */
export type ContentfulPlaceholderProductDetailsPerksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderProductDetailsPerksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulServicePerkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderProductDetails) */
export type ContentfulPlaceholderProductDetailsPerksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderProductDetailsPerksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulServicePerkFilter>;
};

export type ContentfulPlaceholderProductDetailsCollection = {
  __typename?: 'PlaceholderProductDetailsCollection';
  items: Array<Maybe<ContentfulPlaceholderProductDetails>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPlaceholderProductDetailsCursorCollection = {
  __typename?: 'PlaceholderProductDetailsCursorCollection';
  items: Array<Maybe<ContentfulPlaceholderProductDetails>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPlaceholderProductDetailsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderProductDetailsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderProductDetailsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  perks?: InputMaybe<ContentfulCfServicePerkNestedFilter>;
  perksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulPlaceholderProductDetailsLinkingCollections = {
  __typename?: 'PlaceholderProductDetailsLinkingCollections';
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulPlaceholderProductDetailsLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderProductDetailsLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderProductDetailsLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderProductDetailsLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderProductDetailsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderProductDetailsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderProductDetailsLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulPlaceholderProductDetailsLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulPlaceholderProductDetailsOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderProductDetailsPerksCollection = {
  __typename?: 'PlaceholderProductDetailsPerksCollection';
  items: Array<Maybe<ContentfulServicePerk>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPlaceholderProductDetailsPerksCollectionOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type ContentfulPlaceholderProductDetailsPerksCursorCollection = {
  __typename?: 'PlaceholderProductDetailsPerksCursorCollection';
  items: Array<Maybe<ContentfulServicePerk>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPlaceholderProductDetailsPerksCursorCollectionOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderService) */
export type ContentfulPlaceholderService = ContentfulEntry & Contentful_Node & {
  __typename?: 'PlaceholderService';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  heading?: Maybe<ContentfulHeading>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPlaceholderServiceLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  subtext?: Maybe<ContentfulPlaceholderServiceSubtext>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderService) */
export type ContentfulPlaceholderServiceHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderService) */
export type ContentfulPlaceholderServiceInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderService) */
export type ContentfulPlaceholderServiceLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderService) */
export type ContentfulPlaceholderServiceLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderService) */
export type ContentfulPlaceholderServiceSubtextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderService) */
export type ContentfulPlaceholderServiceTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderServiceCollection = {
  __typename?: 'PlaceholderServiceCollection';
  items: Array<Maybe<ContentfulPlaceholderService>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPlaceholderServiceCursorCollection = {
  __typename?: 'PlaceholderServiceCursorCollection';
  items: Array<Maybe<ContentfulPlaceholderService>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPlaceholderServiceFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  heading?: InputMaybe<ContentfulCfHeadingNestedFilter>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtext_contains?: InputMaybe<Scalars['String']['input']>;
  subtext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtext_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulPlaceholderServiceLinkingCollections = {
  __typename?: 'PlaceholderServiceLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  contentGroupCollection?: Maybe<ContentfulContentGroupCollection>;
  contentGroupCursorCollection?: Maybe<ContentfulContentGroupCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulPlaceholderServiceLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderServiceLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderServiceLinkingCollectionsContentGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceLinkingCollectionsContentGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderServiceLinkingCollectionsContentGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceLinkingCollectionsContentGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderServiceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderServiceLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderServiceLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderServiceLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderServiceLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderServiceLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderServiceLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderServiceLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderServiceLinkingCollectionsContentGroupCollectionOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderServiceLinkingCollectionsContentGroupCursorCollectionOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderServiceLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderServiceLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderServiceLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderServiceLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderServiceOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderServiceSubtext = {
  __typename?: 'PlaceholderServiceSubtext';
  json: Scalars['JSON']['output'];
  links: ContentfulPlaceholderServiceSubtextLinks;
};

export type ContentfulPlaceholderServiceSubtextAssets = {
  __typename?: 'PlaceholderServiceSubtextAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulPlaceholderServiceSubtextEntries = {
  __typename?: 'PlaceholderServiceSubtextEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulPlaceholderServiceSubtextLinks = {
  __typename?: 'PlaceholderServiceSubtextLinks';
  assets: ContentfulPlaceholderServiceSubtextAssets;
  entries: ContentfulPlaceholderServiceSubtextEntries;
  resources: ContentfulPlaceholderServiceSubtextResources;
};

export type ContentfulPlaceholderServiceSubtextResources = {
  __typename?: 'PlaceholderServiceSubtextResources';
  block: Array<ContentfulPlaceholderServiceSubtextResourcesBlock>;
  hyperlink: Array<ContentfulPlaceholderServiceSubtextResourcesHyperlink>;
  inline: Array<ContentfulPlaceholderServiceSubtextResourcesInline>;
};

export type ContentfulPlaceholderServiceSubtextResourcesBlock = ContentfulResourceLink & {
  __typename?: 'PlaceholderServiceSubtextResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulPlaceholderServiceSubtextResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'PlaceholderServiceSubtextResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulPlaceholderServiceSubtextResourcesInline = ContentfulResourceLink & {
  __typename?: 'PlaceholderServiceSubtextResourcesInline';
  sys: ContentfulResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStores = ContentfulEntry & Contentful_Node & {
  __typename?: 'PlaceholderStores';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  boutiqueReferenceKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentfulMetadata: ContentfulContentfulMetadata;
  eyewearAvailable?: Maybe<Scalars['Boolean']['output']>;
  findAStore?: Maybe<ContentfulFindAStore>;
  heading?: Maybe<ContentfulHeading>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulPlaceholderStoresLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  numberOfStores?: Maybe<Scalars['Int']['output']>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStoresBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStoresBoutiqueReferenceKeysArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStoresEyewearAvailableArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStoresFindAStoreArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFindAStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStoresHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStoresInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStoresLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStoresLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStoresNumberOfStoresArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/placeholderStores) */
export type ContentfulPlaceholderStoresTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderStoresCollection = {
  __typename?: 'PlaceholderStoresCollection';
  items: Array<Maybe<ContentfulPlaceholderStores>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulPlaceholderStoresCursorCollection = {
  __typename?: 'PlaceholderStoresCursorCollection';
  items: Array<Maybe<ContentfulPlaceholderStores>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulPlaceholderStoresFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  boutiqueReferenceKeys_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  boutiqueReferenceKeys_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  boutiqueReferenceKeys_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  boutiqueReferenceKeys_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  eyewearAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  eyewearAvailable_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyewearAvailable_not?: InputMaybe<Scalars['Boolean']['input']>;
  findAStore?: InputMaybe<ContentfulCfFindAStoreNestedFilter>;
  findAStore_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<ContentfulCfHeadingNestedFilter>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfStores?: InputMaybe<Scalars['Int']['input']>;
  numberOfStores_exists?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfStores_gt?: InputMaybe<Scalars['Int']['input']>;
  numberOfStores_gte?: InputMaybe<Scalars['Int']['input']>;
  numberOfStores_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfStores_lt?: InputMaybe<Scalars['Int']['input']>;
  numberOfStores_lte?: InputMaybe<Scalars['Int']['input']>;
  numberOfStores_not?: InputMaybe<Scalars['Int']['input']>;
  numberOfStores_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulPlaceholderStoresLinkingCollections = {
  __typename?: 'PlaceholderStoresLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulPlaceholderStoresLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulPlaceholderStoresLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderStoresLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulPlaceholderStoresOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyewearAvailable_ASC'
  | 'eyewearAvailable_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'numberOfStores_ASC'
  | 'numberOfStores_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulPlaceholderSubtext = {
  __typename?: 'PlaceholderSubtext';
  json: Scalars['JSON']['output'];
  links: ContentfulPlaceholderSubtextLinks;
};

export type ContentfulPlaceholderSubtextAssets = {
  __typename?: 'PlaceholderSubtextAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulPlaceholderSubtextEntries = {
  __typename?: 'PlaceholderSubtextEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulPlaceholderSubtextLinks = {
  __typename?: 'PlaceholderSubtextLinks';
  assets: ContentfulPlaceholderSubtextAssets;
  entries: ContentfulPlaceholderSubtextEntries;
  resources: ContentfulPlaceholderSubtextResources;
};

export type ContentfulPlaceholderSubtextResources = {
  __typename?: 'PlaceholderSubtextResources';
  block: Array<ContentfulPlaceholderSubtextResourcesBlock>;
  hyperlink: Array<ContentfulPlaceholderSubtextResourcesHyperlink>;
  inline: Array<ContentfulPlaceholderSubtextResourcesInline>;
};

export type ContentfulPlaceholderSubtextResourcesBlock = ContentfulResourceLink & {
  __typename?: 'PlaceholderSubtextResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulPlaceholderSubtextResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'PlaceholderSubtextResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulPlaceholderSubtextResourcesInline = ContentfulResourceLink & {
  __typename?: 'PlaceholderSubtextResourcesInline';
  sys: ContentfulResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCard = ContentfulEntry & Contentful_Node & {
  __typename?: 'ProductCard';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulContentfulMetadata;
  hoverStyle?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulProductCardLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  showCta?: Maybe<Scalars['Boolean']['output']>;
  showLabel?: Maybe<Scalars['Boolean']['output']>;
  showPrice?: Maybe<Scalars['Boolean']['output']>;
  showShare?: Maybe<Scalars['Boolean']['output']>;
  showWishlist?: Maybe<Scalars['Boolean']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardHoverStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardProductArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardShowCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardShowLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardShowPriceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardShowShareArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardShowWishlistArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardSkuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/productCard) */
export type ContentfulProductCardVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulProductCardCollection = {
  __typename?: 'ProductCardCollection';
  items: Array<Maybe<ContentfulProductCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulProductCardCursorCollection = {
  __typename?: 'ProductCardCursorCollection';
  items: Array<Maybe<ContentfulProductCard>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulProductCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulProductCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulProductCardFilter>>>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  hoverStyle?: InputMaybe<Scalars['String']['input']>;
  hoverStyle_contains?: InputMaybe<Scalars['String']['input']>;
  hoverStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hoverStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hoverStyle_not?: InputMaybe<Scalars['String']['input']>;
  hoverStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  hoverStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  product_contains?: InputMaybe<Scalars['String']['input']>;
  product_exists?: InputMaybe<Scalars['Boolean']['input']>;
  product_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product_not?: InputMaybe<Scalars['String']['input']>;
  product_not_contains?: InputMaybe<Scalars['String']['input']>;
  product_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showCta?: InputMaybe<Scalars['Boolean']['input']>;
  showCta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showCta_not?: InputMaybe<Scalars['Boolean']['input']>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
  showLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  showPrice?: InputMaybe<Scalars['Boolean']['input']>;
  showPrice_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showPrice_not?: InputMaybe<Scalars['Boolean']['input']>;
  showShare?: InputMaybe<Scalars['Boolean']['input']>;
  showShare_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showShare_not?: InputMaybe<Scalars['Boolean']['input']>;
  showWishlist?: InputMaybe<Scalars['Boolean']['input']>;
  showWishlist_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showWishlist_not?: InputMaybe<Scalars['Boolean']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sku_contains?: InputMaybe<Scalars['String']['input']>;
  sku_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sku_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sku_not?: InputMaybe<Scalars['String']['input']>;
  sku_not_contains?: InputMaybe<Scalars['String']['input']>;
  sku_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulProductCardLinkingCollections = {
  __typename?: 'ProductCardLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  contentGroupCollection?: Maybe<ContentfulContentGroupCollection>;
  contentGroupCursorCollection?: Maybe<ContentfulContentGroupCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  gridCollection?: Maybe<ContentfulGridCollection>;
  gridCursorCollection?: Maybe<ContentfulGridCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulProductCardLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsContentGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsContentGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsContentGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsContentGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulProductCardLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulProductCardLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulProductCardLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulProductCardLinkingCollectionsContentGroupCollectionOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulProductCardLinkingCollectionsContentGroupCursorCollectionOrder =
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulProductCardLinkingCollectionsGridCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulProductCardLinkingCollectionsGridCursorCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulProductCardLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulProductCardLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulProductCardLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulProductCardLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulProductCardLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulProductCardLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulProductCardLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulProductCardLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulProductCardOrder =
  | 'hoverStyle_ASC'
  | 'hoverStyle_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'product_ASC'
  | 'product_DESC'
  | 'showCta_ASC'
  | 'showCta_DESC'
  | 'showLabel_ASC'
  | 'showLabel_DESC'
  | 'showPrice_ASC'
  | 'showPrice_DESC'
  | 'showShare_ASC'
  | 'showShare_DESC'
  | 'showWishlist_ASC'
  | 'showWishlist_DESC'
  | 'sku_ASC'
  | 'sku_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentfulQuery = {
  __typename?: 'Query';
  _node?: Maybe<Contentful_Node>;
  _nodes: Array<Maybe<Contentful_Node>>;
  alertBanner?: Maybe<ContentfulAlertBanner>;
  alertBannerCollection?: Maybe<ContentfulAlertBannerCollection>;
  alertBannerCursorCollection?: Maybe<ContentfulAlertBannerCursorCollection>;
  asset?: Maybe<ContentfulAsset>;
  assetCollection?: Maybe<ContentfulAssetCollection>;
  assetCursorCollection?: Maybe<ContentfulAssetCursorCollection>;
  automaticCollectionGroup?: Maybe<ContentfulAutomaticCollectionGroup>;
  automaticCollectionGroupCollection?: Maybe<ContentfulAutomaticCollectionGroupCollection>;
  automaticCollectionGroupCursorCollection?: Maybe<ContentfulAutomaticCollectionGroupCursorCollection>;
  banner?: Maybe<ContentfulBanner>;
  bannerCollection?: Maybe<ContentfulBannerCollection>;
  bannerCursorCollection?: Maybe<ContentfulBannerCursorCollection>;
  bannerHero?: Maybe<ContentfulBannerHero>;
  bannerHeroCollection?: Maybe<ContentfulBannerHeroCollection>;
  bannerHeroCursorCollection?: Maybe<ContentfulBannerHeroCursorCollection>;
  breadcrumb?: Maybe<ContentfulBreadcrumb>;
  breadcrumbCollection?: Maybe<ContentfulBreadcrumbCollection>;
  breadcrumbCursorCollection?: Maybe<ContentfulBreadcrumbCursorCollection>;
  card?: Maybe<ContentfulCard>;
  cardCollection?: Maybe<ContentfulCardCollection>;
  cardCursorCollection?: Maybe<ContentfulCardCursorCollection>;
  collectionGroup?: Maybe<ContentfulCollectionGroup>;
  collectionGroupCollection?: Maybe<ContentfulCollectionGroupCollection>;
  collectionGroupCursorCollection?: Maybe<ContentfulCollectionGroupCursorCollection>;
  collectionGroupEndImage?: Maybe<ContentfulCollectionGroupEndImage>;
  collectionGroupEndImageCollection?: Maybe<ContentfulCollectionGroupEndImageCollection>;
  collectionGroupEndImageCursorCollection?: Maybe<ContentfulCollectionGroupEndImageCursorCollection>;
  collectionItem?: Maybe<ContentfulCollectionItem>;
  collectionItemCollection?: Maybe<ContentfulCollectionItemCollection>;
  collectionItemCursorCollection?: Maybe<ContentfulCollectionItemCursorCollection>;
  conditionalComponent?: Maybe<ContentfulConditionalComponent>;
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  contactUs?: Maybe<ContentfulContactUs>;
  contactUsCollection?: Maybe<ContentfulContactUsCollection>;
  contactUsCursorCollection?: Maybe<ContentfulContactUsCursorCollection>;
  contentGroup?: Maybe<ContentfulContentGroup>;
  contentGroupCollection?: Maybe<ContentfulContentGroupCollection>;
  contentGroupCursorCollection?: Maybe<ContentfulContentGroupCursorCollection>;
  defaultLayout?: Maybe<ContentfulDefaultLayout>;
  defaultLayoutCollection?: Maybe<ContentfulDefaultLayoutCollection>;
  defaultLayoutCursorCollection?: Maybe<ContentfulDefaultLayoutCursorCollection>;
  detailPage?: Maybe<ContentfulDetailPage>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  dictionary?: Maybe<ContentfulDictionary>;
  dictionaryCollection?: Maybe<ContentfulDictionaryCollection>;
  dictionaryCursorCollection?: Maybe<ContentfulDictionaryCursorCollection>;
  dictionaryItem?: Maybe<ContentfulDictionaryItem>;
  dictionaryItemCollection?: Maybe<ContentfulDictionaryItemCollection>;
  dictionaryItemCursorCollection?: Maybe<ContentfulDictionaryItemCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  event?: Maybe<ContentfulEvent>;
  eventCollection?: Maybe<ContentfulEventCollection>;
  eventCursorCollection?: Maybe<ContentfulEventCursorCollection>;
  exhibitionItem?: Maybe<ContentfulExhibitionItem>;
  exhibitionItemCollection?: Maybe<ContentfulExhibitionItemCollection>;
  exhibitionItemCursorCollection?: Maybe<ContentfulExhibitionItemCursorCollection>;
  exhibitionList?: Maybe<ContentfulExhibitionList>;
  exhibitionListCollection?: Maybe<ContentfulExhibitionListCollection>;
  exhibitionListCursorCollection?: Maybe<ContentfulExhibitionListCursorCollection>;
  faqCategories?: Maybe<ContentfulFaqCategories>;
  faqCategoriesCollection?: Maybe<ContentfulFaqCategoriesCollection>;
  faqCategoriesCursorCollection?: Maybe<ContentfulFaqCategoriesCursorCollection>;
  faqItem?: Maybe<ContentfulFaqItem>;
  faqItemCollection?: Maybe<ContentfulFaqItemCollection>;
  faqItemCursorCollection?: Maybe<ContentfulFaqItemCursorCollection>;
  faqWrap?: Maybe<ContentfulFaqWrap>;
  faqWrapCollection?: Maybe<ContentfulFaqWrapCollection>;
  faqWrapCursorCollection?: Maybe<ContentfulFaqWrapCursorCollection>;
  findAStore?: Maybe<ContentfulFindAStore>;
  findAStoreCollection?: Maybe<ContentfulFindAStoreCollection>;
  findAStoreCursorCollection?: Maybe<ContentfulFindAStoreCursorCollection>;
  footer?: Maybe<ContentfulFooter>;
  footerCollection?: Maybe<ContentfulFooterCollection>;
  footerCursorCollection?: Maybe<ContentfulFooterCursorCollection>;
  freeTextContent?: Maybe<ContentfulFreeTextContent>;
  freeTextContentCollection?: Maybe<ContentfulFreeTextContentCollection>;
  freeTextContentCursorCollection?: Maybe<ContentfulFreeTextContentCursorCollection>;
  grid?: Maybe<ContentfulGrid>;
  gridCollection?: Maybe<ContentfulGridCollection>;
  gridCursorCollection?: Maybe<ContentfulGridCursorCollection>;
  heading?: Maybe<ContentfulHeading>;
  headingCollection?: Maybe<ContentfulHeadingCollection>;
  headingCursorCollection?: Maybe<ContentfulHeadingCursorCollection>;
  heroProductListing?: Maybe<ContentfulHeroProductListing>;
  heroProductListingCollection?: Maybe<ContentfulHeroProductListingCollection>;
  heroProductListingCursorCollection?: Maybe<ContentfulHeroProductListingCursorCollection>;
  heroSlider?: Maybe<ContentfulHeroSlider>;
  heroSliderCollection?: Maybe<ContentfulHeroSliderCollection>;
  heroSliderCursorCollection?: Maybe<ContentfulHeroSliderCursorCollection>;
  iframe?: Maybe<ContentfulIframe>;
  iframeCollection?: Maybe<ContentfulIframeCollection>;
  iframeCursorCollection?: Maybe<ContentfulIframeCursorCollection>;
  imageWithFocalPoint?: Maybe<ContentfulImageWithFocalPoint>;
  imageWithFocalPointCollection?: Maybe<ContentfulImageWithFocalPointCollection>;
  imageWithFocalPointCursorCollection?: Maybe<ContentfulImageWithFocalPointCursorCollection>;
  listingPage?: Maybe<ContentfulListingPage>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  mainHeader?: Maybe<ContentfulMainHeader>;
  mainHeaderCollection?: Maybe<ContentfulMainHeaderCollection>;
  mainHeaderCursorCollection?: Maybe<ContentfulMainHeaderCursorCollection>;
  mainMenuItem?: Maybe<ContentfulMainMenuItem>;
  mainMenuItemCollection?: Maybe<ContentfulMainMenuItemCollection>;
  mainMenuItemCursorCollection?: Maybe<ContentfulMainMenuItemCursorCollection>;
  manualCollectionGroupProductReferences?: Maybe<ContentfulManualCollectionGroupProductReferences>;
  manualCollectionGroupProductReferencesCollection?: Maybe<ContentfulManualCollectionGroupProductReferencesCollection>;
  manualCollectionGroupProductReferencesCursorCollection?: Maybe<ContentfulManualCollectionGroupProductReferencesCursorCollection>;
  megaMenu?: Maybe<ContentfulMegaMenu>;
  megaMenuCollection?: Maybe<ContentfulMegaMenuCollection>;
  megaMenuCursorCollection?: Maybe<ContentfulMegaMenuCursorCollection>;
  navQuickLinkItem?: Maybe<ContentfulNavQuickLinkItem>;
  navQuickLinkItemCollection?: Maybe<ContentfulNavQuickLinkItemCollection>;
  navQuickLinkItemCursorCollection?: Maybe<ContentfulNavQuickLinkItemCursorCollection>;
  navQuickLinks?: Maybe<ContentfulNavQuickLinks>;
  navQuickLinksCollection?: Maybe<ContentfulNavQuickLinksCollection>;
  navQuickLinksCursorCollection?: Maybe<ContentfulNavQuickLinksCursorCollection>;
  navQuickLinksWithBanner?: Maybe<ContentfulNavQuickLinksWithBanner>;
  navQuickLinksWithBannerCollection?: Maybe<ContentfulNavQuickLinksWithBannerCollection>;
  navQuickLinksWithBannerCursorCollection?: Maybe<ContentfulNavQuickLinksWithBannerCursorCollection>;
  page?: Maybe<ContentfulPage>;
  pageBoutiqueDetail?: Maybe<ContentfulPageBoutiqueDetail>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
  pageBoutiqueList?: Maybe<ContentfulPageBoutiqueList>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaq?: Maybe<ContentfulPageExhibitionHistoriesFaq>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
  pageFixed?: Maybe<ContentfulPageFixed>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
  placeholder?: Maybe<ContentfulPlaceholder>;
  placeholderBoutiqueDetail?: Maybe<ContentfulPlaceholderBoutiqueDetail>;
  placeholderBoutiqueDetailCollection?: Maybe<ContentfulPlaceholderBoutiqueDetailCollection>;
  placeholderBoutiqueDetailCursorCollection?: Maybe<ContentfulPlaceholderBoutiqueDetailCursorCollection>;
  placeholderCheckoutPayments?: Maybe<ContentfulPlaceholderCheckoutPayments>;
  placeholderCheckoutPaymentsCollection?: Maybe<ContentfulPlaceholderCheckoutPaymentsCollection>;
  placeholderCheckoutPaymentsCursorCollection?: Maybe<ContentfulPlaceholderCheckoutPaymentsCursorCollection>;
  placeholderCollection?: Maybe<ContentfulPlaceholderCollection>;
  placeholderCursorCollection?: Maybe<ContentfulPlaceholderCursorCollection>;
  placeholderHeader?: Maybe<ContentfulPlaceholderHeader>;
  placeholderHeaderCollection?: Maybe<ContentfulPlaceholderHeaderCollection>;
  placeholderHeaderCursorCollection?: Maybe<ContentfulPlaceholderHeaderCursorCollection>;
  placeholderModelStory?: Maybe<ContentfulPlaceholderModelStory>;
  placeholderModelStoryCollection?: Maybe<ContentfulPlaceholderModelStoryCollection>;
  placeholderModelStoryCursorCollection?: Maybe<ContentfulPlaceholderModelStoryCursorCollection>;
  placeholderProductDetails?: Maybe<ContentfulPlaceholderProductDetails>;
  placeholderProductDetailsCollection?: Maybe<ContentfulPlaceholderProductDetailsCollection>;
  placeholderProductDetailsCursorCollection?: Maybe<ContentfulPlaceholderProductDetailsCursorCollection>;
  placeholderService?: Maybe<ContentfulPlaceholderService>;
  placeholderServiceCollection?: Maybe<ContentfulPlaceholderServiceCollection>;
  placeholderServiceCursorCollection?: Maybe<ContentfulPlaceholderServiceCursorCollection>;
  placeholderStores?: Maybe<ContentfulPlaceholderStores>;
  placeholderStoresCollection?: Maybe<ContentfulPlaceholderStoresCollection>;
  placeholderStoresCursorCollection?: Maybe<ContentfulPlaceholderStoresCursorCollection>;
  productCard?: Maybe<ContentfulProductCard>;
  productCardCollection?: Maybe<ContentfulProductCardCollection>;
  productCardCursorCollection?: Maybe<ContentfulProductCardCursorCollection>;
  scrollerItem?: Maybe<ContentfulScrollerItem>;
  scrollerItemCollection?: Maybe<ContentfulScrollerItemCollection>;
  scrollerItemCursorCollection?: Maybe<ContentfulScrollerItemCursorCollection>;
  searchOverlay?: Maybe<ContentfulSearchOverlay>;
  searchOverlayCollection?: Maybe<ContentfulSearchOverlayCollection>;
  searchOverlayCursorCollection?: Maybe<ContentfulSearchOverlayCursorCollection>;
  selector?: Maybe<ContentfulSelector>;
  selectorCollection?: Maybe<ContentfulSelectorCollection>;
  selectorCursorCollection?: Maybe<ContentfulSelectorCursorCollection>;
  selectorLink?: Maybe<ContentfulSelectorLink>;
  selectorLinkCollection?: Maybe<ContentfulSelectorLinkCollection>;
  selectorLinkCursorCollection?: Maybe<ContentfulSelectorLinkCursorCollection>;
  seoConfiguration?: Maybe<ContentfulSeoConfiguration>;
  seoConfigurationCollection?: Maybe<ContentfulSeoConfigurationCollection>;
  seoConfigurationCursorCollection?: Maybe<ContentfulSeoConfigurationCursorCollection>;
  serviceItem?: Maybe<ContentfulServiceItem>;
  serviceItemCollection?: Maybe<ContentfulServiceItemCollection>;
  serviceItemCursorCollection?: Maybe<ContentfulServiceItemCursorCollection>;
  servicePerk?: Maybe<ContentfulServicePerk>;
  servicePerkCollection?: Maybe<ContentfulServicePerkCollection>;
  servicePerkCursorCollection?: Maybe<ContentfulServicePerkCursorCollection>;
  servicesCollection?: Maybe<ContentfulServicesCollection>;
  servicesCollectionCollection?: Maybe<ContentfulServicesCollectionCollection>;
  servicesCollectionCursorCollection?: Maybe<ContentfulServicesCollectionCursorCollection>;
  simpleFooter?: Maybe<ContentfulSimpleFooter>;
  simpleFooterCollection?: Maybe<ContentfulSimpleFooterCollection>;
  simpleFooterCursorCollection?: Maybe<ContentfulSimpleFooterCursorCollection>;
  sliderProductsAutomatic?: Maybe<ContentfulSliderProductsAutomatic>;
  sliderProductsAutomaticCollection?: Maybe<ContentfulSliderProductsAutomaticCollection>;
  sliderProductsAutomaticCursorCollection?: Maybe<ContentfulSliderProductsAutomaticCursorCollection>;
  sliderProductsManual?: Maybe<ContentfulSliderProductsManual>;
  sliderProductsManualCollection?: Maybe<ContentfulSliderProductsManualCollection>;
  sliderProductsManualCursorCollection?: Maybe<ContentfulSliderProductsManualCursorCollection>;
};


export type ContentfulQuery_NodeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQuery_NodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryAlertBannerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryAlertBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulAlertBannerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulAlertBannerFilter>;
};


export type ContentfulQueryAlertBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulAlertBannerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulAlertBannerFilter>;
};


export type ContentfulQueryAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulAssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulAssetFilter>;
};


export type ContentfulQueryAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulAssetOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulAssetFilter>;
};


export type ContentfulQueryAutomaticCollectionGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryAutomaticCollectionGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulAutomaticCollectionGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulAutomaticCollectionGroupFilter>;
};


export type ContentfulQueryAutomaticCollectionGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulAutomaticCollectionGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulAutomaticCollectionGroupFilter>;
};


export type ContentfulQueryBannerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulBannerFilter>;
};


export type ContentfulQueryBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulBannerFilter>;
};


export type ContentfulQueryBannerHeroArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryBannerHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerHeroOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulBannerHeroFilter>;
};


export type ContentfulQueryBannerHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBannerHeroOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulBannerHeroFilter>;
};


export type ContentfulQueryBreadcrumbArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryBreadcrumbCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulBreadcrumbFilter>;
};


export type ContentfulQueryBreadcrumbCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulBreadcrumbOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulBreadcrumbFilter>;
};


export type ContentfulQueryCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCardFilter>;
};


export type ContentfulQueryCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCardFilter>;
};


export type ContentfulQueryCollectionGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryCollectionGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCollectionGroupFilter>;
};


export type ContentfulQueryCollectionGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCollectionGroupFilter>;
};


export type ContentfulQueryCollectionGroupEndImageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryCollectionGroupEndImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupEndImageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCollectionGroupEndImageFilter>;
};


export type ContentfulQueryCollectionGroupEndImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionGroupEndImageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCollectionGroupEndImageFilter>;
};


export type ContentfulQueryCollectionItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryCollectionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCollectionItemFilter>;
};


export type ContentfulQueryCollectionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulCollectionItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulCollectionItemFilter>;
};


export type ContentfulQueryConditionalComponentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulConditionalComponentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulConditionalComponentFilter>;
};


export type ContentfulQueryConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulConditionalComponentOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulConditionalComponentFilter>;
};


export type ContentfulQueryContactUsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryContactUsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulContactUsFilter>;
};


export type ContentfulQueryContactUsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContactUsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulContactUsFilter>;
};


export type ContentfulQueryContentGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryContentGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulContentGroupFilter>;
};


export type ContentfulQueryContentGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulContentGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulContentGroupFilter>;
};


export type ContentfulQueryDefaultLayoutArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryDefaultLayoutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDefaultLayoutOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDefaultLayoutFilter>;
};


export type ContentfulQueryDefaultLayoutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDefaultLayoutOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDefaultLayoutFilter>;
};


export type ContentfulQueryDetailPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDetailPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDetailPageFilter>;
};


export type ContentfulQueryDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDetailPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDetailPageFilter>;
};


export type ContentfulQueryDictionaryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryDictionaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDictionaryFilter>;
};


export type ContentfulQueryDictionaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDictionaryFilter>;
};


export type ContentfulQueryDictionaryItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryDictionaryItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDictionaryItemFilter>;
};


export type ContentfulQueryDictionaryItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulDictionaryItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulDictionaryItemFilter>;
};


export type ContentfulQueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulEntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulEntryFilter>;
};


export type ContentfulQueryEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulEntryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulEntryFilter>;
};


export type ContentfulQueryEventArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulEventOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulEventFilter>;
};


export type ContentfulQueryEventCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulEventOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulEventFilter>;
};


export type ContentfulQueryExhibitionItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryExhibitionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulExhibitionItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulExhibitionItemFilter>;
};


export type ContentfulQueryExhibitionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulExhibitionItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulExhibitionItemFilter>;
};


export type ContentfulQueryExhibitionListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryExhibitionListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulExhibitionListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulExhibitionListFilter>;
};


export type ContentfulQueryExhibitionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulExhibitionListOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulExhibitionListFilter>;
};


export type ContentfulQueryFaqCategoriesArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryFaqCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqCategoriesOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFaqCategoriesFilter>;
};


export type ContentfulQueryFaqCategoriesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqCategoriesOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFaqCategoriesFilter>;
};


export type ContentfulQueryFaqItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryFaqItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFaqItemFilter>;
};


export type ContentfulQueryFaqItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFaqItemFilter>;
};


export type ContentfulQueryFaqWrapArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryFaqWrapCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFaqWrapFilter>;
};


export type ContentfulQueryFaqWrapCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFaqWrapOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFaqWrapFilter>;
};


export type ContentfulQueryFindAStoreArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryFindAStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFindAStoreFilter>;
};


export type ContentfulQueryFindAStoreCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFindAStoreOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFindAStoreFilter>;
};


export type ContentfulQueryFooterArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFooterFilter>;
};


export type ContentfulQueryFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFooterOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFooterFilter>;
};


export type ContentfulQueryFreeTextContentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryFreeTextContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFreeTextContentFilter>;
};


export type ContentfulQueryFreeTextContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulFreeTextContentOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulFreeTextContentFilter>;
};


export type ContentfulQueryGridArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulGridFilter>;
};


export type ContentfulQueryGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulGridOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulGridFilter>;
};


export type ContentfulQueryHeadingArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryHeadingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};


export type ContentfulQueryHeadingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeadingOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};


export type ContentfulQueryHeroProductListingArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryHeroProductListingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroProductListingOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeroProductListingFilter>;
};


export type ContentfulQueryHeroProductListingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroProductListingOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeroProductListingFilter>;
};


export type ContentfulQueryHeroSliderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryHeroSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeroSliderFilter>;
};


export type ContentfulQueryHeroSliderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulHeroSliderOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeroSliderFilter>;
};


export type ContentfulQueryIframeArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryIframeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulIframeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulIframeFilter>;
};


export type ContentfulQueryIframeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulIframeOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulIframeFilter>;
};


export type ContentfulQueryImageWithFocalPointArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryImageWithFocalPointCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


export type ContentfulQueryImageWithFocalPointCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulImageWithFocalPointOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulImageWithFocalPointFilter>;
};


export type ContentfulQueryListingPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulListingPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulListingPageFilter>;
};


export type ContentfulQueryListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulListingPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulListingPageFilter>;
};


export type ContentfulQueryLiveStoryContentTypeArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryLiveStoryContentTypeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulLiveStoryContentTypeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulLiveStoryContentTypeFilter>;
};


export type ContentfulQueryLiveStoryContentTypeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulLiveStoryContentTypeOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulLiveStoryContentTypeFilter>;
};


export type ContentfulQueryMainHeaderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryMainHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainHeaderFilter>;
};


export type ContentfulQueryMainHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainHeaderOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainHeaderFilter>;
};


export type ContentfulQueryMainMenuItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryMainMenuItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainMenuItemFilter>;
};


export type ContentfulQueryMainMenuItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMainMenuItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMainMenuItemFilter>;
};


export type ContentfulQueryManualCollectionGroupProductReferencesArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryManualCollectionGroupProductReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulManualCollectionGroupProductReferencesOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulManualCollectionGroupProductReferencesFilter>;
};


export type ContentfulQueryManualCollectionGroupProductReferencesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulManualCollectionGroupProductReferencesOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulManualCollectionGroupProductReferencesFilter>;
};


export type ContentfulQueryMegaMenuArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryMegaMenuCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMegaMenuOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMegaMenuFilter>;
};


export type ContentfulQueryMegaMenuCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulMegaMenuOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulMegaMenuFilter>;
};


export type ContentfulQueryNavQuickLinkItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryNavQuickLinkItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinkItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulNavQuickLinkItemFilter>;
};


export type ContentfulQueryNavQuickLinkItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinkItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulNavQuickLinkItemFilter>;
};


export type ContentfulQueryNavQuickLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryNavQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulNavQuickLinksFilter>;
};


export type ContentfulQueryNavQuickLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulNavQuickLinksFilter>;
};


export type ContentfulQueryNavQuickLinksWithBannerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryNavQuickLinksWithBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksWithBannerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulNavQuickLinksWithBannerFilter>;
};


export type ContentfulQueryNavQuickLinksWithBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulNavQuickLinksWithBannerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulNavQuickLinksWithBannerFilter>;
};


export type ContentfulQueryPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPageBoutiqueDetailArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueDetailOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageBoutiqueDetailFilter>;
};


export type ContentfulQueryPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueDetailOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageBoutiqueDetailFilter>;
};


export type ContentfulQueryPageBoutiqueListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageBoutiqueListFilter>;
};


export type ContentfulQueryPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageBoutiqueListOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageBoutiqueListFilter>;
};


export type ContentfulQueryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageFilter>;
};


export type ContentfulQueryPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageFilter>;
};


export type ContentfulQueryPageExhibitionHistoriesFaqArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageExhibitionHistoriesFaqOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageExhibitionHistoriesFaqFilter>;
};


export type ContentfulQueryPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageExhibitionHistoriesFaqOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageExhibitionHistoriesFaqFilter>;
};


export type ContentfulQueryPageFixedArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageFixedOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageFixedFilter>;
};


export type ContentfulQueryPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPageFixedOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPageFixedFilter>;
};


export type ContentfulQueryPlaceholderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPlaceholderBoutiqueDetailArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPlaceholderBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderBoutiqueDetailOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderBoutiqueDetailFilter>;
};


export type ContentfulQueryPlaceholderBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderBoutiqueDetailOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderBoutiqueDetailFilter>;
};


export type ContentfulQueryPlaceholderCheckoutPaymentsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPlaceholderCheckoutPaymentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderCheckoutPaymentsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderCheckoutPaymentsFilter>;
};


export type ContentfulQueryPlaceholderCheckoutPaymentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderCheckoutPaymentsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderCheckoutPaymentsFilter>;
};


export type ContentfulQueryPlaceholderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderFilter>;
};


export type ContentfulQueryPlaceholderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderFilter>;
};


export type ContentfulQueryPlaceholderHeaderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPlaceholderHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderHeaderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderHeaderFilter>;
};


export type ContentfulQueryPlaceholderHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderHeaderOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderHeaderFilter>;
};


export type ContentfulQueryPlaceholderModelStoryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPlaceholderModelStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderModelStoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderModelStoryFilter>;
};


export type ContentfulQueryPlaceholderModelStoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderModelStoryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderModelStoryFilter>;
};


export type ContentfulQueryPlaceholderProductDetailsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPlaceholderProductDetailsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderProductDetailsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderProductDetailsFilter>;
};


export type ContentfulQueryPlaceholderProductDetailsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderProductDetailsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderProductDetailsFilter>;
};


export type ContentfulQueryPlaceholderServiceArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPlaceholderServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderServiceFilter>;
};


export type ContentfulQueryPlaceholderServiceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderServiceOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderServiceFilter>;
};


export type ContentfulQueryPlaceholderStoresArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryPlaceholderStoresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderStoresFilter>;
};


export type ContentfulQueryPlaceholderStoresCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulPlaceholderStoresOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulPlaceholderStoresFilter>;
};


export type ContentfulQueryProductCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryProductCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulProductCardFilter>;
};


export type ContentfulQueryProductCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulProductCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulProductCardFilter>;
};


export type ContentfulQueryScrollerItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryScrollerItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulScrollerItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulScrollerItemFilter>;
};


export type ContentfulQueryScrollerItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulScrollerItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulScrollerItemFilter>;
};


export type ContentfulQuerySearchOverlayArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQuerySearchOverlayCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSearchOverlayOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSearchOverlayFilter>;
};


export type ContentfulQuerySearchOverlayCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSearchOverlayOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSearchOverlayFilter>;
};


export type ContentfulQuerySelectorArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQuerySelectorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSelectorOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSelectorFilter>;
};


export type ContentfulQuerySelectorCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSelectorOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSelectorFilter>;
};


export type ContentfulQuerySelectorLinkArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQuerySelectorLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSelectorLinkOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSelectorLinkFilter>;
};


export type ContentfulQuerySelectorLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSelectorLinkOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSelectorLinkFilter>;
};


export type ContentfulQuerySeoConfigurationArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQuerySeoConfigurationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


export type ContentfulQuerySeoConfigurationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSeoConfigurationFilter>;
};


export type ContentfulQueryServiceItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryServiceItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServiceItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulServiceItemFilter>;
};


export type ContentfulQueryServiceItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServiceItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulServiceItemFilter>;
};


export type ContentfulQueryServicePerkArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryServicePerkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicePerkOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulServicePerkFilter>;
};


export type ContentfulQueryServicePerkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicePerkOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulServicePerkFilter>;
};


export type ContentfulQueryServicesCollectionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQueryServicesCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulServicesCollectionFilter>;
};


export type ContentfulQueryServicesCollectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulServicesCollectionFilter>;
};


export type ContentfulQuerySimpleFooterArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQuerySimpleFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSimpleFooterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSimpleFooterFilter>;
};


export type ContentfulQuerySimpleFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSimpleFooterOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSimpleFooterFilter>;
};


export type ContentfulQuerySliderProductsAutomaticArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQuerySliderProductsAutomaticCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsAutomaticOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSliderProductsAutomaticFilter>;
};


export type ContentfulQuerySliderProductsAutomaticCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsAutomaticOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSliderProductsAutomaticFilter>;
};


export type ContentfulQuerySliderProductsManualArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulQuerySliderProductsManualCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSliderProductsManualFilter>;
};


export type ContentfulQuerySliderProductsManualCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSliderProductsManualFilter>;
};

export type ContentfulResourceLink = {
  sys: ContentfulResourceSys;
};

export type ContentfulResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/scrollerItem) */
export type ContentfulScrollerItem = ContentfulEntry & Contentful_Node & {
  __typename?: 'ScrollerItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  image?: Maybe<ContentfulAsset>;
  internalName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulScrollerItemLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  openUrlInNewTab?: Maybe<Scalars['Boolean']['output']>;
  sys: ContentfulSys;
  url?: Maybe<Scalars['String']['output']>;
  visibleInDesktop?: Maybe<Scalars['Boolean']['output']>;
  visibleInMobile?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/scrollerItem) */
export type ContentfulScrollerItemImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/scrollerItem) */
export type ContentfulScrollerItemInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/scrollerItem) */
export type ContentfulScrollerItemLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/scrollerItem) */
export type ContentfulScrollerItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/scrollerItem) */
export type ContentfulScrollerItemLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/scrollerItem) */
export type ContentfulScrollerItemOpenUrlInNewTabArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/scrollerItem) */
export type ContentfulScrollerItemUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/scrollerItem) */
export type ContentfulScrollerItemVisibleInDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/scrollerItem) */
export type ContentfulScrollerItemVisibleInMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulScrollerItemCollection = {
  __typename?: 'ScrollerItemCollection';
  items: Array<Maybe<ContentfulScrollerItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulScrollerItemCursorCollection = {
  __typename?: 'ScrollerItemCursorCollection';
  items: Array<Maybe<ContentfulScrollerItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulScrollerItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulScrollerItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulScrollerItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibleInDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulScrollerItemLinkingCollections = {
  __typename?: 'ScrollerItemLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  mainMenuItemCollection?: Maybe<ContentfulMainMenuItemCollection>;
  mainMenuItemCursorCollection?: Maybe<ContentfulMainMenuItemCursorCollection>;
};


export type ContentfulScrollerItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulScrollerItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulScrollerItemLinkingCollectionsMainMenuItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulScrollerItemLinkingCollectionsMainMenuItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulScrollerItemLinkingCollectionsMainMenuItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulScrollerItemLinkingCollectionsMainMenuItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulScrollerItemLinkingCollectionsMainMenuItemCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulScrollerItemLinkingCollectionsMainMenuItemCursorCollectionOrder =
  | 'bottomLinkAriaLabel_ASC'
  | 'bottomLinkAriaLabel_DESC'
  | 'bottomLinkLabel_ASC'
  | 'bottomLinkLabel_DESC'
  | 'bottomLinkUrl_ASC'
  | 'bottomLinkUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'scrollerLabel_ASC'
  | 'scrollerLabel_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulScrollerItemOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'openUrlInNewTab_ASC'
  | 'openUrlInNewTab_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/searchOverlay) */
export type ContentfulSearchOverlay = ContentfulEntry & Contentful_Node & {
  __typename?: 'SearchOverlay';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  displayRetailers?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ContentfulSearchOverlayLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  noResultsContentCollection?: Maybe<ContentfulSearchOverlayNoResultsContentCollection>;
  noResultsContentCursorCollection?: Maybe<ContentfulSearchOverlayNoResultsContentCursorCollection>;
  searchBox?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/searchOverlay) */
export type ContentfulSearchOverlayDisplayRetailersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/searchOverlay) */
export type ContentfulSearchOverlayLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/searchOverlay) */
export type ContentfulSearchOverlayLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/searchOverlay) */
export type ContentfulSearchOverlayNoResultsContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSearchOverlayNoResultsContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/searchOverlay) */
export type ContentfulSearchOverlayNoResultsContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSearchOverlayNoResultsContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/searchOverlay) */
export type ContentfulSearchOverlaySearchBoxArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/searchOverlay) */
export type ContentfulSearchOverlayTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/searchOverlay) */
export type ContentfulSearchOverlayTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSearchOverlayCollection = {
  __typename?: 'SearchOverlayCollection';
  items: Array<Maybe<ContentfulSearchOverlay>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulSearchOverlayCursorCollection = {
  __typename?: 'SearchOverlayCursorCollection';
  items: Array<Maybe<ContentfulSearchOverlay>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulSearchOverlayFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulSearchOverlayFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulSearchOverlayFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  displayRetailers?: InputMaybe<Scalars['Boolean']['input']>;
  displayRetailers_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayRetailers_not?: InputMaybe<Scalars['Boolean']['input']>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsContent?: InputMaybe<ContentfulCfnoResultsContentMultiTypeNestedFilter>;
  noResultsContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchBox?: InputMaybe<Scalars['String']['input']>;
  searchBox_contains?: InputMaybe<Scalars['String']['input']>;
  searchBox_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchBox_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchBox_not?: InputMaybe<Scalars['String']['input']>;
  searchBox_not_contains?: InputMaybe<Scalars['String']['input']>;
  searchBox_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulSearchOverlayLinkingCollections = {
  __typename?: 'SearchOverlayLinkingCollections';
  defaultLayoutCollection?: Maybe<ContentfulDefaultLayoutCollection>;
  defaultLayoutCursorCollection?: Maybe<ContentfulDefaultLayoutCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulSearchOverlayLinkingCollectionsDefaultLayoutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSearchOverlayLinkingCollectionsDefaultLayoutCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSearchOverlayLinkingCollectionsDefaultLayoutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSearchOverlayLinkingCollectionsDefaultLayoutCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSearchOverlayLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSearchOverlayLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSearchOverlayLinkingCollectionsDefaultLayoutCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSearchOverlayLinkingCollectionsDefaultLayoutCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSearchOverlayNoResultsContentCollection = {
  __typename?: 'SearchOverlayNoResultsContentCollection';
  items: Array<Maybe<ContentfulSearchOverlayNoResultsContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulSearchOverlayNoResultsContentCursorCollection = {
  __typename?: 'SearchOverlayNoResultsContentCursorCollection';
  items: Array<Maybe<ContentfulSearchOverlayNoResultsContentItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulSearchOverlayNoResultsContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulSearchOverlayNoResultsContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulSearchOverlayNoResultsContentFilter>>>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulSearchOverlayNoResultsContentItem = ContentfulCard | ContentfulSliderProductsAutomatic | ContentfulSliderProductsManual;

export type ContentfulSearchOverlayOrder =
  | 'displayRetailers_ASC'
  | 'displayRetailers_DESC'
  | 'searchBox_ASC'
  | 'searchBox_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selector) */
export type ContentfulSelector = ContentfulEntry & Contentful_Node & {
  __typename?: 'Selector';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  linkedFrom?: Maybe<ContentfulSelectorLinkingCollections>;
  linksCollection?: Maybe<ContentfulSelectorLinksCollection>;
  linksCursorCollection?: Maybe<ContentfulSelectorLinksCursorCollection>;
  marketingPartner?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selector) */
export type ContentfulSelectorLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selector) */
export type ContentfulSelectorLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSelectorLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSelectorLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selector) */
export type ContentfulSelectorLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSelectorLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulSelectorLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selector) */
export type ContentfulSelectorMarketingPartnerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selector) */
export type ContentfulSelectorNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selector) */
export type ContentfulSelectorTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSelectorCollection = {
  __typename?: 'SelectorCollection';
  items: Array<Maybe<ContentfulSelector>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulSelectorCursorCollection = {
  __typename?: 'SelectorCursorCollection';
  items: Array<Maybe<ContentfulSelector>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulSelectorFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulSelectorFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulSelectorFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  links?: InputMaybe<ContentfulCfSelectorLinkNestedFilter>;
  linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  marketingPartner?: InputMaybe<Scalars['String']['input']>;
  marketingPartner_contains?: InputMaybe<Scalars['String']['input']>;
  marketingPartner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  marketingPartner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marketingPartner_not?: InputMaybe<Scalars['String']['input']>;
  marketingPartner_not_contains?: InputMaybe<Scalars['String']['input']>;
  marketingPartner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selectorLink) */
export type ContentfulSelectorLink = ContentfulEntry & Contentful_Node & {
  __typename?: 'SelectorLink';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  image?: Maybe<ContentfulAsset>;
  linkedFrom?: Maybe<ContentfulSelectorLinkLinkingCollections>;
  reference?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
  text?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selectorLink) */
export type ContentfulSelectorLinkImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selectorLink) */
export type ContentfulSelectorLinkLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selectorLink) */
export type ContentfulSelectorLinkReferenceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selectorLink) */
export type ContentfulSelectorLinkSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/selectorLink) */
export type ContentfulSelectorLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSelectorLinkCollection = {
  __typename?: 'SelectorLinkCollection';
  items: Array<Maybe<ContentfulSelectorLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulSelectorLinkCursorCollection = {
  __typename?: 'SelectorLinkCursorCollection';
  items: Array<Maybe<ContentfulSelectorLink>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulSelectorLinkFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulSelectorLinkFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulSelectorLinkFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  reference_contains?: InputMaybe<Scalars['String']['input']>;
  reference_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reference_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reference_not?: InputMaybe<Scalars['String']['input']>;
  reference_not_contains?: InputMaybe<Scalars['String']['input']>;
  reference_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulSelectorLinkLinkingCollections = {
  __typename?: 'SelectorLinkLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  selectorCollection?: Maybe<ContentfulSelectorCollection>;
  selectorCursorCollection?: Maybe<ContentfulSelectorCursorCollection>;
};


export type ContentfulSelectorLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSelectorLinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSelectorLinkLinkingCollectionsSelectorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSelectorLinkLinkingCollectionsSelectorCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSelectorLinkLinkingCollectionsSelectorCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSelectorLinkLinkingCollectionsSelectorCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSelectorLinkLinkingCollectionsSelectorCollectionOrder =
  | 'marketingPartner_ASC'
  | 'marketingPartner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentfulSelectorLinkLinkingCollectionsSelectorCursorCollectionOrder =
  | 'marketingPartner_ASC'
  | 'marketingPartner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentfulSelectorLinkOrder =
  | 'reference_ASC'
  | 'reference_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC';

export type ContentfulSelectorLinkingCollections = {
  __typename?: 'SelectorLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
};


export type ContentfulSelectorLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSelectorLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSelectorLinksCollection = {
  __typename?: 'SelectorLinksCollection';
  items: Array<Maybe<ContentfulSelectorLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulSelectorLinksCollectionOrder =
  | 'reference_ASC'
  | 'reference_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC';

export type ContentfulSelectorLinksCursorCollection = {
  __typename?: 'SelectorLinksCursorCollection';
  items: Array<Maybe<ContentfulSelectorLink>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulSelectorLinksCursorCollectionOrder =
  | 'reference_ASC'
  | 'reference_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC';

export type ContentfulSelectorOrder =
  | 'marketingPartner_ASC'
  | 'marketingPartner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/seoConfiguration) */
export type ContentfulSeoConfiguration = ContentfulEntry & Contentful_Node & {
  __typename?: 'SeoConfiguration';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulSeoConfigurationLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  seoCanonical?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoIndex?: Maybe<Scalars['Boolean']['output']>;
  seoThumbnail?: Maybe<ContentfulAsset>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/seoConfiguration) */
export type ContentfulSeoConfigurationInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/seoConfiguration) */
export type ContentfulSeoConfigurationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/seoConfiguration) */
export type ContentfulSeoConfigurationLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/seoConfiguration) */
export type ContentfulSeoConfigurationSeoCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/seoConfiguration) */
export type ContentfulSeoConfigurationSeoDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/seoConfiguration) */
export type ContentfulSeoConfigurationSeoIndexArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/seoConfiguration) */
export type ContentfulSeoConfigurationSeoThumbnailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/seoConfiguration) */
export type ContentfulSeoConfigurationSeoTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSeoConfigurationCollection = {
  __typename?: 'SeoConfigurationCollection';
  items: Array<Maybe<ContentfulSeoConfiguration>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulSeoConfigurationCursorCollection = {
  __typename?: 'SeoConfigurationCursorCollection';
  items: Array<Maybe<ContentfulSeoConfiguration>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulSeoConfigurationFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoCanonical?: InputMaybe<Scalars['String']['input']>;
  seoCanonical_contains?: InputMaybe<Scalars['String']['input']>;
  seoCanonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoCanonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoCanonical_not?: InputMaybe<Scalars['String']['input']>;
  seoCanonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  seoCanonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
  seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoDescription_not?: InputMaybe<Scalars['String']['input']>;
  seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoIndex?: InputMaybe<Scalars['Boolean']['input']>;
  seoIndex_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  seoThumbnail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoTitle_not?: InputMaybe<Scalars['String']['input']>;
  seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulSeoConfigurationLinkingCollections = {
  __typename?: 'SeoConfigurationLinkingCollections';
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageExhibitionHistoriesFaqCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCollection>;
  pageExhibitionHistoriesFaqCursorCollection?: Maybe<ContentfulPageExhibitionHistoriesFaqCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulSeoConfigurationLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsPageExhibitionHistoriesFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSeoConfigurationLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSeoConfigurationLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSeoConfigurationLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueDetailCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsPageExhibitionHistoriesFaqCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsPageExhibitionHistoriesFaqCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSeoConfigurationLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSeoConfigurationOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'seoCanonical_ASC'
  | 'seoCanonical_DESC'
  | 'seoDescription_ASC'
  | 'seoDescription_DESC'
  | 'seoIndex_ASC'
  | 'seoIndex_DESC'
  | 'seoTitle_ASC'
  | 'seoTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/serviceItem) */
export type ContentfulServiceItem = ContentfulEntry & Contentful_Node & {
  __typename?: 'ServiceItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  heading?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulServiceItemLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  media?: Maybe<ContentfulAsset>;
  sys: ContentfulSys;
  url?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/serviceItem) */
export type ContentfulServiceItemHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/serviceItem) */
export type ContentfulServiceItemIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/serviceItem) */
export type ContentfulServiceItemInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/serviceItem) */
export type ContentfulServiceItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/serviceItem) */
export type ContentfulServiceItemLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/serviceItem) */
export type ContentfulServiceItemMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/serviceItem) */
export type ContentfulServiceItemUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulServiceItemCollection = {
  __typename?: 'ServiceItemCollection';
  items: Array<Maybe<ContentfulServiceItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulServiceItemCursorCollection = {
  __typename?: 'ServiceItemCursorCollection';
  items: Array<Maybe<ContentfulServiceItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulServiceItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulServiceItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulServiceItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulServiceItemLinkingCollections = {
  __typename?: 'ServiceItemLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  servicesCollectionCollection?: Maybe<ContentfulServicesCollectionCollection>;
  servicesCollectionCursorCollection?: Maybe<ContentfulServicesCollectionCursorCollection>;
};


export type ContentfulServiceItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServiceItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServiceItemLinkingCollectionsServicesCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServiceItemLinkingCollectionsServicesCollectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServiceItemLinkingCollectionsServicesCollectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServiceItemLinkingCollectionsServicesCollectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulServiceItemLinkingCollectionsServicesCollectionCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServiceItemLinkingCollectionsServicesCollectionCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServiceItemOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicePerk) */
export type ContentfulServicePerk = ContentfulEntry & Contentful_Node & {
  __typename?: 'ServicePerk';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  heading?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulServicePerkLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  modalText?: Maybe<ContentfulServicePerkModalText>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicePerk) */
export type ContentfulServicePerkHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicePerk) */
export type ContentfulServicePerkInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicePerk) */
export type ContentfulServicePerkLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicePerk) */
export type ContentfulServicePerkLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicePerk) */
export type ContentfulServicePerkModalTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicePerk) */
export type ContentfulServicePerkTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicePerk) */
export type ContentfulServicePerkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulServicePerkCollection = {
  __typename?: 'ServicePerkCollection';
  items: Array<Maybe<ContentfulServicePerk>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulServicePerkCursorCollection = {
  __typename?: 'ServicePerkCursorCollection';
  items: Array<Maybe<ContentfulServicePerk>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulServicePerkFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulServicePerkFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulServicePerkFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalText_contains?: InputMaybe<Scalars['String']['input']>;
  modalText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulServicePerkLinkingCollections = {
  __typename?: 'ServicePerkLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  placeholderProductDetailsCollection?: Maybe<ContentfulPlaceholderProductDetailsCollection>;
  placeholderProductDetailsCursorCollection?: Maybe<ContentfulPlaceholderProductDetailsCursorCollection>;
};


export type ContentfulServicePerkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicePerkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicePerkLinkingCollectionsPlaceholderProductDetailsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicePerkLinkingCollectionsPlaceholderProductDetailsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicePerkLinkingCollectionsPlaceholderProductDetailsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicePerkLinkingCollectionsPlaceholderProductDetailsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulServicePerkLinkingCollectionsPlaceholderProductDetailsCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServicePerkLinkingCollectionsPlaceholderProductDetailsCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServicePerkModalText = {
  __typename?: 'ServicePerkModalText';
  json: Scalars['JSON']['output'];
  links: ContentfulServicePerkModalTextLinks;
};

export type ContentfulServicePerkModalTextAssets = {
  __typename?: 'ServicePerkModalTextAssets';
  block: Array<Maybe<ContentfulAsset>>;
  hyperlink: Array<Maybe<ContentfulAsset>>;
};

export type ContentfulServicePerkModalTextEntries = {
  __typename?: 'ServicePerkModalTextEntries';
  block: Array<Maybe<ContentfulEntry>>;
  hyperlink: Array<Maybe<ContentfulEntry>>;
  inline: Array<Maybe<ContentfulEntry>>;
};

export type ContentfulServicePerkModalTextLinks = {
  __typename?: 'ServicePerkModalTextLinks';
  assets: ContentfulServicePerkModalTextAssets;
  entries: ContentfulServicePerkModalTextEntries;
  resources: ContentfulServicePerkModalTextResources;
};

export type ContentfulServicePerkModalTextResources = {
  __typename?: 'ServicePerkModalTextResources';
  block: Array<ContentfulServicePerkModalTextResourcesBlock>;
  hyperlink: Array<ContentfulServicePerkModalTextResourcesHyperlink>;
  inline: Array<ContentfulServicePerkModalTextResourcesInline>;
};

export type ContentfulServicePerkModalTextResourcesBlock = ContentfulResourceLink & {
  __typename?: 'ServicePerkModalTextResourcesBlock';
  sys: ContentfulResourceSys;
};

export type ContentfulServicePerkModalTextResourcesHyperlink = ContentfulResourceLink & {
  __typename?: 'ServicePerkModalTextResourcesHyperlink';
  sys: ContentfulResourceSys;
};

export type ContentfulServicePerkModalTextResourcesInline = ContentfulResourceLink & {
  __typename?: 'ServicePerkModalTextResourcesInline';
  sys: ContentfulResourceSys;
};

export type ContentfulServicePerkOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'url_ASC'
  | 'url_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicesCollection) */
export type ContentfulServicesCollection = ContentfulEntry & Contentful_Node & {
  __typename?: 'ServicesCollection';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulContentfulMetadata;
  headline?: Maybe<ContentfulHeading>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulServicesCollectionLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  servicesCollection?: Maybe<ContentfulServicesCollectionServicesCollection>;
  servicesCursorCollection?: Maybe<ContentfulServicesCollectionServicesCursorCollection>;
  sys: ContentfulSys;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicesCollection) */
export type ContentfulServicesCollectionHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicesCollection) */
export type ContentfulServicesCollectionInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicesCollection) */
export type ContentfulServicesCollectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicesCollection) */
export type ContentfulServicesCollectionLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicesCollection) */
export type ContentfulServicesCollectionServicesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionServicesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulServiceItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/servicesCollection) */
export type ContentfulServicesCollectionServicesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionServicesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulServiceItemFilter>;
};

export type ContentfulServicesCollectionCollection = {
  __typename?: 'ServicesCollectionCollection';
  items: Array<Maybe<ContentfulServicesCollection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulServicesCollectionCursorCollection = {
  __typename?: 'ServicesCollectionCursorCollection';
  items: Array<Maybe<ContentfulServicesCollection>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulServicesCollectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  headline?: InputMaybe<ContentfulCfHeadingNestedFilter>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  services?: InputMaybe<ContentfulCfServiceItemNestedFilter>;
  servicesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulServicesCollectionLinkingCollections = {
  __typename?: 'ServicesCollectionLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
};


export type ContentfulServicesCollectionLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulServicesCollectionLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulServicesCollectionLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulServicesCollectionLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServicesCollectionLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServicesCollectionLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulServicesCollectionLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulServicesCollectionLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulServicesCollectionLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulServicesCollectionLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServicesCollectionLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServicesCollectionLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulServicesCollectionLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulServicesCollectionLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServicesCollectionLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServicesCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulServicesCollectionServicesCollection = {
  __typename?: 'ServicesCollectionServicesCollection';
  items: Array<Maybe<ContentfulServiceItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulServicesCollectionServicesCollectionOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type ContentfulServicesCollectionServicesCursorCollection = {
  __typename?: 'ServicesCollectionServicesCursorCollection';
  items: Array<Maybe<ContentfulServiceItem>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulServicesCollectionServicesCursorCollectionOrder =
  | 'heading_ASC'
  | 'heading_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/simpleFooter) */
export type ContentfulSimpleFooter = ContentfulEntry & Contentful_Node & {
  __typename?: 'SimpleFooter';
  _id: Scalars['ID']['output'];
  background?: Maybe<ContentfulAsset>;
  contentfulMetadata: ContentfulContentfulMetadata;
  cta?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulSimpleFooterLinkingCollections>;
  sys: ContentfulSys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/simpleFooter) */
export type ContentfulSimpleFooterBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/simpleFooter) */
export type ContentfulSimpleFooterCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/simpleFooter) */
export type ContentfulSimpleFooterDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/simpleFooter) */
export type ContentfulSimpleFooterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/simpleFooter) */
export type ContentfulSimpleFooterTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSimpleFooterCollection = {
  __typename?: 'SimpleFooterCollection';
  items: Array<Maybe<ContentfulSimpleFooter>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulSimpleFooterCursorCollection = {
  __typename?: 'SimpleFooterCursorCollection';
  items: Array<Maybe<ContentfulSimpleFooter>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulSimpleFooterFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulSimpleFooterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulSimpleFooterFilter>>>;
  background_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  cta?: InputMaybe<Scalars['String']['input']>;
  cta_contains?: InputMaybe<Scalars['String']['input']>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta_not?: InputMaybe<Scalars['String']['input']>;
  cta_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulSimpleFooterLinkingCollections = {
  __typename?: 'SimpleFooterLinkingCollections';
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
};


export type ContentfulSimpleFooterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSimpleFooterLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSimpleFooterLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSimpleFooterLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSimpleFooterLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSimpleFooterLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSimpleFooterLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSimpleFooterLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSimpleFooterOrder =
  | 'cta_ASC'
  | 'cta_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomatic = ContentfulEntry & Contentful_Node & {
  __typename?: 'SliderProductsAutomatic';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['JSON']['output']>;
  backgroundImage?: Maybe<ContentfulAsset>;
  contentfulMetadata: ContentfulContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulSliderProductsAutomaticLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  productCardBackgroundColor?: Maybe<Scalars['JSON']['output']>;
  showCta?: Maybe<Scalars['Boolean']['output']>;
  showLabel?: Maybe<Scalars['Boolean']['output']>;
  showPrice?: Maybe<Scalars['Boolean']['output']>;
  showWishlist?: Maybe<Scalars['Boolean']['output']>;
  slidesPerView?: Maybe<Scalars['Int']['output']>;
  sys: ContentfulSys;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticProductCardBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticShowCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticShowLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticShowPriceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticShowWishlistArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticSlidesPerViewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsAutomatic) */
export type ContentfulSliderProductsAutomaticTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSliderProductsAutomaticCollection = {
  __typename?: 'SliderProductsAutomaticCollection';
  items: Array<Maybe<ContentfulSliderProductsAutomatic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulSliderProductsAutomaticCursorCollection = {
  __typename?: 'SliderProductsAutomaticCursorCollection';
  items: Array<Maybe<ContentfulSliderProductsAutomatic>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulSliderProductsAutomaticFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsAutomaticFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsAutomaticFilter>>>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productCardBackgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showCta?: InputMaybe<Scalars['Boolean']['input']>;
  showCta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showCta_not?: InputMaybe<Scalars['Boolean']['input']>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
  showLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  showPrice?: InputMaybe<Scalars['Boolean']['input']>;
  showPrice_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showPrice_not?: InputMaybe<Scalars['Boolean']['input']>;
  showWishlist?: InputMaybe<Scalars['Boolean']['input']>;
  showWishlist_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showWishlist_not?: InputMaybe<Scalars['Boolean']['input']>;
  slidesPerView?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slidesPerView_gt?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_gte?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slidesPerView_lt?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_lte?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_not?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulSliderProductsAutomaticLinkingCollections = {
  __typename?: 'SliderProductsAutomaticLinkingCollections';
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  searchOverlayCollection?: Maybe<ContentfulSearchOverlayCollection>;
  searchOverlayCursorCollection?: Maybe<ContentfulSearchOverlayCursorCollection>;
};


export type ContentfulSliderProductsAutomaticLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsAutomaticLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsAutomaticLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsAutomaticLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsAutomaticLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsAutomaticLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsAutomaticLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsAutomaticLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsAutomaticLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsAutomaticLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsAutomaticLinkingCollectionsSearchOverlayCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsAutomaticLinkingCollectionsSearchOverlayCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsAutomaticLinkingCollectionsSearchOverlayCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsAutomaticLinkingCollectionsSearchOverlayCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSliderProductsAutomaticLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulSliderProductsAutomaticLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulSliderProductsAutomaticLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsAutomaticLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsAutomaticLinkingCollectionsSearchOverlayCollectionOrder =
  | 'displayRetailers_ASC'
  | 'displayRetailers_DESC'
  | 'searchBox_ASC'
  | 'searchBox_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsAutomaticLinkingCollectionsSearchOverlayCursorCollectionOrder =
  | 'displayRetailers_ASC'
  | 'displayRetailers_DESC'
  | 'searchBox_ASC'
  | 'searchBox_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsAutomaticOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'showCta_ASC'
  | 'showCta_DESC'
  | 'showLabel_ASC'
  | 'showLabel_DESC'
  | 'showPrice_ASC'
  | 'showPrice_DESC'
  | 'showWishlist_ASC'
  | 'showWishlist_DESC'
  | 'slidesPerView_ASC'
  | 'slidesPerView_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManual = ContentfulEntry & Contentful_Node & {
  __typename?: 'SliderProductsManual';
  _id: Scalars['ID']['output'];
  backgroundColor?: Maybe<Scalars['JSON']['output']>;
  backgroundImage?: Maybe<ContentfulAsset>;
  contentfulMetadata: ContentfulContentfulMetadata;
  ctaAriaLabel?: Maybe<Scalars['String']['output']>;
  ctaStyle?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  entryEffect?: Maybe<Scalars['Boolean']['output']>;
  heading?: Maybe<ContentfulHeading>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentfulSliderProductsManualLinkingCollections>;
  localizationConfiguration?: Maybe<Scalars['JSON']['output']>;
  productCardBackgroundColor?: Maybe<Scalars['JSON']['output']>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showCta?: Maybe<Scalars['Boolean']['output']>;
  showLabel?: Maybe<Scalars['Boolean']['output']>;
  showName?: Maybe<Scalars['Boolean']['output']>;
  showPrice?: Maybe<Scalars['Boolean']['output']>;
  showWishlist?: Maybe<Scalars['Boolean']['output']>;
  slidesPerView?: Maybe<Scalars['Int']['output']>;
  slidesPerViewForMobile?: Maybe<Scalars['Float']['output']>;
  sys: ContentfulSys;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualCtaAriaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualCtaStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualCtaTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualCtaUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualEntryEffectArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentfulHeadingFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualLocalizationConfigurationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualProductCardBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualProductsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualShowCtaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualShowLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualShowNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualShowPriceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualShowWishlistArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualSlidesPerViewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualSlidesPerViewForMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/11yu5j5b14kx/content_types/sliderProductsManual) */
export type ContentfulSliderProductsManualTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSliderProductsManualCollection = {
  __typename?: 'SliderProductsManualCollection';
  items: Array<Maybe<ContentfulSliderProductsManual>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentfulSliderProductsManualCursorCollection = {
  __typename?: 'SliderProductsManualCursorCollection';
  items: Array<Maybe<ContentfulSliderProductsManual>>;
  limit: Scalars['Int']['output'];
  pages: ContentfulCursorPages;
};

export type ContentfulSliderProductsManualFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualFilter>>>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  ctaAriaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaAriaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  ctaAriaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaAriaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaAriaLabel_not?: InputMaybe<Scalars['String']['input']>;
  ctaAriaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaAriaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaStyle?: InputMaybe<Scalars['String']['input']>;
  ctaStyle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaStyle_not?: InputMaybe<Scalars['String']['input']>;
  ctaStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  ctaText_contains?: InputMaybe<Scalars['String']['input']>;
  ctaText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaText_not?: InputMaybe<Scalars['String']['input']>;
  ctaText_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  ctaUrl_contains?: InputMaybe<Scalars['String']['input']>;
  ctaUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaUrl_not?: InputMaybe<Scalars['String']['input']>;
  ctaUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryEffect?: InputMaybe<Scalars['Boolean']['input']>;
  entryEffect_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryEffect_not?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<ContentfulCfHeadingNestedFilter>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productCardBackgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  products_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  products_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  products_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  products_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showCta?: InputMaybe<Scalars['Boolean']['input']>;
  showCta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showCta_not?: InputMaybe<Scalars['Boolean']['input']>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
  showLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  showName?: InputMaybe<Scalars['Boolean']['input']>;
  showName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showName_not?: InputMaybe<Scalars['Boolean']['input']>;
  showPrice?: InputMaybe<Scalars['Boolean']['input']>;
  showPrice_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showPrice_not?: InputMaybe<Scalars['Boolean']['input']>;
  showWishlist?: InputMaybe<Scalars['Boolean']['input']>;
  showWishlist_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showWishlist_not?: InputMaybe<Scalars['Boolean']['input']>;
  slidesPerView?: InputMaybe<Scalars['Int']['input']>;
  slidesPerViewForMobile?: InputMaybe<Scalars['Float']['input']>;
  slidesPerViewForMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slidesPerViewForMobile_gt?: InputMaybe<Scalars['Float']['input']>;
  slidesPerViewForMobile_gte?: InputMaybe<Scalars['Float']['input']>;
  slidesPerViewForMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  slidesPerViewForMobile_lt?: InputMaybe<Scalars['Float']['input']>;
  slidesPerViewForMobile_lte?: InputMaybe<Scalars['Float']['input']>;
  slidesPerViewForMobile_not?: InputMaybe<Scalars['Float']['input']>;
  slidesPerViewForMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  slidesPerView_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slidesPerView_gt?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_gte?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slidesPerView_lt?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_lte?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_not?: InputMaybe<Scalars['Int']['input']>;
  slidesPerView_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulSliderProductsManualLinkingCollections = {
  __typename?: 'SliderProductsManualLinkingCollections';
  conditionalComponentCollection?: Maybe<ContentfulConditionalComponentCollection>;
  conditionalComponentCursorCollection?: Maybe<ContentfulConditionalComponentCursorCollection>;
  detailPageCollection?: Maybe<ContentfulDetailPageCollection>;
  detailPageCursorCollection?: Maybe<ContentfulDetailPageCursorCollection>;
  entryCollection?: Maybe<ContentfulEntryCollection>;
  entryCursorCollection?: Maybe<ContentfulEntryCursorCollection>;
  gridCollection?: Maybe<ContentfulGridCollection>;
  gridCursorCollection?: Maybe<ContentfulGridCursorCollection>;
  listingPageCollection?: Maybe<ContentfulListingPageCollection>;
  listingPageCursorCollection?: Maybe<ContentfulListingPageCursorCollection>;
  pageBoutiqueDetailCollection?: Maybe<ContentfulPageBoutiqueDetailCollection>;
  pageBoutiqueDetailCursorCollection?: Maybe<ContentfulPageBoutiqueDetailCursorCollection>;
  pageBoutiqueListCollection?: Maybe<ContentfulPageBoutiqueListCollection>;
  pageBoutiqueListCursorCollection?: Maybe<ContentfulPageBoutiqueListCursorCollection>;
  pageCollection?: Maybe<ContentfulPageCollection>;
  pageCursorCollection?: Maybe<ContentfulPageCursorCollection>;
  pageFixedCollection?: Maybe<ContentfulPageFixedCollection>;
  pageFixedCursorCollection?: Maybe<ContentfulPageFixedCursorCollection>;
  searchOverlayCollection?: Maybe<ContentfulSearchOverlayCollection>;
  searchOverlayCursorCollection?: Maybe<ContentfulSearchOverlayCursorCollection>;
};


export type ContentfulSliderProductsManualLinkingCollectionsConditionalComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsConditionalComponentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsConditionalComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsConditionalComponentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsDetailPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsDetailPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsDetailPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsDetailPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsGridCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsGridCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsGridCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsListingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsListingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsListingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsListingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueDetailCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueDetailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueDetailCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsPageFixedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsPageFixedCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsPageFixedCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsPageFixedCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsSearchOverlayCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsSearchOverlayCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentfulSliderProductsManualLinkingCollectionsSearchOverlayCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentfulSliderProductsManualLinkingCollectionsSearchOverlayCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulSliderProductsManualLinkingCollectionsConditionalComponentCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsConditionalComponentCursorCollectionOrder =
  | 'displayOnEmptyCondition_ASC'
  | 'displayOnEmptyCondition_DESC'
  | 'displayOnLoggedInCondition_ASC'
  | 'displayOnLoggedInCondition_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsDetailPageCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsDetailPageCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'model_ASC'
  | 'model_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC'
  | 'watchCollection_ASC'
  | 'watchCollection_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsGridCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsGridCursorCollectionOrder =
  | 'colForMobile_ASC'
  | 'colForMobile_DESC'
  | 'colGap_ASC'
  | 'colGap_DESC'
  | 'col_ASC'
  | 'col_DESC'
  | 'contentAlignment_ASC'
  | 'contentAlignment_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSlider_ASC'
  | 'isSlider_DESC'
  | 'maxWidth_ASC'
  | 'maxWidth_DESC'
  | 'paddingBottom_ASC'
  | 'paddingBottom_DESC'
  | 'paddingTop_ASC'
  | 'paddingTop_DESC'
  | 'reverseDisplayOrderForMobile_ASC'
  | 'reverseDisplayOrderForMobile_DESC'
  | 'rowGap_ASC'
  | 'rowGap_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'visibleInDesktop_ASC'
  | 'visibleInDesktop_DESC'
  | 'visibleInMobile_ASC'
  | 'visibleInMobile_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsListingPageCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsListingPageCursorCollectionOrder =
  | 'algoliaCategoryId_ASC'
  | 'algoliaCategoryId_DESC'
  | 'algoliaRuleName_ASC'
  | 'algoliaRuleName_DESC'
  | 'collectionName_ASC'
  | 'collectionName_DESC'
  | 'editorialPageName_ASC'
  | 'editorialPageName_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'saleorCollection_ASC'
  | 'saleorCollection_DESC'
  | 'strapMaterial_ASC'
  | 'strapMaterial_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueDetailCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueDetailCursorCollectionOrder =
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trackingKey_ASC'
  | 'trackingKey_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueListCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsPageBoutiqueListCursorCollectionOrder =
  | 'countryCode_ASC'
  | 'countryCode_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsPageCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsPageCursorCollectionOrder =
  | 'enableSearch_ASC'
  | 'enableSearch_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'publishDate_ASC'
  | 'publishDate_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsPageFixedCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsPageFixedCursorCollectionOrder =
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsSearchOverlayCollectionOrder =
  | 'displayRetailers_ASC'
  | 'displayRetailers_DESC'
  | 'searchBox_ASC'
  | 'searchBox_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsManualLinkingCollectionsSearchOverlayCursorCollectionOrder =
  | 'displayRetailers_ASC'
  | 'displayRetailers_DESC'
  | 'searchBox_ASC'
  | 'searchBox_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSliderProductsManualOrder =
  | 'ctaAriaLabel_ASC'
  | 'ctaAriaLabel_DESC'
  | 'ctaStyle_ASC'
  | 'ctaStyle_DESC'
  | 'ctaText_ASC'
  | 'ctaText_DESC'
  | 'ctaUrl_ASC'
  | 'ctaUrl_DESC'
  | 'entryEffect_ASC'
  | 'entryEffect_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'showCta_ASC'
  | 'showCta_DESC'
  | 'showLabel_ASC'
  | 'showLabel_DESC'
  | 'showName_ASC'
  | 'showName_DESC'
  | 'showPrice_ASC'
  | 'showPrice_DESC'
  | 'showWishlist_ASC'
  | 'showWishlist_DESC'
  | 'slidesPerViewForMobile_ASC'
  | 'slidesPerViewForMobile_DESC'
  | 'slidesPerView_ASC'
  | 'slidesPerView_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type ContentfulSys = {
  __typename?: 'Sys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type ContentfulSysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type ContentfulTaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']['output']>;
};

export type ContentfulTimelineFilterInput = {
  /** Preview content starting from a given release date */
  release_lte?: InputMaybe<Scalars['String']['input']>;
  /** Preview content starting from a given timestamp */
  timestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Contentful_Node = {
  _id: Scalars['ID']['output'];
};

export type ContentfulCfAlertBannerNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfAlertBannerNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfAlertBannerNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfBannerHeroNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfBannerHeroNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfBannerHeroNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleSeoTag?: InputMaybe<Scalars['String']['input']>;
  titleSeoTag_contains?: InputMaybe<Scalars['String']['input']>;
  titleSeoTag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleSeoTag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleSeoTag_not?: InputMaybe<Scalars['String']['input']>;
  titleSeoTag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleSeoTag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleStyle?: InputMaybe<Scalars['String']['input']>;
  titleStyle_contains?: InputMaybe<Scalars['String']['input']>;
  titleStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleStyle_not?: InputMaybe<Scalars['String']['input']>;
  titleStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  urlText_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText_not?: InputMaybe<Scalars['String']['input']>;
  urlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlType?: InputMaybe<Scalars['String']['input']>;
  urlType_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlType_not?: InputMaybe<Scalars['String']['input']>;
  urlType_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfCardNestedFilter>>>;
  backgroundAlignment?: InputMaybe<Scalars['String']['input']>;
  backgroundAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundAlignment_not?: InputMaybe<Scalars['String']['input']>;
  backgroundAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundPosition?: InputMaybe<Scalars['String']['input']>;
  backgroundPosition_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundPosition_not?: InputMaybe<Scalars['String']['input']>;
  backgroundPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlignment?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlignment_not?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth_not?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentOption?: InputMaybe<Scalars['String']['input']>;
  contentOption_contains?: InputMaybe<Scalars['String']['input']>;
  contentOption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentOption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentOption_not?: InputMaybe<Scalars['String']['input']>;
  contentOption_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentOption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  countdown?: InputMaybe<Scalars['Boolean']['input']>;
  countdownToDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countdownToDatetime_gt?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_gte?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  countdownToDatetime_lt?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_lte?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_not?: InputMaybe<Scalars['DateTime']['input']>;
  countdownToDatetime_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  countdown_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countdown_not?: InputMaybe<Scalars['Boolean']['input']>;
  entryEffect?: InputMaybe<Scalars['Boolean']['input']>;
  entryEffect_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryEffect_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaAnimationEffect?: InputMaybe<Scalars['String']['input']>;
  mediaAnimationEffect_contains?: InputMaybe<Scalars['String']['input']>;
  mediaAnimationEffect_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaAnimationEffect_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaAnimationEffect_not?: InputMaybe<Scalars['String']['input']>;
  mediaAnimationEffect_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaAnimationEffect_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrl2InNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openUrl2InNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrl2InNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  saleorProductSku?: InputMaybe<Scalars['String']['input']>;
  saleorProductSku_contains?: InputMaybe<Scalars['String']['input']>;
  saleorProductSku_exists?: InputMaybe<Scalars['Boolean']['input']>;
  saleorProductSku_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  saleorProductSku_not?: InputMaybe<Scalars['String']['input']>;
  saleorProductSku_not_contains?: InputMaybe<Scalars['String']['input']>;
  saleorProductSku_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showMore?: InputMaybe<Scalars['Boolean']['input']>;
  showMore_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showMore_not?: InputMaybe<Scalars['Boolean']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  subHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text2_contains?: InputMaybe<Scalars['String']['input']>;
  text2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text2_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  textColor_contains?: InputMaybe<Scalars['String']['input']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textColor_not?: InputMaybe<Scalars['String']['input']>;
  textColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url1ariaLabel?: InputMaybe<Scalars['String']['input']>;
  url1ariaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  url1ariaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url1ariaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url1ariaLabel_not?: InputMaybe<Scalars['String']['input']>;
  url1ariaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  url1ariaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url1eventType?: InputMaybe<Scalars['String']['input']>;
  url1eventType_contains?: InputMaybe<Scalars['String']['input']>;
  url1eventType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url1eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url1eventType_not?: InputMaybe<Scalars['String']['input']>;
  url1eventType_not_contains?: InputMaybe<Scalars['String']['input']>;
  url1eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2?: InputMaybe<Scalars['String']['input']>;
  url2Text?: InputMaybe<Scalars['String']['input']>;
  url2Text_contains?: InputMaybe<Scalars['String']['input']>;
  url2Text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2Text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2Text_not?: InputMaybe<Scalars['String']['input']>;
  url2Text_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2Text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2Trigger_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2Type?: InputMaybe<Scalars['String']['input']>;
  url2Type_contains?: InputMaybe<Scalars['String']['input']>;
  url2Type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2Type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2Type_not?: InputMaybe<Scalars['String']['input']>;
  url2Type_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2Type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2_contains?: InputMaybe<Scalars['String']['input']>;
  url2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2_not?: InputMaybe<Scalars['String']['input']>;
  url2_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2ariaLabel?: InputMaybe<Scalars['String']['input']>;
  url2ariaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  url2ariaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2ariaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2ariaLabel_not?: InputMaybe<Scalars['String']['input']>;
  url2ariaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2ariaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2eventType?: InputMaybe<Scalars['String']['input']>;
  url2eventType_contains?: InputMaybe<Scalars['String']['input']>;
  url2eventType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url2eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url2eventType_not?: InputMaybe<Scalars['String']['input']>;
  url2eventType_not_contains?: InputMaybe<Scalars['String']['input']>;
  url2eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlDirection?: InputMaybe<Scalars['String']['input']>;
  urlDirection_contains?: InputMaybe<Scalars['String']['input']>;
  urlDirection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlDirection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlDirection_not?: InputMaybe<Scalars['String']['input']>;
  urlDirection_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlDirection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlPosition?: InputMaybe<Scalars['String']['input']>;
  urlPosition_contains?: InputMaybe<Scalars['String']['input']>;
  urlPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlPosition_not?: InputMaybe<Scalars['String']['input']>;
  urlPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  urlText_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText_not?: InputMaybe<Scalars['String']['input']>;
  urlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlTrigger_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlType?: InputMaybe<Scalars['String']['input']>;
  urlType_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlType_not?: InputMaybe<Scalars['String']['input']>;
  urlType_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibleInDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCfCollectionGroupEndImageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfCollectionGroupEndImageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfCollectionGroupEndImageNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  endImageLinkType?: InputMaybe<Scalars['String']['input']>;
  endImageLinkType_contains?: InputMaybe<Scalars['String']['input']>;
  endImageLinkType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  endImageLinkType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImageLinkType_not?: InputMaybe<Scalars['String']['input']>;
  endImageLinkType_not_contains?: InputMaybe<Scalars['String']['input']>;
  endImageLinkType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImageUrl?: InputMaybe<Scalars['String']['input']>;
  endImageUrlText?: InputMaybe<Scalars['String']['input']>;
  endImageUrlText_contains?: InputMaybe<Scalars['String']['input']>;
  endImageUrlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  endImageUrlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImageUrlText_not?: InputMaybe<Scalars['String']['input']>;
  endImageUrlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  endImageUrlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  endImageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  endImageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImageUrl_not?: InputMaybe<Scalars['String']['input']>;
  endImageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  endImageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfCollectionItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfCollectionItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfCollectionItemNestedFilter>>>;
  collectionName?: InputMaybe<Scalars['String']['input']>;
  collectionName_contains?: InputMaybe<Scalars['String']['input']>;
  collectionName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  collectionName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collectionName_not?: InputMaybe<Scalars['String']['input']>;
  collectionName_not_contains?: InputMaybe<Scalars['String']['input']>;
  collectionName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  saleorCollection?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_contains?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  saleorCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  saleorCollection_not?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  saleorCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfDictionaryItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfDictionaryItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfDictionaryItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_contains?: InputMaybe<Scalars['String']['input']>;
  key_exists?: InputMaybe<Scalars['Boolean']['input']>;
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  key_not?: InputMaybe<Scalars['String']['input']>;
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_exists?: InputMaybe<Scalars['Boolean']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfEventNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfEventNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfEventNestedFilter>>>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  campaignName_contains?: InputMaybe<Scalars['String']['input']>;
  campaignName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  campaignName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignName_not?: InputMaybe<Scalars['String']['input']>;
  campaignName_not_contains?: InputMaybe<Scalars['String']['input']>;
  campaignName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  eventId_contains?: InputMaybe<Scalars['String']['input']>;
  eventId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eventId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventId_not?: InputMaybe<Scalars['String']['input']>;
  eventId_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sfId?: InputMaybe<Scalars['String']['input']>;
  sfId_contains?: InputMaybe<Scalars['String']['input']>;
  sfId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sfId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sfId_not?: InputMaybe<Scalars['String']['input']>;
  sfId_not_contains?: InputMaybe<Scalars['String']['input']>;
  sfId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfExhibitionItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfExhibitionItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfExhibitionItemNestedFilter>>>;
  boutiqueId?: InputMaybe<Scalars['String']['input']>;
  boutiqueId_contains?: InputMaybe<Scalars['String']['input']>;
  boutiqueId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  boutiqueId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  boutiqueId_not?: InputMaybe<Scalars['String']['input']>;
  boutiqueId_not_contains?: InputMaybe<Scalars['String']['input']>;
  boutiqueId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfFaqItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfFaqItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfFaqItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  faqAnswer_contains?: InputMaybe<Scalars['String']['input']>;
  faqAnswer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  faqAnswer_not_contains?: InputMaybe<Scalars['String']['input']>;
  faqQuestion?: InputMaybe<Scalars['String']['input']>;
  faqQuestion_contains?: InputMaybe<Scalars['String']['input']>;
  faqQuestion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  faqQuestion_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faqQuestion_not?: InputMaybe<Scalars['String']['input']>;
  faqQuestion_not_contains?: InputMaybe<Scalars['String']['input']>;
  faqQuestion_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfFaqWrapNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfFaqWrapNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfFaqWrapNestedFilter>>>;
  collapse?: InputMaybe<Scalars['Boolean']['input']>;
  collapse_exists?: InputMaybe<Scalars['Boolean']['input']>;
  collapse_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  faqListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCfFindAStoreNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfFindAStoreNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfFindAStoreNestedFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  urlText_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText_not?: InputMaybe<Scalars['String']['input']>;
  urlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfFooterNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfFooterNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfFooterNestedFilter>>>;
  contactLinkAriaLabel?: InputMaybe<Scalars['String']['input']>;
  contactLinkAriaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkAriaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactLinkAriaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLinkAriaLabel_not?: InputMaybe<Scalars['String']['input']>;
  contactLinkAriaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkAriaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLinkText?: InputMaybe<Scalars['String']['input']>;
  contactLinkText_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactLinkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLinkText_not?: InputMaybe<Scalars['String']['input']>;
  contactLinkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLinkUrl?: InputMaybe<Scalars['String']['input']>;
  contactLinkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLinkUrl_not?: InputMaybe<Scalars['String']['input']>;
  contactLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  contactLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  copyrightText?: InputMaybe<Scalars['String']['input']>;
  copyrightText_contains?: InputMaybe<Scalars['String']['input']>;
  copyrightText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copyrightText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copyrightText_not?: InputMaybe<Scalars['String']['input']>;
  copyrightText_not_contains?: InputMaybe<Scalars['String']['input']>;
  copyrightText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayContactInformation?: InputMaybe<Scalars['Boolean']['input']>;
  displayContactInformation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayContactInformation_not?: InputMaybe<Scalars['Boolean']['input']>;
  displayNewsletterSubscribe?: InputMaybe<Scalars['Boolean']['input']>;
  displayNewsletterSubscribe_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayNewsletterSubscribe_not?: InputMaybe<Scalars['Boolean']['input']>;
  displayRegionSelector?: InputMaybe<Scalars['Boolean']['input']>;
  displayRegionSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayRegionSelector_not?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightDesktop?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightMobile?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_not?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoLink?: InputMaybe<Scalars['String']['input']>;
  logoLink_contains?: InputMaybe<Scalars['String']['input']>;
  logoLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoLink_not?: InputMaybe<Scalars['String']['input']>;
  logoLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  logoLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoWidthDesktop?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoWidthDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthMobile?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoWidthMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_not?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  regionSelectorLabel?: InputMaybe<Scalars['String']['input']>;
  regionSelectorLabel_contains?: InputMaybe<Scalars['String']['input']>;
  regionSelectorLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  regionSelectorLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regionSelectorLabel_not?: InputMaybe<Scalars['String']['input']>;
  regionSelectorLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  regionSelectorLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryMenuItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialFacebookUrl?: InputMaybe<Scalars['String']['input']>;
  socialFacebookUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialFacebookUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialFacebookUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialFacebookUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialFacebookUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialFacebookUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialInstagramUrl?: InputMaybe<Scalars['String']['input']>;
  socialInstagramUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialInstagramUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialInstagramUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialInstagramUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialInstagramUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialInstagramUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialLineUrl?: InputMaybe<Scalars['String']['input']>;
  socialLineUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialLineUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialLineUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialLineUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialLineUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialLineUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialNetworkLabel?: InputMaybe<Scalars['String']['input']>;
  socialNetworkLabel_contains?: InputMaybe<Scalars['String']['input']>;
  socialNetworkLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetworkLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialNetworkLabel_not?: InputMaybe<Scalars['String']['input']>;
  socialNetworkLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialNetworkLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialPinterestUrl?: InputMaybe<Scalars['String']['input']>;
  socialPinterestUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialPinterestUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialPinterestUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialPinterestUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialPinterestUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialPinterestUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialStravaUrl?: InputMaybe<Scalars['String']['input']>;
  socialStravaUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialStravaUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialStravaUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialStravaUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialStravaUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialStravaUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialTiktokUrl?: InputMaybe<Scalars['String']['input']>;
  socialTiktokUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialTiktokUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialTiktokUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialTiktokUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialTiktokUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialTiktokUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialXTwitterUrl?: InputMaybe<Scalars['String']['input']>;
  socialXTwitterUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialXTwitterUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialXTwitterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialXTwitterUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialXTwitterUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialXTwitterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialYoutubeUrl?: InputMaybe<Scalars['String']['input']>;
  socialYoutubeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  socialYoutubeUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialYoutubeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialYoutubeUrl_not?: InputMaybe<Scalars['String']['input']>;
  socialYoutubeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialYoutubeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscribeToNewsletterText?: InputMaybe<Scalars['String']['input']>;
  subscribeToNewsletterText_contains?: InputMaybe<Scalars['String']['input']>;
  subscribeToNewsletterText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subscribeToNewsletterText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscribeToNewsletterText_not?: InputMaybe<Scalars['String']['input']>;
  subscribeToNewsletterText_not_contains?: InputMaybe<Scalars['String']['input']>;
  subscribeToNewsletterText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfHeadingNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfHeadingNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfHeadingNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  headingSeoTag?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_contains?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSeoTag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingSeoTag_not?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingSeoTag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingType?: InputMaybe<Scalars['String']['input']>;
  headingType_contains?: InputMaybe<Scalars['String']['input']>;
  headingType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingType_not?: InputMaybe<Scalars['String']['input']>;
  headingType_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingVariation?: InputMaybe<Scalars['String']['input']>;
  headingVariation_contains?: InputMaybe<Scalars['String']['input']>;
  headingVariation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingVariation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingVariation_not?: InputMaybe<Scalars['String']['input']>;
  headingVariation_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingVariation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  highlightColor?: InputMaybe<Scalars['String']['input']>;
  highlightColor_contains?: InputMaybe<Scalars['String']['input']>;
  highlightColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  highlightColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  highlightColor_not?: InputMaybe<Scalars['String']['input']>;
  highlightColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  highlightColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainColor?: InputMaybe<Scalars['String']['input']>;
  mainColor_contains?: InputMaybe<Scalars['String']['input']>;
  mainColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mainColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainColor_not?: InputMaybe<Scalars['String']['input']>;
  mainColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  mainColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfImageWithFocalPointNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfImageWithFocalPointNestedFilter>>>;
  alt?: InputMaybe<Scalars['String']['input']>;
  alt_contains?: InputMaybe<Scalars['String']['input']>;
  alt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alt_not?: InputMaybe<Scalars['String']['input']>;
  alt_not_contains?: InputMaybe<Scalars['String']['input']>;
  alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  focalPoint_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageOnHoverMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageOnHover_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoPlayOption?: InputMaybe<Scalars['String']['input']>;
  videoPlayOption_contains?: InputMaybe<Scalars['String']['input']>;
  videoPlayOption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoPlayOption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoPlayOption_not?: InputMaybe<Scalars['String']['input']>;
  videoPlayOption_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoPlayOption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCfMainHeaderNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfMainHeaderNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfMainHeaderNestedFilter>>>;
  alertBannerCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background?: InputMaybe<Scalars['String']['input']>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_contains?: InputMaybe<Scalars['String']['input']>;
  background_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_not?: InputMaybe<Scalars['String']['input']>;
  background_not_contains?: InputMaybe<Scalars['String']['input']>;
  background_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightDesktop?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  logoHeightDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightMobile?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoHeightMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoHeightMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_not?: InputMaybe<Scalars['Int']['input']>;
  logoHeightMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthDesktop?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoWidthDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  logoWidthDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthMobile?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logoWidthMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logoWidthMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_not?: InputMaybe<Scalars['Int']['input']>;
  logoWidthMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  megamenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  textColorOption?: InputMaybe<Scalars['String']['input']>;
  textColorOption_contains?: InputMaybe<Scalars['String']['input']>;
  textColorOption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textColorOption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textColorOption_not?: InputMaybe<Scalars['String']['input']>;
  textColorOption_not_contains?: InputMaybe<Scalars['String']['input']>;
  textColorOption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfMainMenuItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfMainMenuItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfMainMenuItemNestedFilter>>>;
  bottomLinkAriaLabel?: InputMaybe<Scalars['String']['input']>;
  bottomLinkAriaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkAriaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bottomLinkAriaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bottomLinkAriaLabel_not?: InputMaybe<Scalars['String']['input']>;
  bottomLinkAriaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkAriaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bottomLinkLabel?: InputMaybe<Scalars['String']['input']>;
  bottomLinkLabel_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bottomLinkLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bottomLinkLabel_not?: InputMaybe<Scalars['String']['input']>;
  bottomLinkLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bottomLinkUrl?: InputMaybe<Scalars['String']['input']>;
  bottomLinkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bottomLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bottomLinkUrl_not?: InputMaybe<Scalars['String']['input']>;
  bottomLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  bottomLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  scrollerItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scrollerLabel?: InputMaybe<Scalars['String']['input']>;
  scrollerLabel_contains?: InputMaybe<Scalars['String']['input']>;
  scrollerLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scrollerLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scrollerLabel_not?: InputMaybe<Scalars['String']['input']>;
  scrollerLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  scrollerLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submenuItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibleInDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCfMegaMenuNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfMegaMenuNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfMegaMenuNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfNavQuickLinkItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfNavQuickLinkItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfNavQuickLinkItemNestedFilter>>>;
  Url?: InputMaybe<Scalars['String']['input']>;
  Url_contains?: InputMaybe<Scalars['String']['input']>;
  Url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  Url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Url_not?: InputMaybe<Scalars['String']['input']>;
  Url_not_contains?: InputMaybe<Scalars['String']['input']>;
  Url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  disableNavigationScrollToTop?: InputMaybe<Scalars['Boolean']['input']>;
  disableNavigationScrollToTop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableNavigationScrollToTop_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  topLabelText?: InputMaybe<Scalars['String']['input']>;
  topLabelText_contains?: InputMaybe<Scalars['String']['input']>;
  topLabelText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  topLabelText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topLabelText_not?: InputMaybe<Scalars['String']['input']>;
  topLabelText_not_contains?: InputMaybe<Scalars['String']['input']>;
  topLabelText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlTarget?: InputMaybe<Scalars['String']['input']>;
  urlTarget_contains?: InputMaybe<Scalars['String']['input']>;
  urlTarget_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlTarget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlTarget_not?: InputMaybe<Scalars['String']['input']>;
  urlTarget_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlTarget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  urlText_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlText_not?: InputMaybe<Scalars['String']['input']>;
  urlText_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlTrigger_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCfNavQuickLinksNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfNavQuickLinksNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfNavQuickLinksNestedFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSticky?: InputMaybe<Scalars['Boolean']['input']>;
  isSticky_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isSticky_not?: InputMaybe<Scalars['Boolean']['input']>;
  linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfPageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfPageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfPageNestedFilter>>>;
  contentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  enableSearch?: InputMaybe<Scalars['Boolean']['input']>;
  enableSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  footer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mainHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  seoConfigurationOverride_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not?: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  simpleFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  tagsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfScrollerItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfScrollerItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfScrollerItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openUrlInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibleInDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulCfSearchOverlayNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfSearchOverlayNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfSearchOverlayNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  displayRetailers?: InputMaybe<Scalars['Boolean']['input']>;
  displayRetailers_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayRetailers_not?: InputMaybe<Scalars['Boolean']['input']>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchBox?: InputMaybe<Scalars['String']['input']>;
  searchBox_contains?: InputMaybe<Scalars['String']['input']>;
  searchBox_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchBox_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchBox_not?: InputMaybe<Scalars['String']['input']>;
  searchBox_not_contains?: InputMaybe<Scalars['String']['input']>;
  searchBox_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfSelectorLinkNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfSelectorLinkNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfSelectorLinkNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  reference_contains?: InputMaybe<Scalars['String']['input']>;
  reference_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reference_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reference_not?: InputMaybe<Scalars['String']['input']>;
  reference_not_contains?: InputMaybe<Scalars['String']['input']>;
  reference_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfSeoConfigurationNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfSeoConfigurationNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfSeoConfigurationNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoCanonical?: InputMaybe<Scalars['String']['input']>;
  seoCanonical_contains?: InputMaybe<Scalars['String']['input']>;
  seoCanonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoCanonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoCanonical_not?: InputMaybe<Scalars['String']['input']>;
  seoCanonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  seoCanonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoDescription_contains?: InputMaybe<Scalars['String']['input']>;
  seoDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoDescription_not?: InputMaybe<Scalars['String']['input']>;
  seoDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoIndex?: InputMaybe<Scalars['Boolean']['input']>;
  seoIndex_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  seoThumbnail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  seoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  seoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoTitle_not?: InputMaybe<Scalars['String']['input']>;
  seoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfServiceItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfServiceItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfServiceItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfServicePerkNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfServicePerkNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfServicePerkNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalText_contains?: InputMaybe<Scalars['String']['input']>;
  modalText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalText_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfSimpleFooterNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfSimpleFooterNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfSimpleFooterNestedFilter>>>;
  background_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  cta?: InputMaybe<Scalars['String']['input']>;
  cta_contains?: InputMaybe<Scalars['String']['input']>;
  cta_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cta_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cta_not?: InputMaybe<Scalars['String']['input']>;
  cta_not_contains?: InputMaybe<Scalars['String']['input']>;
  cta_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<ContentfulSysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCfbottomContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfbottomContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfbottomContentMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfcontentAboveBoutiquesMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfcontentAboveBoutiquesMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfcontentAboveBoutiquesMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfcontentBelowBoutiquesMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfcontentBelowBoutiquesMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfcontentBelowBoutiquesMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfcontentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfcontentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfcontentMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfitemsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfitemsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfitemsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulCfnoResultsContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCfnoResultsContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCfnoResultsContentMultiTypeNestedFilter>>>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationConfiguration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<ContentfulSysFilter>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulCftopContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentfulCftopContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentfulCftopContentMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulContentfulMetadataFilter>;
  sys?: InputMaybe<ContentfulSysFilter>;
};

export type ContentfulAlertBannerFragment = { __typename?: 'AlertBanner', internalName?: string | null, type?: string | null, alertBannerText?: { __typename?: 'AlertBannerText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulAutomaticCollectionGroupFragment = { __typename?: 'AutomaticCollectionGroup', internalName?: string | null, collection?: string | null, algoliaFacetFilters?: Array<string | null> | null, maximumNumberOfProducts?: number | null, algoliaRuleName?: string | null, sortBy?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulBannerFragment = { __typename?: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null };

export type ContentfulBannerHeroFragment = { __typename?: 'BannerHero', internalName?: string | null, title?: string | null, titleSeoTag?: string | null, text?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulBreadcrumbFragment = { __typename?: 'Breadcrumb', style?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulCardFragment = { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null };

export type ContentfulCollectionGroupFragment = { __typename?: 'CollectionGroup', internalName?: string | null, type?: string | null, banner?: { __typename?: 'BannerHero', internalName?: string | null, title?: string | null, titleSeoTag?: string | null, text?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, productReferences?: { __typename?: 'AutomaticCollectionGroup', internalName?: string | null, collection?: string | null, algoliaFacetFilters?: Array<string | null> | null, maximumNumberOfProducts?: number | null, algoliaRuleName?: string | null, sortBy?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ManualCollectionGroupProductReferences', internalName?: string | null, manualProductReferences?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, endImage?: { __typename?: 'CollectionGroupEndImage', internalName?: string | null, endImageLinkType?: string | null, endImageUrl?: string | null, endImageUrlText?: string | null, endImage?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulCollectionGroupEndImageFragment = { __typename?: 'CollectionGroupEndImage', internalName?: string | null, endImageLinkType?: string | null, endImageUrl?: string | null, endImageUrlText?: string | null, endImage?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulCollectionItemFragment = { __typename?: 'CollectionItem', saleorCollection?: string | null, collectionName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null };

export type ContentfulConditionalComponentFragment = { __typename?: 'ConditionalComponent', displayOnLoggedInCondition?: string | null, displayOnEmptyCondition?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contentCollection?: { __typename?: 'ConditionalComponentContentCollection', items: Array<{ __typename?: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Breadcrumb', style?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Grid', id?: string | null, col?: string | null, colForMobile?: string | null, isSlider?: boolean | null, rowGap?: string | null, colGap?: string | null, maxWidth?: string | null, paddingTop?: string | null, paddingBottom?: string | null, backgroundColor?: any | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, reverseDisplayOrderForMobile?: boolean | null, contentAlignment?: string | null, contentCollection?: { __typename?: 'GridContentCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup' } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'HeroSlider', autoslide?: boolean | null, autoslideDurationMs?: number | null, slidesCollection?: { __typename?: 'HeroSliderSlidesCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Placeholder', heading?: string | null, type?: string | null, videoUrl?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, subtext?: { __typename?: 'PlaceholderSubtext', json: any } | null, warrantyText?: { __typename?: 'Card', type?: string | null, subHeading?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null, warrantyTakingCareOfYourWatch?: { __typename?: 'Card', type?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null } | { __typename?: 'PlaceholderCheckoutPayments', internalName?: string | null, ctaText?: string | null, ctaTel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, paymentsMediaCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulContactUsFragment = { __typename?: 'ContactUs', internalName?: string | null, phone?: string | null, email?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contactHeader?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null };

export type ContentfulContentGroupFragment = { __typename?: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulEventFragment = { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulExhibitionListFragment = { __typename?: 'ExhibitionList', internalName?: string | null, categoryTitle?: string | null, categoryTitleSeoTag?: string | null, categoryDescription?: string | null, exhibitionListLabel?: string | null, pastExhibitionsLabel?: string | null, loadMoreLabel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, exhibitionItemsCollection?: { __typename?: 'ExhibitionListExhibitionItemsCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'ExhibitionItem', internalName?: string | null, boutiqueId?: string | null, label?: string | null, startDate?: string | null, endDate?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null };

export type ContentfulFaqCategoriesFragment = { __typename?: 'FaqCategories', internalName?: string | null, categoryLabel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqWrapsCollection?: { __typename?: 'FaqCategoriesFaqWrapsCollection', items: Array<{ __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null } | null> } | null };

export type ContentfulFaqWrapFragment = { __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null };

export type ContentfulFaqWrapFaqListCollectionFragment = { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> };

export type ContentfulFindAStoreFragment = { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null };

export type ContentfulFooterItemFragment = { __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulFooterFragment = { __typename?: 'Footer', internalName?: string | null, type?: string | null, subscribeToNewsletterText?: string | null, copyrightText?: string | null, displayContactInformation?: boolean | null, displayNewsletterSubscribe?: boolean | null, displayRegionSelector?: boolean | null, regionSelectorLabel?: string | null, socialNetworkLabel?: string | null, socialFacebookUrl?: string | null, socialInstagramUrl?: string | null, socialPinterestUrl?: string | null, socialYoutubeUrl?: string | null, socialXTwitterUrl?: string | null, socialStravaUrl?: string | null, socialTiktokUrl?: string | null, socialLineUrl?: string | null, localizationConfiguration?: any | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, logoLink?: string | null, menuItemsCollection?: { __typename?: 'FooterMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, secondaryMenuItemsCollection?: { __typename?: 'FooterSecondaryMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulFreeTextContentFragment = { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null };

export type ContentfulGridFragment = { __typename?: 'Grid', id?: string | null, col?: string | null, colForMobile?: string | null, isSlider?: boolean | null, rowGap?: string | null, colGap?: string | null, maxWidth?: string | null, paddingTop?: string | null, paddingBottom?: string | null, backgroundColor?: any | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, reverseDisplayOrderForMobile?: boolean | null, contentAlignment?: string | null, contentCollection?: { __typename?: 'GridContentCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup' } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulHeadingFragment = { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulHeroProductListingFragment = { __typename?: 'HeroProductListing', type?: string | null, heading?: string | null, headingNumberOfColoredWords?: number | null, subheader?: string | null, subheaderIsCapitalized?: boolean | null, textBelowMedia?: boolean | null, textAlignment?: string | null, showFilters?: boolean | null, showBreadcrumbs?: boolean | null, backgroundColor?: any | null, backgroundColorOpacity?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, contentAlignment?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, collectionItemsCollection?: { __typename?: 'HeroProductListingCollectionItemsCollection', items: Array<{ __typename?: 'CollectionItem', saleorCollection?: string | null, collectionName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, heroProductListingText?: { __typename?: 'HeroProductListingText', json: any } | null, heroProductListingTitle?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null };

export type ContentfulHeroSliderFragment = { __typename?: 'HeroSlider', autoslide?: boolean | null, autoslideDurationMs?: number | null, slidesCollection?: { __typename?: 'HeroSliderSlidesCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulIframeFragment = { __typename?: 'Iframe', internalName?: string | null, url?: string | null, maxWidth?: string | null, height?: string | null, hasScrollbar?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulLiveStoryFragment = { __typename?: 'LiveStoryContentType', title?: string | null, coverImg?: string | null, id?: string | null, type?: string | null, ssc?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulImageWithFocalPointFragment = { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulMainHeaderFragment = { __typename?: 'MainHeader', internalName?: string | null, type?: string | null, background?: string | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, textColorOption?: string | null, backgroundImage?: { __typename?: 'Asset', url?: string | null } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, megamenu?: { __typename?: 'MegaMenu', internalName?: string | null, menuItemsCollection?: { __typename?: 'MegaMenuMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, alertBannerCollection?: { __typename?: 'MainHeaderAlertBannerCollection', items: Array<{ __typename?: 'AlertBanner', internalName?: string | null, type?: string | null, alertBannerText?: { __typename?: 'AlertBannerText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulSubmenuItemFragment = { __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulMainMenuItemFragment = { __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, localizationConfiguration?: any | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null };

export type ContentfulManualCollectionGroupProductReferencesFragment = { __typename?: 'ManualCollectionGroupProductReferences', internalName?: string | null, manualProductReferences?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulMediaFragment = { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulMegaMenuFragment = { __typename?: 'MegaMenu', internalName?: string | null, menuItemsCollection?: { __typename?: 'MegaMenuMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulNavQuickLinkFragment = { __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null };

export type ContentfulNavQuickLinksFragment = { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulNavQuickLinksWithBannerFragment = { __typename?: 'NavQuickLinksWithBanner', type?: string | null, navQuickLinks?: { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, card?: { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulPageBreadcrumbFragment = { __typename?: 'Page', slug?: string | null, pageTitle?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulPlaceholderFragment = { __typename?: 'Placeholder', heading?: string | null, type?: string | null, videoUrl?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, subtext?: { __typename?: 'PlaceholderSubtext', json: any } | null, warrantyText?: { __typename?: 'Card', type?: string | null, subHeading?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null, warrantyTakingCareOfYourWatch?: { __typename?: 'Card', type?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null };

export type ContentfulPlaceholderBoutiqueDetailFragment = { __typename?: 'PlaceholderBoutiqueDetail', internalName?: string | null, type?: string | null, sys: { __typename?: 'Sys', id: string } };

export type ContentfulPlaceholderCheckoutPaymentsFragment = { __typename?: 'PlaceholderCheckoutPayments', internalName?: string | null, ctaText?: string | null, ctaTel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, paymentsMediaCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulPlaceholderHeaderFragment = { __typename?: 'PlaceholderHeader', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulPlaceholderModelStoryFragment = { __typename?: 'PlaceholderModelStory', mediaAlignment?: string | null, type?: string | null, storyBackgroundColor?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, storyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null };

export type ContentfulPlaceholderProductDetailsFragment = { __typename?: 'PlaceholderProductDetails', sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, perksCollection?: { __typename?: 'PlaceholderProductDetailsPerksCollection', items: Array<{ __typename?: 'ServicePerk', heading?: string | null, type?: string | null, url?: string | null, modalText?: { __typename?: 'ServicePerkModalText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulPlaceholderServiceFragment = { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null };

export type ContentfulPlaceholderStoresFragment = { __typename?: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null };

export type ContentfulProductCardFragment = { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulScrollerItemFragment = { __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, localizationConfiguration?: any | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulSearchOverlayFragment = { __typename?: 'SearchOverlay', type?: string | null, title?: string | null, searchBox?: string | null, displayRetailers?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, noResultsContentCollection?: { __typename?: 'SearchOverlayNoResultsContentCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'SliderProductsAutomatic', title?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, type?: string | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulSeoConfigurationFragment = { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null };

export type ContentfulServiceFragment = { __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null };

export type ContentfulServicePerkFragment = { __typename?: 'ServicePerk', heading?: string | null, type?: string | null, url?: string | null, modalText?: { __typename?: 'ServicePerkModalText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulServicesFragment = { __typename?: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulSimpleFooterFragment = { __typename?: 'SimpleFooter', title?: string | null, description?: string | null, cta?: string | null, background?: { __typename?: 'Asset', url?: string | null } | null };

export type ContentfulSiteMapMenuFragment = { __typename?: 'MegaMenu', internalName?: string | null, menuItemsCollection?: { __typename?: 'MegaMenuMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulSliderProductsAutomaticFragment = { __typename?: 'SliderProductsAutomatic', title?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, type?: string | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulSliderProductsManualFragment = { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } };

export type ContentfulSysFragment = { __typename?: 'Sys', id: string, publishedAt?: string | null };

export type ContentfulDefaultHeaderSettingsQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type ContentfulDefaultHeaderSettingsQuery = { __typename?: 'Query', defaultLayoutCollection?: { __typename?: 'DefaultLayoutCollection', items: Array<{ __typename?: 'DefaultLayout', header?: { __typename?: 'MainHeader', internalName?: string | null, type?: string | null, background?: string | null, textColorOption?: string | null, backgroundImage?: { __typename?: 'Asset', url?: string | null } | null, logo?: { __typename?: 'Asset', url?: string | null } | null } | null } | null> } | null };

export type ContentfulDefaultLayoutQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type ContentfulDefaultLayoutQuery = { __typename?: 'Query', defaultLayoutCollection?: { __typename?: 'DefaultLayoutCollection', items: Array<{ __typename?: 'DefaultLayout', header?: { __typename?: 'MainHeader', internalName?: string | null, type?: string | null, background?: string | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, textColorOption?: string | null, backgroundImage?: { __typename?: 'Asset', url?: string | null } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, megamenu?: { __typename?: 'MegaMenu', internalName?: string | null, menuItemsCollection?: { __typename?: 'MegaMenuMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, alertBannerCollection?: { __typename?: 'MainHeaderAlertBannerCollection', items: Array<{ __typename?: 'AlertBanner', internalName?: string | null, type?: string | null, alertBannerText?: { __typename?: 'AlertBannerText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, footer?: { __typename?: 'Footer', internalName?: string | null, type?: string | null, subscribeToNewsletterText?: string | null, copyrightText?: string | null, displayContactInformation?: boolean | null, displayNewsletterSubscribe?: boolean | null, displayRegionSelector?: boolean | null, regionSelectorLabel?: string | null, socialNetworkLabel?: string | null, socialFacebookUrl?: string | null, socialInstagramUrl?: string | null, socialPinterestUrl?: string | null, socialYoutubeUrl?: string | null, socialXTwitterUrl?: string | null, socialStravaUrl?: string | null, socialTiktokUrl?: string | null, socialLineUrl?: string | null, localizationConfiguration?: any | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, logoLink?: string | null, menuItemsCollection?: { __typename?: 'FooterMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, secondaryMenuItemsCollection?: { __typename?: 'FooterSecondaryMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, search?: { __typename?: 'SearchOverlay', type?: string | null, title?: string | null, searchBox?: string | null, displayRetailers?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, noResultsContentCollection?: { __typename?: 'SearchOverlayNoResultsContentCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'SliderProductsAutomatic', title?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, type?: string | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | null } | null> } | null };

export type ContentfulDetailPageQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  sku: Scalars['String']['input'];
  collectionName: Scalars['String']['input'];
  modelName: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContentfulDetailPageQuery = { __typename?: 'Query', detailPageCollection?: { __typename?: 'DetailPageCollection', items: Array<{ __typename?: 'DetailPage', watchSkus?: Array<string | null> | null, strapSkus?: Array<string | null> | null, watchCollection?: string | null, model?: string | null, default?: boolean | null, mainHeader?: { __typename?: 'MainHeader', internalName?: string | null, type?: string | null, background?: string | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, textColorOption?: string | null, backgroundImage?: { __typename?: 'Asset', url?: string | null } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, megamenu?: { __typename?: 'MegaMenu', internalName?: string | null, menuItemsCollection?: { __typename?: 'MegaMenuMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, alertBannerCollection?: { __typename?: 'MainHeaderAlertBannerCollection', items: Array<{ __typename?: 'AlertBanner', internalName?: string | null, type?: string | null, alertBannerText?: { __typename?: 'AlertBannerText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, footer?: { __typename?: 'Footer', internalName?: string | null, type?: string | null, subscribeToNewsletterText?: string | null, copyrightText?: string | null, displayContactInformation?: boolean | null, displayNewsletterSubscribe?: boolean | null, displayRegionSelector?: boolean | null, regionSelectorLabel?: string | null, socialNetworkLabel?: string | null, socialFacebookUrl?: string | null, socialInstagramUrl?: string | null, socialPinterestUrl?: string | null, socialYoutubeUrl?: string | null, socialXTwitterUrl?: string | null, socialStravaUrl?: string | null, socialTiktokUrl?: string | null, socialLineUrl?: string | null, localizationConfiguration?: any | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, logoLink?: string | null, menuItemsCollection?: { __typename?: 'FooterMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, secondaryMenuItemsCollection?: { __typename?: 'FooterSecondaryMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, contentCollection?: { __typename?: 'DetailPageContentCollection', items: Array<{ __typename?: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContactUs', internalName?: string | null, phone?: string | null, email?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contactHeader?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup' } | { __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | { __typename?: 'Grid', id?: string | null, col?: string | null, colForMobile?: string | null, isSlider?: boolean | null, rowGap?: string | null, colGap?: string | null, maxWidth?: string | null, paddingTop?: string | null, paddingBottom?: string | null, backgroundColor?: any | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, reverseDisplayOrderForMobile?: boolean | null, contentAlignment?: string | null, contentCollection?: { __typename?: 'GridContentCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup' } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Placeholder', heading?: string | null, type?: string | null, videoUrl?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, subtext?: { __typename?: 'PlaceholderSubtext', json: any } | null, warrantyText?: { __typename?: 'Card', type?: string | null, subHeading?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null, warrantyTakingCareOfYourWatch?: { __typename?: 'Card', type?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null } | { __typename?: 'PlaceholderModelStory', mediaAlignment?: string | null, type?: string | null, storyBackgroundColor?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, storyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'PlaceholderProductDetails', sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, perksCollection?: { __typename?: 'PlaceholderProductDetailsPerksCollection', items: Array<{ __typename?: 'ServicePerk', heading?: string | null, type?: string | null, url?: string | null, modalText?: { __typename?: 'ServicePerkModalText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | { __typename?: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null } | { __typename?: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsAutomatic', title?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, type?: string | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | null> } | null };

export type ContentfulDictionaryQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
}>;


export type ContentfulDictionaryQuery = { __typename?: 'Query', dictionaryCollection?: { __typename?: 'DictionaryCollection', items: Array<{ __typename?: 'Dictionary', contentCollection?: { __typename?: 'DictionaryContentCollection', items: Array<{ __typename?: 'DictionaryItem', key?: string | null, value?: string | null } | null> } | null } | null> } | null };

export type ContentfulFixedPageQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContentfulFixedPageQuery = { __typename?: 'Query', pageFixedCollection?: { __typename?: 'PageFixedCollection', items: Array<{ __typename?: 'PageFixed', internalName?: string | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, pinnedNewsCollection?: { __typename?: 'PageFixedPinnedNewsCollection', items: Array<{ __typename?: 'Page', slug?: string | null, pageTitle?: string | null, shortDescription?: string | null, publishDate?: string | null, mainHeader?: { __typename?: 'MainHeader', internalName?: string | null, type?: string | null, background?: string | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, textColorOption?: string | null, backgroundImage?: { __typename?: 'Asset', url?: string | null } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, megamenu?: { __typename?: 'MegaMenu', internalName?: string | null, menuItemsCollection?: { __typename?: 'MegaMenuMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, alertBannerCollection?: { __typename?: 'MainHeaderAlertBannerCollection', items: Array<{ __typename?: 'AlertBanner', internalName?: string | null, type?: string | null, alertBannerText?: { __typename?: 'AlertBannerText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, thumbnail?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, tagsCollection?: { __typename?: 'PageTagsCollection', items: Array<{ __typename?: 'DictionaryItem', key?: string | null, value?: string | null } | null> } | null } | null> } | null, topContentCollection?: { __typename?: 'PageFixedTopContentCollection', items: Array<{ __typename?: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Breadcrumb', style?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ConditionalComponent', displayOnLoggedInCondition?: string | null, displayOnEmptyCondition?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contentCollection?: { __typename?: 'ConditionalComponentContentCollection', items: Array<{ __typename?: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Breadcrumb', style?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Grid', id?: string | null, col?: string | null, colForMobile?: string | null, isSlider?: boolean | null, rowGap?: string | null, colGap?: string | null, maxWidth?: string | null, paddingTop?: string | null, paddingBottom?: string | null, backgroundColor?: any | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, reverseDisplayOrderForMobile?: boolean | null, contentAlignment?: string | null, contentCollection?: { __typename?: 'GridContentCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup' } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'HeroSlider', autoslide?: boolean | null, autoslideDurationMs?: number | null, slidesCollection?: { __typename?: 'HeroSliderSlidesCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Placeholder', heading?: string | null, type?: string | null, videoUrl?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, subtext?: { __typename?: 'PlaceholderSubtext', json: any } | null, warrantyText?: { __typename?: 'Card', type?: string | null, subHeading?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null, warrantyTakingCareOfYourWatch?: { __typename?: 'Card', type?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null } | { __typename?: 'PlaceholderCheckoutPayments', internalName?: string | null, ctaText?: string | null, ctaTel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, paymentsMediaCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | { __typename?: 'ContactUs' } | { __typename?: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Grid', id?: string | null, col?: string | null, colForMobile?: string | null, isSlider?: boolean | null, rowGap?: string | null, colGap?: string | null, maxWidth?: string | null, paddingTop?: string | null, paddingBottom?: string | null, backgroundColor?: any | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, reverseDisplayOrderForMobile?: boolean | null, contentAlignment?: string | null, contentCollection?: { __typename?: 'GridContentCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup' } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Placeholder' } | { __typename?: 'PlaceholderService' } | { __typename?: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null } | { __typename?: 'ProductCard' } | { __typename?: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, bottomContentCollection?: { __typename?: 'PageFixedBottomContentCollection', items: Array<{ __typename?: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Breadcrumb' } | { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ConditionalComponent', displayOnLoggedInCondition?: string | null, displayOnEmptyCondition?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contentCollection?: { __typename?: 'ConditionalComponentContentCollection', items: Array<{ __typename?: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Breadcrumb', style?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Grid', id?: string | null, col?: string | null, colForMobile?: string | null, isSlider?: boolean | null, rowGap?: string | null, colGap?: string | null, maxWidth?: string | null, paddingTop?: string | null, paddingBottom?: string | null, backgroundColor?: any | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, reverseDisplayOrderForMobile?: boolean | null, contentAlignment?: string | null, contentCollection?: { __typename?: 'GridContentCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup' } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'HeroSlider', autoslide?: boolean | null, autoslideDurationMs?: number | null, slidesCollection?: { __typename?: 'HeroSliderSlidesCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Placeholder', heading?: string | null, type?: string | null, videoUrl?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, subtext?: { __typename?: 'PlaceholderSubtext', json: any } | null, warrantyText?: { __typename?: 'Card', type?: string | null, subHeading?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null, warrantyTakingCareOfYourWatch?: { __typename?: 'Card', type?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null } | { __typename?: 'PlaceholderCheckoutPayments', internalName?: string | null, ctaText?: string | null, ctaTel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, paymentsMediaCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | { __typename?: 'ContactUs', internalName?: string | null, phone?: string | null, email?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contactHeader?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Grid', id?: string | null, col?: string | null, colForMobile?: string | null, isSlider?: boolean | null, rowGap?: string | null, colGap?: string | null, maxWidth?: string | null, paddingTop?: string | null, paddingBottom?: string | null, backgroundColor?: any | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, reverseDisplayOrderForMobile?: boolean | null, contentAlignment?: string | null, contentCollection?: { __typename?: 'GridContentCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup' } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Placeholder', heading?: string | null, type?: string | null, videoUrl?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, subtext?: { __typename?: 'PlaceholderSubtext', json: any } | null, warrantyText?: { __typename?: 'Card', type?: string | null, subHeading?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null, warrantyTakingCareOfYourWatch?: { __typename?: 'Card', type?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null } | { __typename?: 'PlaceholderCheckoutPayments', internalName?: string | null, ctaText?: string | null, ctaTel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, paymentsMediaCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | { __typename?: 'PlaceholderService' } | { __typename?: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null } | { __typename?: 'ProductCard' } | { __typename?: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, dictionaryCollection?: { __typename?: 'PageFixedDictionaryCollection', items: Array<{ __typename?: 'DictionaryItem', key?: string | null, value?: string | null } | null> } | null } | null> } | null };

export type ContentfulGetAllNewsPagesQueryVariables = Exact<{
  languageCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContentfulGetAllNewsPagesQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', slug?: string | null, pageTitle?: string | null, shortDescription?: string | null, publishDate?: string | null, thumbnail?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, tagsCollection?: { __typename?: 'PageTagsCollection', items: Array<{ __typename?: 'DictionaryItem', key?: string | null, value?: string | null } | null> } | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulGetExhibitionHistoriesFaqPagesQueryVariables = Exact<{
  languageCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type ContentfulGetExhibitionHistoriesFaqPagesQuery = { __typename?: 'Query', pageExhibitionHistoriesFaqCollection?: { __typename?: 'PageExhibitionHistoriesFaqCollection', items: Array<{ __typename?: 'PageExhibitionHistoriesFaq', type?: string | null, slug?: string | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulGetFixedPagesQueryVariables = Exact<{
  languageCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type ContentfulGetFixedPagesQuery = { __typename?: 'Query', pageFixedCollection?: { __typename?: 'PageFixedCollection', items: Array<{ __typename?: 'PageFixed', slug?: string | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulGetMegaMenuQueryVariables = Exact<{
  internalName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  countryCode: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContentfulGetMegaMenuQuery = { __typename?: 'Query', megaMenuCollection?: { __typename?: 'MegaMenuCollection', limit: number, skip: number, total: number, items: Array<{ __typename?: 'MegaMenu', internalName?: string | null, menuItemsCollection?: { __typename?: 'MegaMenuMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulGetPagesQueryVariables = Exact<{
  languageCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type ContentfulGetPagesQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', slug?: string | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulGetPagesDetailsQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  slugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContentfulGetPagesDetailsQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', slug?: string | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulGetPdpDetailsQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
}>;


export type ContentfulGetPdpDetailsQuery = { __typename?: 'Query', detailPageCollection?: { __typename?: 'DetailPageCollection', items: Array<{ __typename?: 'DetailPage', internalName?: string | null, watchSkus?: Array<string | null> | null, strapSkus?: Array<string | null> | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulGetPlpDetailsQueryVariables = Exact<{
  languageCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type ContentfulGetPlpDetailsQuery = { __typename?: 'Query', listingPageCollection?: { __typename?: 'ListingPageCollection', items: Array<{ __typename?: 'ListingPage', type?: string | null, collectionName?: string | null, strapMaterial?: string | null, editorialPageName?: string | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulListingPageQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  collectionItemsLimit: Scalars['Int']['input'];
  languageCode: Scalars['String']['input'];
  collectionName?: InputMaybe<Scalars['String']['input']>;
  editorialPageName?: InputMaybe<Scalars['String']['input']>;
  strapMaterial?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContentfulListingPageQuery = { __typename?: 'Query', listingPageCollection?: { __typename?: 'ListingPageCollection', items: Array<{ __typename?: 'ListingPage', algoliaCategoryId?: string | null, algoliaRuleName?: string | null, collectionName?: string | null, editorialPageName?: string | null, mainHeader?: { __typename?: 'MainHeader', internalName?: string | null, type?: string | null, background?: string | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, textColorOption?: string | null, backgroundImage?: { __typename?: 'Asset', url?: string | null } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, megamenu?: { __typename?: 'MegaMenu', internalName?: string | null, menuItemsCollection?: { __typename?: 'MegaMenuMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, alertBannerCollection?: { __typename?: 'MainHeaderAlertBannerCollection', items: Array<{ __typename?: 'AlertBanner', internalName?: string | null, type?: string | null, alertBannerText?: { __typename?: 'AlertBannerText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, footer?: { __typename?: 'Footer', internalName?: string | null, type?: string | null, subscribeToNewsletterText?: string | null, copyrightText?: string | null, displayContactInformation?: boolean | null, displayNewsletterSubscribe?: boolean | null, displayRegionSelector?: boolean | null, regionSelectorLabel?: string | null, socialNetworkLabel?: string | null, socialFacebookUrl?: string | null, socialInstagramUrl?: string | null, socialPinterestUrl?: string | null, socialYoutubeUrl?: string | null, socialXTwitterUrl?: string | null, socialStravaUrl?: string | null, socialTiktokUrl?: string | null, socialLineUrl?: string | null, localizationConfiguration?: any | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, logoLink?: string | null, menuItemsCollection?: { __typename?: 'FooterMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, secondaryMenuItemsCollection?: { __typename?: 'FooterSecondaryMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, contentCollection?: { __typename?: 'ListingPageContentCollection', items: Array<{ __typename?: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'CollectionGroup', internalName?: string | null, type?: string | null, banner?: { __typename?: 'BannerHero', internalName?: string | null, title?: string | null, titleSeoTag?: string | null, text?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, productReferences?: { __typename?: 'AutomaticCollectionGroup', internalName?: string | null, collection?: string | null, algoliaFacetFilters?: Array<string | null> | null, maximumNumberOfProducts?: number | null, algoliaRuleName?: string | null, sortBy?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ManualCollectionGroupProductReferences', internalName?: string | null, manualProductReferences?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, endImage?: { __typename?: 'CollectionGroupEndImage', internalName?: string | null, endImageLinkType?: string | null, endImageUrl?: string | null, endImageUrlText?: string | null, endImage?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ContactUs', internalName?: string | null, phone?: string | null, email?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contactHeader?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'HeroProductListing', type?: string | null, heading?: string | null, headingNumberOfColoredWords?: number | null, subheader?: string | null, subheaderIsCapitalized?: boolean | null, textBelowMedia?: boolean | null, textAlignment?: string | null, showFilters?: boolean | null, showBreadcrumbs?: boolean | null, backgroundColor?: any | null, backgroundColorOpacity?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, contentAlignment?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, collectionItemsCollection?: { __typename?: 'HeroProductListingCollectionItemsCollection', items: Array<{ __typename?: 'CollectionItem', saleorCollection?: string | null, collectionName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, heroProductListingText?: { __typename?: 'HeroProductListingText', json: any } | null, heroProductListingTitle?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Placeholder', heading?: string | null, type?: string | null, videoUrl?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, subtext?: { __typename?: 'PlaceholderSubtext', json: any } | null, warrantyText?: { __typename?: 'Card', type?: string | null, subHeading?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null, warrantyTakingCareOfYourWatch?: { __typename?: 'Card', type?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null } | { __typename?: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null } | { __typename?: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsAutomatic', title?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, type?: string | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | null> } | null };

export type ContentfulPageQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  parentSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContentfulPageQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', pageTitle?: string | null, publishDate?: string | null, type?: string | null, shortDescription?: string | null, localizationConfiguration?: any | null, tagsCollection?: { __typename?: 'PageTagsCollection', items: Array<{ __typename?: 'DictionaryItem', key?: string | null, value?: string | null } | null> } | null, mainHeader?: { __typename?: 'MainHeader', internalName?: string | null, type?: string | null, background?: string | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, textColorOption?: string | null, backgroundImage?: { __typename?: 'Asset', url?: string | null } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, megamenu?: { __typename?: 'MegaMenu', internalName?: string | null, menuItemsCollection?: { __typename?: 'MegaMenuMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, alertBannerCollection?: { __typename?: 'MainHeaderAlertBannerCollection', items: Array<{ __typename?: 'AlertBanner', internalName?: string | null, type?: string | null, alertBannerText?: { __typename?: 'AlertBannerText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, footer?: { __typename?: 'Footer', internalName?: string | null, type?: string | null, subscribeToNewsletterText?: string | null, copyrightText?: string | null, displayContactInformation?: boolean | null, displayNewsletterSubscribe?: boolean | null, displayRegionSelector?: boolean | null, regionSelectorLabel?: string | null, socialNetworkLabel?: string | null, socialFacebookUrl?: string | null, socialInstagramUrl?: string | null, socialPinterestUrl?: string | null, socialYoutubeUrl?: string | null, socialXTwitterUrl?: string | null, socialStravaUrl?: string | null, socialTiktokUrl?: string | null, socialLineUrl?: string | null, localizationConfiguration?: any | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, logoLink?: string | null, menuItemsCollection?: { __typename?: 'FooterMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, secondaryMenuItemsCollection?: { __typename?: 'FooterSecondaryMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, contentCollection?: { __typename?: 'PageContentCollection', items: Array<{ __typename?: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Breadcrumb', style?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContactUs', internalName?: string | null, phone?: string | null, email?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contactHeader?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Grid', id?: string | null, col?: string | null, colForMobile?: string | null, isSlider?: boolean | null, rowGap?: string | null, colGap?: string | null, maxWidth?: string | null, paddingTop?: string | null, paddingBottom?: string | null, backgroundColor?: any | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, reverseDisplayOrderForMobile?: boolean | null, contentAlignment?: string | null, contentCollection?: { __typename?: 'GridContentCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup' } | { __typename?: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'HeroSlider', autoslide?: boolean | null, autoslideDurationMs?: number | null, slidesCollection?: { __typename?: 'HeroSliderSlidesCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Iframe', internalName?: string | null, url?: string | null, maxWidth?: string | null, height?: string | null, hasScrollbar?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'NavQuickLinksWithBanner', type?: string | null, navQuickLinks?: { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, card?: { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderHeader', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, simpleFooter?: { __typename?: 'SimpleFooter', title?: string | null, description?: string | null, cta?: string | null, background?: { __typename?: 'Asset', url?: string | null } | null } | null } | null> } | null, breadcrumb?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', slug?: string | null, pageTitle?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQueryVariables = Exact<{
  trackingKey?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery = { __typename?: 'Query', pageBoutiqueDetailCollection?: { __typename?: 'PageBoutiqueDetailCollection', total: number, items: Array<{ __typename?: 'PageBoutiqueDetail', internalName?: string | null, trackingKey?: string | null, type?: string | null, default?: boolean | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, contentCollection?: { __typename?: 'PageBoutiqueDetailContentCollection', items: Array<{ __typename?: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContactUs', internalName?: string | null, phone?: string | null, email?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contactHeader?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | { __typename?: 'HeroSlider', autoslide?: boolean | null, autoslideDurationMs?: number | null, slidesCollection?: { __typename?: 'HeroSliderSlidesCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderBoutiqueDetail', internalName?: string | null, type?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | null> } | null };

export type ContentfulPageBoutiqueListCollectionQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  selectedCountry?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContentfulPageBoutiqueListCollectionQuery = { __typename?: 'Query', pageBoutiqueListCollection?: { __typename?: 'PageBoutiqueListCollection', total: number, items: Array<{ __typename?: 'PageBoutiqueList', internalName?: string | null, default?: boolean | null, countryCode?: string | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, contentAboveBoutiquesCollection?: { __typename?: 'PageBoutiqueListContentAboveBoutiquesCollection', total: number, items: Array<{ __typename: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename: 'ContactUs', internalName?: string | null, phone?: string | null, email?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contactHeader?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | { __typename: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename: 'HeroSlider' } | { __typename: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename: 'Placeholder', heading?: string | null, type?: string | null, videoUrl?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, subtext?: { __typename?: 'PlaceholderSubtext', json: any } | null, warrantyText?: { __typename?: 'Card', type?: string | null, subHeading?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null, warrantyTakingCareOfYourWatch?: { __typename?: 'Card', type?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null } | { __typename: 'PlaceholderCheckoutPayments', internalName?: string | null, ctaText?: string | null, ctaTel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, paymentsMediaCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | { __typename: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null } | { __typename: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, contentBelowBoutiquesCollection?: { __typename?: 'PageBoutiqueListContentBelowBoutiquesCollection', total: number, items: Array<{ __typename: 'Banner', heading?: string | null, textAlignment?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, imagePosition?: string | null, backgroundColor?: any | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, bannerText?: { __typename?: 'BannerText', json: any } | null, image?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename: 'ContactUs' } | { __typename: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | { __typename: 'FreeTextContent', internalName?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, freeTextContent?: { __typename?: 'FreeTextContentTextContent', json: any, links: { __typename?: 'FreeTextContentTextContentLinks', assets: { __typename?: 'FreeTextContentTextContentAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | { __typename: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename: 'HeroSlider' } | { __typename: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename: 'Placeholder', heading?: string | null, type?: string | null, videoUrl?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, subtext?: { __typename?: 'PlaceholderSubtext', json: any } | null, warrantyText?: { __typename?: 'Card', type?: string | null, subHeading?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null, warrantyTakingCareOfYourWatch?: { __typename?: 'Card', type?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, placeholderWarrantyText?: { __typename?: 'CardText', json: any } | null, placeholderWarrantyText2?: { __typename?: 'CardText2', json: any } | null } | null } | { __typename: 'PlaceholderCheckoutPayments', internalName?: string | null, ctaText?: string | null, ctaTel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, paymentsMediaCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | { __typename: 'PlaceholderStores', numberOfStores?: number | null, type?: string | null, boutiqueReferenceKeys?: Array<string | null> | null, placeholderStoresColor?: string | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStore?: { __typename?: 'FindAStore', type?: string | null, url?: string | null, urlText?: string | null, findAStoreColor?: string | null, cardImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, longImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, findAStoreText?: { __typename?: 'FindAStoreText', json: any } | null } | null } | { __typename: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename: 'ServicesCollection', headline?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, servicesCollection?: { __typename?: 'ServicesCollectionServicesCollection', items: Array<{ __typename?: 'ServiceItem', heading?: string | null, url?: string | null, id?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename: 'SliderProductsManual', type?: string | null, showCta?: boolean | null, showPrice?: boolean | null, showWishlist?: boolean | null, showLabel?: boolean | null, showName?: boolean | null, products?: Array<string | null> | null, backgroundColor?: any | null, productCardBackgroundColor?: any | null, slidesPerView?: number | null, slidesPerViewForMobile?: number | null, ctaText?: string | null, ctaStyle?: string | null, ctaUrl?: string | null, ctaAriaLabel?: string | null, backgroundImage?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, headingEntry?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null } | null> } | null };

export type ContentfulPageExhibitionHistoriesFaqQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  parentSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContentfulPageExhibitionHistoriesFaqQuery = { __typename?: 'Query', pageExhibitionHistoriesFaqCollection?: { __typename?: 'PageExhibitionHistoriesFaqCollection', items: Array<{ __typename?: 'PageExhibitionHistoriesFaq', localizationConfiguration?: any | null, slug?: string | null, pageTitle?: string | null, mainHeader?: { __typename?: 'MainHeader', internalName?: string | null, type?: string | null, background?: string | null, logoWidthDesktop?: number | null, logoHeightDesktop?: number | null, logoWidthMobile?: number | null, logoHeightMobile?: number | null, textColorOption?: string | null, backgroundImage?: { __typename?: 'Asset', url?: string | null } | null, logo?: { __typename?: 'Asset', url?: string | null } | null, megamenu?: { __typename?: 'MegaMenu', internalName?: string | null, menuItemsCollection?: { __typename?: 'MegaMenuMenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', scrollerLabel?: string | null, internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, scrollerItemsCollection?: { __typename?: 'MainMenuItemScrollerItemsCollection', items: Array<{ __typename?: 'ScrollerItem', internalName?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, submenuItemsCollection?: { __typename?: 'MainMenuItemSubmenuItemsCollection', items: Array<{ __typename?: 'MainMenuItem', internalName?: string | null, type?: string | null, label?: string | null, url?: string | null, openUrlInNewTab?: boolean | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, bottomLinkLabel?: string | null, bottomLinkAriaLabel?: string | null, bottomLinkUrl?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, alertBannerCollection?: { __typename?: 'MainHeaderAlertBannerCollection', items: Array<{ __typename?: 'AlertBanner', internalName?: string | null, type?: string | null, alertBannerText?: { __typename?: 'AlertBannerText', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, seoConfiguration?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, seoConfigurationOverride?: { __typename?: 'SeoConfiguration', seoTitle?: string | null, seoDescription?: string | null, seoIndex?: boolean | null, seoCanonical?: string | null, seoThumbnail?: { __typename?: 'Asset', url?: string | null, title?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string } } | null } | null, contentCollection?: { __typename?: 'PageExhibitionHistoriesFaqContentCollection', items: Array<{ __typename?: 'Breadcrumb', style?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContactUs', internalName?: string | null, phone?: string | null, email?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, contactHeader?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'ContentGroup', id?: string | null, type?: string | null, itemsCollection?: { __typename?: 'ContentGroupItemsCollection', items: Array<{ __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | { __typename?: 'Grid' } | { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ExhibitionList', internalName?: string | null, categoryTitle?: string | null, categoryTitleSeoTag?: string | null, categoryDescription?: string | null, exhibitionListLabel?: string | null, pastExhibitionsLabel?: string | null, loadMoreLabel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, exhibitionItemsCollection?: { __typename?: 'ExhibitionListExhibitionItemsCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'ExhibitionItem', internalName?: string | null, boutiqueId?: string | null, label?: string | null, startDate?: string | null, endDate?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null } | { __typename?: 'FaqCategories', internalName?: string | null, categoryLabel?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqWrapsCollection?: { __typename?: 'FaqCategoriesFaqWrapsCollection', items: Array<{ __typename?: 'FaqWrap', internalName?: string | null, collapse?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, faqListCollection?: { __typename?: 'FaqWrapFaqListCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'FaqItem', faqQuestion?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, faqAnswer?: { __typename?: 'FaqItemFaqAnswer', json: any, links: { __typename?: 'FaqItemFaqAnswerLinks', assets: { __typename?: 'FaqItemFaqAnswerAssets', block: Array<{ __typename?: 'Asset', url?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null } | null> } | null } | { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'NavQuickLinksWithBanner', type?: string | null, navQuickLinks?: { __typename?: 'NavQuickLinks', type?: string | null, isSticky?: boolean | null, navQuickLinkBackgroundColor?: string | null, linksCollection?: { __typename?: 'NavQuickLinksLinksCollection', items: Array<{ __typename?: 'NavQuickLinkItem', backgroundColor?: string | null, icon?: string | null, url?: string | null, urlText?: string | null, urlTarget?: string | null, topLabelText?: string | null, internalName?: string | null, disableNavigationScrollToTop?: boolean | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, media?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, card?: { __typename?: 'Card', internalName?: string | null, id?: string | null, saleorProductSku?: string | null, subHeading?: string | null, type?: string | null, contentOption?: string | null, contentMaxWidth?: string | null, url?: string | null, urlText?: string | null, urlType?: string | null, url1EventType?: string | null, url2?: string | null, url2Text?: string | null, url2Type?: string | null, url2EventType?: string | null, urlDirection?: string | null, urlPosition?: string | null, backgroundPosition?: string | null, openUrlInNewTab?: boolean | null, openUrl2InNewTab?: boolean | null, textColor?: string | null, textAlignment?: string | null, contentAlignment?: string | null, backgroundColor?: any | null, backgroundAlignment?: string | null, mediaAnimationEffect?: string | null, visibleInDesktop?: boolean | null, visibleInMobile?: boolean | null, showMore?: boolean | null, countdown?: boolean | null, countdownToDatetime?: string | null, urlTrigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, url2Trigger?: { __typename?: 'Event', type?: string | null, sfId?: string | null, campaignName?: string | null, eventId?: string | null, title?: string | null, description?: { __typename?: 'EventDescription', json: any } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, cardText?: { __typename?: 'CardText', json: any } | null, cardText2?: { __typename?: 'CardText2', json: any } | null, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, media?: { __typename?: 'ImageWithFocalPoint', internalName?: string | null, focalPoint?: any | null, alt?: string | null, url?: string | null, videoPlayOption?: string | null, image?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHover?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, imageOnHoverMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, video?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, videoMobile?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, icon?: { __typename?: 'Asset', title?: string | null, contentType?: string | null, width?: number | null, height?: number | null, url?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | { __typename?: 'ProductCard', type?: string | null, variant?: string | null, product?: string | null, showPrice?: boolean | null, showCta?: boolean | null, showWishlist?: boolean | null, showShare?: boolean | null, backgroundColor?: any | null, showLabel?: boolean | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null, breadcrumb?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', slug?: string | null, pageTitle?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null> } | null };

export type ContentfulPlaceholderServiceCollectionByTypeQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
}>;


export type ContentfulPlaceholderServiceCollectionByTypeQuery = { __typename?: 'Query', placeholderServiceCollection?: { __typename?: 'PlaceholderServiceCollection', items: Array<{ __typename?: 'PlaceholderService', type?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null }, placeholderHeading?: { __typename?: 'Heading', text?: string | null, headingType?: string | null, headingSeoTag?: string | null, headingVariation?: string | null, mainColor?: string | null, highlightColor?: string | null, textAlignment?: string | null, sys: { __typename?: 'Sys', id: string, publishedAt?: string | null } } | null, subtext?: { __typename?: 'PlaceholderServiceSubtext', json: any } | null } | null> } | null };

export type ContentfulSelectorModalByMarketingPartnerQueryVariables = Exact<{
  marketingPartner: Scalars['String']['input'];
  preview: Scalars['Boolean']['input'];
  languageCode: Scalars['String']['input'];
}>;


export type ContentfulSelectorModalByMarketingPartnerQuery = { __typename?: 'Query', selectorCollection?: { __typename?: 'SelectorCollection', items: Array<{ __typename?: 'Selector', name?: string | null, title?: string | null, marketingPartner?: string | null, linksCollection?: { __typename?: 'SelectorLinksCollection', items: Array<{ __typename?: 'SelectorLink', text?: string | null, reference?: string | null, slug?: string | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null, description?: string | null } | null } | null> } | null } | null> } | null };

export const SysFragmentDoc = gql`
    fragment Sys on Sys {
  id
  publishedAt
}
    `;
export const MediaFragmentDoc = gql`
    fragment Media on Asset {
  title
  contentType
  width
  height
  url
  sys {
    ...Sys
  }
}
    `;
export const ImageWithFocalPointFragmentDoc = gql`
    fragment imageWithFocalPoint on ImageWithFocalPoint {
  internalName
  image {
    ...Media
  }
  imageOnHover {
    ...Media
  }
  focalPoint
  imageMobile {
    ...Media
  }
  imageOnHoverMobile {
    ...Media
  }
  video {
    ...Media
  }
  videoMobile {
    ...Media
  }
  alt
  url
  videoPlayOption
  sys {
    ...Sys
  }
}
    `;
export const BannerHeroFragmentDoc = gql`
    fragment BannerHero on BannerHero {
  internalName
  image {
    ...imageWithFocalPoint
  }
  title
  titleSeoTag
  text
  url
  urlText
  urlType
  sys {
    ...Sys
  }
}
    `;
export const AutomaticCollectionGroupFragmentDoc = gql`
    fragment AutomaticCollectionGroup on AutomaticCollectionGroup {
  internalName
  collection
  algoliaFacetFilters
  maximumNumberOfProducts
  algoliaRuleName
  sortBy
  sys {
    ...Sys
  }
}
    `;
export const ManualCollectionGroupProductReferencesFragmentDoc = gql`
    fragment ManualCollectionGroupProductReferences on ManualCollectionGroupProductReferences {
  internalName
  manualProductReferences
  sys {
    ...Sys
  }
}
    `;
export const CollectionGroupEndImageFragmentDoc = gql`
    fragment CollectionGroupEndImage on CollectionGroupEndImage {
  internalName
  endImage {
    ...imageWithFocalPoint
  }
  endImageLinkType
  endImageUrl
  endImageUrlText
  sys {
    ...Sys
  }
}
    `;
export const CollectionGroupFragmentDoc = gql`
    fragment CollectionGroup on CollectionGroup {
  internalName
  type
  banner {
    ... on BannerHero {
      ...BannerHero
    }
  }
  productReferences {
    ... on AutomaticCollectionGroup {
      ...AutomaticCollectionGroup
    }
    ... on ManualCollectionGroupProductReferences {
      ...ManualCollectionGroupProductReferences
    }
  }
  endImage {
    ... on CollectionGroupEndImage {
      ...CollectionGroupEndImage
    }
  }
  sys {
    ...Sys
  }
}
    `;
export const EventFragmentDoc = gql`
    fragment Event on Event {
  type
  sfId
  campaignName
  eventId
  title
  description {
    json
  }
  sys {
    ...Sys
  }
}
    `;
export const HeadingFragmentDoc = gql`
    fragment Heading on Heading {
  text
  headingType
  headingSeoTag
  headingVariation
  mainColor
  highlightColor
  textAlignment
  sys {
    ...Sys
  }
}
    `;
export const CardFragmentDoc = gql`
    fragment Card on Card {
  internalName
  id
  saleorProductSku
  subHeading
  type
  contentOption
  contentMaxWidth
  url
  urlText
  urlType
  url1EventType
  urlTrigger {
    ...Event
  }
  url2
  url2Text
  url2Type
  url2EventType
  url2Trigger {
    ...Event
  }
  urlDirection
  urlPosition
  backgroundPosition
  openUrlInNewTab
  openUrl2InNewTab
  cardText: text {
    json
  }
  cardText2: text2 {
    json
  }
  textColor
  placeholderHeading: title {
    ...Heading
  }
  textAlignment
  contentAlignment
  backgroundColor
  backgroundAlignment
  mediaAnimationEffect
  visibleInDesktop
  visibleInMobile
  showMore
  media {
    ...imageWithFocalPoint
  }
  sys {
    ...Sys
  }
  icon {
    ...Media
  }
  countdown
  countdownToDatetime
}
    `;
export const FindAStoreFragmentDoc = gql`
    fragment FindAStore on FindAStore {
  cardImage {
    ...Media
  }
  longImage {
    ...Media
  }
  sys {
    ...Sys
  }
  findAStoreColor: backgroundColor
  type
  url
  urlText
  findAStoreText: text {
    json
  }
}
    `;
export const PlaceholderStoresFragmentDoc = gql`
    fragment PlaceholderStores on PlaceholderStores {
  numberOfStores
  type
  placeholderHeading: heading {
    ...Heading
  }
  placeholderStoresColor: backgroundColor
  sys {
    ...Sys
  }
  boutiqueReferenceKeys
  findAStore {
    ...FindAStore
  }
}
    `;
export const ServiceFragmentDoc = gql`
    fragment Service on ServiceItem {
  heading
  url
  id
  sys {
    ...Sys
  }
  media {
    ...Media
  }
}
    `;
export const ServicesFragmentDoc = gql`
    fragment Services on ServicesCollection {
  headline {
    ...Heading
  }
  servicesCollection(
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ...Service
    }
  }
  sys {
    ...Sys
  }
}
    `;
export const NavQuickLinkFragmentDoc = gql`
    fragment NavQuickLink on NavQuickLinkItem {
  backgroundColor
  icon
  url
  urlText
  urlTarget
  urlTrigger {
    ...Event
  }
  topLabelText
  internalName
  sys {
    ...Sys
  }
  media {
    ...Media
  }
  disableNavigationScrollToTop
}
    `;
export const NavQuickLinksFragmentDoc = gql`
    fragment NavQuickLinks on NavQuickLinks {
  type
  isSticky
  navQuickLinkBackgroundColor: backgroundColor
  linksCollection(
    limit: 10
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ...NavQuickLink
    }
  }
  sys {
    ...Sys
  }
}
    `;
export const ProductCardFragmentDoc = gql`
    fragment ProductCard on ProductCard {
  sys {
    ...Sys
  }
  type
  variant
  product
  showPrice
  showCta
  showWishlist
  showShare
  backgroundColor
  showLabel
}
    `;
export const PlaceholderServiceFragmentDoc = gql`
    fragment PlaceholderService on PlaceholderService {
  sys {
    ...Sys
  }
  type
  placeholderHeading: heading {
    ...Heading
  }
  subtext {
    json
  }
}
    `;
export const ContentGroupFragmentDoc = gql`
    fragment ContentGroup on ContentGroup {
  itemsCollection(
    limit: 10
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on Card {
        ...Card
      }
      ... on ProductCard {
        ...ProductCard
      }
      ... on ImageWithFocalPoint {
        ...imageWithFocalPoint
      }
      ... on PlaceholderService {
        ...PlaceholderService
      }
    }
  }
  id
  type
  sys {
    ...Sys
  }
}
    `;
export const BannerFragmentDoc = gql`
    fragment Banner on Banner {
  sys {
    ...Sys
  }
  heading
  bannerText: text {
    json
  }
  textAlignment
  url
  urlText
  urlType
  image {
    ...imageWithFocalPoint
  }
  imagePosition
  backgroundColor
}
    `;
export const FaqWrapFaqListCollectionFragmentDoc = gql`
    fragment FaqWrapFaqListCollection on FaqWrapFaqListCollection {
  total
  skip
  limit
  items {
    sys {
      ...Sys
    }
    faqQuestion
    faqAnswer {
      json
      links {
        assets {
          block {
            sys {
              id
            }
            url
          }
        }
      }
    }
  }
}
    `;
export const FaqWrapFragmentDoc = gql`
    fragment FaqWrap on FaqWrap {
  sys {
    ...Sys
  }
  internalName
  collapse
  faqListCollection(
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    ...FaqWrapFaqListCollection
  }
  placeholderHeading: title {
    ...Heading
  }
}
    `;
export const FreeTextContentFragmentDoc = gql`
    fragment FreeTextContent on FreeTextContent {
  sys {
    ...Sys
  }
  internalName
  freeTextContent: textContent {
    json
    links {
      assets {
        block {
          sys {
            id
          }
          url
        }
      }
    }
  }
}
    `;
export const PlaceholderCheckoutPaymentsFragmentDoc = gql`
    fragment PlaceholderCheckoutPayments on PlaceholderCheckoutPayments {
  sys {
    ...Sys
  }
  internalName
  ctaText
  ctaTel
  paymentsMediaCollection {
    items {
      ...Media
    }
  }
}
    `;
export const SliderProductsManualFragmentDoc = gql`
    fragment SliderProductsManual on SliderProductsManual {
  type
  showCta
  showPrice
  showWishlist
  showLabel
  showName
  products
  backgroundColor
  backgroundImage {
    ...Media
  }
  productCardBackgroundColor
  slidesPerView
  slidesPerViewForMobile
  headingEntry: heading {
    ...Heading
  }
  ctaText
  ctaStyle
  ctaUrl
  ctaAriaLabel
  sys {
    ...Sys
  }
}
    `;
export const BreadcrumbFragmentDoc = gql`
    fragment Breadcrumb on Breadcrumb {
  sys {
    ...Sys
  }
  style
}
    `;
export const GridFragmentDoc = gql`
    fragment Grid on Grid {
  id
  col
  colForMobile
  isSlider
  rowGap
  colGap
  maxWidth
  paddingTop
  paddingBottom
  backgroundColor
  visibleInDesktop
  visibleInMobile
  reverseDisplayOrderForMobile
  contentAlignment
  contentCollection(
    limit: 15
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on Card {
        ...Card
      }
      ... on ProductCard {
        ...ProductCard
      }
      ... on ImageWithFocalPoint {
        ...imageWithFocalPoint
      }
      ... on SliderProductsManual {
        ...SliderProductsManual
      }
      ... on Heading {
        ...Heading
      }
      ... on FreeTextContent {
        ...FreeTextContent
      }
    }
  }
  sys {
    ...Sys
  }
}
    `;
export const HeroSliderFragmentDoc = gql`
    fragment HeroSlider on HeroSlider {
  slidesCollection(
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on Card {
        ...Card
      }
    }
  }
  autoslide
  autoslideDurationMs
  sys {
    ...Sys
  }
}
    `;
export const PlaceholderFragmentDoc = gql`
    fragment Placeholder on Placeholder {
  sys {
    ...Sys
  }
  heading
  subtext: subtext {
    json
  }
  type
  videoUrl
  warrantyText(
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    type
    placeholderWarrantyHeading: title {
      ...Heading
    }
    subHeading
    placeholderWarrantyText: text {
      json
    }
    placeholderWarrantyText2: text2 {
      json
    }
    url
    urlText
    urlType
  }
  warrantyTakingCareOfYourWatch(
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    media {
      ...imageWithFocalPoint
    }
    type
    placeholderWarrantyHeading: title {
      ...Heading
    }
    placeholderWarrantyText: text {
      json
    }
    placeholderWarrantyText2: text2 {
      json
    }
    url
    urlText
    urlType
  }
}
    `;
export const ConditionalComponentFragmentDoc = gql`
    fragment ConditionalComponent on ConditionalComponent {
  sys {
    ...Sys
  }
  displayOnLoggedInCondition
  displayOnEmptyCondition
  contentCollection(
    limit: 5
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on Card {
        ...Card
      }
      ... on PlaceholderStores {
        ...PlaceholderStores
      }
      ... on ServicesCollection {
        ...Services
      }
      ... on NavQuickLinks {
        ...NavQuickLinks
      }
      ... on ContentGroup {
        ...ContentGroup
      }
      ... on Banner {
        ...Banner
      }
      ... on ProductCard {
        ...ProductCard
      }
      ... on FindAStore {
        ...FindAStore
      }
      ... on FaqWrap {
        ...FaqWrap
      }
      ... on Heading {
        ...Heading
      }
      ... on FreeTextContent {
        ...FreeTextContent
      }
      ... on PlaceholderCheckoutPayments {
        ...PlaceholderCheckoutPayments
      }
      ... on SliderProductsManual {
        ...SliderProductsManual
      }
      ... on PlaceholderService {
        ...PlaceholderService
      }
      ... on Breadcrumb {
        ...Breadcrumb
      }
      ... on Grid {
        ...Grid
      }
      ... on HeroSlider {
        ...HeroSlider
      }
      ... on Placeholder {
        ...Placeholder
      }
    }
  }
}
    `;
export const ContactUsFragmentDoc = gql`
    fragment ContactUs on ContactUs {
  sys {
    ...Sys
  }
  internalName
  contactHeader: heading {
    ...Heading
  }
  phone
  email
}
    `;
export const ExhibitionListFragmentDoc = gql`
    fragment ExhibitionList on ExhibitionList {
  sys {
    ...Sys
  }
  internalName
  categoryTitle
  categoryTitleSeoTag
  categoryDescription
  exhibitionListLabel
  pastExhibitionsLabel
  loadMoreLabel
  exhibitionItemsCollection(
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    total
    skip
    limit
    items {
      sys {
        ...Sys
      }
      internalName
      boutiqueId
      label
      startDate
      endDate
      media {
        ...imageWithFocalPoint
      }
    }
  }
}
    `;
export const FaqCategoriesFragmentDoc = gql`
    fragment FaqCategories on FaqCategories {
  sys {
    ...Sys
  }
  internalName
  categoryLabel
  faqWrapsCollection(
    limit: 50
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      sys {
        ...Sys
      }
      internalName
      collapse
      placeholderHeading: title {
        ...Heading
      }
      faqListCollection(
        limit: 60
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on FaqWrapFaqListCollection {
          ...FaqWrapFaqListCollection
        }
      }
    }
  }
}
    `;
export const FooterItemFragmentDoc = gql`
    fragment FooterItem on MainMenuItem {
  internalName
  type
  label
  url
  openUrlInNewTab
  visibleInDesktop
  visibleInMobile
  sys {
    ...Sys
  }
}
    `;
export const FooterFragmentDoc = gql`
    fragment Footer on Footer {
  internalName
  type
  menuItemsCollection(
    preview: $preview
    limit: 10
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on MainMenuItem {
        ...FooterItem
        submenuItemsCollection(
          preview: $preview
          limit: 15
          where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
        ) {
          items {
            ... on MainMenuItem {
              ...FooterItem
            }
          }
        }
      }
    }
  }
  secondaryMenuItemsCollection(
    preview: $preview
    limit: 10
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on MainMenuItem {
        ...FooterItem
      }
    }
  }
  subscribeToNewsletterText
  copyrightText
  displayContactInformation
  displayNewsletterSubscribe
  displayRegionSelector
  regionSelectorLabel
  socialNetworkLabel
  socialFacebookUrl
  socialInstagramUrl
  socialPinterestUrl
  socialYoutubeUrl
  socialXTwitterUrl
  socialStravaUrl
  socialTiktokUrl
  socialLineUrl
  localizationConfiguration
  logo {
    ... on Asset {
      url
    }
  }
  logoWidthDesktop
  logoHeightDesktop
  logoWidthMobile
  logoHeightMobile
  logoLink
  sys {
    ...Sys
  }
}
    `;
export const CollectionItemFragmentDoc = gql`
    fragment CollectionItem on CollectionItem {
  sys {
    ...Sys
  }
  saleorCollection
  image {
    ...imageWithFocalPoint
  }
  collectionName
}
    `;
export const HeroProductListingFragmentDoc = gql`
    fragment HeroProductListing on HeroProductListing {
  sys {
    ...Sys
  }
  type
  heading
  headingNumberOfColoredWords
  subheader
  subheaderIsCapitalized
  textBelowMedia
  textAlignment
  showFilters
  showBreadcrumbs
  backgroundColor
  backgroundColorOpacity
  media {
    ...imageWithFocalPoint
  }
  collectionItemsCollection(
    limit: $collectionItemsLimit
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ...CollectionItem
    }
  }
  url
  urlText
  urlType
  url1EventType
  url2
  url2Text
  url2Type
  url2EventType
  urlDirection
  urlPosition
  openUrlInNewTab
  openUrl2InNewTab
  heroProductListingText: text {
    json
  }
  textColor
  heroProductListingTitle: title {
    ...Heading
  }
  contentAlignment
  visibleInDesktop
  visibleInMobile
}
    `;
export const IframeFragmentDoc = gql`
    fragment Iframe on Iframe {
  internalName
  url
  maxWidth
  height
  hasScrollbar
  sys {
    ...Sys
  }
}
    `;
export const SubmenuItemFragmentDoc = gql`
    fragment SubmenuItem on MainMenuItem {
  internalName
  type
  label
  url
  openUrlInNewTab
  visibleInDesktop
  visibleInMobile
  bottomLinkLabel
  bottomLinkAriaLabel
  bottomLinkUrl
  image {
    ...Media
  }
  sys {
    ...Sys
  }
}
    `;
export const ScrollerItemFragmentDoc = gql`
    fragment ScrollerItem on ScrollerItem {
  internalName
  label
  url
  openUrlInNewTab
  visibleInDesktop
  visibleInMobile
  localizationConfiguration
  image {
    ...Media
  }
  sys {
    ...Sys
  }
}
    `;
export const MainMenuItemFragmentDoc = gql`
    fragment MainMenuItem on MainMenuItem {
  ...SubmenuItem
  scrollerLabel
  scrollerItemsCollection(preview: $preview, limit: 10) {
    items {
      ...ScrollerItem
    }
  }
  submenuItemsCollection(
    preview: $preview
    limit: 10
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on MainMenuItem {
        ...SubmenuItem
        submenuItemsCollection(
          preview: $preview
          limit: 16
          where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
        ) {
          items {
            ... on MainMenuItem {
              ...SubmenuItem
            }
          }
        }
      }
    }
  }
  sys {
    ...Sys
  }
}
    `;
export const MegaMenuFragmentDoc = gql`
    fragment MegaMenu on MegaMenu {
  internalName
  menuItemsCollection(
    preview: $preview
    limit: 16
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on MainMenuItem {
        ...MainMenuItem
      }
    }
  }
  sys {
    ...Sys
  }
}
    `;
export const AlertBannerFragmentDoc = gql`
    fragment AlertBanner on AlertBanner {
  internalName
  type
  alertBannerText: text {
    json
  }
  sys {
    ...Sys
  }
}
    `;
export const MainHeaderFragmentDoc = gql`
    fragment MainHeader on MainHeader {
  internalName
  type
  background
  backgroundImage {
    ... on Asset {
      url
    }
  }
  logo {
    ... on Asset {
      url
    }
  }
  logoWidthDesktop
  logoHeightDesktop
  logoWidthMobile
  logoHeightMobile
  textColorOption
  megamenu {
    ...MegaMenu
  }
  alertBannerCollection(
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on AlertBanner {
        ...AlertBanner
      }
    }
  }
  sys {
    ...Sys
  }
}
    `;
export const NavQuickLinksWithBannerFragmentDoc = gql`
    fragment NavQuickLinksWithBanner on NavQuickLinksWithBanner {
  type
  navQuickLinks {
    ...NavQuickLinks
  }
  card {
    ...Card
  }
  sys {
    ...Sys
  }
}
    `;
export const PageBreadcrumbFragmentDoc = gql`
    fragment PageBreadcrumb on Page {
  slug
  pageTitle
  sys {
    ...Sys
  }
}
    `;
export const PlaceholderBoutiqueDetailFragmentDoc = gql`
    fragment PlaceholderBoutiqueDetail on PlaceholderBoutiqueDetail {
  sys {
    id
  }
  internalName
  type
}
    `;
export const PlaceholderHeaderFragmentDoc = gql`
    fragment PlaceholderHeader on PlaceholderHeader {
  internalName
  sys {
    ...Sys
  }
}
    `;
export const PlaceholderModelStoryFragmentDoc = gql`
    fragment PlaceholderModelStory on PlaceholderModelStory {
  sys {
    ...Sys
  }
  storyHeading: title {
    ...Heading
  }
  storyBackgroundColor: backgroundColor
  mediaAlignment
  type
}
    `;
export const ServicePerkFragmentDoc = gql`
    fragment ServicePerk on ServicePerk {
  heading
  type
  url
  modalText {
    json
  }
  sys {
    ...Sys
  }
}
    `;
export const PlaceholderProductDetailsFragmentDoc = gql`
    fragment PlaceholderProductDetails on PlaceholderProductDetails {
  sys {
    ...Sys
  }
  perksCollection(
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ...ServicePerk
    }
  }
}
    `;
export const SliderProductsAutomaticFragmentDoc = gql`
    fragment SliderProductsAutomatic on SliderProductsAutomatic {
  title
  showCta
  showPrice
  showWishlist
  showLabel
  type
  backgroundColor
  backgroundImage {
    ...Media
  }
  productCardBackgroundColor
  slidesPerView
  sys {
    ...Sys
  }
}
    `;
export const SearchOverlayFragmentDoc = gql`
    fragment SearchOverlay on SearchOverlay {
  sys {
    ...Sys
  }
  type
  title
  searchBox
  displayRetailers
  noResultsContentCollection(
    limit: 5
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on SliderProductsAutomatic {
        ...SliderProductsAutomatic
      }
      ... on SliderProductsManual {
        ...SliderProductsManual
      }
      ... on Card {
        ...Card
      }
    }
  }
}
    `;
export const SeoConfigurationFragmentDoc = gql`
    fragment SeoConfiguration on SeoConfiguration {
  seoTitle
  seoDescription
  seoIndex
  seoThumbnail {
    sys {
      id
    }
    url
    title
    contentType
  }
  seoCanonical
}
    `;
export const LiveStoryFragmentDoc = gql`
    fragment LiveStory on LiveStoryContentType {
  title
  coverImg
  id
  type
  ssc
  sys {
    ...Sys
  }
}
    `;
export const SimpleFooterFragmentDoc = gql`
    fragment SimpleFooter on SimpleFooter {
  background {
    ... on Asset {
      url
    }
  }
  title
  description
  cta
}
    `;
export const SiteMapMenuFragmentDoc = gql`
    fragment SiteMapMenu on MegaMenu {
  internalName
  menuItemsCollection(
    limit: 15
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ... on MainMenuItem {
        ...MainMenuItem
      }
    }
  }
  sys {
    ...Sys
  }
}
    `;
export const DefaultHeaderSettingsDocument = gql`
    query DefaultHeaderSettings($preview: Boolean, $languageCode: String!, $countryCode: String!) @contentSourceMaps {
  defaultLayoutCollection(
    preview: $preview
    limit: 1
    locale: $languageCode
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      header(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on MainHeader {
          internalName
          type
          background
          backgroundImage {
            url
          }
          logo {
            url
          }
          textColorOption
        }
      }
    }
  }
}
    `;

/**
 * __useDefaultHeaderSettingsQuery__
 *
 * To run a query within a React component, call `useDefaultHeaderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultHeaderSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultHeaderSettingsQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      languageCode: // value for 'languageCode'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useDefaultHeaderSettingsQuery(baseOptions: Apollo.QueryHookOptions<ContentfulDefaultHeaderSettingsQuery, ContentfulDefaultHeaderSettingsQueryVariables> & ({ variables: ContentfulDefaultHeaderSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulDefaultHeaderSettingsQuery, ContentfulDefaultHeaderSettingsQueryVariables>(DefaultHeaderSettingsDocument, options);
      }
export function useDefaultHeaderSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulDefaultHeaderSettingsQuery, ContentfulDefaultHeaderSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulDefaultHeaderSettingsQuery, ContentfulDefaultHeaderSettingsQueryVariables>(DefaultHeaderSettingsDocument, options);
        }
export function useDefaultHeaderSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulDefaultHeaderSettingsQuery, ContentfulDefaultHeaderSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulDefaultHeaderSettingsQuery, ContentfulDefaultHeaderSettingsQueryVariables>(DefaultHeaderSettingsDocument, options);
        }
export type DefaultHeaderSettingsQueryHookResult = ReturnType<typeof useDefaultHeaderSettingsQuery>;
export type DefaultHeaderSettingsLazyQueryHookResult = ReturnType<typeof useDefaultHeaderSettingsLazyQuery>;
export type DefaultHeaderSettingsSuspenseQueryHookResult = ReturnType<typeof useDefaultHeaderSettingsSuspenseQuery>;
export type DefaultHeaderSettingsQueryResult = Apollo.QueryResult<ContentfulDefaultHeaderSettingsQuery, ContentfulDefaultHeaderSettingsQueryVariables>;
export const DefaultLayoutDocument = gql`
    query DefaultLayout($preview: Boolean, $languageCode: String!, $countryCode: String!) @contentSourceMaps {
  defaultLayoutCollection(
    preview: $preview
    limit: 1
    locale: $languageCode
    where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      header(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on MainHeader {
          ...MainHeader
        }
      }
      footer(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on Footer {
          ...Footer
        }
      }
      search {
        ... on SearchOverlay {
          ...SearchOverlay
        }
      }
    }
  }
}
    ${MainHeaderFragmentDoc}
${MegaMenuFragmentDoc}
${MainMenuItemFragmentDoc}
${SubmenuItemFragmentDoc}
${MediaFragmentDoc}
${SysFragmentDoc}
${ScrollerItemFragmentDoc}
${AlertBannerFragmentDoc}
${FooterFragmentDoc}
${FooterItemFragmentDoc}
${SearchOverlayFragmentDoc}
${SliderProductsAutomaticFragmentDoc}
${SliderProductsManualFragmentDoc}
${HeadingFragmentDoc}
${CardFragmentDoc}
${EventFragmentDoc}
${ImageWithFocalPointFragmentDoc}`;

/**
 * __useDefaultLayoutQuery__
 *
 * To run a query within a React component, call `useDefaultLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultLayoutQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      languageCode: // value for 'languageCode'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useDefaultLayoutQuery(baseOptions: Apollo.QueryHookOptions<ContentfulDefaultLayoutQuery, ContentfulDefaultLayoutQueryVariables> & ({ variables: ContentfulDefaultLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulDefaultLayoutQuery, ContentfulDefaultLayoutQueryVariables>(DefaultLayoutDocument, options);
      }
export function useDefaultLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulDefaultLayoutQuery, ContentfulDefaultLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulDefaultLayoutQuery, ContentfulDefaultLayoutQueryVariables>(DefaultLayoutDocument, options);
        }
export function useDefaultLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulDefaultLayoutQuery, ContentfulDefaultLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulDefaultLayoutQuery, ContentfulDefaultLayoutQueryVariables>(DefaultLayoutDocument, options);
        }
export type DefaultLayoutQueryHookResult = ReturnType<typeof useDefaultLayoutQuery>;
export type DefaultLayoutLazyQueryHookResult = ReturnType<typeof useDefaultLayoutLazyQuery>;
export type DefaultLayoutSuspenseQueryHookResult = ReturnType<typeof useDefaultLayoutSuspenseQuery>;
export type DefaultLayoutQueryResult = Apollo.QueryResult<ContentfulDefaultLayoutQuery, ContentfulDefaultLayoutQueryVariables>;
export const DetailPageDocument = gql`
    query DetailPage($preview: Boolean, $type: String!, $sku: String!, $collectionName: String!, $modelName: String!, $languageCode: String!, $countryCode: String) @contentSourceMaps {
  detailPageCollection(
    preview: $preview
    limit: 10
    where: {AND: [{OR: [{type: $type, watchSkus_contains_some: [$sku]}, {type: $type, strapSkus_contains_some: [$sku]}, {type: $type, watchCollection: $collectionName}, {type: $type, model: $modelName}, {type: $type, default: true}]}, {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}]}
    locale: $languageCode
  ) {
    items {
      mainHeader(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on MainHeader {
          ...MainHeader
        }
      }
      footer(
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on Footer {
          ...Footer
        }
      }
      watchSkus
      strapSkus
      watchCollection
      model
      default
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      contentCollection(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        items {
          ... on Banner {
            ...Banner
          }
          ... on PlaceholderProductDetails {
            ...PlaceholderProductDetails
          }
          ... on PlaceholderModelStory {
            ...PlaceholderModelStory
          }
          ... on Placeholder {
            ...Placeholder
          }
          ... on Card {
            ...Card
          }
          ... on ServicesCollection {
            ...Services
          }
          ... on SliderProductsAutomatic {
            ...SliderProductsAutomatic
          }
          ... on SliderProductsManual {
            ...SliderProductsManual
          }
          ... on Grid {
            ...Grid
          }
          ... on PlaceholderStores {
            ...PlaceholderStores
          }
          ... on FindAStore {
            ...FindAStore
          }
          ... on FaqWrap {
            ...FaqWrap
          }
          ... on ContactUs {
            ...ContactUs
          }
        }
      }
    }
  }
}
    ${MainHeaderFragmentDoc}
${MegaMenuFragmentDoc}
${MainMenuItemFragmentDoc}
${SubmenuItemFragmentDoc}
${MediaFragmentDoc}
${SysFragmentDoc}
${ScrollerItemFragmentDoc}
${AlertBannerFragmentDoc}
${FooterFragmentDoc}
${FooterItemFragmentDoc}
${SeoConfigurationFragmentDoc}
${BannerFragmentDoc}
${ImageWithFocalPointFragmentDoc}
${PlaceholderProductDetailsFragmentDoc}
${ServicePerkFragmentDoc}
${PlaceholderModelStoryFragmentDoc}
${HeadingFragmentDoc}
${PlaceholderFragmentDoc}
${CardFragmentDoc}
${EventFragmentDoc}
${ServicesFragmentDoc}
${ServiceFragmentDoc}
${SliderProductsAutomaticFragmentDoc}
${SliderProductsManualFragmentDoc}
${GridFragmentDoc}
${ProductCardFragmentDoc}
${FreeTextContentFragmentDoc}
${PlaceholderStoresFragmentDoc}
${FindAStoreFragmentDoc}
${FaqWrapFragmentDoc}
${FaqWrapFaqListCollectionFragmentDoc}
${ContactUsFragmentDoc}`;

/**
 * __useDetailPageQuery__
 *
 * To run a query within a React component, call `useDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailPageQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      type: // value for 'type'
 *      sku: // value for 'sku'
 *      collectionName: // value for 'collectionName'
 *      modelName: // value for 'modelName'
 *      languageCode: // value for 'languageCode'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useDetailPageQuery(baseOptions: Apollo.QueryHookOptions<ContentfulDetailPageQuery, ContentfulDetailPageQueryVariables> & ({ variables: ContentfulDetailPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulDetailPageQuery, ContentfulDetailPageQueryVariables>(DetailPageDocument, options);
      }
export function useDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulDetailPageQuery, ContentfulDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulDetailPageQuery, ContentfulDetailPageQueryVariables>(DetailPageDocument, options);
        }
export function useDetailPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulDetailPageQuery, ContentfulDetailPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulDetailPageQuery, ContentfulDetailPageQueryVariables>(DetailPageDocument, options);
        }
export type DetailPageQueryHookResult = ReturnType<typeof useDetailPageQuery>;
export type DetailPageLazyQueryHookResult = ReturnType<typeof useDetailPageLazyQuery>;
export type DetailPageSuspenseQueryHookResult = ReturnType<typeof useDetailPageSuspenseQuery>;
export type DetailPageQueryResult = Apollo.QueryResult<ContentfulDetailPageQuery, ContentfulDetailPageQueryVariables>;
export const DictionaryDocument = gql`
    query Dictionary($preview: Boolean, $limit: Int!, $skip: Int!, $locale: String!) @contentSourceMaps {
  dictionaryCollection(preview: $preview, limit: 1, locale: $locale) {
    items {
      contentCollection(preview: $preview, limit: $limit, skip: $skip) {
        items {
          key
          value
        }
      }
    }
  }
}
    `;

/**
 * __useDictionaryQuery__
 *
 * To run a query within a React component, call `useDictionaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDictionaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDictionaryQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useDictionaryQuery(baseOptions: Apollo.QueryHookOptions<ContentfulDictionaryQuery, ContentfulDictionaryQueryVariables> & ({ variables: ContentfulDictionaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulDictionaryQuery, ContentfulDictionaryQueryVariables>(DictionaryDocument, options);
      }
export function useDictionaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulDictionaryQuery, ContentfulDictionaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulDictionaryQuery, ContentfulDictionaryQueryVariables>(DictionaryDocument, options);
        }
export function useDictionarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulDictionaryQuery, ContentfulDictionaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulDictionaryQuery, ContentfulDictionaryQueryVariables>(DictionaryDocument, options);
        }
export type DictionaryQueryHookResult = ReturnType<typeof useDictionaryQuery>;
export type DictionaryLazyQueryHookResult = ReturnType<typeof useDictionaryLazyQuery>;
export type DictionarySuspenseQueryHookResult = ReturnType<typeof useDictionarySuspenseQuery>;
export type DictionaryQueryResult = Apollo.QueryResult<ContentfulDictionaryQuery, ContentfulDictionaryQueryVariables>;
export const FixedPageDocument = gql`
    query FixedPage($preview: Boolean, $slug: String!, $languageCode: String!, $countryCode: String) @contentSourceMaps {
  pageFixedCollection(
    preview: $preview
    limit: 1
    where: {slug: $slug, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
    locale: $languageCode
  ) {
    items {
      internalName
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      pinnedNewsCollection(preview: $preview, limit: 10) {
        items {
          ... on Page {
            mainHeader(preview: $preview) {
              ... on MainHeader {
                ...MainHeader
              }
            }
            seoConfiguration {
              ...SeoConfiguration
            }
            thumbnail {
              ...imageWithFocalPoint
            }
            tagsCollection {
              items {
                key
                value
              }
            }
            slug
            pageTitle
            shortDescription
            publishDate
          }
        }
      }
      topContentCollection(
        preview: $preview
        limit: 10
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        items {
          ... on Card {
            ...Card
          }
          ... on PlaceholderStores {
            ...PlaceholderStores
          }
          ... on ServicesCollection {
            ...Services
          }
          ... on NavQuickLinks {
            ...NavQuickLinks
          }
          ... on ContentGroup {
            ...ContentGroup
          }
          ... on Banner {
            ...Banner
          }
          ... on FindAStore {
            ...FindAStore
          }
          ... on FaqWrap {
            ...FaqWrap
          }
          ... on Heading {
            ...Heading
          }
          ... on FreeTextContent {
            ...FreeTextContent
          }
          ... on SliderProductsManual {
            ...SliderProductsManual
          }
          ... on Breadcrumb {
            ...Breadcrumb
          }
          ... on ConditionalComponent {
            ...ConditionalComponent
          }
          ... on Grid {
            ...Grid
          }
        }
      }
      bottomContentCollection(
        preview: $preview
        limit: 10
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        items {
          ... on Card {
            ...Card
          }
          ... on PlaceholderStores {
            ...PlaceholderStores
          }
          ... on ServicesCollection {
            ...Services
          }
          ... on NavQuickLinks {
            ...NavQuickLinks
          }
          ... on ContentGroup {
            ...ContentGroup
          }
          ... on FindAStore {
            ...FindAStore
          }
          ... on FaqWrap {
            ...FaqWrap
          }
          ... on Heading {
            ...Heading
          }
          ... on FreeTextContent {
            ...FreeTextContent
          }
          ... on PlaceholderCheckoutPayments {
            ...PlaceholderCheckoutPayments
          }
          ... on SliderProductsManual {
            ...SliderProductsManual
          }
          ... on ConditionalComponent {
            ...ConditionalComponent
          }
          ... on Grid {
            ...Grid
          }
          ... on Placeholder {
            ...Placeholder
          }
          ... on ContactUs {
            ...ContactUs
          }
          ... on Banner {
            ...Banner
          }
        }
      }
      dictionaryCollection {
        items {
          key
          value
        }
      }
    }
  }
}
    ${SeoConfigurationFragmentDoc}
${MainHeaderFragmentDoc}
${MegaMenuFragmentDoc}
${MainMenuItemFragmentDoc}
${SubmenuItemFragmentDoc}
${MediaFragmentDoc}
${SysFragmentDoc}
${ScrollerItemFragmentDoc}
${AlertBannerFragmentDoc}
${ImageWithFocalPointFragmentDoc}
${CardFragmentDoc}
${EventFragmentDoc}
${HeadingFragmentDoc}
${PlaceholderStoresFragmentDoc}
${FindAStoreFragmentDoc}
${ServicesFragmentDoc}
${ServiceFragmentDoc}
${NavQuickLinksFragmentDoc}
${NavQuickLinkFragmentDoc}
${ContentGroupFragmentDoc}
${ProductCardFragmentDoc}
${PlaceholderServiceFragmentDoc}
${BannerFragmentDoc}
${FaqWrapFragmentDoc}
${FaqWrapFaqListCollectionFragmentDoc}
${FreeTextContentFragmentDoc}
${SliderProductsManualFragmentDoc}
${BreadcrumbFragmentDoc}
${ConditionalComponentFragmentDoc}
${PlaceholderCheckoutPaymentsFragmentDoc}
${GridFragmentDoc}
${HeroSliderFragmentDoc}
${PlaceholderFragmentDoc}
${ContactUsFragmentDoc}`;

/**
 * __useFixedPageQuery__
 *
 * To run a query within a React component, call `useFixedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixedPageQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      slug: // value for 'slug'
 *      languageCode: // value for 'languageCode'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useFixedPageQuery(baseOptions: Apollo.QueryHookOptions<ContentfulFixedPageQuery, ContentfulFixedPageQueryVariables> & ({ variables: ContentfulFixedPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulFixedPageQuery, ContentfulFixedPageQueryVariables>(FixedPageDocument, options);
      }
export function useFixedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulFixedPageQuery, ContentfulFixedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulFixedPageQuery, ContentfulFixedPageQueryVariables>(FixedPageDocument, options);
        }
export function useFixedPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulFixedPageQuery, ContentfulFixedPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulFixedPageQuery, ContentfulFixedPageQueryVariables>(FixedPageDocument, options);
        }
export type FixedPageQueryHookResult = ReturnType<typeof useFixedPageQuery>;
export type FixedPageLazyQueryHookResult = ReturnType<typeof useFixedPageLazyQuery>;
export type FixedPageSuspenseQueryHookResult = ReturnType<typeof useFixedPageSuspenseQuery>;
export type FixedPageQueryResult = Apollo.QueryResult<ContentfulFixedPageQuery, ContentfulFixedPageQueryVariables>;
export const GetAllNewsPagesDocument = gql`
    query GetAllNewsPages($languageCode: String!, $countryCode: String!, $preview: Boolean) @contentSourceMaps {
  pageCollection(
    where: {type: "News", OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
    locale: $languageCode
    preview: $preview
  ) {
    items {
      slug
      pageTitle
      shortDescription
      publishDate
      thumbnail {
        ...imageWithFocalPoint
      }
      tagsCollection {
        items {
          key
          value
        }
      }
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      sys {
        ...Sys
      }
    }
  }
}
    ${ImageWithFocalPointFragmentDoc}
${MediaFragmentDoc}
${SysFragmentDoc}
${SeoConfigurationFragmentDoc}`;

/**
 * __useGetAllNewsPagesQuery__
 *
 * To run a query within a React component, call `useGetAllNewsPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNewsPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNewsPagesQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      countryCode: // value for 'countryCode'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetAllNewsPagesQuery(baseOptions: Apollo.QueryHookOptions<ContentfulGetAllNewsPagesQuery, ContentfulGetAllNewsPagesQueryVariables> & ({ variables: ContentfulGetAllNewsPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulGetAllNewsPagesQuery, ContentfulGetAllNewsPagesQueryVariables>(GetAllNewsPagesDocument, options);
      }
export function useGetAllNewsPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulGetAllNewsPagesQuery, ContentfulGetAllNewsPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulGetAllNewsPagesQuery, ContentfulGetAllNewsPagesQueryVariables>(GetAllNewsPagesDocument, options);
        }
export function useGetAllNewsPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulGetAllNewsPagesQuery, ContentfulGetAllNewsPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulGetAllNewsPagesQuery, ContentfulGetAllNewsPagesQueryVariables>(GetAllNewsPagesDocument, options);
        }
export type GetAllNewsPagesQueryHookResult = ReturnType<typeof useGetAllNewsPagesQuery>;
export type GetAllNewsPagesLazyQueryHookResult = ReturnType<typeof useGetAllNewsPagesLazyQuery>;
export type GetAllNewsPagesSuspenseQueryHookResult = ReturnType<typeof useGetAllNewsPagesSuspenseQuery>;
export type GetAllNewsPagesQueryResult = Apollo.QueryResult<ContentfulGetAllNewsPagesQuery, ContentfulGetAllNewsPagesQueryVariables>;
export const GetExhibitionHistoriesFaqPagesDocument = gql`
    query GetExhibitionHistoriesFaqPages($languageCode: String!, $countryCode: String!) @contentSourceMaps {
  pageExhibitionHistoriesFaqCollection(
    preview: false
    locale: $languageCode
    limit: 1000
    where: {sys: {publishedAt_exists: true}, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      type
      slug
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      sys {
        ...Sys
      }
    }
  }
}
    ${SeoConfigurationFragmentDoc}
${SysFragmentDoc}`;

/**
 * __useGetExhibitionHistoriesFaqPagesQuery__
 *
 * To run a query within a React component, call `useGetExhibitionHistoriesFaqPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExhibitionHistoriesFaqPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExhibitionHistoriesFaqPagesQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetExhibitionHistoriesFaqPagesQuery(baseOptions: Apollo.QueryHookOptions<ContentfulGetExhibitionHistoriesFaqPagesQuery, ContentfulGetExhibitionHistoriesFaqPagesQueryVariables> & ({ variables: ContentfulGetExhibitionHistoriesFaqPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulGetExhibitionHistoriesFaqPagesQuery, ContentfulGetExhibitionHistoriesFaqPagesQueryVariables>(GetExhibitionHistoriesFaqPagesDocument, options);
      }
export function useGetExhibitionHistoriesFaqPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulGetExhibitionHistoriesFaqPagesQuery, ContentfulGetExhibitionHistoriesFaqPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulGetExhibitionHistoriesFaqPagesQuery, ContentfulGetExhibitionHistoriesFaqPagesQueryVariables>(GetExhibitionHistoriesFaqPagesDocument, options);
        }
export function useGetExhibitionHistoriesFaqPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulGetExhibitionHistoriesFaqPagesQuery, ContentfulGetExhibitionHistoriesFaqPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulGetExhibitionHistoriesFaqPagesQuery, ContentfulGetExhibitionHistoriesFaqPagesQueryVariables>(GetExhibitionHistoriesFaqPagesDocument, options);
        }
export type GetExhibitionHistoriesFaqPagesQueryHookResult = ReturnType<typeof useGetExhibitionHistoriesFaqPagesQuery>;
export type GetExhibitionHistoriesFaqPagesLazyQueryHookResult = ReturnType<typeof useGetExhibitionHistoriesFaqPagesLazyQuery>;
export type GetExhibitionHistoriesFaqPagesSuspenseQueryHookResult = ReturnType<typeof useGetExhibitionHistoriesFaqPagesSuspenseQuery>;
export type GetExhibitionHistoriesFaqPagesQueryResult = Apollo.QueryResult<ContentfulGetExhibitionHistoriesFaqPagesQuery, ContentfulGetExhibitionHistoriesFaqPagesQueryVariables>;
export const GetFixedPagesDocument = gql`
    query GetFixedPages($languageCode: String!, $countryCode: String!) @contentSourceMaps {
  pageFixedCollection(
    preview: false
    locale: $languageCode
    limit: 1000
    where: {sys: {publishedAt_exists: true}, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      slug
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      sys {
        ...Sys
      }
    }
  }
}
    ${SeoConfigurationFragmentDoc}
${SysFragmentDoc}`;

/**
 * __useGetFixedPagesQuery__
 *
 * To run a query within a React component, call `useGetFixedPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFixedPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFixedPagesQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetFixedPagesQuery(baseOptions: Apollo.QueryHookOptions<ContentfulGetFixedPagesQuery, ContentfulGetFixedPagesQueryVariables> & ({ variables: ContentfulGetFixedPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulGetFixedPagesQuery, ContentfulGetFixedPagesQueryVariables>(GetFixedPagesDocument, options);
      }
export function useGetFixedPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulGetFixedPagesQuery, ContentfulGetFixedPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulGetFixedPagesQuery, ContentfulGetFixedPagesQueryVariables>(GetFixedPagesDocument, options);
        }
export function useGetFixedPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulGetFixedPagesQuery, ContentfulGetFixedPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulGetFixedPagesQuery, ContentfulGetFixedPagesQueryVariables>(GetFixedPagesDocument, options);
        }
export type GetFixedPagesQueryHookResult = ReturnType<typeof useGetFixedPagesQuery>;
export type GetFixedPagesLazyQueryHookResult = ReturnType<typeof useGetFixedPagesLazyQuery>;
export type GetFixedPagesSuspenseQueryHookResult = ReturnType<typeof useGetFixedPagesSuspenseQuery>;
export type GetFixedPagesQueryResult = Apollo.QueryResult<ContentfulGetFixedPagesQuery, ContentfulGetFixedPagesQueryVariables>;
export const GetMegaMenuDocument = gql`
    query GetMegaMenu($internalName: String!, $limit: Int = 10, $locale: String, $skip: Int = 0, $countryCode: String!, $preview: Boolean) @contentSourceMaps {
  megaMenuCollection(
    preview: $preview
    limit: $limit
    locale: $locale
    skip: $skip
    where: {internalName: $internalName, sys: {publishedAt_exists: true}, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      ...SiteMapMenu
    }
    limit
    skip
    total
  }
}
    ${SiteMapMenuFragmentDoc}
${MainMenuItemFragmentDoc}
${SubmenuItemFragmentDoc}
${MediaFragmentDoc}
${SysFragmentDoc}
${ScrollerItemFragmentDoc}`;

/**
 * __useGetMegaMenuQuery__
 *
 * To run a query within a React component, call `useGetMegaMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMegaMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMegaMenuQuery({
 *   variables: {
 *      internalName: // value for 'internalName'
 *      limit: // value for 'limit'
 *      locale: // value for 'locale'
 *      skip: // value for 'skip'
 *      countryCode: // value for 'countryCode'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetMegaMenuQuery(baseOptions: Apollo.QueryHookOptions<ContentfulGetMegaMenuQuery, ContentfulGetMegaMenuQueryVariables> & ({ variables: ContentfulGetMegaMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulGetMegaMenuQuery, ContentfulGetMegaMenuQueryVariables>(GetMegaMenuDocument, options);
      }
export function useGetMegaMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulGetMegaMenuQuery, ContentfulGetMegaMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulGetMegaMenuQuery, ContentfulGetMegaMenuQueryVariables>(GetMegaMenuDocument, options);
        }
export function useGetMegaMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulGetMegaMenuQuery, ContentfulGetMegaMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulGetMegaMenuQuery, ContentfulGetMegaMenuQueryVariables>(GetMegaMenuDocument, options);
        }
export type GetMegaMenuQueryHookResult = ReturnType<typeof useGetMegaMenuQuery>;
export type GetMegaMenuLazyQueryHookResult = ReturnType<typeof useGetMegaMenuLazyQuery>;
export type GetMegaMenuSuspenseQueryHookResult = ReturnType<typeof useGetMegaMenuSuspenseQuery>;
export type GetMegaMenuQueryResult = Apollo.QueryResult<ContentfulGetMegaMenuQuery, ContentfulGetMegaMenuQueryVariables>;
export const GetPagesDocument = gql`
    query GetPages($languageCode: String!, $countryCode: String!) @contentSourceMaps {
  pageCollection(
    preview: false
    locale: $languageCode
    limit: 1000
    where: {sys: {publishedAt_exists: true, publishedVersion_exists: true}, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      slug
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      sys {
        ...Sys
      }
    }
  }
}
    ${SeoConfigurationFragmentDoc}
${SysFragmentDoc}`;

/**
 * __useGetPagesQuery__
 *
 * To run a query within a React component, call `useGetPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagesQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetPagesQuery(baseOptions: Apollo.QueryHookOptions<ContentfulGetPagesQuery, ContentfulGetPagesQueryVariables> & ({ variables: ContentfulGetPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulGetPagesQuery, ContentfulGetPagesQueryVariables>(GetPagesDocument, options);
      }
export function useGetPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulGetPagesQuery, ContentfulGetPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulGetPagesQuery, ContentfulGetPagesQueryVariables>(GetPagesDocument, options);
        }
export function useGetPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulGetPagesQuery, ContentfulGetPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulGetPagesQuery, ContentfulGetPagesQueryVariables>(GetPagesDocument, options);
        }
export type GetPagesQueryHookResult = ReturnType<typeof useGetPagesQuery>;
export type GetPagesLazyQueryHookResult = ReturnType<typeof useGetPagesLazyQuery>;
export type GetPagesSuspenseQueryHookResult = ReturnType<typeof useGetPagesSuspenseQuery>;
export type GetPagesQueryResult = Apollo.QueryResult<ContentfulGetPagesQuery, ContentfulGetPagesQueryVariables>;
export const GetPagesDetailsDocument = gql`
    query GetPagesDetails($preview: Boolean, $slugs: [String!]!, $type: String) @contentSourceMaps {
  pageCollection(preview: $preview, where: {slug_in: $slugs, type: $type}) {
    items {
      slug
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      sys {
        ...Sys
      }
    }
  }
}
    ${SeoConfigurationFragmentDoc}
${SysFragmentDoc}`;

/**
 * __useGetPagesDetailsQuery__
 *
 * To run a query within a React component, call `useGetPagesDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagesDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagesDetailsQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      slugs: // value for 'slugs'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPagesDetailsQuery(baseOptions: Apollo.QueryHookOptions<ContentfulGetPagesDetailsQuery, ContentfulGetPagesDetailsQueryVariables> & ({ variables: ContentfulGetPagesDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulGetPagesDetailsQuery, ContentfulGetPagesDetailsQueryVariables>(GetPagesDetailsDocument, options);
      }
export function useGetPagesDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulGetPagesDetailsQuery, ContentfulGetPagesDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulGetPagesDetailsQuery, ContentfulGetPagesDetailsQueryVariables>(GetPagesDetailsDocument, options);
        }
export function useGetPagesDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulGetPagesDetailsQuery, ContentfulGetPagesDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulGetPagesDetailsQuery, ContentfulGetPagesDetailsQueryVariables>(GetPagesDetailsDocument, options);
        }
export type GetPagesDetailsQueryHookResult = ReturnType<typeof useGetPagesDetailsQuery>;
export type GetPagesDetailsLazyQueryHookResult = ReturnType<typeof useGetPagesDetailsLazyQuery>;
export type GetPagesDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPagesDetailsSuspenseQuery>;
export type GetPagesDetailsQueryResult = Apollo.QueryResult<ContentfulGetPagesDetailsQuery, ContentfulGetPagesDetailsQueryVariables>;
export const GetPdpDetailsDocument = gql`
    query GetPdpDetails($skus: [String!]!, $type: String, $languageCode: String!) @contentSourceMaps {
  detailPageCollection(
    where: {AND: [{type: $type}, {OR: [{watchSkus_contains_some: $skus}, {strapSkus_contains_some: $skus}]}]}
    locale: $languageCode
  ) {
    items {
      internalName
      watchSkus
      strapSkus
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      sys {
        ...Sys
      }
    }
  }
}
    ${SeoConfigurationFragmentDoc}
${SysFragmentDoc}`;

/**
 * __useGetPdpDetailsQuery__
 *
 * To run a query within a React component, call `useGetPdpDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdpDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdpDetailsQuery({
 *   variables: {
 *      skus: // value for 'skus'
 *      type: // value for 'type'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useGetPdpDetailsQuery(baseOptions: Apollo.QueryHookOptions<ContentfulGetPdpDetailsQuery, ContentfulGetPdpDetailsQueryVariables> & ({ variables: ContentfulGetPdpDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulGetPdpDetailsQuery, ContentfulGetPdpDetailsQueryVariables>(GetPdpDetailsDocument, options);
      }
export function useGetPdpDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulGetPdpDetailsQuery, ContentfulGetPdpDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulGetPdpDetailsQuery, ContentfulGetPdpDetailsQueryVariables>(GetPdpDetailsDocument, options);
        }
export function useGetPdpDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulGetPdpDetailsQuery, ContentfulGetPdpDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulGetPdpDetailsQuery, ContentfulGetPdpDetailsQueryVariables>(GetPdpDetailsDocument, options);
        }
export type GetPdpDetailsQueryHookResult = ReturnType<typeof useGetPdpDetailsQuery>;
export type GetPdpDetailsLazyQueryHookResult = ReturnType<typeof useGetPdpDetailsLazyQuery>;
export type GetPdpDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPdpDetailsSuspenseQuery>;
export type GetPdpDetailsQueryResult = Apollo.QueryResult<ContentfulGetPdpDetailsQuery, ContentfulGetPdpDetailsQueryVariables>;
export const GetPlpDetailsDocument = gql`
    query GetPlpDetails($languageCode: String!, $countryCode: String!) @contentSourceMaps {
  listingPageCollection(
    preview: false
    locale: $languageCode
    limit: 1000
    where: {sys: {publishedAt_exists: true}, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    items {
      type
      collectionName
      strapMaterial
      editorialPageName
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      sys {
        ...Sys
      }
    }
  }
}
    ${SeoConfigurationFragmentDoc}
${SysFragmentDoc}`;

/**
 * __useGetPlpDetailsQuery__
 *
 * To run a query within a React component, call `useGetPlpDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlpDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlpDetailsQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetPlpDetailsQuery(baseOptions: Apollo.QueryHookOptions<ContentfulGetPlpDetailsQuery, ContentfulGetPlpDetailsQueryVariables> & ({ variables: ContentfulGetPlpDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulGetPlpDetailsQuery, ContentfulGetPlpDetailsQueryVariables>(GetPlpDetailsDocument, options);
      }
export function useGetPlpDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulGetPlpDetailsQuery, ContentfulGetPlpDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulGetPlpDetailsQuery, ContentfulGetPlpDetailsQueryVariables>(GetPlpDetailsDocument, options);
        }
export function useGetPlpDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulGetPlpDetailsQuery, ContentfulGetPlpDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulGetPlpDetailsQuery, ContentfulGetPlpDetailsQueryVariables>(GetPlpDetailsDocument, options);
        }
export type GetPlpDetailsQueryHookResult = ReturnType<typeof useGetPlpDetailsQuery>;
export type GetPlpDetailsLazyQueryHookResult = ReturnType<typeof useGetPlpDetailsLazyQuery>;
export type GetPlpDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPlpDetailsSuspenseQuery>;
export type GetPlpDetailsQueryResult = Apollo.QueryResult<ContentfulGetPlpDetailsQuery, ContentfulGetPlpDetailsQueryVariables>;
export const ListingPageDocument = gql`
    query ListingPage($preview: Boolean, $type: String!, $collectionItemsLimit: Int!, $languageCode: String!, $collectionName: String, $editorialPageName: String, $strapMaterial: String, $countryCode: String) @contentSourceMaps {
  listingPageCollection(
    preview: $preview
    limit: 1
    where: {type: $type, collectionName: $collectionName, editorialPageName: $editorialPageName, strapMaterial: $strapMaterial, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
    locale: $languageCode
  ) {
    items {
      mainHeader(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on MainHeader {
          ...MainHeader
        }
      }
      footer(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on Footer {
          ...Footer
        }
      }
      algoliaCategoryId
      algoliaRuleName
      collectionName
      editorialPageName
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      contentCollection(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        items {
          ... on Banner {
            ...Banner
          }
          ... on Card {
            ...Card
          }
          ... on HeroProductListing {
            ...HeroProductListing
          }
          ... on ServicesCollection {
            ...Services
          }
          ... on Placeholder {
            ...Placeholder
          }
          ... on SliderProductsAutomatic {
            ...SliderProductsAutomatic
          }
          ... on SliderProductsManual {
            ...SliderProductsManual
          }
          ... on CollectionGroup {
            ...CollectionGroup
          }
          ... on PlaceholderStores {
            ...PlaceholderStores
          }
          ... on ContactUs {
            ...ContactUs
          }
          ... on FaqWrap {
            ...FaqWrap
          }
        }
      }
    }
  }
}
    ${MainHeaderFragmentDoc}
${MegaMenuFragmentDoc}
${MainMenuItemFragmentDoc}
${SubmenuItemFragmentDoc}
${MediaFragmentDoc}
${SysFragmentDoc}
${ScrollerItemFragmentDoc}
${AlertBannerFragmentDoc}
${FooterFragmentDoc}
${FooterItemFragmentDoc}
${SeoConfigurationFragmentDoc}
${BannerFragmentDoc}
${ImageWithFocalPointFragmentDoc}
${CardFragmentDoc}
${EventFragmentDoc}
${HeadingFragmentDoc}
${HeroProductListingFragmentDoc}
${CollectionItemFragmentDoc}
${ServicesFragmentDoc}
${ServiceFragmentDoc}
${PlaceholderFragmentDoc}
${SliderProductsAutomaticFragmentDoc}
${SliderProductsManualFragmentDoc}
${CollectionGroupFragmentDoc}
${BannerHeroFragmentDoc}
${AutomaticCollectionGroupFragmentDoc}
${ManualCollectionGroupProductReferencesFragmentDoc}
${CollectionGroupEndImageFragmentDoc}
${PlaceholderStoresFragmentDoc}
${FindAStoreFragmentDoc}
${ContactUsFragmentDoc}
${FaqWrapFragmentDoc}
${FaqWrapFaqListCollectionFragmentDoc}`;

/**
 * __useListingPageQuery__
 *
 * To run a query within a React component, call `useListingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingPageQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      type: // value for 'type'
 *      collectionItemsLimit: // value for 'collectionItemsLimit'
 *      languageCode: // value for 'languageCode'
 *      collectionName: // value for 'collectionName'
 *      editorialPageName: // value for 'editorialPageName'
 *      strapMaterial: // value for 'strapMaterial'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useListingPageQuery(baseOptions: Apollo.QueryHookOptions<ContentfulListingPageQuery, ContentfulListingPageQueryVariables> & ({ variables: ContentfulListingPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulListingPageQuery, ContentfulListingPageQueryVariables>(ListingPageDocument, options);
      }
export function useListingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulListingPageQuery, ContentfulListingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulListingPageQuery, ContentfulListingPageQueryVariables>(ListingPageDocument, options);
        }
export function useListingPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulListingPageQuery, ContentfulListingPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulListingPageQuery, ContentfulListingPageQueryVariables>(ListingPageDocument, options);
        }
export type ListingPageQueryHookResult = ReturnType<typeof useListingPageQuery>;
export type ListingPageLazyQueryHookResult = ReturnType<typeof useListingPageLazyQuery>;
export type ListingPageSuspenseQueryHookResult = ReturnType<typeof useListingPageSuspenseQuery>;
export type ListingPageQueryResult = Apollo.QueryResult<ContentfulListingPageQuery, ContentfulListingPageQueryVariables>;
export const PageDocument = gql`
    query Page($preview: Boolean, $slug: String!, $languageCode: String!, $parentSlugs: [String], $countryCode: String, $type: String) @contentSourceMaps {
  pageCollection(
    preview: $preview
    limit: 1
    where: {slug: $slug, type: $type, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
    locale: $languageCode
  ) {
    items {
      pageTitle
      publishDate
      type
      shortDescription
      tagsCollection {
        items {
          key
          value
        }
      }
      mainHeader(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on MainHeader {
          ...MainHeader
        }
      }
      footer(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on Footer {
          ...Footer
        }
      }
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      localizationConfiguration
      contentCollection(
        preview: $preview
        limit: 50
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        items {
          ... on PlaceholderHeader {
            ...PlaceholderHeader
          }
          ... on HeroSlider {
            ...HeroSlider
          }
          ... on Card {
            ...Card
          }
          ... on PlaceholderStores {
            ...PlaceholderStores
          }
          ... on ServicesCollection {
            ...Services
          }
          ... on NavQuickLinksWithBanner {
            ...NavQuickLinksWithBanner
          }
          ... on NavQuickLinks {
            ...NavQuickLinks
          }
          ... on ContentGroup {
            ...ContentGroup
          }
          ... on Banner {
            ...Banner
          }
          ... on ProductCard {
            ...ProductCard
          }
          ... on FindAStore {
            ...FindAStore
          }
          ... on FaqWrap {
            ...FaqWrap
          }
          ... on Heading {
            ...Heading
          }
          ... on FreeTextContent {
            ...FreeTextContent
          }
          ... on SliderProductsManual {
            ...SliderProductsManual
          }
          ... on PlaceholderService {
            ...PlaceholderService
          }
          ... on Breadcrumb {
            ...Breadcrumb
          }
          ... on Grid {
            ...Grid
          }
          ... on Event {
            ...Event
          }
          ... on ContactUs {
            ...ContactUs
          }
          ... on Iframe {
            ...Iframe
          }
          ... on LiveStoryContentType {
            ...LiveStory
          }
        }
      }
      simpleFooter {
        ... on SimpleFooter {
          ...SimpleFooter
        }
      }
    }
  }
  breadcrumb: pageCollection(
    preview: $preview
    limit: 5
    where: {slug_in: $parentSlugs, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
    locale: $languageCode
  ) {
    items {
      ...PageBreadcrumb
    }
  }
}
    ${MainHeaderFragmentDoc}
${MegaMenuFragmentDoc}
${MainMenuItemFragmentDoc}
${SubmenuItemFragmentDoc}
${MediaFragmentDoc}
${SysFragmentDoc}
${ScrollerItemFragmentDoc}
${AlertBannerFragmentDoc}
${FooterFragmentDoc}
${FooterItemFragmentDoc}
${SeoConfigurationFragmentDoc}
${PlaceholderHeaderFragmentDoc}
${HeroSliderFragmentDoc}
${CardFragmentDoc}
${EventFragmentDoc}
${HeadingFragmentDoc}
${ImageWithFocalPointFragmentDoc}
${PlaceholderStoresFragmentDoc}
${FindAStoreFragmentDoc}
${ServicesFragmentDoc}
${ServiceFragmentDoc}
${NavQuickLinksWithBannerFragmentDoc}
${NavQuickLinksFragmentDoc}
${NavQuickLinkFragmentDoc}
${ContentGroupFragmentDoc}
${ProductCardFragmentDoc}
${PlaceholderServiceFragmentDoc}
${BannerFragmentDoc}
${FaqWrapFragmentDoc}
${FaqWrapFaqListCollectionFragmentDoc}
${FreeTextContentFragmentDoc}
${SliderProductsManualFragmentDoc}
${BreadcrumbFragmentDoc}
${GridFragmentDoc}
${ContactUsFragmentDoc}
${IframeFragmentDoc}
${LiveStoryFragmentDoc}
${SimpleFooterFragmentDoc}
${PageBreadcrumbFragmentDoc}`;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      slug: // value for 'slug'
 *      languageCode: // value for 'languageCode'
 *      parentSlugs: // value for 'parentSlugs'
 *      countryCode: // value for 'countryCode'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<ContentfulPageQuery, ContentfulPageQueryVariables> & ({ variables: ContentfulPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulPageQuery, ContentfulPageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulPageQuery, ContentfulPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulPageQuery, ContentfulPageQueryVariables>(PageDocument, options);
        }
export function usePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulPageQuery, ContentfulPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulPageQuery, ContentfulPageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageSuspenseQueryHookResult = ReturnType<typeof usePageSuspenseQuery>;
export type PageQueryResult = Apollo.QueryResult<ContentfulPageQuery, ContentfulPageQueryVariables>;
export const PageBoutiqueDetailCollectionBySlugAndTrackingKeyDocument = gql`
    query PageBoutiqueDetailCollectionBySlugAndTrackingKey($trackingKey: String, $default: Boolean, $countryCode: String, $locale: String, $type: String) @contentSourceMaps {
  pageBoutiqueDetailCollection(
    where: {trackingKey: $trackingKey, default: $default, type: $type, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
    limit: 10
  ) {
    total
    items {
      internalName
      trackingKey
      type
      default
      seoConfiguration(locale: $locale) {
        ...SeoConfiguration
      }
      seoConfigurationOverride(locale: $locale) {
        ...SeoConfiguration
      }
      contentCollection(
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
        locale: $locale
      ) {
        items {
          ... on HeroSlider {
            ...HeroSlider
          }
          ... on FindAStore {
            ...FindAStore
          }
          ... on FaqWrap {
            ...FaqWrap
          }
          ... on SliderProductsManual {
            ...SliderProductsManual
          }
          ... on Card {
            ...Card
          }
          ... on Banner {
            ...Banner
          }
          ... on PlaceholderBoutiqueDetail {
            ...PlaceholderBoutiqueDetail
          }
          ... on ContactUs {
            ...ContactUs
          }
          ... on ContentGroup {
            ...ContentGroup
          }
        }
      }
    }
  }
}
    ${SeoConfigurationFragmentDoc}
${HeroSliderFragmentDoc}
${CardFragmentDoc}
${EventFragmentDoc}
${SysFragmentDoc}
${HeadingFragmentDoc}
${ImageWithFocalPointFragmentDoc}
${MediaFragmentDoc}
${FindAStoreFragmentDoc}
${FaqWrapFragmentDoc}
${FaqWrapFaqListCollectionFragmentDoc}
${SliderProductsManualFragmentDoc}
${BannerFragmentDoc}
${PlaceholderBoutiqueDetailFragmentDoc}
${ContactUsFragmentDoc}
${ContentGroupFragmentDoc}
${ProductCardFragmentDoc}
${PlaceholderServiceFragmentDoc}`;

/**
 * __usePageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery__
 *
 * To run a query within a React component, call `usePageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery({
 *   variables: {
 *      trackingKey: // value for 'trackingKey'
 *      default: // value for 'default'
 *      countryCode: // value for 'countryCode'
 *      locale: // value for 'locale'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery(baseOptions?: Apollo.QueryHookOptions<ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery, ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery, ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQueryVariables>(PageBoutiqueDetailCollectionBySlugAndTrackingKeyDocument, options);
      }
export function usePageBoutiqueDetailCollectionBySlugAndTrackingKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery, ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery, ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQueryVariables>(PageBoutiqueDetailCollectionBySlugAndTrackingKeyDocument, options);
        }
export function usePageBoutiqueDetailCollectionBySlugAndTrackingKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery, ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery, ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQueryVariables>(PageBoutiqueDetailCollectionBySlugAndTrackingKeyDocument, options);
        }
export type PageBoutiqueDetailCollectionBySlugAndTrackingKeyQueryHookResult = ReturnType<typeof usePageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery>;
export type PageBoutiqueDetailCollectionBySlugAndTrackingKeyLazyQueryHookResult = ReturnType<typeof usePageBoutiqueDetailCollectionBySlugAndTrackingKeyLazyQuery>;
export type PageBoutiqueDetailCollectionBySlugAndTrackingKeySuspenseQueryHookResult = ReturnType<typeof usePageBoutiqueDetailCollectionBySlugAndTrackingKeySuspenseQuery>;
export type PageBoutiqueDetailCollectionBySlugAndTrackingKeyQueryResult = Apollo.QueryResult<ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQuery, ContentfulPageBoutiqueDetailCollectionBySlugAndTrackingKeyQueryVariables>;
export const PageBoutiqueListCollectionQueryDocument = gql`
    query PageBoutiqueListCollectionQuery($preview: Boolean, $selectedCountry: String, $countryCode: String, $isDefault: Boolean, $locale: String) @contentSourceMaps {
  pageBoutiqueListCollection(
    preview: $preview
    limit: 1
    where: {countryCode: $selectedCountry, default: $isDefault, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
  ) {
    total
    items {
      internalName
      default
      countryCode
      seoConfiguration(locale: $locale) {
        ...SeoConfiguration
      }
      seoConfigurationOverride(locale: $locale) {
        ...SeoConfiguration
      }
      contentAboveBoutiquesCollection(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        total
        items {
          __typename
          ... on Card {
            ...Card
          }
          ... on Banner {
            ...Banner
          }
          ... on Placeholder {
            ...Placeholder
          }
          ... on NavQuickLinks {
            ...NavQuickLinks
          }
          ... on Heading {
            ...Heading
          }
          ... on ContentGroup {
            ...ContentGroup
          }
          ... on ServicesCollection {
            ...Services
          }
          ... on PlaceholderStores {
            ...PlaceholderStores
          }
          ... on ProductCard {
            ...ProductCard
          }
          ... on FindAStore {
            ...FindAStore
          }
          ... on FaqWrap {
            ...FaqWrap
          }
          ... on SliderProductsManual {
            ...SliderProductsManual
          }
          ... on FreeTextContent {
            ...FreeTextContent
          }
          ... on PlaceholderCheckoutPayments {
            ...PlaceholderCheckoutPayments
          }
          ... on ContactUs {
            ...ContactUs
          }
        }
      }
      contentBelowBoutiquesCollection(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
        locale: $locale
      ) {
        total
        items {
          __typename
          ... on Card {
            ...Card
          }
          ... on Banner {
            ...Banner
          }
          ... on Placeholder {
            ...Placeholder
          }
          ... on NavQuickLinks {
            ...NavQuickLinks
          }
          ... on Heading {
            ...Heading
          }
          ... on ContentGroup {
            ...ContentGroup
          }
          ... on ServicesCollection {
            ...Services
          }
          ... on PlaceholderStores {
            ...PlaceholderStores
          }
          ... on ProductCard {
            ...ProductCard
          }
          ... on FindAStore {
            ...FindAStore
          }
          ... on FaqWrap {
            ...FaqWrap
          }
          ... on SliderProductsManual {
            ...SliderProductsManual
          }
          ... on FreeTextContent {
            ...FreeTextContent
          }
          ... on PlaceholderCheckoutPayments {
            ...PlaceholderCheckoutPayments
          }
        }
      }
    }
  }
}
    ${SeoConfigurationFragmentDoc}
${CardFragmentDoc}
${EventFragmentDoc}
${SysFragmentDoc}
${HeadingFragmentDoc}
${ImageWithFocalPointFragmentDoc}
${MediaFragmentDoc}
${BannerFragmentDoc}
${PlaceholderFragmentDoc}
${NavQuickLinksFragmentDoc}
${NavQuickLinkFragmentDoc}
${ContentGroupFragmentDoc}
${ProductCardFragmentDoc}
${PlaceholderServiceFragmentDoc}
${ServicesFragmentDoc}
${ServiceFragmentDoc}
${PlaceholderStoresFragmentDoc}
${FindAStoreFragmentDoc}
${FaqWrapFragmentDoc}
${FaqWrapFaqListCollectionFragmentDoc}
${SliderProductsManualFragmentDoc}
${FreeTextContentFragmentDoc}
${PlaceholderCheckoutPaymentsFragmentDoc}
${ContactUsFragmentDoc}`;

/**
 * __usePageBoutiqueListCollectionQuery__
 *
 * To run a query within a React component, call `usePageBoutiqueListCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageBoutiqueListCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageBoutiqueListCollectionQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      selectedCountry: // value for 'selectedCountry'
 *      countryCode: // value for 'countryCode'
 *      isDefault: // value for 'isDefault'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function usePageBoutiqueListCollectionQuery(baseOptions?: Apollo.QueryHookOptions<ContentfulPageBoutiqueListCollectionQuery, ContentfulPageBoutiqueListCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulPageBoutiqueListCollectionQuery, ContentfulPageBoutiqueListCollectionQueryVariables>(PageBoutiqueListCollectionQueryDocument, options);
      }
export function usePageBoutiqueListCollectionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulPageBoutiqueListCollectionQuery, ContentfulPageBoutiqueListCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulPageBoutiqueListCollectionQuery, ContentfulPageBoutiqueListCollectionQueryVariables>(PageBoutiqueListCollectionQueryDocument, options);
        }
export function usePageBoutiqueListCollectionQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulPageBoutiqueListCollectionQuery, ContentfulPageBoutiqueListCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulPageBoutiqueListCollectionQuery, ContentfulPageBoutiqueListCollectionQueryVariables>(PageBoutiqueListCollectionQueryDocument, options);
        }
export type PageBoutiqueListCollectionQueryHookResult = ReturnType<typeof usePageBoutiqueListCollectionQuery>;
export type PageBoutiqueListCollectionQueryLazyQueryHookResult = ReturnType<typeof usePageBoutiqueListCollectionQueryLazyQuery>;
export type PageBoutiqueListCollectionQuerySuspenseQueryHookResult = ReturnType<typeof usePageBoutiqueListCollectionQuerySuspenseQuery>;
export type PageBoutiqueListCollectionQueryQueryResult = Apollo.QueryResult<ContentfulPageBoutiqueListCollectionQuery, ContentfulPageBoutiqueListCollectionQueryVariables>;
export const PageExhibitionHistoriesFaqDocument = gql`
    query pageExhibitionHistoriesFaq($preview: Boolean, $slug: String!, $languageCode: String!, $parentSlugs: [String], $countryCode: String, $type: String) @contentSourceMaps {
  pageExhibitionHistoriesFaqCollection(
    preview: $preview
    limit: 1
    where: {slug: $slug, type: $type, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
    locale: $languageCode
  ) {
    items {
      mainHeader(
        preview: $preview
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        ... on MainHeader {
          ...MainHeader
        }
      }
      seoConfiguration {
        ...SeoConfiguration
      }
      seoConfigurationOverride {
        ...SeoConfiguration
      }
      localizationConfiguration
      contentCollection(
        preview: $preview
        limit: 50
        where: {OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
      ) {
        items {
          ... on Card {
            ...Card
          }
          ... on Heading {
            ...Heading
          }
          ... on ContentGroup {
            ...ContentGroup
          }
          ... on Breadcrumb {
            ...Breadcrumb
          }
          ... on ExhibitionList {
            ...ExhibitionList
          }
          ... on NavQuickLinksWithBanner {
            ...NavQuickLinksWithBanner
          }
          ... on NavQuickLinks {
            ...NavQuickLinks
          }
          ... on ProductCard {
            ...ProductCard
          }
          ... on FaqCategories {
            ...FaqCategories
          }
          ... on ContactUs {
            ...ContactUs
          }
        }
      }
      slug
      pageTitle
      sys {
        ...Sys
      }
    }
  }
  breadcrumb: pageCollection(
    preview: $preview
    limit: 5
    where: {slug_in: $parentSlugs, OR: [{contentfulMetadata: {tags: {id_contains_some: [$countryCode]}}}, {contentfulMetadata: {tags_exists: false}}]}
    locale: $languageCode
  ) {
    items {
      ...PageBreadcrumb
    }
  }
}
    ${MainHeaderFragmentDoc}
${MegaMenuFragmentDoc}
${MainMenuItemFragmentDoc}
${SubmenuItemFragmentDoc}
${MediaFragmentDoc}
${SysFragmentDoc}
${ScrollerItemFragmentDoc}
${AlertBannerFragmentDoc}
${SeoConfigurationFragmentDoc}
${CardFragmentDoc}
${EventFragmentDoc}
${HeadingFragmentDoc}
${ImageWithFocalPointFragmentDoc}
${ContentGroupFragmentDoc}
${ProductCardFragmentDoc}
${PlaceholderServiceFragmentDoc}
${BreadcrumbFragmentDoc}
${ExhibitionListFragmentDoc}
${NavQuickLinksWithBannerFragmentDoc}
${NavQuickLinksFragmentDoc}
${NavQuickLinkFragmentDoc}
${FaqCategoriesFragmentDoc}
${FaqWrapFaqListCollectionFragmentDoc}
${ContactUsFragmentDoc}
${PageBreadcrumbFragmentDoc}`;

/**
 * __usePageExhibitionHistoriesFaqQuery__
 *
 * To run a query within a React component, call `usePageExhibitionHistoriesFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageExhibitionHistoriesFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageExhibitionHistoriesFaqQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      slug: // value for 'slug'
 *      languageCode: // value for 'languageCode'
 *      parentSlugs: // value for 'parentSlugs'
 *      countryCode: // value for 'countryCode'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePageExhibitionHistoriesFaqQuery(baseOptions: Apollo.QueryHookOptions<ContentfulPageExhibitionHistoriesFaqQuery, ContentfulPageExhibitionHistoriesFaqQueryVariables> & ({ variables: ContentfulPageExhibitionHistoriesFaqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulPageExhibitionHistoriesFaqQuery, ContentfulPageExhibitionHistoriesFaqQueryVariables>(PageExhibitionHistoriesFaqDocument, options);
      }
export function usePageExhibitionHistoriesFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulPageExhibitionHistoriesFaqQuery, ContentfulPageExhibitionHistoriesFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulPageExhibitionHistoriesFaqQuery, ContentfulPageExhibitionHistoriesFaqQueryVariables>(PageExhibitionHistoriesFaqDocument, options);
        }
export function usePageExhibitionHistoriesFaqSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulPageExhibitionHistoriesFaqQuery, ContentfulPageExhibitionHistoriesFaqQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulPageExhibitionHistoriesFaqQuery, ContentfulPageExhibitionHistoriesFaqQueryVariables>(PageExhibitionHistoriesFaqDocument, options);
        }
export type PageExhibitionHistoriesFaqQueryHookResult = ReturnType<typeof usePageExhibitionHistoriesFaqQuery>;
export type PageExhibitionHistoriesFaqLazyQueryHookResult = ReturnType<typeof usePageExhibitionHistoriesFaqLazyQuery>;
export type PageExhibitionHistoriesFaqSuspenseQueryHookResult = ReturnType<typeof usePageExhibitionHistoriesFaqSuspenseQuery>;
export type PageExhibitionHistoriesFaqQueryResult = Apollo.QueryResult<ContentfulPageExhibitionHistoriesFaqQuery, ContentfulPageExhibitionHistoriesFaqQueryVariables>;
export const PlaceholderServiceCollectionByTypeDocument = gql`
    query PlaceholderServiceCollectionByType($preview: Boolean, $type: String!, $languageCode: String!) @contentSourceMaps {
  placeholderServiceCollection(
    preview: $preview
    limit: 1
    where: {type: $type}
    locale: $languageCode
  ) {
    items {
      ... on PlaceholderService {
        ...PlaceholderService
      }
    }
  }
}
    ${PlaceholderServiceFragmentDoc}
${SysFragmentDoc}
${HeadingFragmentDoc}`;

/**
 * __usePlaceholderServiceCollectionByTypeQuery__
 *
 * To run a query within a React component, call `usePlaceholderServiceCollectionByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholderServiceCollectionByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceholderServiceCollectionByTypeQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *      type: // value for 'type'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function usePlaceholderServiceCollectionByTypeQuery(baseOptions: Apollo.QueryHookOptions<ContentfulPlaceholderServiceCollectionByTypeQuery, ContentfulPlaceholderServiceCollectionByTypeQueryVariables> & ({ variables: ContentfulPlaceholderServiceCollectionByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulPlaceholderServiceCollectionByTypeQuery, ContentfulPlaceholderServiceCollectionByTypeQueryVariables>(PlaceholderServiceCollectionByTypeDocument, options);
      }
export function usePlaceholderServiceCollectionByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulPlaceholderServiceCollectionByTypeQuery, ContentfulPlaceholderServiceCollectionByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulPlaceholderServiceCollectionByTypeQuery, ContentfulPlaceholderServiceCollectionByTypeQueryVariables>(PlaceholderServiceCollectionByTypeDocument, options);
        }
export function usePlaceholderServiceCollectionByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulPlaceholderServiceCollectionByTypeQuery, ContentfulPlaceholderServiceCollectionByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulPlaceholderServiceCollectionByTypeQuery, ContentfulPlaceholderServiceCollectionByTypeQueryVariables>(PlaceholderServiceCollectionByTypeDocument, options);
        }
export type PlaceholderServiceCollectionByTypeQueryHookResult = ReturnType<typeof usePlaceholderServiceCollectionByTypeQuery>;
export type PlaceholderServiceCollectionByTypeLazyQueryHookResult = ReturnType<typeof usePlaceholderServiceCollectionByTypeLazyQuery>;
export type PlaceholderServiceCollectionByTypeSuspenseQueryHookResult = ReturnType<typeof usePlaceholderServiceCollectionByTypeSuspenseQuery>;
export type PlaceholderServiceCollectionByTypeQueryResult = Apollo.QueryResult<ContentfulPlaceholderServiceCollectionByTypeQuery, ContentfulPlaceholderServiceCollectionByTypeQueryVariables>;
export const SelectorModalByMarketingPartnerDocument = gql`
    query SelectorModalByMarketingPartner($marketingPartner: String!, $preview: Boolean!, $languageCode: String!) @contentSourceMaps {
  selectorCollection(
    where: {marketingPartner: $marketingPartner}
    limit: 1
    preview: $preview
    locale: $languageCode
  ) {
    items {
      name
      title
      marketingPartner
      linksCollection(preview: $preview) {
        items {
          ... on SelectorLink {
            text
            reference
            slug
            image {
              url
              width
              height
              title
              description
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSelectorModalByMarketingPartnerQuery__
 *
 * To run a query within a React component, call `useSelectorModalByMarketingPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectorModalByMarketingPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectorModalByMarketingPartnerQuery({
 *   variables: {
 *      marketingPartner: // value for 'marketingPartner'
 *      preview: // value for 'preview'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useSelectorModalByMarketingPartnerQuery(baseOptions: Apollo.QueryHookOptions<ContentfulSelectorModalByMarketingPartnerQuery, ContentfulSelectorModalByMarketingPartnerQueryVariables> & ({ variables: ContentfulSelectorModalByMarketingPartnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentfulSelectorModalByMarketingPartnerQuery, ContentfulSelectorModalByMarketingPartnerQueryVariables>(SelectorModalByMarketingPartnerDocument, options);
      }
export function useSelectorModalByMarketingPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentfulSelectorModalByMarketingPartnerQuery, ContentfulSelectorModalByMarketingPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentfulSelectorModalByMarketingPartnerQuery, ContentfulSelectorModalByMarketingPartnerQueryVariables>(SelectorModalByMarketingPartnerDocument, options);
        }
export function useSelectorModalByMarketingPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentfulSelectorModalByMarketingPartnerQuery, ContentfulSelectorModalByMarketingPartnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentfulSelectorModalByMarketingPartnerQuery, ContentfulSelectorModalByMarketingPartnerQueryVariables>(SelectorModalByMarketingPartnerDocument, options);
        }
export type SelectorModalByMarketingPartnerQueryHookResult = ReturnType<typeof useSelectorModalByMarketingPartnerQuery>;
export type SelectorModalByMarketingPartnerLazyQueryHookResult = ReturnType<typeof useSelectorModalByMarketingPartnerLazyQuery>;
export type SelectorModalByMarketingPartnerSuspenseQueryHookResult = ReturnType<typeof useSelectorModalByMarketingPartnerSuspenseQuery>;
export type SelectorModalByMarketingPartnerQueryResult = Apollo.QueryResult<ContentfulSelectorModalByMarketingPartnerQuery, ContentfulSelectorModalByMarketingPartnerQueryVariables>;
export type AlertBannerKeySpecifier = ('_id' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'sys' | 'text' | 'type' | AlertBannerKeySpecifier)[];
export type AlertBannerFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | AlertBannerCollectionKeySpecifier)[];
export type AlertBannerCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | AlertBannerCursorCollectionKeySpecifier)[];
export type AlertBannerCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'mainHeaderCollection' | 'mainHeaderCursorCollection' | AlertBannerLinkingCollectionsKeySpecifier)[];
export type AlertBannerLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeaderCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeaderCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerTextKeySpecifier = ('json' | 'links' | AlertBannerTextKeySpecifier)[];
export type AlertBannerTextFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerTextAssetsKeySpecifier = ('block' | 'hyperlink' | AlertBannerTextAssetsKeySpecifier)[];
export type AlertBannerTextAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerTextEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | AlertBannerTextEntriesKeySpecifier)[];
export type AlertBannerTextEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerTextLinksKeySpecifier = ('assets' | 'entries' | 'resources' | AlertBannerTextLinksKeySpecifier)[];
export type AlertBannerTextLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerTextResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | AlertBannerTextResourcesKeySpecifier)[];
export type AlertBannerTextResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerTextResourcesBlockKeySpecifier = ('sys' | AlertBannerTextResourcesBlockKeySpecifier)[];
export type AlertBannerTextResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerTextResourcesHyperlinkKeySpecifier = ('sys' | AlertBannerTextResourcesHyperlinkKeySpecifier)[];
export type AlertBannerTextResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AlertBannerTextResourcesInlineKeySpecifier = ('sys' | AlertBannerTextResourcesInlineKeySpecifier)[];
export type AlertBannerTextResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssetKeySpecifier = ('contentType' | 'contentfulMetadata' | 'description' | 'fileName' | 'height' | 'linkedFrom' | 'size' | 'sys' | 'title' | 'url' | 'width' | AssetKeySpecifier)[];
export type AssetFieldPolicy = {
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssetCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | AssetCollectionKeySpecifier)[];
export type AssetCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssetCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | AssetCursorCollectionKeySpecifier)[];
export type AssetCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssetLinkingCollectionsKeySpecifier = ('cardCollection' | 'cardCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'findAStoreCollection' | 'findAStoreCursorCollection' | 'footerCollection' | 'footerCursorCollection' | 'imageWithFocalPointCollection' | 'imageWithFocalPointCursorCollection' | 'mainHeaderCollection' | 'mainHeaderCursorCollection' | 'mainMenuItemCollection' | 'mainMenuItemCursorCollection' | 'navQuickLinkItemCollection' | 'navQuickLinkItemCursorCollection' | 'placeholderCheckoutPaymentsCollection' | 'placeholderCheckoutPaymentsCursorCollection' | 'scrollerItemCollection' | 'scrollerItemCursorCollection' | 'selectorLinkCollection' | 'selectorLinkCursorCollection' | 'seoConfigurationCollection' | 'seoConfigurationCursorCollection' | 'serviceItemCollection' | 'serviceItemCursorCollection' | 'simpleFooterCollection' | 'simpleFooterCursorCollection' | 'sliderProductsAutomaticCollection' | 'sliderProductsAutomaticCursorCollection' | 'sliderProductsManualCollection' | 'sliderProductsManualCursorCollection' | AssetLinkingCollectionsKeySpecifier)[];
export type AssetLinkingCollectionsFieldPolicy = {
	cardCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	cardCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	findAStoreCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	findAStoreCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	footerCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	footerCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	imageWithFocalPointCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	imageWithFocalPointCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeaderCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeaderCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainMenuItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainMenuItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinkItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinkItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderCheckoutPaymentsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderCheckoutPaymentsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	scrollerItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	scrollerItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	selectorLinkCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	selectorLinkCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleFooterCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleFooterCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsAutomaticCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsAutomaticCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsManualCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsManualCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutomaticCollectionGroupKeySpecifier = ('_id' | 'algoliaFacetFilters' | 'algoliaRuleName' | 'collection' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'maximumNumberOfProducts' | 'sortBy' | 'sys' | AutomaticCollectionGroupKeySpecifier)[];
export type AutomaticCollectionGroupFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	algoliaFacetFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	algoliaRuleName?: FieldPolicy<any> | FieldReadFunction<any>,
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumNumberOfProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	sortBy?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutomaticCollectionGroupCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | AutomaticCollectionGroupCollectionKeySpecifier)[];
export type AutomaticCollectionGroupCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutomaticCollectionGroupCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | AutomaticCollectionGroupCursorCollectionKeySpecifier)[];
export type AutomaticCollectionGroupCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutomaticCollectionGroupLinkingCollectionsKeySpecifier = ('collectionGroupCollection' | 'collectionGroupCursorCollection' | 'entryCollection' | 'entryCursorCollection' | AutomaticCollectionGroupLinkingCollectionsKeySpecifier)[];
export type AutomaticCollectionGroupLinkingCollectionsFieldPolicy = {
	collectionGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerKeySpecifier = ('_id' | 'backgroundColor' | 'contentfulMetadata' | 'heading' | 'image' | 'imagePosition' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'subHeading' | 'sys' | 'text' | 'textAlignment' | 'url' | 'urlText' | 'urlType' | BannerKeySpecifier)[];
export type BannerFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	imagePosition?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	subHeading?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	textAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	urlText?: FieldPolicy<any> | FieldReadFunction<any>,
	urlType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | BannerCollectionKeySpecifier)[];
export type BannerCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | BannerCursorCollectionKeySpecifier)[];
export type BannerCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerHeroKeySpecifier = ('_id' | 'contentfulMetadata' | 'image' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'sys' | 'text' | 'title' | 'titleSeoTag' | 'titleStyle' | 'url' | 'urlText' | 'urlType' | BannerHeroKeySpecifier)[];
export type BannerHeroFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	titleSeoTag?: FieldPolicy<any> | FieldReadFunction<any>,
	titleStyle?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	urlText?: FieldPolicy<any> | FieldReadFunction<any>,
	urlType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerHeroCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | BannerHeroCollectionKeySpecifier)[];
export type BannerHeroCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerHeroCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | BannerHeroCursorCollectionKeySpecifier)[];
export type BannerHeroCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerHeroLinkingCollectionsKeySpecifier = ('collectionGroupCollection' | 'collectionGroupCursorCollection' | 'entryCollection' | 'entryCursorCollection' | BannerHeroLinkingCollectionsKeySpecifier)[];
export type BannerHeroLinkingCollectionsFieldPolicy = {
	collectionGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | BannerLinkingCollectionsKeySpecifier)[];
export type BannerLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	liveStoryContentType?: FieldPolicy<any> | FieldReadFunction<any>,
	liveStoryContentTypeCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	liveStoryContentTypeCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerTextKeySpecifier = ('json' | 'links' | BannerTextKeySpecifier)[];
export type BannerTextFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerTextAssetsKeySpecifier = ('block' | 'hyperlink' | BannerTextAssetsKeySpecifier)[];
export type BannerTextAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerTextEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | BannerTextEntriesKeySpecifier)[];
export type BannerTextEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerTextLinksKeySpecifier = ('assets' | 'entries' | 'resources' | BannerTextLinksKeySpecifier)[];
export type BannerTextLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerTextResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | BannerTextResourcesKeySpecifier)[];
export type BannerTextResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerTextResourcesBlockKeySpecifier = ('sys' | BannerTextResourcesBlockKeySpecifier)[];
export type BannerTextResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerTextResourcesHyperlinkKeySpecifier = ('sys' | BannerTextResourcesHyperlinkKeySpecifier)[];
export type BannerTextResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerTextResourcesInlineKeySpecifier = ('sys' | BannerTextResourcesInlineKeySpecifier)[];
export type BannerTextResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreadcrumbKeySpecifier = ('_id' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'style' | 'sys' | BreadcrumbKeySpecifier)[];
export type BreadcrumbFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	style?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreadcrumbCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | BreadcrumbCollectionKeySpecifier)[];
export type BreadcrumbCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreadcrumbCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | BreadcrumbCursorCollectionKeySpecifier)[];
export type BreadcrumbCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreadcrumbLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | BreadcrumbLinkingCollectionsKeySpecifier)[];
export type BreadcrumbLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardKeySpecifier = ('_id' | 'backgroundAlignment' | 'backgroundColor' | 'backgroundPosition' | 'contentAlignment' | 'contentMaxWidth' | 'contentOption' | 'contentfulMetadata' | 'countdown' | 'countdownToDatetime' | 'entryEffect' | 'icon' | 'id' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'media' | 'mediaAnimationEffect' | 'openUrl2InNewTab' | 'openUrlInNewTab' | 'saleorProductSku' | 'showMore' | 'subHeading' | 'sys' | 'text' | 'text2' | 'textAlignment' | 'textColor' | 'title' | 'type' | 'url' | 'url1AriaLabel' | 'url1EventType' | 'url2' | 'url2AriaLabel' | 'url2EventType' | 'url2Text' | 'url2Trigger' | 'url2Type' | 'urlDirection' | 'urlPosition' | 'urlText' | 'urlTrigger' | 'urlType' | 'visibleInDesktop' | 'visibleInMobile' | CardKeySpecifier)[];
export type CardFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	contentAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	contentMaxWidth?: FieldPolicy<any> | FieldReadFunction<any>,
	contentOption?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	countdown?: FieldPolicy<any> | FieldReadFunction<any>,
	countdownToDatetime?: FieldPolicy<any> | FieldReadFunction<any>,
	entryEffect?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaAnimationEffect?: FieldPolicy<any> | FieldReadFunction<any>,
	openUrl2InNewTab?: FieldPolicy<any> | FieldReadFunction<any>,
	openUrlInNewTab?: FieldPolicy<any> | FieldReadFunction<any>,
	saleorProductSku?: FieldPolicy<any> | FieldReadFunction<any>,
	showMore?: FieldPolicy<any> | FieldReadFunction<any>,
	subHeading?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	text2?: FieldPolicy<any> | FieldReadFunction<any>,
	textAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	textColor?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	url1AriaLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	url1EventType?: FieldPolicy<any> | FieldReadFunction<any>,
	url2?: FieldPolicy<any> | FieldReadFunction<any>,
	url2AriaLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	url2EventType?: FieldPolicy<any> | FieldReadFunction<any>,
	url2Text?: FieldPolicy<any> | FieldReadFunction<any>,
	url2Trigger?: FieldPolicy<any> | FieldReadFunction<any>,
	url2Type?: FieldPolicy<any> | FieldReadFunction<any>,
	urlDirection?: FieldPolicy<any> | FieldReadFunction<any>,
	urlPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	urlText?: FieldPolicy<any> | FieldReadFunction<any>,
	urlTrigger?: FieldPolicy<any> | FieldReadFunction<any>,
	urlType?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInMobile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | CardCollectionKeySpecifier)[];
export type CardCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | CardCursorCollectionKeySpecifier)[];
export type CardCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'contentGroupCollection' | 'contentGroupCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'gridCollection' | 'gridCursorCollection' | 'heroSliderCollection' | 'heroSliderCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'navQuickLinksWithBannerCollection' | 'navQuickLinksWithBannerCursorCollection' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | 'placeholderCollection' | 'placeholderCursorCollection' | 'searchOverlayCollection' | 'searchOverlayCursorCollection' | CardLinkingCollectionsKeySpecifier)[];
export type CardLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroSliderCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroSliderCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksWithBannerCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksWithBannerCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	searchOverlayCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	searchOverlayCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardTextKeySpecifier = ('json' | 'links' | CardTextKeySpecifier)[];
export type CardTextFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardText2KeySpecifier = ('json' | 'links' | CardText2KeySpecifier)[];
export type CardText2FieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardText2AssetsKeySpecifier = ('block' | 'hyperlink' | CardText2AssetsKeySpecifier)[];
export type CardText2AssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardText2EntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | CardText2EntriesKeySpecifier)[];
export type CardText2EntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardText2LinksKeySpecifier = ('assets' | 'entries' | 'resources' | CardText2LinksKeySpecifier)[];
export type CardText2LinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardText2ResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | CardText2ResourcesKeySpecifier)[];
export type CardText2ResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardText2ResourcesBlockKeySpecifier = ('sys' | CardText2ResourcesBlockKeySpecifier)[];
export type CardText2ResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardText2ResourcesHyperlinkKeySpecifier = ('sys' | CardText2ResourcesHyperlinkKeySpecifier)[];
export type CardText2ResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardText2ResourcesInlineKeySpecifier = ('sys' | CardText2ResourcesInlineKeySpecifier)[];
export type CardText2ResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardTextAssetsKeySpecifier = ('block' | 'hyperlink' | CardTextAssetsKeySpecifier)[];
export type CardTextAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardTextEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | CardTextEntriesKeySpecifier)[];
export type CardTextEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardTextLinksKeySpecifier = ('assets' | 'entries' | 'resources' | CardTextLinksKeySpecifier)[];
export type CardTextLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardTextResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | CardTextResourcesKeySpecifier)[];
export type CardTextResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardTextResourcesBlockKeySpecifier = ('sys' | CardTextResourcesBlockKeySpecifier)[];
export type CardTextResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardTextResourcesHyperlinkKeySpecifier = ('sys' | CardTextResourcesHyperlinkKeySpecifier)[];
export type CardTextResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardTextResourcesInlineKeySpecifier = ('sys' | CardTextResourcesInlineKeySpecifier)[];
export type CardTextResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionGroupKeySpecifier = ('_id' | 'banner' | 'contentfulMetadata' | 'endImage' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'productReferences' | 'sys' | 'type' | CollectionGroupKeySpecifier)[];
export type CollectionGroupFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	banner?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	endImage?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	productReferences?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionGroupCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | CollectionGroupCollectionKeySpecifier)[];
export type CollectionGroupCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionGroupCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | CollectionGroupCursorCollectionKeySpecifier)[];
export type CollectionGroupCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionGroupEndImageKeySpecifier = ('_id' | 'contentfulMetadata' | 'endImage' | 'endImageLinkType' | 'endImageUrl' | 'endImageUrlText' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'sys' | CollectionGroupEndImageKeySpecifier)[];
export type CollectionGroupEndImageFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	endImage?: FieldPolicy<any> | FieldReadFunction<any>,
	endImageLinkType?: FieldPolicy<any> | FieldReadFunction<any>,
	endImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	endImageUrlText?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionGroupEndImageCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | CollectionGroupEndImageCollectionKeySpecifier)[];
export type CollectionGroupEndImageCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionGroupEndImageCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | CollectionGroupEndImageCursorCollectionKeySpecifier)[];
export type CollectionGroupEndImageCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionGroupEndImageLinkingCollectionsKeySpecifier = ('collectionGroupCollection' | 'collectionGroupCursorCollection' | 'entryCollection' | 'entryCursorCollection' | CollectionGroupEndImageLinkingCollectionsKeySpecifier)[];
export type CollectionGroupEndImageLinkingCollectionsFieldPolicy = {
	collectionGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionGroupLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | CollectionGroupLinkingCollectionsKeySpecifier)[];
export type CollectionGroupLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionItemKeySpecifier = ('_id' | 'collectionName' | 'contentfulMetadata' | 'image' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'saleorCollection' | 'sys' | CollectionItemKeySpecifier)[];
export type CollectionItemFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	saleorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionItemCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | CollectionItemCollectionKeySpecifier)[];
export type CollectionItemCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionItemCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | CollectionItemCursorCollectionKeySpecifier)[];
export type CollectionItemCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionItemLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'heroProductListingCollection' | 'heroProductListingCursorCollection' | CollectionItemLinkingCollectionsKeySpecifier)[];
export type CollectionItemLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroProductListingCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroProductListingCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConditionalComponentKeySpecifier = ('_id' | 'contentCollection' | 'contentCursorCollection' | 'contentfulMetadata' | 'displayOnEmptyCondition' | 'displayOnLoggedInCondition' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'sys' | ConditionalComponentKeySpecifier)[];
export type ConditionalComponentFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	displayOnEmptyCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	displayOnLoggedInCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConditionalComponentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ConditionalComponentCollectionKeySpecifier)[];
export type ConditionalComponentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConditionalComponentContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ConditionalComponentContentCollectionKeySpecifier)[];
export type ConditionalComponentContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConditionalComponentContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ConditionalComponentContentCursorCollectionKeySpecifier)[];
export type ConditionalComponentContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConditionalComponentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ConditionalComponentCursorCollectionKeySpecifier)[];
export type ConditionalComponentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConditionalComponentLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | ConditionalComponentLinkingCollectionsKeySpecifier)[];
export type ConditionalComponentLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactUsKeySpecifier = ('_id' | 'contentfulMetadata' | 'email' | 'heading' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'phone' | 'sys' | 'type' | ContactUsKeySpecifier)[];
export type ContactUsFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactUsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ContactUsCollectionKeySpecifier)[];
export type ContactUsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactUsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ContactUsCursorCollectionKeySpecifier)[];
export type ContactUsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactUsLinkingCollectionsKeySpecifier = ('detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | ContactUsLinkingCollectionsKeySpecifier)[];
export type ContactUsLinkingCollectionsFieldPolicy = {
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentGroupKeySpecifier = ('_id' | 'contentfulMetadata' | 'id' | 'internalName' | 'itemsCollection' | 'itemsCursorCollection' | 'linkedFrom' | 'localizationConfiguration' | 'sys' | 'type' | ContentGroupKeySpecifier)[];
export type ContentGroupFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentGroupCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ContentGroupCollectionKeySpecifier)[];
export type ContentGroupCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentGroupCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ContentGroupCursorCollectionKeySpecifier)[];
export type ContentGroupCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentGroupItemsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ContentGroupItemsCollectionKeySpecifier)[];
export type ContentGroupItemsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentGroupItemsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ContentGroupItemsCursorCollectionKeySpecifier)[];
export type ContentGroupItemsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentGroupLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'gridCollection' | 'gridCursorCollection' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | ContentGroupLinkingCollectionsKeySpecifier)[];
export type ContentGroupLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentfulMetadataKeySpecifier = ('concepts' | 'tags' | ContentfulMetadataKeySpecifier)[];
export type ContentfulMetadataFieldPolicy = {
	concepts?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentfulTagKeySpecifier = ('id' | 'name' | ContentfulTagKeySpecifier)[];
export type ContentfulTagFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CursorPagesKeySpecifier = ('next' | 'prev' | CursorPagesKeySpecifier)[];
export type CursorPagesFieldPolicy = {
	next?: FieldPolicy<any> | FieldReadFunction<any>,
	prev?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DefaultLayoutKeySpecifier = ('_id' | 'contentfulMetadata' | 'footer' | 'header' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'search' | 'sys' | DefaultLayoutKeySpecifier)[];
export type DefaultLayoutFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	footer?: FieldPolicy<any> | FieldReadFunction<any>,
	header?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	search?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DefaultLayoutCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | DefaultLayoutCollectionKeySpecifier)[];
export type DefaultLayoutCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DefaultLayoutCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | DefaultLayoutCursorCollectionKeySpecifier)[];
export type DefaultLayoutCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DefaultLayoutLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | DefaultLayoutLinkingCollectionsKeySpecifier)[];
export type DefaultLayoutLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DetailPageKeySpecifier = ('_id' | 'contentCollection' | 'contentCursorCollection' | 'contentfulMetadata' | 'default' | 'footer' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'mainHeader' | 'model' | 'seoConfiguration' | 'seoConfigurationOverride' | 'strapSkus' | 'sys' | 'type' | 'watchCollection' | 'watchSkus' | DetailPageKeySpecifier)[];
export type DetailPageFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	footer?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	strapSkus?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	watchCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	watchSkus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DetailPageCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | DetailPageCollectionKeySpecifier)[];
export type DetailPageCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DetailPageContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | DetailPageContentCollectionKeySpecifier)[];
export type DetailPageContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DetailPageContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | DetailPageContentCursorCollectionKeySpecifier)[];
export type DetailPageContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DetailPageCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | DetailPageCursorCollectionKeySpecifier)[];
export type DetailPageCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DetailPageLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | DetailPageLinkingCollectionsKeySpecifier)[];
export type DetailPageLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DictionaryKeySpecifier = ('_id' | 'contentCollection' | 'contentCursorCollection' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'sys' | DictionaryKeySpecifier)[];
export type DictionaryFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DictionaryCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | DictionaryCollectionKeySpecifier)[];
export type DictionaryCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DictionaryContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | DictionaryContentCollectionKeySpecifier)[];
export type DictionaryContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DictionaryContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | DictionaryContentCursorCollectionKeySpecifier)[];
export type DictionaryContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DictionaryCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | DictionaryCursorCollectionKeySpecifier)[];
export type DictionaryCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DictionaryItemKeySpecifier = ('_id' | 'contentfulMetadata' | 'key' | 'linkedFrom' | 'sys' | 'value' | DictionaryItemKeySpecifier)[];
export type DictionaryItemFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DictionaryItemCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | DictionaryItemCollectionKeySpecifier)[];
export type DictionaryItemCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DictionaryItemCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | DictionaryItemCursorCollectionKeySpecifier)[];
export type DictionaryItemCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DictionaryItemLinkingCollectionsKeySpecifier = ('dictionaryCollection' | 'dictionaryCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | DictionaryItemLinkingCollectionsKeySpecifier)[];
export type DictionaryItemLinkingCollectionsFieldPolicy = {
	dictionaryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionaryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DictionaryLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | DictionaryLinkingCollectionsKeySpecifier)[];
export type DictionaryLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntryKeySpecifier = ('contentfulMetadata' | 'sys' | EntryKeySpecifier)[];
export type EntryFieldPolicy = {
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntryCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | EntryCollectionKeySpecifier)[];
export type EntryCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntryCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | EntryCursorCollectionKeySpecifier)[];
export type EntryCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventKeySpecifier = ('_id' | 'campaignName' | 'contentfulMetadata' | 'description' | 'eventId' | 'linkedFrom' | 'sfId' | 'sys' | 'title' | 'type' | EventKeySpecifier)[];
export type EventFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	campaignName?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	sfId?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | EventCollectionKeySpecifier)[];
export type EventCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | EventCursorCollectionKeySpecifier)[];
export type EventCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDescriptionKeySpecifier = ('json' | 'links' | EventDescriptionKeySpecifier)[];
export type EventDescriptionFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDescriptionAssetsKeySpecifier = ('block' | 'hyperlink' | EventDescriptionAssetsKeySpecifier)[];
export type EventDescriptionAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDescriptionEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | EventDescriptionEntriesKeySpecifier)[];
export type EventDescriptionEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDescriptionLinksKeySpecifier = ('assets' | 'entries' | 'resources' | EventDescriptionLinksKeySpecifier)[];
export type EventDescriptionLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDescriptionResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | EventDescriptionResourcesKeySpecifier)[];
export type EventDescriptionResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDescriptionResourcesBlockKeySpecifier = ('sys' | EventDescriptionResourcesBlockKeySpecifier)[];
export type EventDescriptionResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDescriptionResourcesHyperlinkKeySpecifier = ('sys' | EventDescriptionResourcesHyperlinkKeySpecifier)[];
export type EventDescriptionResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDescriptionResourcesInlineKeySpecifier = ('sys' | EventDescriptionResourcesInlineKeySpecifier)[];
export type EventDescriptionResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventLinkingCollectionsKeySpecifier = ('cardCollection' | 'cardCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'navQuickLinkItemCollection' | 'navQuickLinkItemCursorCollection' | 'pageCollection' | 'pageCursorCollection' | EventLinkingCollectionsKeySpecifier)[];
export type EventLinkingCollectionsFieldPolicy = {
	cardCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	cardCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinkItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinkItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExhibitionItemKeySpecifier = ('_id' | 'boutiqueId' | 'contentfulMetadata' | 'endDate' | 'internalName' | 'label' | 'linkedFrom' | 'media' | 'startDate' | 'sys' | ExhibitionItemKeySpecifier)[];
export type ExhibitionItemFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	boutiqueId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExhibitionItemCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ExhibitionItemCollectionKeySpecifier)[];
export type ExhibitionItemCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExhibitionItemCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ExhibitionItemCursorCollectionKeySpecifier)[];
export type ExhibitionItemCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExhibitionItemLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'exhibitionListCollection' | 'exhibitionListCursorCollection' | ExhibitionItemLinkingCollectionsKeySpecifier)[];
export type ExhibitionItemLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExhibitionListKeySpecifier = ('_id' | 'categoryDescription' | 'categoryTitle' | 'categoryTitleSeoTag' | 'categoryTitleStyle' | 'contentfulMetadata' | 'exhibitionItemsCollection' | 'exhibitionItemsCursorCollection' | 'exhibitionListLabel' | 'internalName' | 'linkedFrom' | 'loadMoreLabel' | 'pastExhibitionsLabel' | 'sys' | ExhibitionListKeySpecifier)[];
export type ExhibitionListFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryTitleSeoTag?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryTitleStyle?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionItemsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionItemsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionListLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	loadMoreLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	pastExhibitionsLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExhibitionListCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ExhibitionListCollectionKeySpecifier)[];
export type ExhibitionListCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExhibitionListCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ExhibitionListCursorCollectionKeySpecifier)[];
export type ExhibitionListCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExhibitionListExhibitionItemsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ExhibitionListExhibitionItemsCollectionKeySpecifier)[];
export type ExhibitionListExhibitionItemsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExhibitionListExhibitionItemsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ExhibitionListExhibitionItemsCursorCollectionKeySpecifier)[];
export type ExhibitionListExhibitionItemsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExhibitionListLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | ExhibitionListLinkingCollectionsKeySpecifier)[];
export type ExhibitionListLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqCategoriesKeySpecifier = ('_id' | 'categoryLabel' | 'contentfulMetadata' | 'faqWrapsCollection' | 'faqWrapsCursorCollection' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'sys' | FaqCategoriesKeySpecifier)[];
export type FaqCategoriesFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	faqWrapsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqWrapsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqCategoriesCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | FaqCategoriesCollectionKeySpecifier)[];
export type FaqCategoriesCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqCategoriesCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | FaqCategoriesCursorCollectionKeySpecifier)[];
export type FaqCategoriesCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqCategoriesFaqWrapsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | FaqCategoriesFaqWrapsCollectionKeySpecifier)[];
export type FaqCategoriesFaqWrapsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqCategoriesFaqWrapsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | FaqCategoriesFaqWrapsCursorCollectionKeySpecifier)[];
export type FaqCategoriesFaqWrapsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqCategoriesLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | FaqCategoriesLinkingCollectionsKeySpecifier)[];
export type FaqCategoriesLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemKeySpecifier = ('_id' | 'contentfulMetadata' | 'faqAnswer' | 'faqQuestion' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'sys' | FaqItemKeySpecifier)[];
export type FaqItemFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	faqAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	faqQuestion?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | FaqItemCollectionKeySpecifier)[];
export type FaqItemCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | FaqItemCursorCollectionKeySpecifier)[];
export type FaqItemCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemFaqAnswerKeySpecifier = ('json' | 'links' | FaqItemFaqAnswerKeySpecifier)[];
export type FaqItemFaqAnswerFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemFaqAnswerAssetsKeySpecifier = ('block' | 'hyperlink' | FaqItemFaqAnswerAssetsKeySpecifier)[];
export type FaqItemFaqAnswerAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemFaqAnswerEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | FaqItemFaqAnswerEntriesKeySpecifier)[];
export type FaqItemFaqAnswerEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemFaqAnswerLinksKeySpecifier = ('assets' | 'entries' | 'resources' | FaqItemFaqAnswerLinksKeySpecifier)[];
export type FaqItemFaqAnswerLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemFaqAnswerResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | FaqItemFaqAnswerResourcesKeySpecifier)[];
export type FaqItemFaqAnswerResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemFaqAnswerResourcesBlockKeySpecifier = ('sys' | FaqItemFaqAnswerResourcesBlockKeySpecifier)[];
export type FaqItemFaqAnswerResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemFaqAnswerResourcesHyperlinkKeySpecifier = ('sys' | FaqItemFaqAnswerResourcesHyperlinkKeySpecifier)[];
export type FaqItemFaqAnswerResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemFaqAnswerResourcesInlineKeySpecifier = ('sys' | FaqItemFaqAnswerResourcesInlineKeySpecifier)[];
export type FaqItemFaqAnswerResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqItemLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'faqWrapCollection' | 'faqWrapCursorCollection' | FaqItemLinkingCollectionsKeySpecifier)[];
export type FaqItemLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqWrapCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqWrapCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqWrapKeySpecifier = ('_id' | 'collapse' | 'contentfulMetadata' | 'faqListCollection' | 'faqListCursorCollection' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'sys' | 'title' | FaqWrapKeySpecifier)[];
export type FaqWrapFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	collapse?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	faqListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqWrapCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | FaqWrapCollectionKeySpecifier)[];
export type FaqWrapCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqWrapCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | FaqWrapCursorCollectionKeySpecifier)[];
export type FaqWrapCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqWrapFaqListCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | FaqWrapFaqListCollectionKeySpecifier)[];
export type FaqWrapFaqListCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqWrapFaqListCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | FaqWrapFaqListCursorCollectionKeySpecifier)[];
export type FaqWrapFaqListCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqWrapLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'faqCategoriesCollection' | 'faqCategoriesCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | FaqWrapLinkingCollectionsKeySpecifier)[];
export type FaqWrapLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqCategoriesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqCategoriesCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreKeySpecifier = ('_id' | 'backgroundColor' | 'cardImage' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'longImage' | 'sys' | 'text' | 'type' | 'url' | 'urlText' | FindAStoreKeySpecifier)[];
export type FindAStoreFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImage?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	longImage?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	urlText?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | FindAStoreCollectionKeySpecifier)[];
export type FindAStoreCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | FindAStoreCursorCollectionKeySpecifier)[];
export type FindAStoreCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | 'placeholderStoresCollection' | 'placeholderStoresCursorCollection' | FindAStoreLinkingCollectionsKeySpecifier)[];
export type FindAStoreLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderStoresCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderStoresCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreTextKeySpecifier = ('json' | 'links' | FindAStoreTextKeySpecifier)[];
export type FindAStoreTextFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreTextAssetsKeySpecifier = ('block' | 'hyperlink' | FindAStoreTextAssetsKeySpecifier)[];
export type FindAStoreTextAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreTextEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | FindAStoreTextEntriesKeySpecifier)[];
export type FindAStoreTextEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreTextLinksKeySpecifier = ('assets' | 'entries' | 'resources' | FindAStoreTextLinksKeySpecifier)[];
export type FindAStoreTextLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreTextResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | FindAStoreTextResourcesKeySpecifier)[];
export type FindAStoreTextResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreTextResourcesBlockKeySpecifier = ('sys' | FindAStoreTextResourcesBlockKeySpecifier)[];
export type FindAStoreTextResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreTextResourcesHyperlinkKeySpecifier = ('sys' | FindAStoreTextResourcesHyperlinkKeySpecifier)[];
export type FindAStoreTextResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FindAStoreTextResourcesInlineKeySpecifier = ('sys' | FindAStoreTextResourcesInlineKeySpecifier)[];
export type FindAStoreTextResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FooterKeySpecifier = ('_id' | 'contactLinkAriaLabel' | 'contactLinkText' | 'contactLinkUrl' | 'contentfulMetadata' | 'copyrightText' | 'displayContactInformation' | 'displayNewsletterSubscribe' | 'displayRegionSelector' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'logo' | 'logoHeightDesktop' | 'logoHeightMobile' | 'logoLink' | 'logoWidthDesktop' | 'logoWidthMobile' | 'menuItemsCollection' | 'menuItemsCursorCollection' | 'regionSelectorLabel' | 'secondaryMenuItemsCollection' | 'secondaryMenuItemsCursorCollection' | 'socialFacebookUrl' | 'socialInstagramUrl' | 'socialLineUrl' | 'socialNetworkLabel' | 'socialPinterestUrl' | 'socialStravaUrl' | 'socialTiktokUrl' | 'socialXTwitterUrl' | 'socialYoutubeUrl' | 'subscribeToNewsletterText' | 'sys' | 'type' | FooterKeySpecifier)[];
export type FooterFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contactLinkAriaLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	contactLinkText?: FieldPolicy<any> | FieldReadFunction<any>,
	contactLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	copyrightText?: FieldPolicy<any> | FieldReadFunction<any>,
	displayContactInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	displayNewsletterSubscribe?: FieldPolicy<any> | FieldReadFunction<any>,
	displayRegionSelector?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	logoHeightDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	logoHeightMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	logoLink?: FieldPolicy<any> | FieldReadFunction<any>,
	logoWidthDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	logoWidthMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	regionSelectorLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryMenuItemsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryMenuItemsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	socialFacebookUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	socialInstagramUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	socialLineUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	socialNetworkLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	socialPinterestUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	socialStravaUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	socialTiktokUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	socialXTwitterUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	socialYoutubeUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	subscribeToNewsletterText?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FooterCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | FooterCollectionKeySpecifier)[];
export type FooterCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FooterCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | FooterCursorCollectionKeySpecifier)[];
export type FooterCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FooterLinkingCollectionsKeySpecifier = ('defaultLayoutCollection' | 'defaultLayoutCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'pageCollection' | 'pageCursorCollection' | FooterLinkingCollectionsKeySpecifier)[];
export type FooterLinkingCollectionsFieldPolicy = {
	defaultLayoutCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLayoutCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FooterMenuItemsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | FooterMenuItemsCollectionKeySpecifier)[];
export type FooterMenuItemsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FooterMenuItemsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | FooterMenuItemsCursorCollectionKeySpecifier)[];
export type FooterMenuItemsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FooterSecondaryMenuItemsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | FooterSecondaryMenuItemsCollectionKeySpecifier)[];
export type FooterSecondaryMenuItemsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FooterSecondaryMenuItemsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | FooterSecondaryMenuItemsCursorCollectionKeySpecifier)[];
export type FooterSecondaryMenuItemsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentKeySpecifier = ('_id' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'sys' | 'textContent' | FreeTextContentKeySpecifier)[];
export type FreeTextContentFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	textContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | FreeTextContentCollectionKeySpecifier)[];
export type FreeTextContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | FreeTextContentCursorCollectionKeySpecifier)[];
export type FreeTextContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'gridCollection' | 'gridCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | FreeTextContentLinkingCollectionsKeySpecifier)[];
export type FreeTextContentLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentTextContentKeySpecifier = ('json' | 'links' | FreeTextContentTextContentKeySpecifier)[];
export type FreeTextContentTextContentFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentTextContentAssetsKeySpecifier = ('block' | 'hyperlink' | FreeTextContentTextContentAssetsKeySpecifier)[];
export type FreeTextContentTextContentAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentTextContentEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | FreeTextContentTextContentEntriesKeySpecifier)[];
export type FreeTextContentTextContentEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentTextContentLinksKeySpecifier = ('assets' | 'entries' | 'resources' | FreeTextContentTextContentLinksKeySpecifier)[];
export type FreeTextContentTextContentLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentTextContentResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | FreeTextContentTextContentResourcesKeySpecifier)[];
export type FreeTextContentTextContentResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentTextContentResourcesBlockKeySpecifier = ('sys' | FreeTextContentTextContentResourcesBlockKeySpecifier)[];
export type FreeTextContentTextContentResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentTextContentResourcesHyperlinkKeySpecifier = ('sys' | FreeTextContentTextContentResourcesHyperlinkKeySpecifier)[];
export type FreeTextContentTextContentResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeTextContentTextContentResourcesInlineKeySpecifier = ('sys' | FreeTextContentTextContentResourcesInlineKeySpecifier)[];
export type FreeTextContentTextContentResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GridKeySpecifier = ('_id' | 'backgroundColor' | 'col' | 'colForMobile' | 'colGap' | 'contentAlignment' | 'contentCollection' | 'contentCursorCollection' | 'contentfulMetadata' | 'entryEffect' | 'id' | 'internalName' | 'isSlider' | 'linkedFrom' | 'localizationConfiguration' | 'maxWidth' | 'paddingBottom' | 'paddingTop' | 'reverseDisplayOrderForMobile' | 'rowGap' | 'sys' | 'visibleInDesktop' | 'visibleInMobile' | GridKeySpecifier)[];
export type GridFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	col?: FieldPolicy<any> | FieldReadFunction<any>,
	colForMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	colGap?: FieldPolicy<any> | FieldReadFunction<any>,
	contentAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	entryEffect?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isSlider?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxWidth?: FieldPolicy<any> | FieldReadFunction<any>,
	paddingBottom?: FieldPolicy<any> | FieldReadFunction<any>,
	paddingTop?: FieldPolicy<any> | FieldReadFunction<any>,
	reverseDisplayOrderForMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	rowGap?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInMobile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GridCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | GridCollectionKeySpecifier)[];
export type GridCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GridContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | GridContentCollectionKeySpecifier)[];
export type GridContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GridContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | GridContentCursorCollectionKeySpecifier)[];
export type GridContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GridCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | GridCursorCollectionKeySpecifier)[];
export type GridCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GridLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'contentGroupCollection' | 'contentGroupCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | GridLinkingCollectionsKeySpecifier)[];
export type GridLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeadingKeySpecifier = ('_id' | 'contentfulMetadata' | 'headingSeoTag' | 'headingType' | 'headingVariation' | 'highlightColor' | 'linkedFrom' | 'mainColor' | 'sys' | 'text' | 'textAlignment' | HeadingKeySpecifier)[];
export type HeadingFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	headingSeoTag?: FieldPolicy<any> | FieldReadFunction<any>,
	headingType?: FieldPolicy<any> | FieldReadFunction<any>,
	headingVariation?: FieldPolicy<any> | FieldReadFunction<any>,
	highlightColor?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	mainColor?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	textAlignment?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeadingCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | HeadingCollectionKeySpecifier)[];
export type HeadingCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeadingCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | HeadingCursorCollectionKeySpecifier)[];
export type HeadingCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeadingLinkingCollectionsKeySpecifier = ('cardCollection' | 'cardCursorCollection' | 'conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'contactUsCollection' | 'contactUsCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'faqWrapCollection' | 'faqWrapCursorCollection' | 'gridCollection' | 'gridCursorCollection' | 'heroProductListingCollection' | 'heroProductListingCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | 'placeholderModelStoryCollection' | 'placeholderModelStoryCursorCollection' | 'placeholderServiceCollection' | 'placeholderServiceCursorCollection' | 'placeholderStoresCollection' | 'placeholderStoresCursorCollection' | 'servicesCollectionCollection' | 'servicesCollectionCursorCollection' | 'sliderProductsManualCollection' | 'sliderProductsManualCursorCollection' | HeadingLinkingCollectionsKeySpecifier)[];
export type HeadingLinkingCollectionsFieldPolicy = {
	cardCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	cardCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contactUsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contactUsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqWrapCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqWrapCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroProductListingCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroProductListingCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderModelStoryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderModelStoryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderServiceCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderServiceCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderStoresCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderStoresCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesCollectionCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesCollectionCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsManualCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsManualCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingKeySpecifier = ('_id' | 'backgroundColor' | 'backgroundColorOpacity' | 'collectionItemsCollection' | 'collectionItemsCursorCollection' | 'contentAlignment' | 'contentfulMetadata' | 'heading' | 'headingNumberOfColoredWords' | 'headingSeoTag' | 'headingStyle' | 'internalName' | 'linkedFrom' | 'media' | 'openUrl2InNewTab' | 'openUrlInNewTab' | 'showBreadcrumbs' | 'showFilters' | 'subheader' | 'subheaderIsCapitalized' | 'subheading' | 'sys' | 'text' | 'textAlignment' | 'textBelowMedia' | 'textColor' | 'title' | 'type' | 'url' | 'url1EventType' | 'url2' | 'url2EventType' | 'url2Text' | 'url2Type' | 'urlDirection' | 'urlPosition' | 'urlText' | 'urlType' | 'visibleInDesktop' | 'visibleInMobile' | HeroProductListingKeySpecifier)[];
export type HeroProductListingFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColorOpacity?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionItemsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionItemsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	headingNumberOfColoredWords?: FieldPolicy<any> | FieldReadFunction<any>,
	headingSeoTag?: FieldPolicy<any> | FieldReadFunction<any>,
	headingStyle?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	openUrl2InNewTab?: FieldPolicy<any> | FieldReadFunction<any>,
	openUrlInNewTab?: FieldPolicy<any> | FieldReadFunction<any>,
	showBreadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>,
	showFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	subheader?: FieldPolicy<any> | FieldReadFunction<any>,
	subheaderIsCapitalized?: FieldPolicy<any> | FieldReadFunction<any>,
	subheading?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	textAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	textBelowMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	textColor?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	url1EventType?: FieldPolicy<any> | FieldReadFunction<any>,
	url2?: FieldPolicy<any> | FieldReadFunction<any>,
	url2EventType?: FieldPolicy<any> | FieldReadFunction<any>,
	url2Text?: FieldPolicy<any> | FieldReadFunction<any>,
	url2Type?: FieldPolicy<any> | FieldReadFunction<any>,
	urlDirection?: FieldPolicy<any> | FieldReadFunction<any>,
	urlPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	urlText?: FieldPolicy<any> | FieldReadFunction<any>,
	urlType?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInMobile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | HeroProductListingCollectionKeySpecifier)[];
export type HeroProductListingCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingCollectionItemsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | HeroProductListingCollectionItemsCollectionKeySpecifier)[];
export type HeroProductListingCollectionItemsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingCollectionItemsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | HeroProductListingCollectionItemsCursorCollectionKeySpecifier)[];
export type HeroProductListingCollectionItemsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | HeroProductListingCursorCollectionKeySpecifier)[];
export type HeroProductListingCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | HeroProductListingLinkingCollectionsKeySpecifier)[];
export type HeroProductListingLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingTextKeySpecifier = ('json' | 'links' | HeroProductListingTextKeySpecifier)[];
export type HeroProductListingTextFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingTextAssetsKeySpecifier = ('block' | 'hyperlink' | HeroProductListingTextAssetsKeySpecifier)[];
export type HeroProductListingTextAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingTextEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | HeroProductListingTextEntriesKeySpecifier)[];
export type HeroProductListingTextEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingTextLinksKeySpecifier = ('assets' | 'entries' | 'resources' | HeroProductListingTextLinksKeySpecifier)[];
export type HeroProductListingTextLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingTextResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | HeroProductListingTextResourcesKeySpecifier)[];
export type HeroProductListingTextResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingTextResourcesBlockKeySpecifier = ('sys' | HeroProductListingTextResourcesBlockKeySpecifier)[];
export type HeroProductListingTextResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingTextResourcesHyperlinkKeySpecifier = ('sys' | HeroProductListingTextResourcesHyperlinkKeySpecifier)[];
export type HeroProductListingTextResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroProductListingTextResourcesInlineKeySpecifier = ('sys' | HeroProductListingTextResourcesInlineKeySpecifier)[];
export type HeroProductListingTextResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroSliderKeySpecifier = ('_id' | 'autoslide' | 'autoslideDurationMs' | 'contentfulMetadata' | 'fixToTop' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'slidesCollection' | 'slidesCursorCollection' | 'sys' | HeroSliderKeySpecifier)[];
export type HeroSliderFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	autoslide?: FieldPolicy<any> | FieldReadFunction<any>,
	autoslideDurationMs?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	fixToTop?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	slidesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	slidesCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroSliderCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | HeroSliderCollectionKeySpecifier)[];
export type HeroSliderCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroSliderCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | HeroSliderCursorCollectionKeySpecifier)[];
export type HeroSliderCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroSliderLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | HeroSliderLinkingCollectionsKeySpecifier)[];
export type HeroSliderLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroSliderSlidesCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | HeroSliderSlidesCollectionKeySpecifier)[];
export type HeroSliderSlidesCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeroSliderSlidesCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | HeroSliderSlidesCursorCollectionKeySpecifier)[];
export type HeroSliderSlidesCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IframeKeySpecifier = ('_id' | 'contentfulMetadata' | 'hasScrollbar' | 'height' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'maxWidth' | 'sys' | 'url' | IframeKeySpecifier)[];
export type IframeFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	hasScrollbar?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxWidth?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IframeCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | IframeCollectionKeySpecifier)[];
export type IframeCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IframeCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | IframeCursorCollectionKeySpecifier)[];
export type IframeCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IframeLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'pageCollection' | 'pageCursorCollection' | IframeLinkingCollectionsKeySpecifier)[];
export type IframeLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageWithFocalPointKeySpecifier = ('_id' | 'alt' | 'contentfulMetadata' | 'focalPoint' | 'image' | 'imageMobile' | 'imageOnHover' | 'imageOnHoverMobile' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'sys' | 'url' | 'video' | 'videoMobile' | 'videoPlayOption' | ImageWithFocalPointKeySpecifier)[];
export type ImageWithFocalPointFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	alt?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	focalPoint?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	imageMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	imageOnHover?: FieldPolicy<any> | FieldReadFunction<any>,
	imageOnHoverMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>,
	videoMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	videoPlayOption?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageWithFocalPointCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ImageWithFocalPointCollectionKeySpecifier)[];
export type ImageWithFocalPointCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageWithFocalPointCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ImageWithFocalPointCursorCollectionKeySpecifier)[];
export type ImageWithFocalPointCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageWithFocalPointLinkingCollectionsKeySpecifier = ('bannerCollection' | 'bannerCursorCollection' | 'bannerHeroCollection' | 'bannerHeroCursorCollection' | 'cardCollection' | 'cardCursorCollection' | 'collectionGroupEndImageCollection' | 'collectionGroupEndImageCursorCollection' | 'collectionItemCollection' | 'collectionItemCursorCollection' | 'contentGroupCollection' | 'contentGroupCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'exhibitionItemCollection' | 'exhibitionItemCursorCollection' | 'gridCollection' | 'gridCursorCollection' | 'heroProductListingCollection' | 'heroProductListingCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | ImageWithFocalPointLinkingCollectionsKeySpecifier)[];
export type ImageWithFocalPointLinkingCollectionsFieldPolicy = {
	bannerCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerHeroCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerHeroCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	cardCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	cardCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupEndImageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupEndImageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroProductListingCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroProductListingCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ListingPageKeySpecifier = ('_id' | 'algoliaCategoryId' | 'algoliaRuleName' | 'collectionName' | 'contentCollection' | 'contentCursorCollection' | 'contentfulMetadata' | 'editorialPageName' | 'footer' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'mainHeader' | 'saleorCollection' | 'seoConfiguration' | 'seoConfigurationOverride' | 'strapMaterial' | 'sys' | 'type' | ListingPageKeySpecifier)[];
export type ListingPageFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	algoliaCategoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	algoliaRuleName?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	editorialPageName?: FieldPolicy<any> | FieldReadFunction<any>,
	footer?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	saleorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	strapMaterial?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ListingPageCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ListingPageCollectionKeySpecifier)[];
export type ListingPageCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ListingPageContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ListingPageContentCollectionKeySpecifier)[];
export type ListingPageContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ListingPageContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ListingPageContentCursorCollectionKeySpecifier)[];
export type ListingPageContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ListingPageCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ListingPageCursorCollectionKeySpecifier)[];
export type ListingPageCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ListingPageLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | ListingPageLinkingCollectionsKeySpecifier)[];
export type ListingPageLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LiveStoryContentTypeKeySpecifier = ('_id' | 'contentfulMetadata' | 'coverImg' | 'description' | 'id' | 'linkedFrom' | 'ssc' | 'sys' | 'title' | 'type' | LiveStoryContentTypeKeySpecifier)[];
export type LiveStoryContentTypeFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	coverImg?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	ssc?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LiveStoryContentTypeCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | LiveStoryContentTypeCollectionKeySpecifier)[];
export type LiveStoryContentTypeCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LiveStoryContentTypeCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | LiveStoryContentTypeCursorCollectionKeySpecifier)[];
export type LiveStoryContentTypeCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LiveStoryContentTypeLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'pageCollection' | 'pageCursorCollection' | LiveStoryContentTypeLinkingCollectionsKeySpecifier)[];
export type LiveStoryContentTypeLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainHeaderKeySpecifier = ('_id' | 'alertBannerCollection' | 'alertBannerCursorCollection' | 'background' | 'backgroundImage' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'logo' | 'logoHeightDesktop' | 'logoHeightMobile' | 'logoWidthDesktop' | 'logoWidthMobile' | 'megamenu' | 'sys' | 'textColorOption' | 'type' | MainHeaderKeySpecifier)[];
export type MainHeaderFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	alertBannerCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	alertBannerCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	background?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	logoHeightDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	logoHeightMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	logoWidthDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	logoWidthMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	megamenu?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	textColorOption?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainHeaderAlertBannerCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | MainHeaderAlertBannerCollectionKeySpecifier)[];
export type MainHeaderAlertBannerCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainHeaderAlertBannerCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | MainHeaderAlertBannerCursorCollectionKeySpecifier)[];
export type MainHeaderAlertBannerCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainHeaderCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | MainHeaderCollectionKeySpecifier)[];
export type MainHeaderCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainHeaderCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | MainHeaderCursorCollectionKeySpecifier)[];
export type MainHeaderCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainHeaderLinkingCollectionsKeySpecifier = ('defaultLayoutCollection' | 'defaultLayoutCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | MainHeaderLinkingCollectionsKeySpecifier)[];
export type MainHeaderLinkingCollectionsFieldPolicy = {
	defaultLayoutCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLayoutCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainMenuItemKeySpecifier = ('_id' | 'bottomLinkAriaLabel' | 'bottomLinkLabel' | 'bottomLinkUrl' | 'contentfulMetadata' | 'image' | 'internalName' | 'label' | 'linkedFrom' | 'localizationConfiguration' | 'openUrlInNewTab' | 'scrollerItemsCollection' | 'scrollerItemsCursorCollection' | 'scrollerLabel' | 'submenuItemsCollection' | 'submenuItemsCursorCollection' | 'sys' | 'type' | 'url' | 'visibleInDesktop' | 'visibleInMobile' | MainMenuItemKeySpecifier)[];
export type MainMenuItemFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	bottomLinkAriaLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	bottomLinkLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	bottomLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	openUrlInNewTab?: FieldPolicy<any> | FieldReadFunction<any>,
	scrollerItemsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	scrollerItemsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	scrollerLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	submenuItemsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	submenuItemsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInMobile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainMenuItemCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | MainMenuItemCollectionKeySpecifier)[];
export type MainMenuItemCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainMenuItemCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | MainMenuItemCursorCollectionKeySpecifier)[];
export type MainMenuItemCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainMenuItemLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'footerCollection' | 'footerCursorCollection' | 'mainMenuItemCollection' | 'mainMenuItemCursorCollection' | 'megaMenuCollection' | 'megaMenuCursorCollection' | MainMenuItemLinkingCollectionsKeySpecifier)[];
export type MainMenuItemLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	footerCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	footerCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainMenuItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainMenuItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	megaMenuCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	megaMenuCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainMenuItemScrollerItemsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | MainMenuItemScrollerItemsCollectionKeySpecifier)[];
export type MainMenuItemScrollerItemsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainMenuItemScrollerItemsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | MainMenuItemScrollerItemsCursorCollectionKeySpecifier)[];
export type MainMenuItemScrollerItemsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainMenuItemSubmenuItemsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | MainMenuItemSubmenuItemsCollectionKeySpecifier)[];
export type MainMenuItemSubmenuItemsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MainMenuItemSubmenuItemsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | MainMenuItemSubmenuItemsCursorCollectionKeySpecifier)[];
export type MainMenuItemSubmenuItemsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualCollectionGroupProductReferencesKeySpecifier = ('_id' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'manualProductReferences' | 'sys' | ManualCollectionGroupProductReferencesKeySpecifier)[];
export type ManualCollectionGroupProductReferencesFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	manualProductReferences?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualCollectionGroupProductReferencesCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ManualCollectionGroupProductReferencesCollectionKeySpecifier)[];
export type ManualCollectionGroupProductReferencesCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualCollectionGroupProductReferencesCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ManualCollectionGroupProductReferencesCursorCollectionKeySpecifier)[];
export type ManualCollectionGroupProductReferencesCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualCollectionGroupProductReferencesLinkingCollectionsKeySpecifier = ('collectionGroupCollection' | 'collectionGroupCursorCollection' | 'entryCollection' | 'entryCursorCollection' | ManualCollectionGroupProductReferencesLinkingCollectionsKeySpecifier)[];
export type ManualCollectionGroupProductReferencesLinkingCollectionsFieldPolicy = {
	collectionGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MegaMenuKeySpecifier = ('_id' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'menuItemsCollection' | 'menuItemsCursorCollection' | 'sys' | MegaMenuKeySpecifier)[];
export type MegaMenuFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MegaMenuCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | MegaMenuCollectionKeySpecifier)[];
export type MegaMenuCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MegaMenuCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | MegaMenuCursorCollectionKeySpecifier)[];
export type MegaMenuCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MegaMenuLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'mainHeaderCollection' | 'mainHeaderCursorCollection' | MegaMenuLinkingCollectionsKeySpecifier)[];
export type MegaMenuLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeaderCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeaderCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MegaMenuMenuItemsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | MegaMenuMenuItemsCollectionKeySpecifier)[];
export type MegaMenuMenuItemsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MegaMenuMenuItemsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | MegaMenuMenuItemsCursorCollectionKeySpecifier)[];
export type MegaMenuMenuItemsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinkItemKeySpecifier = ('_id' | 'backgroundColor' | 'contentfulMetadata' | 'disableNavigationScrollToTop' | 'icon' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'media' | 'sys' | 'topLabelText' | 'url' | 'urlTarget' | 'urlText' | 'urlTrigger' | NavQuickLinkItemKeySpecifier)[];
export type NavQuickLinkItemFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	disableNavigationScrollToTop?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	topLabelText?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	urlTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	urlText?: FieldPolicy<any> | FieldReadFunction<any>,
	urlTrigger?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinkItemCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | NavQuickLinkItemCollectionKeySpecifier)[];
export type NavQuickLinkItemCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinkItemCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | NavQuickLinkItemCursorCollectionKeySpecifier)[];
export type NavQuickLinkItemCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinkItemLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'navQuickLinksCollection' | 'navQuickLinksCursorCollection' | NavQuickLinkItemLinkingCollectionsKeySpecifier)[];
export type NavQuickLinkItemLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinksKeySpecifier = ('_id' | 'backgroundColor' | 'contentfulMetadata' | 'internalName' | 'isSticky' | 'linkedFrom' | 'linksCollection' | 'linksCursorCollection' | 'localizationConfiguration' | 'sys' | 'type' | NavQuickLinksKeySpecifier)[];
export type NavQuickLinksFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isSticky?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	linksCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	linksCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinksCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | NavQuickLinksCollectionKeySpecifier)[];
export type NavQuickLinksCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinksCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | NavQuickLinksCursorCollectionKeySpecifier)[];
export type NavQuickLinksCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinksLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'navQuickLinksWithBannerCollection' | 'navQuickLinksWithBannerCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | NavQuickLinksLinkingCollectionsKeySpecifier)[];
export type NavQuickLinksLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksWithBannerCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksWithBannerCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinksLinksCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | NavQuickLinksLinksCollectionKeySpecifier)[];
export type NavQuickLinksLinksCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinksLinksCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | NavQuickLinksLinksCursorCollectionKeySpecifier)[];
export type NavQuickLinksLinksCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinksWithBannerKeySpecifier = ('_id' | 'card' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'navQuickLinks' | 'sys' | 'type' | NavQuickLinksWithBannerKeySpecifier)[];
export type NavQuickLinksWithBannerFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	card?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinksWithBannerCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | NavQuickLinksWithBannerCollectionKeySpecifier)[];
export type NavQuickLinksWithBannerCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinksWithBannerCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | NavQuickLinksWithBannerCursorCollectionKeySpecifier)[];
export type NavQuickLinksWithBannerCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavQuickLinksWithBannerLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | NavQuickLinksWithBannerLinkingCollectionsKeySpecifier)[];
export type NavQuickLinksWithBannerLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageKeySpecifier = ('_id' | 'contentCollection' | 'contentCursorCollection' | 'contentfulMetadata' | 'enableSearch' | 'footer' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'mainHeader' | 'pageTitle' | 'publishDate' | 'seoConfiguration' | 'seoConfigurationOverride' | 'shortDescription' | 'simpleFooter' | 'slug' | 'sys' | 'tagsCollection' | 'tagsCursorCollection' | 'thumbnail' | 'type' | PageKeySpecifier)[];
export type PageFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	enableSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	footer?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	publishDate?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleFooter?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	tagsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	tagsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueDetailKeySpecifier = ('_id' | 'contentCollection' | 'contentCursorCollection' | 'contentfulMetadata' | 'default' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'seoConfiguration' | 'seoConfigurationOverride' | 'sys' | 'trackingKey' | 'type' | PageBoutiqueDetailKeySpecifier)[];
export type PageBoutiqueDetailFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingKey?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueDetailCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageBoutiqueDetailCollectionKeySpecifier)[];
export type PageBoutiqueDetailCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueDetailContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageBoutiqueDetailContentCollectionKeySpecifier)[];
export type PageBoutiqueDetailContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueDetailContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageBoutiqueDetailContentCursorCollectionKeySpecifier)[];
export type PageBoutiqueDetailContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueDetailCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageBoutiqueDetailCursorCollectionKeySpecifier)[];
export type PageBoutiqueDetailCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueDetailLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | PageBoutiqueDetailLinkingCollectionsKeySpecifier)[];
export type PageBoutiqueDetailLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueListKeySpecifier = ('_id' | 'contentAboveBoutiquesCollection' | 'contentAboveBoutiquesCursorCollection' | 'contentBelowBoutiquesCollection' | 'contentBelowBoutiquesCursorCollection' | 'contentfulMetadata' | 'countryCode' | 'default' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'seoConfiguration' | 'seoConfigurationOverride' | 'sys' | PageBoutiqueListKeySpecifier)[];
export type PageBoutiqueListFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentAboveBoutiquesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentAboveBoutiquesCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentBelowBoutiquesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentBelowBoutiquesCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueListCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageBoutiqueListCollectionKeySpecifier)[];
export type PageBoutiqueListCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueListContentAboveBoutiquesCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageBoutiqueListContentAboveBoutiquesCollectionKeySpecifier)[];
export type PageBoutiqueListContentAboveBoutiquesCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueListContentAboveBoutiquesCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageBoutiqueListContentAboveBoutiquesCursorCollectionKeySpecifier)[];
export type PageBoutiqueListContentAboveBoutiquesCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueListContentBelowBoutiquesCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageBoutiqueListContentBelowBoutiquesCollectionKeySpecifier)[];
export type PageBoutiqueListContentBelowBoutiquesCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueListContentBelowBoutiquesCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageBoutiqueListContentBelowBoutiquesCursorCollectionKeySpecifier)[];
export type PageBoutiqueListContentBelowBoutiquesCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueListCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageBoutiqueListCursorCollectionKeySpecifier)[];
export type PageBoutiqueListCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBoutiqueListLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | PageBoutiqueListLinkingCollectionsKeySpecifier)[];
export type PageBoutiqueListLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageCollectionKeySpecifier)[];
export type PageCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageContentCollectionKeySpecifier)[];
export type PageContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageContentCursorCollectionKeySpecifier)[];
export type PageContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageCursorCollectionKeySpecifier)[];
export type PageCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageExhibitionHistoriesFaqKeySpecifier = ('_id' | 'contentCollection' | 'contentCursorCollection' | 'contentfulMetadata' | 'enableSearch' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'mainHeader' | 'pageTitle' | 'seoConfiguration' | 'seoConfigurationOverride' | 'slug' | 'sys' | 'thumbnail' | 'type' | PageExhibitionHistoriesFaqKeySpecifier)[];
export type PageExhibitionHistoriesFaqFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	enableSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageExhibitionHistoriesFaqCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageExhibitionHistoriesFaqCollectionKeySpecifier)[];
export type PageExhibitionHistoriesFaqCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageExhibitionHistoriesFaqContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageExhibitionHistoriesFaqContentCollectionKeySpecifier)[];
export type PageExhibitionHistoriesFaqContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageExhibitionHistoriesFaqContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageExhibitionHistoriesFaqContentCursorCollectionKeySpecifier)[];
export type PageExhibitionHistoriesFaqContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageExhibitionHistoriesFaqCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageExhibitionHistoriesFaqCursorCollectionKeySpecifier)[];
export type PageExhibitionHistoriesFaqCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageExhibitionHistoriesFaqLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | PageExhibitionHistoriesFaqLinkingCollectionsKeySpecifier)[];
export type PageExhibitionHistoriesFaqLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedKeySpecifier = ('_id' | 'bottomContentCollection' | 'bottomContentCursorCollection' | 'contentfulMetadata' | 'dictionaryCollection' | 'dictionaryCursorCollection' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'pinnedNewsCollection' | 'pinnedNewsCursorCollection' | 'seoConfiguration' | 'seoConfigurationOverride' | 'slug' | 'sys' | 'topContentCollection' | 'topContentCursorCollection' | PageFixedKeySpecifier)[];
export type PageFixedFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	bottomContentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	bottomContentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionaryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionaryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	pinnedNewsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pinnedNewsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	topContentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	topContentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedBottomContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageFixedBottomContentCollectionKeySpecifier)[];
export type PageFixedBottomContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedBottomContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageFixedBottomContentCursorCollectionKeySpecifier)[];
export type PageFixedBottomContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageFixedCollectionKeySpecifier)[];
export type PageFixedCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageFixedCursorCollectionKeySpecifier)[];
export type PageFixedCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedDictionaryCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageFixedDictionaryCollectionKeySpecifier)[];
export type PageFixedDictionaryCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedDictionaryCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageFixedDictionaryCursorCollectionKeySpecifier)[];
export type PageFixedDictionaryCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | PageFixedLinkingCollectionsKeySpecifier)[];
export type PageFixedLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedPinnedNewsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageFixedPinnedNewsCollectionKeySpecifier)[];
export type PageFixedPinnedNewsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedPinnedNewsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageFixedPinnedNewsCursorCollectionKeySpecifier)[];
export type PageFixedPinnedNewsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedTopContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageFixedTopContentCollectionKeySpecifier)[];
export type PageFixedTopContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageFixedTopContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageFixedTopContentCursorCollectionKeySpecifier)[];
export type PageFixedTopContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | PageLinkingCollectionsKeySpecifier)[];
export type PageLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTagsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PageTagsCollectionKeySpecifier)[];
export type PageTagsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTagsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PageTagsCursorCollectionKeySpecifier)[];
export type PageTagsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderKeySpecifier = ('_id' | 'contentfulMetadata' | 'heading' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'subtext' | 'sys' | 'type' | 'videoUrl' | 'warrantyTakingCareOfYourWatch' | 'warrantyText' | PlaceholderKeySpecifier)[];
export type PlaceholderFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	subtext?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	videoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	warrantyTakingCareOfYourWatch?: FieldPolicy<any> | FieldReadFunction<any>,
	warrantyText?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderBoutiqueDetailKeySpecifier = ('_id' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'sys' | 'type' | PlaceholderBoutiqueDetailKeySpecifier)[];
export type PlaceholderBoutiqueDetailFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderBoutiqueDetailCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PlaceholderBoutiqueDetailCollectionKeySpecifier)[];
export type PlaceholderBoutiqueDetailCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderBoutiqueDetailCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PlaceholderBoutiqueDetailCursorCollectionKeySpecifier)[];
export type PlaceholderBoutiqueDetailCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderBoutiqueDetailLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | PlaceholderBoutiqueDetailLinkingCollectionsKeySpecifier)[];
export type PlaceholderBoutiqueDetailLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderCheckoutPaymentsKeySpecifier = ('_id' | 'contentfulMetadata' | 'ctaTel' | 'ctaText' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'paymentsMediaCollection' | 'paymentsMediaCursorCollection' | 'sys' | PlaceholderCheckoutPaymentsKeySpecifier)[];
export type PlaceholderCheckoutPaymentsFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaTel?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaText?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentsMediaCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentsMediaCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderCheckoutPaymentsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PlaceholderCheckoutPaymentsCollectionKeySpecifier)[];
export type PlaceholderCheckoutPaymentsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderCheckoutPaymentsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PlaceholderCheckoutPaymentsCursorCollectionKeySpecifier)[];
export type PlaceholderCheckoutPaymentsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderCheckoutPaymentsLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | PlaceholderCheckoutPaymentsLinkingCollectionsKeySpecifier)[];
export type PlaceholderCheckoutPaymentsLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PlaceholderCollectionKeySpecifier)[];
export type PlaceholderCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PlaceholderCursorCollectionKeySpecifier)[];
export type PlaceholderCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderHeaderKeySpecifier = ('_id' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'sys' | PlaceholderHeaderKeySpecifier)[];
export type PlaceholderHeaderFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderHeaderCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PlaceholderHeaderCollectionKeySpecifier)[];
export type PlaceholderHeaderCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderHeaderCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PlaceholderHeaderCursorCollectionKeySpecifier)[];
export type PlaceholderHeaderCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderHeaderLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'pageCollection' | 'pageCursorCollection' | PlaceholderHeaderLinkingCollectionsKeySpecifier)[];
export type PlaceholderHeaderLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | PlaceholderLinkingCollectionsKeySpecifier)[];
export type PlaceholderLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderModelStoryKeySpecifier = ('_id' | 'backgroundColor' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'mediaAlignment' | 'sys' | 'title' | 'type' | PlaceholderModelStoryKeySpecifier)[];
export type PlaceholderModelStoryFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderModelStoryCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PlaceholderModelStoryCollectionKeySpecifier)[];
export type PlaceholderModelStoryCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderModelStoryCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PlaceholderModelStoryCursorCollectionKeySpecifier)[];
export type PlaceholderModelStoryCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderModelStoryLinkingCollectionsKeySpecifier = ('detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | PlaceholderModelStoryLinkingCollectionsKeySpecifier)[];
export type PlaceholderModelStoryLinkingCollectionsFieldPolicy = {
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderProductDetailsKeySpecifier = ('_id' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'perksCollection' | 'perksCursorCollection' | 'sys' | PlaceholderProductDetailsKeySpecifier)[];
export type PlaceholderProductDetailsFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	perksCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	perksCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderProductDetailsCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PlaceholderProductDetailsCollectionKeySpecifier)[];
export type PlaceholderProductDetailsCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderProductDetailsCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PlaceholderProductDetailsCursorCollectionKeySpecifier)[];
export type PlaceholderProductDetailsCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderProductDetailsLinkingCollectionsKeySpecifier = ('detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | PlaceholderProductDetailsLinkingCollectionsKeySpecifier)[];
export type PlaceholderProductDetailsLinkingCollectionsFieldPolicy = {
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderProductDetailsPerksCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PlaceholderProductDetailsPerksCollectionKeySpecifier)[];
export type PlaceholderProductDetailsPerksCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderProductDetailsPerksCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PlaceholderProductDetailsPerksCursorCollectionKeySpecifier)[];
export type PlaceholderProductDetailsPerksCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceKeySpecifier = ('_id' | 'contentfulMetadata' | 'heading' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'subtext' | 'sys' | 'type' | PlaceholderServiceKeySpecifier)[];
export type PlaceholderServiceFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	subtext?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PlaceholderServiceCollectionKeySpecifier)[];
export type PlaceholderServiceCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PlaceholderServiceCursorCollectionKeySpecifier)[];
export type PlaceholderServiceCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'contentGroupCollection' | 'contentGroupCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | PlaceholderServiceLinkingCollectionsKeySpecifier)[];
export type PlaceholderServiceLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceSubtextKeySpecifier = ('json' | 'links' | PlaceholderServiceSubtextKeySpecifier)[];
export type PlaceholderServiceSubtextFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceSubtextAssetsKeySpecifier = ('block' | 'hyperlink' | PlaceholderServiceSubtextAssetsKeySpecifier)[];
export type PlaceholderServiceSubtextAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceSubtextEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | PlaceholderServiceSubtextEntriesKeySpecifier)[];
export type PlaceholderServiceSubtextEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceSubtextLinksKeySpecifier = ('assets' | 'entries' | 'resources' | PlaceholderServiceSubtextLinksKeySpecifier)[];
export type PlaceholderServiceSubtextLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceSubtextResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | PlaceholderServiceSubtextResourcesKeySpecifier)[];
export type PlaceholderServiceSubtextResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceSubtextResourcesBlockKeySpecifier = ('sys' | PlaceholderServiceSubtextResourcesBlockKeySpecifier)[];
export type PlaceholderServiceSubtextResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceSubtextResourcesHyperlinkKeySpecifier = ('sys' | PlaceholderServiceSubtextResourcesHyperlinkKeySpecifier)[];
export type PlaceholderServiceSubtextResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderServiceSubtextResourcesInlineKeySpecifier = ('sys' | PlaceholderServiceSubtextResourcesInlineKeySpecifier)[];
export type PlaceholderServiceSubtextResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderStoresKeySpecifier = ('_id' | 'backgroundColor' | 'boutiqueReferenceKeys' | 'contentfulMetadata' | 'eyewearAvailable' | 'findAStore' | 'heading' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'numberOfStores' | 'sys' | 'type' | PlaceholderStoresKeySpecifier)[];
export type PlaceholderStoresFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	boutiqueReferenceKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	eyewearAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	findAStore?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfStores?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderStoresCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | PlaceholderStoresCollectionKeySpecifier)[];
export type PlaceholderStoresCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderStoresCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | PlaceholderStoresCursorCollectionKeySpecifier)[];
export type PlaceholderStoresCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderStoresLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | PlaceholderStoresLinkingCollectionsKeySpecifier)[];
export type PlaceholderStoresLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderSubtextKeySpecifier = ('json' | 'links' | PlaceholderSubtextKeySpecifier)[];
export type PlaceholderSubtextFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderSubtextAssetsKeySpecifier = ('block' | 'hyperlink' | PlaceholderSubtextAssetsKeySpecifier)[];
export type PlaceholderSubtextAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderSubtextEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | PlaceholderSubtextEntriesKeySpecifier)[];
export type PlaceholderSubtextEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderSubtextLinksKeySpecifier = ('assets' | 'entries' | 'resources' | PlaceholderSubtextLinksKeySpecifier)[];
export type PlaceholderSubtextLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderSubtextResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | PlaceholderSubtextResourcesKeySpecifier)[];
export type PlaceholderSubtextResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderSubtextResourcesBlockKeySpecifier = ('sys' | PlaceholderSubtextResourcesBlockKeySpecifier)[];
export type PlaceholderSubtextResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderSubtextResourcesHyperlinkKeySpecifier = ('sys' | PlaceholderSubtextResourcesHyperlinkKeySpecifier)[];
export type PlaceholderSubtextResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceholderSubtextResourcesInlineKeySpecifier = ('sys' | PlaceholderSubtextResourcesInlineKeySpecifier)[];
export type PlaceholderSubtextResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCardKeySpecifier = ('_id' | 'backgroundColor' | 'contentfulMetadata' | 'hoverStyle' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'product' | 'showCta' | 'showLabel' | 'showPrice' | 'showShare' | 'showWishlist' | 'sku' | 'sys' | 'type' | 'variant' | ProductCardKeySpecifier)[];
export type ProductCardFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	hoverStyle?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	showCta?: FieldPolicy<any> | FieldReadFunction<any>,
	showLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	showPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	showShare?: FieldPolicy<any> | FieldReadFunction<any>,
	showWishlist?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCardCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ProductCardCollectionKeySpecifier)[];
export type ProductCardCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCardCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ProductCardCursorCollectionKeySpecifier)[];
export type ProductCardCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCardLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'contentGroupCollection' | 'contentGroupCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'gridCollection' | 'gridCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | ProductCardLinkingCollectionsKeySpecifier)[];
export type ProductCardLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('_node' | '_nodes' | 'alertBanner' | 'alertBannerCollection' | 'alertBannerCursorCollection' | 'asset' | 'assetCollection' | 'assetCursorCollection' | 'automaticCollectionGroup' | 'automaticCollectionGroupCollection' | 'automaticCollectionGroupCursorCollection' | 'banner' | 'bannerCollection' | 'bannerCursorCollection' | 'bannerHero' | 'bannerHeroCollection' | 'bannerHeroCursorCollection' | 'breadcrumb' | 'breadcrumbCollection' | 'breadcrumbCursorCollection' | 'card' | 'cardCollection' | 'cardCursorCollection' | 'collectionGroup' | 'collectionGroupCollection' | 'collectionGroupCursorCollection' | 'collectionGroupEndImage' | 'collectionGroupEndImageCollection' | 'collectionGroupEndImageCursorCollection' | 'collectionItem' | 'collectionItemCollection' | 'collectionItemCursorCollection' | 'conditionalComponent' | 'conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'contactUs' | 'contactUsCollection' | 'contactUsCursorCollection' | 'contentGroup' | 'contentGroupCollection' | 'contentGroupCursorCollection' | 'defaultLayout' | 'defaultLayoutCollection' | 'defaultLayoutCursorCollection' | 'detailPage' | 'detailPageCollection' | 'detailPageCursorCollection' | 'dictionary' | 'dictionaryCollection' | 'dictionaryCursorCollection' | 'dictionaryItem' | 'dictionaryItemCollection' | 'dictionaryItemCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'event' | 'eventCollection' | 'eventCursorCollection' | 'exhibitionItem' | 'exhibitionItemCollection' | 'exhibitionItemCursorCollection' | 'exhibitionList' | 'exhibitionListCollection' | 'exhibitionListCursorCollection' | 'faqCategories' | 'faqCategoriesCollection' | 'faqCategoriesCursorCollection' | 'faqItem' | 'faqItemCollection' | 'faqItemCursorCollection' | 'faqWrap' | 'faqWrapCollection' | 'faqWrapCursorCollection' | 'findAStore' | 'findAStoreCollection' | 'findAStoreCursorCollection' | 'footer' | 'footerCollection' | 'footerCursorCollection' | 'freeTextContent' | 'freeTextContentCollection' | 'freeTextContentCursorCollection' | 'grid' | 'gridCollection' | 'gridCursorCollection' | 'heading' | 'headingCollection' | 'headingCursorCollection' | 'heroProductListing' | 'heroProductListingCollection' | 'heroProductListingCursorCollection' | 'heroSlider' | 'heroSliderCollection' | 'heroSliderCursorCollection' | 'iframe' | 'iframeCollection' | 'iframeCursorCollection' | 'imageWithFocalPoint' | 'imageWithFocalPointCollection' | 'imageWithFocalPointCursorCollection' | 'listingPage' | 'listingPageCollection' | 'listingPageCursorCollection' | 'mainHeader' | 'mainHeaderCollection' | 'mainHeaderCursorCollection' | 'mainMenuItem' | 'mainMenuItemCollection' | 'mainMenuItemCursorCollection' | 'manualCollectionGroupProductReferences' | 'manualCollectionGroupProductReferencesCollection' | 'manualCollectionGroupProductReferencesCursorCollection' | 'megaMenu' | 'megaMenuCollection' | 'megaMenuCursorCollection' | 'navQuickLinkItem' | 'navQuickLinkItemCollection' | 'navQuickLinkItemCursorCollection' | 'navQuickLinks' | 'navQuickLinksCollection' | 'navQuickLinksCursorCollection' | 'navQuickLinksWithBanner' | 'navQuickLinksWithBannerCollection' | 'navQuickLinksWithBannerCursorCollection' | 'page' | 'pageBoutiqueDetail' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | 'pageBoutiqueList' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaq' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | 'pageFixed' | 'pageFixedCollection' | 'pageFixedCursorCollection' | 'placeholder' | 'placeholderBoutiqueDetail' | 'placeholderBoutiqueDetailCollection' | 'placeholderBoutiqueDetailCursorCollection' | 'placeholderCheckoutPayments' | 'placeholderCheckoutPaymentsCollection' | 'placeholderCheckoutPaymentsCursorCollection' | 'placeholderCollection' | 'placeholderCursorCollection' | 'placeholderHeader' | 'placeholderHeaderCollection' | 'placeholderHeaderCursorCollection' | 'placeholderModelStory' | 'placeholderModelStoryCollection' | 'placeholderModelStoryCursorCollection' | 'placeholderProductDetails' | 'placeholderProductDetailsCollection' | 'placeholderProductDetailsCursorCollection' | 'placeholderService' | 'placeholderServiceCollection' | 'placeholderServiceCursorCollection' | 'placeholderStores' | 'placeholderStoresCollection' | 'placeholderStoresCursorCollection' | 'productCard' | 'productCardCollection' | 'productCardCursorCollection' | 'scrollerItem' | 'scrollerItemCollection' | 'scrollerItemCursorCollection' | 'searchOverlay' | 'searchOverlayCollection' | 'searchOverlayCursorCollection' | 'selector' | 'selectorCollection' | 'selectorCursorCollection' | 'selectorLink' | 'selectorLinkCollection' | 'selectorLinkCursorCollection' | 'seoConfiguration' | 'seoConfigurationCollection' | 'seoConfigurationCursorCollection' | 'serviceItem' | 'serviceItemCollection' | 'serviceItemCursorCollection' | 'servicePerk' | 'servicePerkCollection' | 'servicePerkCursorCollection' | 'servicesCollection' | 'servicesCollectionCollection' | 'servicesCollectionCursorCollection' | 'simpleFooter' | 'simpleFooterCollection' | 'simpleFooterCursorCollection' | 'sliderProductsAutomatic' | 'sliderProductsAutomaticCollection' | 'sliderProductsAutomaticCursorCollection' | 'sliderProductsManual' | 'sliderProductsManualCollection' | 'sliderProductsManualCursorCollection' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	_node?: FieldPolicy<any> | FieldReadFunction<any>,
	_nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	alertBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	alertBannerCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	alertBannerCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	assetCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	assetCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticCollectionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticCollectionGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticCollectionGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	banner?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerHero?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerHeroCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerHeroCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	breadcrumb?: FieldPolicy<any> | FieldReadFunction<any>,
	breadcrumbCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	breadcrumbCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	card?: FieldPolicy<any> | FieldReadFunction<any>,
	cardCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	cardCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupEndImage?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupEndImageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionGroupEndImageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionItem?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponent?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contactUs?: FieldPolicy<any> | FieldReadFunction<any>,
	contactUsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contactUsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentGroupCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLayoutCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLayoutCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPage?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionary?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionaryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionaryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionaryItem?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionaryItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionaryItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	eventCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionItem?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionList?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	exhibitionListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	faqCategoriesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqCategoriesCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqItem?: FieldPolicy<any> | FieldReadFunction<any>,
	faqItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqWrap?: FieldPolicy<any> | FieldReadFunction<any>,
	faqWrapCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	faqWrapCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	findAStore?: FieldPolicy<any> | FieldReadFunction<any>,
	findAStoreCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	findAStoreCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	footer?: FieldPolicy<any> | FieldReadFunction<any>,
	footerCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	footerCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	freeTextContent?: FieldPolicy<any> | FieldReadFunction<any>,
	freeTextContentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	freeTextContentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	grid?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	headingCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	headingCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroProductListing?: FieldPolicy<any> | FieldReadFunction<any>,
	heroProductListingCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroProductListingCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroSlider?: FieldPolicy<any> | FieldReadFunction<any>,
	heroSliderCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	heroSliderCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	iframe?: FieldPolicy<any> | FieldReadFunction<any>,
	iframeCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	iframeCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	imageWithFocalPoint?: FieldPolicy<any> | FieldReadFunction<any>,
	imageWithFocalPointCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	imageWithFocalPointCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPage?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeaderCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainHeaderCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainMenuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	mainMenuItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainMenuItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	manualCollectionGroupProductReferences?: FieldPolicy<any> | FieldReadFunction<any>,
	manualCollectionGroupProductReferencesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	manualCollectionGroupProductReferencesCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	megaMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	megaMenuCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	megaMenuCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinkItem?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinkItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinkItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksWithBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksWithBannerCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	navQuickLinksWithBannerCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueList?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaq?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixed?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholder?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderBoutiqueDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderCheckoutPayments?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderCheckoutPaymentsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderCheckoutPaymentsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderHeaderCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderHeaderCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderModelStory?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderModelStoryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderModelStoryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderProductDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderProductDetailsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderProductDetailsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderService?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderServiceCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderServiceCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderStores?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderStoresCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderStoresCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	productCard?: FieldPolicy<any> | FieldReadFunction<any>,
	productCardCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	productCardCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	scrollerItem?: FieldPolicy<any> | FieldReadFunction<any>,
	scrollerItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	scrollerItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	searchOverlay?: FieldPolicy<any> | FieldReadFunction<any>,
	searchOverlayCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	searchOverlayCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	selector?: FieldPolicy<any> | FieldReadFunction<any>,
	selectorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	selectorCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	selectorLink?: FieldPolicy<any> | FieldReadFunction<any>,
	selectorLinkCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	selectorLinkCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	seoConfigurationCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceItem?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePerk?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePerkCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	servicePerkCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesCollectionCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesCollectionCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleFooter?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleFooterCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	simpleFooterCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsAutomatic?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsAutomaticCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsAutomaticCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsManual?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsManualCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sliderProductsManualCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResourceLinkKeySpecifier = ('sys' | ResourceLinkKeySpecifier)[];
export type ResourceLinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResourceSysKeySpecifier = ('linkType' | 'urn' | ResourceSysKeySpecifier)[];
export type ResourceSysFieldPolicy = {
	linkType?: FieldPolicy<any> | FieldReadFunction<any>,
	urn?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScrollerItemKeySpecifier = ('_id' | 'contentfulMetadata' | 'image' | 'internalName' | 'label' | 'linkedFrom' | 'localizationConfiguration' | 'openUrlInNewTab' | 'sys' | 'url' | 'visibleInDesktop' | 'visibleInMobile' | ScrollerItemKeySpecifier)[];
export type ScrollerItemFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	openUrlInNewTab?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInMobile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScrollerItemCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ScrollerItemCollectionKeySpecifier)[];
export type ScrollerItemCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScrollerItemCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ScrollerItemCursorCollectionKeySpecifier)[];
export type ScrollerItemCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScrollerItemLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'mainMenuItemCollection' | 'mainMenuItemCursorCollection' | ScrollerItemLinkingCollectionsKeySpecifier)[];
export type ScrollerItemLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainMenuItemCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	mainMenuItemCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchOverlayKeySpecifier = ('_id' | 'contentfulMetadata' | 'displayRetailers' | 'linkedFrom' | 'localizationConfiguration' | 'noResultsContentCollection' | 'noResultsContentCursorCollection' | 'searchBox' | 'sys' | 'title' | 'type' | SearchOverlayKeySpecifier)[];
export type SearchOverlayFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	displayRetailers?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	noResultsContentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	noResultsContentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	searchBox?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchOverlayCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | SearchOverlayCollectionKeySpecifier)[];
export type SearchOverlayCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchOverlayCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | SearchOverlayCursorCollectionKeySpecifier)[];
export type SearchOverlayCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchOverlayLinkingCollectionsKeySpecifier = ('defaultLayoutCollection' | 'defaultLayoutCursorCollection' | 'entryCollection' | 'entryCursorCollection' | SearchOverlayLinkingCollectionsKeySpecifier)[];
export type SearchOverlayLinkingCollectionsFieldPolicy = {
	defaultLayoutCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLayoutCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchOverlayNoResultsContentCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | SearchOverlayNoResultsContentCollectionKeySpecifier)[];
export type SearchOverlayNoResultsContentCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchOverlayNoResultsContentCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | SearchOverlayNoResultsContentCursorCollectionKeySpecifier)[];
export type SearchOverlayNoResultsContentCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectorKeySpecifier = ('_id' | 'contentfulMetadata' | 'linkedFrom' | 'linksCollection' | 'linksCursorCollection' | 'marketingPartner' | 'name' | 'sys' | 'title' | SelectorKeySpecifier)[];
export type SelectorFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	linksCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	linksCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	marketingPartner?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectorCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | SelectorCollectionKeySpecifier)[];
export type SelectorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectorCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | SelectorCursorCollectionKeySpecifier)[];
export type SelectorCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectorLinkKeySpecifier = ('_id' | 'contentfulMetadata' | 'image' | 'linkedFrom' | 'reference' | 'slug' | 'sys' | 'text' | SelectorLinkKeySpecifier)[];
export type SelectorLinkFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectorLinkCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | SelectorLinkCollectionKeySpecifier)[];
export type SelectorLinkCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectorLinkCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | SelectorLinkCursorCollectionKeySpecifier)[];
export type SelectorLinkCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectorLinkLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'selectorCollection' | 'selectorCursorCollection' | SelectorLinkLinkingCollectionsKeySpecifier)[];
export type SelectorLinkLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	selectorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	selectorCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectorLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | SelectorLinkingCollectionsKeySpecifier)[];
export type SelectorLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectorLinksCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | SelectorLinksCollectionKeySpecifier)[];
export type SelectorLinksCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectorLinksCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | SelectorLinksCursorCollectionKeySpecifier)[];
export type SelectorLinksCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SeoConfigurationKeySpecifier = ('_id' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'seoCanonical' | 'seoDescription' | 'seoIndex' | 'seoThumbnail' | 'seoTitle' | 'sys' | SeoConfigurationKeySpecifier)[];
export type SeoConfigurationFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	seoCanonical?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoIndex?: FieldPolicy<any> | FieldReadFunction<any>,
	seoThumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SeoConfigurationCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | SeoConfigurationCollectionKeySpecifier)[];
export type SeoConfigurationCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SeoConfigurationCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | SeoConfigurationCursorCollectionKeySpecifier)[];
export type SeoConfigurationCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SeoConfigurationLinkingCollectionsKeySpecifier = ('detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageExhibitionHistoriesFaqCollection' | 'pageExhibitionHistoriesFaqCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | SeoConfigurationLinkingCollectionsKeySpecifier)[];
export type SeoConfigurationLinkingCollectionsFieldPolicy = {
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageExhibitionHistoriesFaqCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServiceItemKeySpecifier = ('_id' | 'contentfulMetadata' | 'heading' | 'id' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'media' | 'sys' | 'url' | ServiceItemKeySpecifier)[];
export type ServiceItemFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServiceItemCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ServiceItemCollectionKeySpecifier)[];
export type ServiceItemCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServiceItemCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ServiceItemCursorCollectionKeySpecifier)[];
export type ServiceItemCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServiceItemLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'servicesCollectionCollection' | 'servicesCollectionCursorCollection' | ServiceItemLinkingCollectionsKeySpecifier)[];
export type ServiceItemLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesCollectionCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesCollectionCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkKeySpecifier = ('_id' | 'contentfulMetadata' | 'heading' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'modalText' | 'sys' | 'type' | 'url' | ServicePerkKeySpecifier)[];
export type ServicePerkFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	modalText?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ServicePerkCollectionKeySpecifier)[];
export type ServicePerkCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ServicePerkCursorCollectionKeySpecifier)[];
export type ServicePerkCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'placeholderProductDetailsCollection' | 'placeholderProductDetailsCursorCollection' | ServicePerkLinkingCollectionsKeySpecifier)[];
export type ServicePerkLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderProductDetailsCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholderProductDetailsCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkModalTextKeySpecifier = ('json' | 'links' | ServicePerkModalTextKeySpecifier)[];
export type ServicePerkModalTextFieldPolicy = {
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkModalTextAssetsKeySpecifier = ('block' | 'hyperlink' | ServicePerkModalTextAssetsKeySpecifier)[];
export type ServicePerkModalTextAssetsFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkModalTextEntriesKeySpecifier = ('block' | 'hyperlink' | 'inline' | ServicePerkModalTextEntriesKeySpecifier)[];
export type ServicePerkModalTextEntriesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkModalTextLinksKeySpecifier = ('assets' | 'entries' | 'resources' | ServicePerkModalTextLinksKeySpecifier)[];
export type ServicePerkModalTextLinksFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkModalTextResourcesKeySpecifier = ('block' | 'hyperlink' | 'inline' | ServicePerkModalTextResourcesKeySpecifier)[];
export type ServicePerkModalTextResourcesFieldPolicy = {
	block?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperlink?: FieldPolicy<any> | FieldReadFunction<any>,
	inline?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkModalTextResourcesBlockKeySpecifier = ('sys' | ServicePerkModalTextResourcesBlockKeySpecifier)[];
export type ServicePerkModalTextResourcesBlockFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkModalTextResourcesHyperlinkKeySpecifier = ('sys' | ServicePerkModalTextResourcesHyperlinkKeySpecifier)[];
export type ServicePerkModalTextResourcesHyperlinkFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePerkModalTextResourcesInlineKeySpecifier = ('sys' | ServicePerkModalTextResourcesInlineKeySpecifier)[];
export type ServicePerkModalTextResourcesInlineFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicesCollectionKeySpecifier = ('_id' | 'contentfulMetadata' | 'headline' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'servicesCollection' | 'servicesCursorCollection' | 'sys' | ServicesCollectionKeySpecifier)[];
export type ServicesCollectionFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	headline?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicesCollectionCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ServicesCollectionCollectionKeySpecifier)[];
export type ServicesCollectionCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicesCollectionCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ServicesCollectionCursorCollectionKeySpecifier)[];
export type ServicesCollectionCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicesCollectionLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | ServicesCollectionLinkingCollectionsKeySpecifier)[];
export type ServicesCollectionLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicesCollectionServicesCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | ServicesCollectionServicesCollectionKeySpecifier)[];
export type ServicesCollectionServicesCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicesCollectionServicesCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | ServicesCollectionServicesCursorCollectionKeySpecifier)[];
export type ServicesCollectionServicesCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SimpleFooterKeySpecifier = ('_id' | 'background' | 'contentfulMetadata' | 'cta' | 'description' | 'linkedFrom' | 'sys' | 'title' | SimpleFooterKeySpecifier)[];
export type SimpleFooterFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	background?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	cta?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SimpleFooterCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | SimpleFooterCollectionKeySpecifier)[];
export type SimpleFooterCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SimpleFooterCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | SimpleFooterCursorCollectionKeySpecifier)[];
export type SimpleFooterCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SimpleFooterLinkingCollectionsKeySpecifier = ('entryCollection' | 'entryCursorCollection' | 'pageCollection' | 'pageCursorCollection' | SimpleFooterLinkingCollectionsKeySpecifier)[];
export type SimpleFooterLinkingCollectionsFieldPolicy = {
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SliderProductsAutomaticKeySpecifier = ('_id' | 'backgroundColor' | 'backgroundImage' | 'contentfulMetadata' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'productCardBackgroundColor' | 'showCta' | 'showLabel' | 'showPrice' | 'showWishlist' | 'slidesPerView' | 'sys' | 'title' | 'type' | SliderProductsAutomaticKeySpecifier)[];
export type SliderProductsAutomaticFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	productCardBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	showCta?: FieldPolicy<any> | FieldReadFunction<any>,
	showLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	showPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	showWishlist?: FieldPolicy<any> | FieldReadFunction<any>,
	slidesPerView?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SliderProductsAutomaticCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | SliderProductsAutomaticCollectionKeySpecifier)[];
export type SliderProductsAutomaticCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SliderProductsAutomaticCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | SliderProductsAutomaticCursorCollectionKeySpecifier)[];
export type SliderProductsAutomaticCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SliderProductsAutomaticLinkingCollectionsKeySpecifier = ('detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'searchOverlayCollection' | 'searchOverlayCursorCollection' | SliderProductsAutomaticLinkingCollectionsKeySpecifier)[];
export type SliderProductsAutomaticLinkingCollectionsFieldPolicy = {
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	searchOverlayCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	searchOverlayCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SliderProductsManualKeySpecifier = ('_id' | 'backgroundColor' | 'backgroundImage' | 'contentfulMetadata' | 'ctaAriaLabel' | 'ctaStyle' | 'ctaText' | 'ctaUrl' | 'entryEffect' | 'heading' | 'internalName' | 'linkedFrom' | 'localizationConfiguration' | 'productCardBackgroundColor' | 'products' | 'showCta' | 'showLabel' | 'showName' | 'showPrice' | 'showWishlist' | 'slidesPerView' | 'slidesPerViewForMobile' | 'sys' | 'type' | SliderProductsManualKeySpecifier)[];
export type SliderProductsManualFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	contentfulMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaAriaLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaStyle?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaText?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	entryEffect?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	localizationConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	productCardBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	showCta?: FieldPolicy<any> | FieldReadFunction<any>,
	showLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	showName?: FieldPolicy<any> | FieldReadFunction<any>,
	showPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	showWishlist?: FieldPolicy<any> | FieldReadFunction<any>,
	slidesPerView?: FieldPolicy<any> | FieldReadFunction<any>,
	slidesPerViewForMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SliderProductsManualCollectionKeySpecifier = ('items' | 'limit' | 'skip' | 'total' | SliderProductsManualCollectionKeySpecifier)[];
export type SliderProductsManualCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	skip?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SliderProductsManualCursorCollectionKeySpecifier = ('items' | 'limit' | 'pages' | SliderProductsManualCursorCollectionKeySpecifier)[];
export type SliderProductsManualCursorCollectionFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SliderProductsManualLinkingCollectionsKeySpecifier = ('conditionalComponentCollection' | 'conditionalComponentCursorCollection' | 'detailPageCollection' | 'detailPageCursorCollection' | 'entryCollection' | 'entryCursorCollection' | 'gridCollection' | 'gridCursorCollection' | 'listingPageCollection' | 'listingPageCursorCollection' | 'pageBoutiqueDetailCollection' | 'pageBoutiqueDetailCursorCollection' | 'pageBoutiqueListCollection' | 'pageBoutiqueListCursorCollection' | 'pageCollection' | 'pageCursorCollection' | 'pageFixedCollection' | 'pageFixedCursorCollection' | 'searchOverlayCollection' | 'searchOverlayCursorCollection' | SliderProductsManualLinkingCollectionsKeySpecifier)[];
export type SliderProductsManualLinkingCollectionsFieldPolicy = {
	conditionalComponentCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	conditionalComponentCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	detailPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	gridCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	listingPageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueDetailCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBoutiqueListCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	pageFixedCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	searchOverlayCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	searchOverlayCursorCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SysKeySpecifier = ('environmentId' | 'firstPublishedAt' | 'id' | 'locale' | 'publishedAt' | 'publishedVersion' | 'spaceId' | SysKeySpecifier)[];
export type SysFieldPolicy = {
	environmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	firstPublishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	spaceId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyConceptKeySpecifier = ('id' | TaxonomyConceptKeySpecifier)[];
export type TaxonomyConceptFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type _NodeKeySpecifier = ('_id' | _NodeKeySpecifier)[];
export type _NodeFieldPolicy = {
	_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AlertBanner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerKeySpecifier | (() => undefined | AlertBannerKeySpecifier),
		fields?: AlertBannerFieldPolicy,
	},
	AlertBannerCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerCollectionKeySpecifier | (() => undefined | AlertBannerCollectionKeySpecifier),
		fields?: AlertBannerCollectionFieldPolicy,
	},
	AlertBannerCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerCursorCollectionKeySpecifier | (() => undefined | AlertBannerCursorCollectionKeySpecifier),
		fields?: AlertBannerCursorCollectionFieldPolicy,
	},
	AlertBannerLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerLinkingCollectionsKeySpecifier | (() => undefined | AlertBannerLinkingCollectionsKeySpecifier),
		fields?: AlertBannerLinkingCollectionsFieldPolicy,
	},
	AlertBannerText?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerTextKeySpecifier | (() => undefined | AlertBannerTextKeySpecifier),
		fields?: AlertBannerTextFieldPolicy,
	},
	AlertBannerTextAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerTextAssetsKeySpecifier | (() => undefined | AlertBannerTextAssetsKeySpecifier),
		fields?: AlertBannerTextAssetsFieldPolicy,
	},
	AlertBannerTextEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerTextEntriesKeySpecifier | (() => undefined | AlertBannerTextEntriesKeySpecifier),
		fields?: AlertBannerTextEntriesFieldPolicy,
	},
	AlertBannerTextLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerTextLinksKeySpecifier | (() => undefined | AlertBannerTextLinksKeySpecifier),
		fields?: AlertBannerTextLinksFieldPolicy,
	},
	AlertBannerTextResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerTextResourcesKeySpecifier | (() => undefined | AlertBannerTextResourcesKeySpecifier),
		fields?: AlertBannerTextResourcesFieldPolicy,
	},
	AlertBannerTextResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerTextResourcesBlockKeySpecifier | (() => undefined | AlertBannerTextResourcesBlockKeySpecifier),
		fields?: AlertBannerTextResourcesBlockFieldPolicy,
	},
	AlertBannerTextResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerTextResourcesHyperlinkKeySpecifier | (() => undefined | AlertBannerTextResourcesHyperlinkKeySpecifier),
		fields?: AlertBannerTextResourcesHyperlinkFieldPolicy,
	},
	AlertBannerTextResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AlertBannerTextResourcesInlineKeySpecifier | (() => undefined | AlertBannerTextResourcesInlineKeySpecifier),
		fields?: AlertBannerTextResourcesInlineFieldPolicy,
	},
	Asset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssetKeySpecifier | (() => undefined | AssetKeySpecifier),
		fields?: AssetFieldPolicy,
	},
	AssetCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssetCollectionKeySpecifier | (() => undefined | AssetCollectionKeySpecifier),
		fields?: AssetCollectionFieldPolicy,
	},
	AssetCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssetCursorCollectionKeySpecifier | (() => undefined | AssetCursorCollectionKeySpecifier),
		fields?: AssetCursorCollectionFieldPolicy,
	},
	AssetLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssetLinkingCollectionsKeySpecifier | (() => undefined | AssetLinkingCollectionsKeySpecifier),
		fields?: AssetLinkingCollectionsFieldPolicy,
	},
	AutomaticCollectionGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutomaticCollectionGroupKeySpecifier | (() => undefined | AutomaticCollectionGroupKeySpecifier),
		fields?: AutomaticCollectionGroupFieldPolicy,
	},
	AutomaticCollectionGroupCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutomaticCollectionGroupCollectionKeySpecifier | (() => undefined | AutomaticCollectionGroupCollectionKeySpecifier),
		fields?: AutomaticCollectionGroupCollectionFieldPolicy,
	},
	AutomaticCollectionGroupCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutomaticCollectionGroupCursorCollectionKeySpecifier | (() => undefined | AutomaticCollectionGroupCursorCollectionKeySpecifier),
		fields?: AutomaticCollectionGroupCursorCollectionFieldPolicy,
	},
	AutomaticCollectionGroupLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutomaticCollectionGroupLinkingCollectionsKeySpecifier | (() => undefined | AutomaticCollectionGroupLinkingCollectionsKeySpecifier),
		fields?: AutomaticCollectionGroupLinkingCollectionsFieldPolicy,
	},
	Banner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerKeySpecifier | (() => undefined | BannerKeySpecifier),
		fields?: BannerFieldPolicy,
	},
	BannerCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerCollectionKeySpecifier | (() => undefined | BannerCollectionKeySpecifier),
		fields?: BannerCollectionFieldPolicy,
	},
	BannerCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerCursorCollectionKeySpecifier | (() => undefined | BannerCursorCollectionKeySpecifier),
		fields?: BannerCursorCollectionFieldPolicy,
	},
	BannerHero?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerHeroKeySpecifier | (() => undefined | BannerHeroKeySpecifier),
		fields?: BannerHeroFieldPolicy,
	},
	BannerHeroCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerHeroCollectionKeySpecifier | (() => undefined | BannerHeroCollectionKeySpecifier),
		fields?: BannerHeroCollectionFieldPolicy,
	},
	BannerHeroCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerHeroCursorCollectionKeySpecifier | (() => undefined | BannerHeroCursorCollectionKeySpecifier),
		fields?: BannerHeroCursorCollectionFieldPolicy,
	},
	BannerHeroLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerHeroLinkingCollectionsKeySpecifier | (() => undefined | BannerHeroLinkingCollectionsKeySpecifier),
		fields?: BannerHeroLinkingCollectionsFieldPolicy,
	},
	BannerLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerLinkingCollectionsKeySpecifier | (() => undefined | BannerLinkingCollectionsKeySpecifier),
		fields?: BannerLinkingCollectionsFieldPolicy,
	},
	BannerText?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerTextKeySpecifier | (() => undefined | BannerTextKeySpecifier),
		fields?: BannerTextFieldPolicy,
	},
	BannerTextAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerTextAssetsKeySpecifier | (() => undefined | BannerTextAssetsKeySpecifier),
		fields?: BannerTextAssetsFieldPolicy,
	},
	BannerTextEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerTextEntriesKeySpecifier | (() => undefined | BannerTextEntriesKeySpecifier),
		fields?: BannerTextEntriesFieldPolicy,
	},
	BannerTextLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerTextLinksKeySpecifier | (() => undefined | BannerTextLinksKeySpecifier),
		fields?: BannerTextLinksFieldPolicy,
	},
	BannerTextResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerTextResourcesKeySpecifier | (() => undefined | BannerTextResourcesKeySpecifier),
		fields?: BannerTextResourcesFieldPolicy,
	},
	BannerTextResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerTextResourcesBlockKeySpecifier | (() => undefined | BannerTextResourcesBlockKeySpecifier),
		fields?: BannerTextResourcesBlockFieldPolicy,
	},
	BannerTextResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerTextResourcesHyperlinkKeySpecifier | (() => undefined | BannerTextResourcesHyperlinkKeySpecifier),
		fields?: BannerTextResourcesHyperlinkFieldPolicy,
	},
	BannerTextResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerTextResourcesInlineKeySpecifier | (() => undefined | BannerTextResourcesInlineKeySpecifier),
		fields?: BannerTextResourcesInlineFieldPolicy,
	},
	Breadcrumb?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreadcrumbKeySpecifier | (() => undefined | BreadcrumbKeySpecifier),
		fields?: BreadcrumbFieldPolicy,
	},
	BreadcrumbCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreadcrumbCollectionKeySpecifier | (() => undefined | BreadcrumbCollectionKeySpecifier),
		fields?: BreadcrumbCollectionFieldPolicy,
	},
	BreadcrumbCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreadcrumbCursorCollectionKeySpecifier | (() => undefined | BreadcrumbCursorCollectionKeySpecifier),
		fields?: BreadcrumbCursorCollectionFieldPolicy,
	},
	BreadcrumbLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreadcrumbLinkingCollectionsKeySpecifier | (() => undefined | BreadcrumbLinkingCollectionsKeySpecifier),
		fields?: BreadcrumbLinkingCollectionsFieldPolicy,
	},
	Card?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardKeySpecifier | (() => undefined | CardKeySpecifier),
		fields?: CardFieldPolicy,
	},
	CardCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardCollectionKeySpecifier | (() => undefined | CardCollectionKeySpecifier),
		fields?: CardCollectionFieldPolicy,
	},
	CardCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardCursorCollectionKeySpecifier | (() => undefined | CardCursorCollectionKeySpecifier),
		fields?: CardCursorCollectionFieldPolicy,
	},
	CardLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardLinkingCollectionsKeySpecifier | (() => undefined | CardLinkingCollectionsKeySpecifier),
		fields?: CardLinkingCollectionsFieldPolicy,
	},
	CardText?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardTextKeySpecifier | (() => undefined | CardTextKeySpecifier),
		fields?: CardTextFieldPolicy,
	},
	CardText2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardText2KeySpecifier | (() => undefined | CardText2KeySpecifier),
		fields?: CardText2FieldPolicy,
	},
	CardText2Assets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardText2AssetsKeySpecifier | (() => undefined | CardText2AssetsKeySpecifier),
		fields?: CardText2AssetsFieldPolicy,
	},
	CardText2Entries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardText2EntriesKeySpecifier | (() => undefined | CardText2EntriesKeySpecifier),
		fields?: CardText2EntriesFieldPolicy,
	},
	CardText2Links?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardText2LinksKeySpecifier | (() => undefined | CardText2LinksKeySpecifier),
		fields?: CardText2LinksFieldPolicy,
	},
	CardText2Resources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardText2ResourcesKeySpecifier | (() => undefined | CardText2ResourcesKeySpecifier),
		fields?: CardText2ResourcesFieldPolicy,
	},
	CardText2ResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardText2ResourcesBlockKeySpecifier | (() => undefined | CardText2ResourcesBlockKeySpecifier),
		fields?: CardText2ResourcesBlockFieldPolicy,
	},
	CardText2ResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardText2ResourcesHyperlinkKeySpecifier | (() => undefined | CardText2ResourcesHyperlinkKeySpecifier),
		fields?: CardText2ResourcesHyperlinkFieldPolicy,
	},
	CardText2ResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardText2ResourcesInlineKeySpecifier | (() => undefined | CardText2ResourcesInlineKeySpecifier),
		fields?: CardText2ResourcesInlineFieldPolicy,
	},
	CardTextAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardTextAssetsKeySpecifier | (() => undefined | CardTextAssetsKeySpecifier),
		fields?: CardTextAssetsFieldPolicy,
	},
	CardTextEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardTextEntriesKeySpecifier | (() => undefined | CardTextEntriesKeySpecifier),
		fields?: CardTextEntriesFieldPolicy,
	},
	CardTextLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardTextLinksKeySpecifier | (() => undefined | CardTextLinksKeySpecifier),
		fields?: CardTextLinksFieldPolicy,
	},
	CardTextResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardTextResourcesKeySpecifier | (() => undefined | CardTextResourcesKeySpecifier),
		fields?: CardTextResourcesFieldPolicy,
	},
	CardTextResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardTextResourcesBlockKeySpecifier | (() => undefined | CardTextResourcesBlockKeySpecifier),
		fields?: CardTextResourcesBlockFieldPolicy,
	},
	CardTextResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardTextResourcesHyperlinkKeySpecifier | (() => undefined | CardTextResourcesHyperlinkKeySpecifier),
		fields?: CardTextResourcesHyperlinkFieldPolicy,
	},
	CardTextResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardTextResourcesInlineKeySpecifier | (() => undefined | CardTextResourcesInlineKeySpecifier),
		fields?: CardTextResourcesInlineFieldPolicy,
	},
	CollectionGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionGroupKeySpecifier | (() => undefined | CollectionGroupKeySpecifier),
		fields?: CollectionGroupFieldPolicy,
	},
	CollectionGroupCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionGroupCollectionKeySpecifier | (() => undefined | CollectionGroupCollectionKeySpecifier),
		fields?: CollectionGroupCollectionFieldPolicy,
	},
	CollectionGroupCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionGroupCursorCollectionKeySpecifier | (() => undefined | CollectionGroupCursorCollectionKeySpecifier),
		fields?: CollectionGroupCursorCollectionFieldPolicy,
	},
	CollectionGroupEndImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionGroupEndImageKeySpecifier | (() => undefined | CollectionGroupEndImageKeySpecifier),
		fields?: CollectionGroupEndImageFieldPolicy,
	},
	CollectionGroupEndImageCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionGroupEndImageCollectionKeySpecifier | (() => undefined | CollectionGroupEndImageCollectionKeySpecifier),
		fields?: CollectionGroupEndImageCollectionFieldPolicy,
	},
	CollectionGroupEndImageCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionGroupEndImageCursorCollectionKeySpecifier | (() => undefined | CollectionGroupEndImageCursorCollectionKeySpecifier),
		fields?: CollectionGroupEndImageCursorCollectionFieldPolicy,
	},
	CollectionGroupEndImageLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionGroupEndImageLinkingCollectionsKeySpecifier | (() => undefined | CollectionGroupEndImageLinkingCollectionsKeySpecifier),
		fields?: CollectionGroupEndImageLinkingCollectionsFieldPolicy,
	},
	CollectionGroupLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionGroupLinkingCollectionsKeySpecifier | (() => undefined | CollectionGroupLinkingCollectionsKeySpecifier),
		fields?: CollectionGroupLinkingCollectionsFieldPolicy,
	},
	CollectionItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionItemKeySpecifier | (() => undefined | CollectionItemKeySpecifier),
		fields?: CollectionItemFieldPolicy,
	},
	CollectionItemCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionItemCollectionKeySpecifier | (() => undefined | CollectionItemCollectionKeySpecifier),
		fields?: CollectionItemCollectionFieldPolicy,
	},
	CollectionItemCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionItemCursorCollectionKeySpecifier | (() => undefined | CollectionItemCursorCollectionKeySpecifier),
		fields?: CollectionItemCursorCollectionFieldPolicy,
	},
	CollectionItemLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionItemLinkingCollectionsKeySpecifier | (() => undefined | CollectionItemLinkingCollectionsKeySpecifier),
		fields?: CollectionItemLinkingCollectionsFieldPolicy,
	},
	ConditionalComponent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConditionalComponentKeySpecifier | (() => undefined | ConditionalComponentKeySpecifier),
		fields?: ConditionalComponentFieldPolicy,
	},
	ConditionalComponentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConditionalComponentCollectionKeySpecifier | (() => undefined | ConditionalComponentCollectionKeySpecifier),
		fields?: ConditionalComponentCollectionFieldPolicy,
	},
	ConditionalComponentContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConditionalComponentContentCollectionKeySpecifier | (() => undefined | ConditionalComponentContentCollectionKeySpecifier),
		fields?: ConditionalComponentContentCollectionFieldPolicy,
	},
	ConditionalComponentContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConditionalComponentContentCursorCollectionKeySpecifier | (() => undefined | ConditionalComponentContentCursorCollectionKeySpecifier),
		fields?: ConditionalComponentContentCursorCollectionFieldPolicy,
	},
	ConditionalComponentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConditionalComponentCursorCollectionKeySpecifier | (() => undefined | ConditionalComponentCursorCollectionKeySpecifier),
		fields?: ConditionalComponentCursorCollectionFieldPolicy,
	},
	ConditionalComponentLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConditionalComponentLinkingCollectionsKeySpecifier | (() => undefined | ConditionalComponentLinkingCollectionsKeySpecifier),
		fields?: ConditionalComponentLinkingCollectionsFieldPolicy,
	},
	ContactUs?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactUsKeySpecifier | (() => undefined | ContactUsKeySpecifier),
		fields?: ContactUsFieldPolicy,
	},
	ContactUsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactUsCollectionKeySpecifier | (() => undefined | ContactUsCollectionKeySpecifier),
		fields?: ContactUsCollectionFieldPolicy,
	},
	ContactUsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactUsCursorCollectionKeySpecifier | (() => undefined | ContactUsCursorCollectionKeySpecifier),
		fields?: ContactUsCursorCollectionFieldPolicy,
	},
	ContactUsLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactUsLinkingCollectionsKeySpecifier | (() => undefined | ContactUsLinkingCollectionsKeySpecifier),
		fields?: ContactUsLinkingCollectionsFieldPolicy,
	},
	ContentGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentGroupKeySpecifier | (() => undefined | ContentGroupKeySpecifier),
		fields?: ContentGroupFieldPolicy,
	},
	ContentGroupCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentGroupCollectionKeySpecifier | (() => undefined | ContentGroupCollectionKeySpecifier),
		fields?: ContentGroupCollectionFieldPolicy,
	},
	ContentGroupCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentGroupCursorCollectionKeySpecifier | (() => undefined | ContentGroupCursorCollectionKeySpecifier),
		fields?: ContentGroupCursorCollectionFieldPolicy,
	},
	ContentGroupItemsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentGroupItemsCollectionKeySpecifier | (() => undefined | ContentGroupItemsCollectionKeySpecifier),
		fields?: ContentGroupItemsCollectionFieldPolicy,
	},
	ContentGroupItemsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentGroupItemsCursorCollectionKeySpecifier | (() => undefined | ContentGroupItemsCursorCollectionKeySpecifier),
		fields?: ContentGroupItemsCursorCollectionFieldPolicy,
	},
	ContentGroupLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentGroupLinkingCollectionsKeySpecifier | (() => undefined | ContentGroupLinkingCollectionsKeySpecifier),
		fields?: ContentGroupLinkingCollectionsFieldPolicy,
	},
	ContentfulMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentfulMetadataKeySpecifier | (() => undefined | ContentfulMetadataKeySpecifier),
		fields?: ContentfulMetadataFieldPolicy,
	},
	ContentfulTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentfulTagKeySpecifier | (() => undefined | ContentfulTagKeySpecifier),
		fields?: ContentfulTagFieldPolicy,
	},
	CursorPages?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CursorPagesKeySpecifier | (() => undefined | CursorPagesKeySpecifier),
		fields?: CursorPagesFieldPolicy,
	},
	DefaultLayout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DefaultLayoutKeySpecifier | (() => undefined | DefaultLayoutKeySpecifier),
		fields?: DefaultLayoutFieldPolicy,
	},
	DefaultLayoutCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DefaultLayoutCollectionKeySpecifier | (() => undefined | DefaultLayoutCollectionKeySpecifier),
		fields?: DefaultLayoutCollectionFieldPolicy,
	},
	DefaultLayoutCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DefaultLayoutCursorCollectionKeySpecifier | (() => undefined | DefaultLayoutCursorCollectionKeySpecifier),
		fields?: DefaultLayoutCursorCollectionFieldPolicy,
	},
	DefaultLayoutLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DefaultLayoutLinkingCollectionsKeySpecifier | (() => undefined | DefaultLayoutLinkingCollectionsKeySpecifier),
		fields?: DefaultLayoutLinkingCollectionsFieldPolicy,
	},
	DetailPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DetailPageKeySpecifier | (() => undefined | DetailPageKeySpecifier),
		fields?: DetailPageFieldPolicy,
	},
	DetailPageCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DetailPageCollectionKeySpecifier | (() => undefined | DetailPageCollectionKeySpecifier),
		fields?: DetailPageCollectionFieldPolicy,
	},
	DetailPageContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DetailPageContentCollectionKeySpecifier | (() => undefined | DetailPageContentCollectionKeySpecifier),
		fields?: DetailPageContentCollectionFieldPolicy,
	},
	DetailPageContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DetailPageContentCursorCollectionKeySpecifier | (() => undefined | DetailPageContentCursorCollectionKeySpecifier),
		fields?: DetailPageContentCursorCollectionFieldPolicy,
	},
	DetailPageCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DetailPageCursorCollectionKeySpecifier | (() => undefined | DetailPageCursorCollectionKeySpecifier),
		fields?: DetailPageCursorCollectionFieldPolicy,
	},
	DetailPageLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DetailPageLinkingCollectionsKeySpecifier | (() => undefined | DetailPageLinkingCollectionsKeySpecifier),
		fields?: DetailPageLinkingCollectionsFieldPolicy,
	},
	Dictionary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DictionaryKeySpecifier | (() => undefined | DictionaryKeySpecifier),
		fields?: DictionaryFieldPolicy,
	},
	DictionaryCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DictionaryCollectionKeySpecifier | (() => undefined | DictionaryCollectionKeySpecifier),
		fields?: DictionaryCollectionFieldPolicy,
	},
	DictionaryContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DictionaryContentCollectionKeySpecifier | (() => undefined | DictionaryContentCollectionKeySpecifier),
		fields?: DictionaryContentCollectionFieldPolicy,
	},
	DictionaryContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DictionaryContentCursorCollectionKeySpecifier | (() => undefined | DictionaryContentCursorCollectionKeySpecifier),
		fields?: DictionaryContentCursorCollectionFieldPolicy,
	},
	DictionaryCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DictionaryCursorCollectionKeySpecifier | (() => undefined | DictionaryCursorCollectionKeySpecifier),
		fields?: DictionaryCursorCollectionFieldPolicy,
	},
	DictionaryItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DictionaryItemKeySpecifier | (() => undefined | DictionaryItemKeySpecifier),
		fields?: DictionaryItemFieldPolicy,
	},
	DictionaryItemCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DictionaryItemCollectionKeySpecifier | (() => undefined | DictionaryItemCollectionKeySpecifier),
		fields?: DictionaryItemCollectionFieldPolicy,
	},
	DictionaryItemCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DictionaryItemCursorCollectionKeySpecifier | (() => undefined | DictionaryItemCursorCollectionKeySpecifier),
		fields?: DictionaryItemCursorCollectionFieldPolicy,
	},
	DictionaryItemLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DictionaryItemLinkingCollectionsKeySpecifier | (() => undefined | DictionaryItemLinkingCollectionsKeySpecifier),
		fields?: DictionaryItemLinkingCollectionsFieldPolicy,
	},
	DictionaryLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DictionaryLinkingCollectionsKeySpecifier | (() => undefined | DictionaryLinkingCollectionsKeySpecifier),
		fields?: DictionaryLinkingCollectionsFieldPolicy,
	},
	Entry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntryKeySpecifier | (() => undefined | EntryKeySpecifier),
		fields?: EntryFieldPolicy,
	},
	EntryCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntryCollectionKeySpecifier | (() => undefined | EntryCollectionKeySpecifier),
		fields?: EntryCollectionFieldPolicy,
	},
	EntryCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntryCursorCollectionKeySpecifier | (() => undefined | EntryCursorCollectionKeySpecifier),
		fields?: EntryCursorCollectionFieldPolicy,
	},
	Event?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventKeySpecifier | (() => undefined | EventKeySpecifier),
		fields?: EventFieldPolicy,
	},
	EventCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventCollectionKeySpecifier | (() => undefined | EventCollectionKeySpecifier),
		fields?: EventCollectionFieldPolicy,
	},
	EventCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventCursorCollectionKeySpecifier | (() => undefined | EventCursorCollectionKeySpecifier),
		fields?: EventCursorCollectionFieldPolicy,
	},
	EventDescription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDescriptionKeySpecifier | (() => undefined | EventDescriptionKeySpecifier),
		fields?: EventDescriptionFieldPolicy,
	},
	EventDescriptionAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDescriptionAssetsKeySpecifier | (() => undefined | EventDescriptionAssetsKeySpecifier),
		fields?: EventDescriptionAssetsFieldPolicy,
	},
	EventDescriptionEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDescriptionEntriesKeySpecifier | (() => undefined | EventDescriptionEntriesKeySpecifier),
		fields?: EventDescriptionEntriesFieldPolicy,
	},
	EventDescriptionLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDescriptionLinksKeySpecifier | (() => undefined | EventDescriptionLinksKeySpecifier),
		fields?: EventDescriptionLinksFieldPolicy,
	},
	EventDescriptionResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDescriptionResourcesKeySpecifier | (() => undefined | EventDescriptionResourcesKeySpecifier),
		fields?: EventDescriptionResourcesFieldPolicy,
	},
	EventDescriptionResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDescriptionResourcesBlockKeySpecifier | (() => undefined | EventDescriptionResourcesBlockKeySpecifier),
		fields?: EventDescriptionResourcesBlockFieldPolicy,
	},
	EventDescriptionResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDescriptionResourcesHyperlinkKeySpecifier | (() => undefined | EventDescriptionResourcesHyperlinkKeySpecifier),
		fields?: EventDescriptionResourcesHyperlinkFieldPolicy,
	},
	EventDescriptionResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDescriptionResourcesInlineKeySpecifier | (() => undefined | EventDescriptionResourcesInlineKeySpecifier),
		fields?: EventDescriptionResourcesInlineFieldPolicy,
	},
	EventLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventLinkingCollectionsKeySpecifier | (() => undefined | EventLinkingCollectionsKeySpecifier),
		fields?: EventLinkingCollectionsFieldPolicy,
	},
	ExhibitionItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExhibitionItemKeySpecifier | (() => undefined | ExhibitionItemKeySpecifier),
		fields?: ExhibitionItemFieldPolicy,
	},
	ExhibitionItemCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExhibitionItemCollectionKeySpecifier | (() => undefined | ExhibitionItemCollectionKeySpecifier),
		fields?: ExhibitionItemCollectionFieldPolicy,
	},
	ExhibitionItemCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExhibitionItemCursorCollectionKeySpecifier | (() => undefined | ExhibitionItemCursorCollectionKeySpecifier),
		fields?: ExhibitionItemCursorCollectionFieldPolicy,
	},
	ExhibitionItemLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExhibitionItemLinkingCollectionsKeySpecifier | (() => undefined | ExhibitionItemLinkingCollectionsKeySpecifier),
		fields?: ExhibitionItemLinkingCollectionsFieldPolicy,
	},
	ExhibitionList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExhibitionListKeySpecifier | (() => undefined | ExhibitionListKeySpecifier),
		fields?: ExhibitionListFieldPolicy,
	},
	ExhibitionListCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExhibitionListCollectionKeySpecifier | (() => undefined | ExhibitionListCollectionKeySpecifier),
		fields?: ExhibitionListCollectionFieldPolicy,
	},
	ExhibitionListCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExhibitionListCursorCollectionKeySpecifier | (() => undefined | ExhibitionListCursorCollectionKeySpecifier),
		fields?: ExhibitionListCursorCollectionFieldPolicy,
	},
	ExhibitionListExhibitionItemsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExhibitionListExhibitionItemsCollectionKeySpecifier | (() => undefined | ExhibitionListExhibitionItemsCollectionKeySpecifier),
		fields?: ExhibitionListExhibitionItemsCollectionFieldPolicy,
	},
	ExhibitionListExhibitionItemsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExhibitionListExhibitionItemsCursorCollectionKeySpecifier | (() => undefined | ExhibitionListExhibitionItemsCursorCollectionKeySpecifier),
		fields?: ExhibitionListExhibitionItemsCursorCollectionFieldPolicy,
	},
	ExhibitionListLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExhibitionListLinkingCollectionsKeySpecifier | (() => undefined | ExhibitionListLinkingCollectionsKeySpecifier),
		fields?: ExhibitionListLinkingCollectionsFieldPolicy,
	},
	FaqCategories?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqCategoriesKeySpecifier | (() => undefined | FaqCategoriesKeySpecifier),
		fields?: FaqCategoriesFieldPolicy,
	},
	FaqCategoriesCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqCategoriesCollectionKeySpecifier | (() => undefined | FaqCategoriesCollectionKeySpecifier),
		fields?: FaqCategoriesCollectionFieldPolicy,
	},
	FaqCategoriesCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqCategoriesCursorCollectionKeySpecifier | (() => undefined | FaqCategoriesCursorCollectionKeySpecifier),
		fields?: FaqCategoriesCursorCollectionFieldPolicy,
	},
	FaqCategoriesFaqWrapsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqCategoriesFaqWrapsCollectionKeySpecifier | (() => undefined | FaqCategoriesFaqWrapsCollectionKeySpecifier),
		fields?: FaqCategoriesFaqWrapsCollectionFieldPolicy,
	},
	FaqCategoriesFaqWrapsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqCategoriesFaqWrapsCursorCollectionKeySpecifier | (() => undefined | FaqCategoriesFaqWrapsCursorCollectionKeySpecifier),
		fields?: FaqCategoriesFaqWrapsCursorCollectionFieldPolicy,
	},
	FaqCategoriesLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqCategoriesLinkingCollectionsKeySpecifier | (() => undefined | FaqCategoriesLinkingCollectionsKeySpecifier),
		fields?: FaqCategoriesLinkingCollectionsFieldPolicy,
	},
	FaqItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemKeySpecifier | (() => undefined | FaqItemKeySpecifier),
		fields?: FaqItemFieldPolicy,
	},
	FaqItemCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemCollectionKeySpecifier | (() => undefined | FaqItemCollectionKeySpecifier),
		fields?: FaqItemCollectionFieldPolicy,
	},
	FaqItemCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemCursorCollectionKeySpecifier | (() => undefined | FaqItemCursorCollectionKeySpecifier),
		fields?: FaqItemCursorCollectionFieldPolicy,
	},
	FaqItemFaqAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemFaqAnswerKeySpecifier | (() => undefined | FaqItemFaqAnswerKeySpecifier),
		fields?: FaqItemFaqAnswerFieldPolicy,
	},
	FaqItemFaqAnswerAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemFaqAnswerAssetsKeySpecifier | (() => undefined | FaqItemFaqAnswerAssetsKeySpecifier),
		fields?: FaqItemFaqAnswerAssetsFieldPolicy,
	},
	FaqItemFaqAnswerEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemFaqAnswerEntriesKeySpecifier | (() => undefined | FaqItemFaqAnswerEntriesKeySpecifier),
		fields?: FaqItemFaqAnswerEntriesFieldPolicy,
	},
	FaqItemFaqAnswerLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemFaqAnswerLinksKeySpecifier | (() => undefined | FaqItemFaqAnswerLinksKeySpecifier),
		fields?: FaqItemFaqAnswerLinksFieldPolicy,
	},
	FaqItemFaqAnswerResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemFaqAnswerResourcesKeySpecifier | (() => undefined | FaqItemFaqAnswerResourcesKeySpecifier),
		fields?: FaqItemFaqAnswerResourcesFieldPolicy,
	},
	FaqItemFaqAnswerResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemFaqAnswerResourcesBlockKeySpecifier | (() => undefined | FaqItemFaqAnswerResourcesBlockKeySpecifier),
		fields?: FaqItemFaqAnswerResourcesBlockFieldPolicy,
	},
	FaqItemFaqAnswerResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemFaqAnswerResourcesHyperlinkKeySpecifier | (() => undefined | FaqItemFaqAnswerResourcesHyperlinkKeySpecifier),
		fields?: FaqItemFaqAnswerResourcesHyperlinkFieldPolicy,
	},
	FaqItemFaqAnswerResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemFaqAnswerResourcesInlineKeySpecifier | (() => undefined | FaqItemFaqAnswerResourcesInlineKeySpecifier),
		fields?: FaqItemFaqAnswerResourcesInlineFieldPolicy,
	},
	FaqItemLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqItemLinkingCollectionsKeySpecifier | (() => undefined | FaqItemLinkingCollectionsKeySpecifier),
		fields?: FaqItemLinkingCollectionsFieldPolicy,
	},
	FaqWrap?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqWrapKeySpecifier | (() => undefined | FaqWrapKeySpecifier),
		fields?: FaqWrapFieldPolicy,
	},
	FaqWrapCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqWrapCollectionKeySpecifier | (() => undefined | FaqWrapCollectionKeySpecifier),
		fields?: FaqWrapCollectionFieldPolicy,
	},
	FaqWrapCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqWrapCursorCollectionKeySpecifier | (() => undefined | FaqWrapCursorCollectionKeySpecifier),
		fields?: FaqWrapCursorCollectionFieldPolicy,
	},
	FaqWrapFaqListCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqWrapFaqListCollectionKeySpecifier | (() => undefined | FaqWrapFaqListCollectionKeySpecifier),
		fields?: FaqWrapFaqListCollectionFieldPolicy,
	},
	FaqWrapFaqListCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqWrapFaqListCursorCollectionKeySpecifier | (() => undefined | FaqWrapFaqListCursorCollectionKeySpecifier),
		fields?: FaqWrapFaqListCursorCollectionFieldPolicy,
	},
	FaqWrapLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqWrapLinkingCollectionsKeySpecifier | (() => undefined | FaqWrapLinkingCollectionsKeySpecifier),
		fields?: FaqWrapLinkingCollectionsFieldPolicy,
	},
	FindAStore?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreKeySpecifier | (() => undefined | FindAStoreKeySpecifier),
		fields?: FindAStoreFieldPolicy,
	},
	FindAStoreCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreCollectionKeySpecifier | (() => undefined | FindAStoreCollectionKeySpecifier),
		fields?: FindAStoreCollectionFieldPolicy,
	},
	FindAStoreCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreCursorCollectionKeySpecifier | (() => undefined | FindAStoreCursorCollectionKeySpecifier),
		fields?: FindAStoreCursorCollectionFieldPolicy,
	},
	FindAStoreLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreLinkingCollectionsKeySpecifier | (() => undefined | FindAStoreLinkingCollectionsKeySpecifier),
		fields?: FindAStoreLinkingCollectionsFieldPolicy,
	},
	FindAStoreText?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreTextKeySpecifier | (() => undefined | FindAStoreTextKeySpecifier),
		fields?: FindAStoreTextFieldPolicy,
	},
	FindAStoreTextAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreTextAssetsKeySpecifier | (() => undefined | FindAStoreTextAssetsKeySpecifier),
		fields?: FindAStoreTextAssetsFieldPolicy,
	},
	FindAStoreTextEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreTextEntriesKeySpecifier | (() => undefined | FindAStoreTextEntriesKeySpecifier),
		fields?: FindAStoreTextEntriesFieldPolicy,
	},
	FindAStoreTextLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreTextLinksKeySpecifier | (() => undefined | FindAStoreTextLinksKeySpecifier),
		fields?: FindAStoreTextLinksFieldPolicy,
	},
	FindAStoreTextResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreTextResourcesKeySpecifier | (() => undefined | FindAStoreTextResourcesKeySpecifier),
		fields?: FindAStoreTextResourcesFieldPolicy,
	},
	FindAStoreTextResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreTextResourcesBlockKeySpecifier | (() => undefined | FindAStoreTextResourcesBlockKeySpecifier),
		fields?: FindAStoreTextResourcesBlockFieldPolicy,
	},
	FindAStoreTextResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreTextResourcesHyperlinkKeySpecifier | (() => undefined | FindAStoreTextResourcesHyperlinkKeySpecifier),
		fields?: FindAStoreTextResourcesHyperlinkFieldPolicy,
	},
	FindAStoreTextResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FindAStoreTextResourcesInlineKeySpecifier | (() => undefined | FindAStoreTextResourcesInlineKeySpecifier),
		fields?: FindAStoreTextResourcesInlineFieldPolicy,
	},
	Footer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FooterKeySpecifier | (() => undefined | FooterKeySpecifier),
		fields?: FooterFieldPolicy,
	},
	FooterCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FooterCollectionKeySpecifier | (() => undefined | FooterCollectionKeySpecifier),
		fields?: FooterCollectionFieldPolicy,
	},
	FooterCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FooterCursorCollectionKeySpecifier | (() => undefined | FooterCursorCollectionKeySpecifier),
		fields?: FooterCursorCollectionFieldPolicy,
	},
	FooterLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FooterLinkingCollectionsKeySpecifier | (() => undefined | FooterLinkingCollectionsKeySpecifier),
		fields?: FooterLinkingCollectionsFieldPolicy,
	},
	FooterMenuItemsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FooterMenuItemsCollectionKeySpecifier | (() => undefined | FooterMenuItemsCollectionKeySpecifier),
		fields?: FooterMenuItemsCollectionFieldPolicy,
	},
	FooterMenuItemsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FooterMenuItemsCursorCollectionKeySpecifier | (() => undefined | FooterMenuItemsCursorCollectionKeySpecifier),
		fields?: FooterMenuItemsCursorCollectionFieldPolicy,
	},
	FooterSecondaryMenuItemsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FooterSecondaryMenuItemsCollectionKeySpecifier | (() => undefined | FooterSecondaryMenuItemsCollectionKeySpecifier),
		fields?: FooterSecondaryMenuItemsCollectionFieldPolicy,
	},
	FooterSecondaryMenuItemsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FooterSecondaryMenuItemsCursorCollectionKeySpecifier | (() => undefined | FooterSecondaryMenuItemsCursorCollectionKeySpecifier),
		fields?: FooterSecondaryMenuItemsCursorCollectionFieldPolicy,
	},
	FreeTextContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentKeySpecifier | (() => undefined | FreeTextContentKeySpecifier),
		fields?: FreeTextContentFieldPolicy,
	},
	FreeTextContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentCollectionKeySpecifier | (() => undefined | FreeTextContentCollectionKeySpecifier),
		fields?: FreeTextContentCollectionFieldPolicy,
	},
	FreeTextContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentCursorCollectionKeySpecifier | (() => undefined | FreeTextContentCursorCollectionKeySpecifier),
		fields?: FreeTextContentCursorCollectionFieldPolicy,
	},
	FreeTextContentLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentLinkingCollectionsKeySpecifier | (() => undefined | FreeTextContentLinkingCollectionsKeySpecifier),
		fields?: FreeTextContentLinkingCollectionsFieldPolicy,
	},
	FreeTextContentTextContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentTextContentKeySpecifier | (() => undefined | FreeTextContentTextContentKeySpecifier),
		fields?: FreeTextContentTextContentFieldPolicy,
	},
	FreeTextContentTextContentAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentTextContentAssetsKeySpecifier | (() => undefined | FreeTextContentTextContentAssetsKeySpecifier),
		fields?: FreeTextContentTextContentAssetsFieldPolicy,
	},
	FreeTextContentTextContentEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentTextContentEntriesKeySpecifier | (() => undefined | FreeTextContentTextContentEntriesKeySpecifier),
		fields?: FreeTextContentTextContentEntriesFieldPolicy,
	},
	FreeTextContentTextContentLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentTextContentLinksKeySpecifier | (() => undefined | FreeTextContentTextContentLinksKeySpecifier),
		fields?: FreeTextContentTextContentLinksFieldPolicy,
	},
	FreeTextContentTextContentResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentTextContentResourcesKeySpecifier | (() => undefined | FreeTextContentTextContentResourcesKeySpecifier),
		fields?: FreeTextContentTextContentResourcesFieldPolicy,
	},
	FreeTextContentTextContentResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentTextContentResourcesBlockKeySpecifier | (() => undefined | FreeTextContentTextContentResourcesBlockKeySpecifier),
		fields?: FreeTextContentTextContentResourcesBlockFieldPolicy,
	},
	FreeTextContentTextContentResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentTextContentResourcesHyperlinkKeySpecifier | (() => undefined | FreeTextContentTextContentResourcesHyperlinkKeySpecifier),
		fields?: FreeTextContentTextContentResourcesHyperlinkFieldPolicy,
	},
	FreeTextContentTextContentResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeTextContentTextContentResourcesInlineKeySpecifier | (() => undefined | FreeTextContentTextContentResourcesInlineKeySpecifier),
		fields?: FreeTextContentTextContentResourcesInlineFieldPolicy,
	},
	Grid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GridKeySpecifier | (() => undefined | GridKeySpecifier),
		fields?: GridFieldPolicy,
	},
	GridCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GridCollectionKeySpecifier | (() => undefined | GridCollectionKeySpecifier),
		fields?: GridCollectionFieldPolicy,
	},
	GridContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GridContentCollectionKeySpecifier | (() => undefined | GridContentCollectionKeySpecifier),
		fields?: GridContentCollectionFieldPolicy,
	},
	GridContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GridContentCursorCollectionKeySpecifier | (() => undefined | GridContentCursorCollectionKeySpecifier),
		fields?: GridContentCursorCollectionFieldPolicy,
	},
	GridCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GridCursorCollectionKeySpecifier | (() => undefined | GridCursorCollectionKeySpecifier),
		fields?: GridCursorCollectionFieldPolicy,
	},
	GridLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GridLinkingCollectionsKeySpecifier | (() => undefined | GridLinkingCollectionsKeySpecifier),
		fields?: GridLinkingCollectionsFieldPolicy,
	},
	Heading?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeadingKeySpecifier | (() => undefined | HeadingKeySpecifier),
		fields?: HeadingFieldPolicy,
	},
	HeadingCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeadingCollectionKeySpecifier | (() => undefined | HeadingCollectionKeySpecifier),
		fields?: HeadingCollectionFieldPolicy,
	},
	HeadingCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeadingCursorCollectionKeySpecifier | (() => undefined | HeadingCursorCollectionKeySpecifier),
		fields?: HeadingCursorCollectionFieldPolicy,
	},
	HeadingLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeadingLinkingCollectionsKeySpecifier | (() => undefined | HeadingLinkingCollectionsKeySpecifier),
		fields?: HeadingLinkingCollectionsFieldPolicy,
	},
	HeroProductListing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingKeySpecifier | (() => undefined | HeroProductListingKeySpecifier),
		fields?: HeroProductListingFieldPolicy,
	},
	HeroProductListingCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingCollectionKeySpecifier | (() => undefined | HeroProductListingCollectionKeySpecifier),
		fields?: HeroProductListingCollectionFieldPolicy,
	},
	HeroProductListingCollectionItemsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingCollectionItemsCollectionKeySpecifier | (() => undefined | HeroProductListingCollectionItemsCollectionKeySpecifier),
		fields?: HeroProductListingCollectionItemsCollectionFieldPolicy,
	},
	HeroProductListingCollectionItemsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingCollectionItemsCursorCollectionKeySpecifier | (() => undefined | HeroProductListingCollectionItemsCursorCollectionKeySpecifier),
		fields?: HeroProductListingCollectionItemsCursorCollectionFieldPolicy,
	},
	HeroProductListingCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingCursorCollectionKeySpecifier | (() => undefined | HeroProductListingCursorCollectionKeySpecifier),
		fields?: HeroProductListingCursorCollectionFieldPolicy,
	},
	HeroProductListingLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingLinkingCollectionsKeySpecifier | (() => undefined | HeroProductListingLinkingCollectionsKeySpecifier),
		fields?: HeroProductListingLinkingCollectionsFieldPolicy,
	},
	HeroProductListingText?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingTextKeySpecifier | (() => undefined | HeroProductListingTextKeySpecifier),
		fields?: HeroProductListingTextFieldPolicy,
	},
	HeroProductListingTextAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingTextAssetsKeySpecifier | (() => undefined | HeroProductListingTextAssetsKeySpecifier),
		fields?: HeroProductListingTextAssetsFieldPolicy,
	},
	HeroProductListingTextEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingTextEntriesKeySpecifier | (() => undefined | HeroProductListingTextEntriesKeySpecifier),
		fields?: HeroProductListingTextEntriesFieldPolicy,
	},
	HeroProductListingTextLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingTextLinksKeySpecifier | (() => undefined | HeroProductListingTextLinksKeySpecifier),
		fields?: HeroProductListingTextLinksFieldPolicy,
	},
	HeroProductListingTextResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingTextResourcesKeySpecifier | (() => undefined | HeroProductListingTextResourcesKeySpecifier),
		fields?: HeroProductListingTextResourcesFieldPolicy,
	},
	HeroProductListingTextResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingTextResourcesBlockKeySpecifier | (() => undefined | HeroProductListingTextResourcesBlockKeySpecifier),
		fields?: HeroProductListingTextResourcesBlockFieldPolicy,
	},
	HeroProductListingTextResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingTextResourcesHyperlinkKeySpecifier | (() => undefined | HeroProductListingTextResourcesHyperlinkKeySpecifier),
		fields?: HeroProductListingTextResourcesHyperlinkFieldPolicy,
	},
	HeroProductListingTextResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroProductListingTextResourcesInlineKeySpecifier | (() => undefined | HeroProductListingTextResourcesInlineKeySpecifier),
		fields?: HeroProductListingTextResourcesInlineFieldPolicy,
	},
	HeroSlider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroSliderKeySpecifier | (() => undefined | HeroSliderKeySpecifier),
		fields?: HeroSliderFieldPolicy,
	},
	HeroSliderCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroSliderCollectionKeySpecifier | (() => undefined | HeroSliderCollectionKeySpecifier),
		fields?: HeroSliderCollectionFieldPolicy,
	},
	HeroSliderCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroSliderCursorCollectionKeySpecifier | (() => undefined | HeroSliderCursorCollectionKeySpecifier),
		fields?: HeroSliderCursorCollectionFieldPolicy,
	},
	HeroSliderLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroSliderLinkingCollectionsKeySpecifier | (() => undefined | HeroSliderLinkingCollectionsKeySpecifier),
		fields?: HeroSliderLinkingCollectionsFieldPolicy,
	},
	HeroSliderSlidesCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroSliderSlidesCollectionKeySpecifier | (() => undefined | HeroSliderSlidesCollectionKeySpecifier),
		fields?: HeroSliderSlidesCollectionFieldPolicy,
	},
	HeroSliderSlidesCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeroSliderSlidesCursorCollectionKeySpecifier | (() => undefined | HeroSliderSlidesCursorCollectionKeySpecifier),
		fields?: HeroSliderSlidesCursorCollectionFieldPolicy,
	},
	Iframe?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IframeKeySpecifier | (() => undefined | IframeKeySpecifier),
		fields?: IframeFieldPolicy,
	},
	IframeCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IframeCollectionKeySpecifier | (() => undefined | IframeCollectionKeySpecifier),
		fields?: IframeCollectionFieldPolicy,
	},
	IframeCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IframeCursorCollectionKeySpecifier | (() => undefined | IframeCursorCollectionKeySpecifier),
		fields?: IframeCursorCollectionFieldPolicy,
	},
	IframeLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IframeLinkingCollectionsKeySpecifier | (() => undefined | IframeLinkingCollectionsKeySpecifier),
		fields?: IframeLinkingCollectionsFieldPolicy,
	},
	ImageWithFocalPoint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageWithFocalPointKeySpecifier | (() => undefined | ImageWithFocalPointKeySpecifier),
		fields?: ImageWithFocalPointFieldPolicy,
	},
	ImageWithFocalPointCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageWithFocalPointCollectionKeySpecifier | (() => undefined | ImageWithFocalPointCollectionKeySpecifier),
		fields?: ImageWithFocalPointCollectionFieldPolicy,
	},
	ImageWithFocalPointCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageWithFocalPointCursorCollectionKeySpecifier | (() => undefined | ImageWithFocalPointCursorCollectionKeySpecifier),
		fields?: ImageWithFocalPointCursorCollectionFieldPolicy,
	},
	ImageWithFocalPointLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageWithFocalPointLinkingCollectionsKeySpecifier | (() => undefined | ImageWithFocalPointLinkingCollectionsKeySpecifier),
		fields?: ImageWithFocalPointLinkingCollectionsFieldPolicy,
	},
	ListingPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ListingPageKeySpecifier | (() => undefined | ListingPageKeySpecifier),
		fields?: ListingPageFieldPolicy,
	},
	ListingPageCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ListingPageCollectionKeySpecifier | (() => undefined | ListingPageCollectionKeySpecifier),
		fields?: ListingPageCollectionFieldPolicy,
	},
	ListingPageContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ListingPageContentCollectionKeySpecifier | (() => undefined | ListingPageContentCollectionKeySpecifier),
		fields?: ListingPageContentCollectionFieldPolicy,
	},
	ListingPageContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ListingPageContentCursorCollectionKeySpecifier | (() => undefined | ListingPageContentCursorCollectionKeySpecifier),
		fields?: ListingPageContentCursorCollectionFieldPolicy,
	},
	ListingPageCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ListingPageCursorCollectionKeySpecifier | (() => undefined | ListingPageCursorCollectionKeySpecifier),
		fields?: ListingPageCursorCollectionFieldPolicy,
	},
	ListingPageLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ListingPageLinkingCollectionsKeySpecifier | (() => undefined | ListingPageLinkingCollectionsKeySpecifier),
		fields?: ListingPageLinkingCollectionsFieldPolicy,
	},
	LiveStoryContentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LiveStoryContentTypeKeySpecifier | (() => undefined | LiveStoryContentTypeKeySpecifier),
		fields?: LiveStoryContentTypeFieldPolicy,
	},
	LiveStoryContentTypeCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LiveStoryContentTypeCollectionKeySpecifier | (() => undefined | LiveStoryContentTypeCollectionKeySpecifier),
		fields?: LiveStoryContentTypeCollectionFieldPolicy,
	},
	LiveStoryContentTypeCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LiveStoryContentTypeCursorCollectionKeySpecifier | (() => undefined | LiveStoryContentTypeCursorCollectionKeySpecifier),
		fields?: LiveStoryContentTypeCursorCollectionFieldPolicy,
	},
	LiveStoryContentTypeLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LiveStoryContentTypeLinkingCollectionsKeySpecifier | (() => undefined | LiveStoryContentTypeLinkingCollectionsKeySpecifier),
		fields?: LiveStoryContentTypeLinkingCollectionsFieldPolicy,
	},
	MainHeader?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainHeaderKeySpecifier | (() => undefined | MainHeaderKeySpecifier),
		fields?: MainHeaderFieldPolicy,
	},
	MainHeaderAlertBannerCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainHeaderAlertBannerCollectionKeySpecifier | (() => undefined | MainHeaderAlertBannerCollectionKeySpecifier),
		fields?: MainHeaderAlertBannerCollectionFieldPolicy,
	},
	MainHeaderAlertBannerCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainHeaderAlertBannerCursorCollectionKeySpecifier | (() => undefined | MainHeaderAlertBannerCursorCollectionKeySpecifier),
		fields?: MainHeaderAlertBannerCursorCollectionFieldPolicy,
	},
	MainHeaderCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainHeaderCollectionKeySpecifier | (() => undefined | MainHeaderCollectionKeySpecifier),
		fields?: MainHeaderCollectionFieldPolicy,
	},
	MainHeaderCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainHeaderCursorCollectionKeySpecifier | (() => undefined | MainHeaderCursorCollectionKeySpecifier),
		fields?: MainHeaderCursorCollectionFieldPolicy,
	},
	MainHeaderLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainHeaderLinkingCollectionsKeySpecifier | (() => undefined | MainHeaderLinkingCollectionsKeySpecifier),
		fields?: MainHeaderLinkingCollectionsFieldPolicy,
	},
	MainMenuItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainMenuItemKeySpecifier | (() => undefined | MainMenuItemKeySpecifier),
		fields?: MainMenuItemFieldPolicy,
	},
	MainMenuItemCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainMenuItemCollectionKeySpecifier | (() => undefined | MainMenuItemCollectionKeySpecifier),
		fields?: MainMenuItemCollectionFieldPolicy,
	},
	MainMenuItemCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainMenuItemCursorCollectionKeySpecifier | (() => undefined | MainMenuItemCursorCollectionKeySpecifier),
		fields?: MainMenuItemCursorCollectionFieldPolicy,
	},
	MainMenuItemLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainMenuItemLinkingCollectionsKeySpecifier | (() => undefined | MainMenuItemLinkingCollectionsKeySpecifier),
		fields?: MainMenuItemLinkingCollectionsFieldPolicy,
	},
	MainMenuItemScrollerItemsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainMenuItemScrollerItemsCollectionKeySpecifier | (() => undefined | MainMenuItemScrollerItemsCollectionKeySpecifier),
		fields?: MainMenuItemScrollerItemsCollectionFieldPolicy,
	},
	MainMenuItemScrollerItemsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainMenuItemScrollerItemsCursorCollectionKeySpecifier | (() => undefined | MainMenuItemScrollerItemsCursorCollectionKeySpecifier),
		fields?: MainMenuItemScrollerItemsCursorCollectionFieldPolicy,
	},
	MainMenuItemSubmenuItemsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainMenuItemSubmenuItemsCollectionKeySpecifier | (() => undefined | MainMenuItemSubmenuItemsCollectionKeySpecifier),
		fields?: MainMenuItemSubmenuItemsCollectionFieldPolicy,
	},
	MainMenuItemSubmenuItemsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MainMenuItemSubmenuItemsCursorCollectionKeySpecifier | (() => undefined | MainMenuItemSubmenuItemsCursorCollectionKeySpecifier),
		fields?: MainMenuItemSubmenuItemsCursorCollectionFieldPolicy,
	},
	ManualCollectionGroupProductReferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualCollectionGroupProductReferencesKeySpecifier | (() => undefined | ManualCollectionGroupProductReferencesKeySpecifier),
		fields?: ManualCollectionGroupProductReferencesFieldPolicy,
	},
	ManualCollectionGroupProductReferencesCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualCollectionGroupProductReferencesCollectionKeySpecifier | (() => undefined | ManualCollectionGroupProductReferencesCollectionKeySpecifier),
		fields?: ManualCollectionGroupProductReferencesCollectionFieldPolicy,
	},
	ManualCollectionGroupProductReferencesCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualCollectionGroupProductReferencesCursorCollectionKeySpecifier | (() => undefined | ManualCollectionGroupProductReferencesCursorCollectionKeySpecifier),
		fields?: ManualCollectionGroupProductReferencesCursorCollectionFieldPolicy,
	},
	ManualCollectionGroupProductReferencesLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualCollectionGroupProductReferencesLinkingCollectionsKeySpecifier | (() => undefined | ManualCollectionGroupProductReferencesLinkingCollectionsKeySpecifier),
		fields?: ManualCollectionGroupProductReferencesLinkingCollectionsFieldPolicy,
	},
	MegaMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MegaMenuKeySpecifier | (() => undefined | MegaMenuKeySpecifier),
		fields?: MegaMenuFieldPolicy,
	},
	MegaMenuCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MegaMenuCollectionKeySpecifier | (() => undefined | MegaMenuCollectionKeySpecifier),
		fields?: MegaMenuCollectionFieldPolicy,
	},
	MegaMenuCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MegaMenuCursorCollectionKeySpecifier | (() => undefined | MegaMenuCursorCollectionKeySpecifier),
		fields?: MegaMenuCursorCollectionFieldPolicy,
	},
	MegaMenuLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MegaMenuLinkingCollectionsKeySpecifier | (() => undefined | MegaMenuLinkingCollectionsKeySpecifier),
		fields?: MegaMenuLinkingCollectionsFieldPolicy,
	},
	MegaMenuMenuItemsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MegaMenuMenuItemsCollectionKeySpecifier | (() => undefined | MegaMenuMenuItemsCollectionKeySpecifier),
		fields?: MegaMenuMenuItemsCollectionFieldPolicy,
	},
	MegaMenuMenuItemsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MegaMenuMenuItemsCursorCollectionKeySpecifier | (() => undefined | MegaMenuMenuItemsCursorCollectionKeySpecifier),
		fields?: MegaMenuMenuItemsCursorCollectionFieldPolicy,
	},
	NavQuickLinkItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinkItemKeySpecifier | (() => undefined | NavQuickLinkItemKeySpecifier),
		fields?: NavQuickLinkItemFieldPolicy,
	},
	NavQuickLinkItemCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinkItemCollectionKeySpecifier | (() => undefined | NavQuickLinkItemCollectionKeySpecifier),
		fields?: NavQuickLinkItemCollectionFieldPolicy,
	},
	NavQuickLinkItemCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinkItemCursorCollectionKeySpecifier | (() => undefined | NavQuickLinkItemCursorCollectionKeySpecifier),
		fields?: NavQuickLinkItemCursorCollectionFieldPolicy,
	},
	NavQuickLinkItemLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinkItemLinkingCollectionsKeySpecifier | (() => undefined | NavQuickLinkItemLinkingCollectionsKeySpecifier),
		fields?: NavQuickLinkItemLinkingCollectionsFieldPolicy,
	},
	NavQuickLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinksKeySpecifier | (() => undefined | NavQuickLinksKeySpecifier),
		fields?: NavQuickLinksFieldPolicy,
	},
	NavQuickLinksCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinksCollectionKeySpecifier | (() => undefined | NavQuickLinksCollectionKeySpecifier),
		fields?: NavQuickLinksCollectionFieldPolicy,
	},
	NavQuickLinksCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinksCursorCollectionKeySpecifier | (() => undefined | NavQuickLinksCursorCollectionKeySpecifier),
		fields?: NavQuickLinksCursorCollectionFieldPolicy,
	},
	NavQuickLinksLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinksLinkingCollectionsKeySpecifier | (() => undefined | NavQuickLinksLinkingCollectionsKeySpecifier),
		fields?: NavQuickLinksLinkingCollectionsFieldPolicy,
	},
	NavQuickLinksLinksCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinksLinksCollectionKeySpecifier | (() => undefined | NavQuickLinksLinksCollectionKeySpecifier),
		fields?: NavQuickLinksLinksCollectionFieldPolicy,
	},
	NavQuickLinksLinksCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinksLinksCursorCollectionKeySpecifier | (() => undefined | NavQuickLinksLinksCursorCollectionKeySpecifier),
		fields?: NavQuickLinksLinksCursorCollectionFieldPolicy,
	},
	NavQuickLinksWithBanner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinksWithBannerKeySpecifier | (() => undefined | NavQuickLinksWithBannerKeySpecifier),
		fields?: NavQuickLinksWithBannerFieldPolicy,
	},
	NavQuickLinksWithBannerCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinksWithBannerCollectionKeySpecifier | (() => undefined | NavQuickLinksWithBannerCollectionKeySpecifier),
		fields?: NavQuickLinksWithBannerCollectionFieldPolicy,
	},
	NavQuickLinksWithBannerCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinksWithBannerCursorCollectionKeySpecifier | (() => undefined | NavQuickLinksWithBannerCursorCollectionKeySpecifier),
		fields?: NavQuickLinksWithBannerCursorCollectionFieldPolicy,
	},
	NavQuickLinksWithBannerLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavQuickLinksWithBannerLinkingCollectionsKeySpecifier | (() => undefined | NavQuickLinksWithBannerLinkingCollectionsKeySpecifier),
		fields?: NavQuickLinksWithBannerLinkingCollectionsFieldPolicy,
	},
	Page?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageKeySpecifier | (() => undefined | PageKeySpecifier),
		fields?: PageFieldPolicy,
	},
	PageBoutiqueDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueDetailKeySpecifier | (() => undefined | PageBoutiqueDetailKeySpecifier),
		fields?: PageBoutiqueDetailFieldPolicy,
	},
	PageBoutiqueDetailCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueDetailCollectionKeySpecifier | (() => undefined | PageBoutiqueDetailCollectionKeySpecifier),
		fields?: PageBoutiqueDetailCollectionFieldPolicy,
	},
	PageBoutiqueDetailContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueDetailContentCollectionKeySpecifier | (() => undefined | PageBoutiqueDetailContentCollectionKeySpecifier),
		fields?: PageBoutiqueDetailContentCollectionFieldPolicy,
	},
	PageBoutiqueDetailContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueDetailContentCursorCollectionKeySpecifier | (() => undefined | PageBoutiqueDetailContentCursorCollectionKeySpecifier),
		fields?: PageBoutiqueDetailContentCursorCollectionFieldPolicy,
	},
	PageBoutiqueDetailCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueDetailCursorCollectionKeySpecifier | (() => undefined | PageBoutiqueDetailCursorCollectionKeySpecifier),
		fields?: PageBoutiqueDetailCursorCollectionFieldPolicy,
	},
	PageBoutiqueDetailLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueDetailLinkingCollectionsKeySpecifier | (() => undefined | PageBoutiqueDetailLinkingCollectionsKeySpecifier),
		fields?: PageBoutiqueDetailLinkingCollectionsFieldPolicy,
	},
	PageBoutiqueList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueListKeySpecifier | (() => undefined | PageBoutiqueListKeySpecifier),
		fields?: PageBoutiqueListFieldPolicy,
	},
	PageBoutiqueListCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueListCollectionKeySpecifier | (() => undefined | PageBoutiqueListCollectionKeySpecifier),
		fields?: PageBoutiqueListCollectionFieldPolicy,
	},
	PageBoutiqueListContentAboveBoutiquesCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueListContentAboveBoutiquesCollectionKeySpecifier | (() => undefined | PageBoutiqueListContentAboveBoutiquesCollectionKeySpecifier),
		fields?: PageBoutiqueListContentAboveBoutiquesCollectionFieldPolicy,
	},
	PageBoutiqueListContentAboveBoutiquesCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueListContentAboveBoutiquesCursorCollectionKeySpecifier | (() => undefined | PageBoutiqueListContentAboveBoutiquesCursorCollectionKeySpecifier),
		fields?: PageBoutiqueListContentAboveBoutiquesCursorCollectionFieldPolicy,
	},
	PageBoutiqueListContentBelowBoutiquesCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueListContentBelowBoutiquesCollectionKeySpecifier | (() => undefined | PageBoutiqueListContentBelowBoutiquesCollectionKeySpecifier),
		fields?: PageBoutiqueListContentBelowBoutiquesCollectionFieldPolicy,
	},
	PageBoutiqueListContentBelowBoutiquesCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueListContentBelowBoutiquesCursorCollectionKeySpecifier | (() => undefined | PageBoutiqueListContentBelowBoutiquesCursorCollectionKeySpecifier),
		fields?: PageBoutiqueListContentBelowBoutiquesCursorCollectionFieldPolicy,
	},
	PageBoutiqueListCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueListCursorCollectionKeySpecifier | (() => undefined | PageBoutiqueListCursorCollectionKeySpecifier),
		fields?: PageBoutiqueListCursorCollectionFieldPolicy,
	},
	PageBoutiqueListLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBoutiqueListLinkingCollectionsKeySpecifier | (() => undefined | PageBoutiqueListLinkingCollectionsKeySpecifier),
		fields?: PageBoutiqueListLinkingCollectionsFieldPolicy,
	},
	PageCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageCollectionKeySpecifier | (() => undefined | PageCollectionKeySpecifier),
		fields?: PageCollectionFieldPolicy,
	},
	PageContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageContentCollectionKeySpecifier | (() => undefined | PageContentCollectionKeySpecifier),
		fields?: PageContentCollectionFieldPolicy,
	},
	PageContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageContentCursorCollectionKeySpecifier | (() => undefined | PageContentCursorCollectionKeySpecifier),
		fields?: PageContentCursorCollectionFieldPolicy,
	},
	PageCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageCursorCollectionKeySpecifier | (() => undefined | PageCursorCollectionKeySpecifier),
		fields?: PageCursorCollectionFieldPolicy,
	},
	PageExhibitionHistoriesFaq?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageExhibitionHistoriesFaqKeySpecifier | (() => undefined | PageExhibitionHistoriesFaqKeySpecifier),
		fields?: PageExhibitionHistoriesFaqFieldPolicy,
	},
	PageExhibitionHistoriesFaqCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageExhibitionHistoriesFaqCollectionKeySpecifier | (() => undefined | PageExhibitionHistoriesFaqCollectionKeySpecifier),
		fields?: PageExhibitionHistoriesFaqCollectionFieldPolicy,
	},
	PageExhibitionHistoriesFaqContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageExhibitionHistoriesFaqContentCollectionKeySpecifier | (() => undefined | PageExhibitionHistoriesFaqContentCollectionKeySpecifier),
		fields?: PageExhibitionHistoriesFaqContentCollectionFieldPolicy,
	},
	PageExhibitionHistoriesFaqContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageExhibitionHistoriesFaqContentCursorCollectionKeySpecifier | (() => undefined | PageExhibitionHistoriesFaqContentCursorCollectionKeySpecifier),
		fields?: PageExhibitionHistoriesFaqContentCursorCollectionFieldPolicy,
	},
	PageExhibitionHistoriesFaqCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageExhibitionHistoriesFaqCursorCollectionKeySpecifier | (() => undefined | PageExhibitionHistoriesFaqCursorCollectionKeySpecifier),
		fields?: PageExhibitionHistoriesFaqCursorCollectionFieldPolicy,
	},
	PageExhibitionHistoriesFaqLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageExhibitionHistoriesFaqLinkingCollectionsKeySpecifier | (() => undefined | PageExhibitionHistoriesFaqLinkingCollectionsKeySpecifier),
		fields?: PageExhibitionHistoriesFaqLinkingCollectionsFieldPolicy,
	},
	PageFixed?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedKeySpecifier | (() => undefined | PageFixedKeySpecifier),
		fields?: PageFixedFieldPolicy,
	},
	PageFixedBottomContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedBottomContentCollectionKeySpecifier | (() => undefined | PageFixedBottomContentCollectionKeySpecifier),
		fields?: PageFixedBottomContentCollectionFieldPolicy,
	},
	PageFixedBottomContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedBottomContentCursorCollectionKeySpecifier | (() => undefined | PageFixedBottomContentCursorCollectionKeySpecifier),
		fields?: PageFixedBottomContentCursorCollectionFieldPolicy,
	},
	PageFixedCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedCollectionKeySpecifier | (() => undefined | PageFixedCollectionKeySpecifier),
		fields?: PageFixedCollectionFieldPolicy,
	},
	PageFixedCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedCursorCollectionKeySpecifier | (() => undefined | PageFixedCursorCollectionKeySpecifier),
		fields?: PageFixedCursorCollectionFieldPolicy,
	},
	PageFixedDictionaryCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedDictionaryCollectionKeySpecifier | (() => undefined | PageFixedDictionaryCollectionKeySpecifier),
		fields?: PageFixedDictionaryCollectionFieldPolicy,
	},
	PageFixedDictionaryCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedDictionaryCursorCollectionKeySpecifier | (() => undefined | PageFixedDictionaryCursorCollectionKeySpecifier),
		fields?: PageFixedDictionaryCursorCollectionFieldPolicy,
	},
	PageFixedLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedLinkingCollectionsKeySpecifier | (() => undefined | PageFixedLinkingCollectionsKeySpecifier),
		fields?: PageFixedLinkingCollectionsFieldPolicy,
	},
	PageFixedPinnedNewsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedPinnedNewsCollectionKeySpecifier | (() => undefined | PageFixedPinnedNewsCollectionKeySpecifier),
		fields?: PageFixedPinnedNewsCollectionFieldPolicy,
	},
	PageFixedPinnedNewsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedPinnedNewsCursorCollectionKeySpecifier | (() => undefined | PageFixedPinnedNewsCursorCollectionKeySpecifier),
		fields?: PageFixedPinnedNewsCursorCollectionFieldPolicy,
	},
	PageFixedTopContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedTopContentCollectionKeySpecifier | (() => undefined | PageFixedTopContentCollectionKeySpecifier),
		fields?: PageFixedTopContentCollectionFieldPolicy,
	},
	PageFixedTopContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageFixedTopContentCursorCollectionKeySpecifier | (() => undefined | PageFixedTopContentCursorCollectionKeySpecifier),
		fields?: PageFixedTopContentCursorCollectionFieldPolicy,
	},
	PageLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageLinkingCollectionsKeySpecifier | (() => undefined | PageLinkingCollectionsKeySpecifier),
		fields?: PageLinkingCollectionsFieldPolicy,
	},
	PageTagsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTagsCollectionKeySpecifier | (() => undefined | PageTagsCollectionKeySpecifier),
		fields?: PageTagsCollectionFieldPolicy,
	},
	PageTagsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTagsCursorCollectionKeySpecifier | (() => undefined | PageTagsCursorCollectionKeySpecifier),
		fields?: PageTagsCursorCollectionFieldPolicy,
	},
	Placeholder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderKeySpecifier | (() => undefined | PlaceholderKeySpecifier),
		fields?: PlaceholderFieldPolicy,
	},
	PlaceholderBoutiqueDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderBoutiqueDetailKeySpecifier | (() => undefined | PlaceholderBoutiqueDetailKeySpecifier),
		fields?: PlaceholderBoutiqueDetailFieldPolicy,
	},
	PlaceholderBoutiqueDetailCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderBoutiqueDetailCollectionKeySpecifier | (() => undefined | PlaceholderBoutiqueDetailCollectionKeySpecifier),
		fields?: PlaceholderBoutiqueDetailCollectionFieldPolicy,
	},
	PlaceholderBoutiqueDetailCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderBoutiqueDetailCursorCollectionKeySpecifier | (() => undefined | PlaceholderBoutiqueDetailCursorCollectionKeySpecifier),
		fields?: PlaceholderBoutiqueDetailCursorCollectionFieldPolicy,
	},
	PlaceholderBoutiqueDetailLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderBoutiqueDetailLinkingCollectionsKeySpecifier | (() => undefined | PlaceholderBoutiqueDetailLinkingCollectionsKeySpecifier),
		fields?: PlaceholderBoutiqueDetailLinkingCollectionsFieldPolicy,
	},
	PlaceholderCheckoutPayments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderCheckoutPaymentsKeySpecifier | (() => undefined | PlaceholderCheckoutPaymentsKeySpecifier),
		fields?: PlaceholderCheckoutPaymentsFieldPolicy,
	},
	PlaceholderCheckoutPaymentsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderCheckoutPaymentsCollectionKeySpecifier | (() => undefined | PlaceholderCheckoutPaymentsCollectionKeySpecifier),
		fields?: PlaceholderCheckoutPaymentsCollectionFieldPolicy,
	},
	PlaceholderCheckoutPaymentsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderCheckoutPaymentsCursorCollectionKeySpecifier | (() => undefined | PlaceholderCheckoutPaymentsCursorCollectionKeySpecifier),
		fields?: PlaceholderCheckoutPaymentsCursorCollectionFieldPolicy,
	},
	PlaceholderCheckoutPaymentsLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderCheckoutPaymentsLinkingCollectionsKeySpecifier | (() => undefined | PlaceholderCheckoutPaymentsLinkingCollectionsKeySpecifier),
		fields?: PlaceholderCheckoutPaymentsLinkingCollectionsFieldPolicy,
	},
	PlaceholderCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderCollectionKeySpecifier | (() => undefined | PlaceholderCollectionKeySpecifier),
		fields?: PlaceholderCollectionFieldPolicy,
	},
	PlaceholderCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderCursorCollectionKeySpecifier | (() => undefined | PlaceholderCursorCollectionKeySpecifier),
		fields?: PlaceholderCursorCollectionFieldPolicy,
	},
	PlaceholderHeader?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderHeaderKeySpecifier | (() => undefined | PlaceholderHeaderKeySpecifier),
		fields?: PlaceholderHeaderFieldPolicy,
	},
	PlaceholderHeaderCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderHeaderCollectionKeySpecifier | (() => undefined | PlaceholderHeaderCollectionKeySpecifier),
		fields?: PlaceholderHeaderCollectionFieldPolicy,
	},
	PlaceholderHeaderCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderHeaderCursorCollectionKeySpecifier | (() => undefined | PlaceholderHeaderCursorCollectionKeySpecifier),
		fields?: PlaceholderHeaderCursorCollectionFieldPolicy,
	},
	PlaceholderHeaderLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderHeaderLinkingCollectionsKeySpecifier | (() => undefined | PlaceholderHeaderLinkingCollectionsKeySpecifier),
		fields?: PlaceholderHeaderLinkingCollectionsFieldPolicy,
	},
	PlaceholderLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderLinkingCollectionsKeySpecifier | (() => undefined | PlaceholderLinkingCollectionsKeySpecifier),
		fields?: PlaceholderLinkingCollectionsFieldPolicy,
	},
	PlaceholderModelStory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderModelStoryKeySpecifier | (() => undefined | PlaceholderModelStoryKeySpecifier),
		fields?: PlaceholderModelStoryFieldPolicy,
	},
	PlaceholderModelStoryCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderModelStoryCollectionKeySpecifier | (() => undefined | PlaceholderModelStoryCollectionKeySpecifier),
		fields?: PlaceholderModelStoryCollectionFieldPolicy,
	},
	PlaceholderModelStoryCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderModelStoryCursorCollectionKeySpecifier | (() => undefined | PlaceholderModelStoryCursorCollectionKeySpecifier),
		fields?: PlaceholderModelStoryCursorCollectionFieldPolicy,
	},
	PlaceholderModelStoryLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderModelStoryLinkingCollectionsKeySpecifier | (() => undefined | PlaceholderModelStoryLinkingCollectionsKeySpecifier),
		fields?: PlaceholderModelStoryLinkingCollectionsFieldPolicy,
	},
	PlaceholderProductDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderProductDetailsKeySpecifier | (() => undefined | PlaceholderProductDetailsKeySpecifier),
		fields?: PlaceholderProductDetailsFieldPolicy,
	},
	PlaceholderProductDetailsCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderProductDetailsCollectionKeySpecifier | (() => undefined | PlaceholderProductDetailsCollectionKeySpecifier),
		fields?: PlaceholderProductDetailsCollectionFieldPolicy,
	},
	PlaceholderProductDetailsCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderProductDetailsCursorCollectionKeySpecifier | (() => undefined | PlaceholderProductDetailsCursorCollectionKeySpecifier),
		fields?: PlaceholderProductDetailsCursorCollectionFieldPolicy,
	},
	PlaceholderProductDetailsLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderProductDetailsLinkingCollectionsKeySpecifier | (() => undefined | PlaceholderProductDetailsLinkingCollectionsKeySpecifier),
		fields?: PlaceholderProductDetailsLinkingCollectionsFieldPolicy,
	},
	PlaceholderProductDetailsPerksCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderProductDetailsPerksCollectionKeySpecifier | (() => undefined | PlaceholderProductDetailsPerksCollectionKeySpecifier),
		fields?: PlaceholderProductDetailsPerksCollectionFieldPolicy,
	},
	PlaceholderProductDetailsPerksCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderProductDetailsPerksCursorCollectionKeySpecifier | (() => undefined | PlaceholderProductDetailsPerksCursorCollectionKeySpecifier),
		fields?: PlaceholderProductDetailsPerksCursorCollectionFieldPolicy,
	},
	PlaceholderService?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceKeySpecifier | (() => undefined | PlaceholderServiceKeySpecifier),
		fields?: PlaceholderServiceFieldPolicy,
	},
	PlaceholderServiceCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceCollectionKeySpecifier | (() => undefined | PlaceholderServiceCollectionKeySpecifier),
		fields?: PlaceholderServiceCollectionFieldPolicy,
	},
	PlaceholderServiceCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceCursorCollectionKeySpecifier | (() => undefined | PlaceholderServiceCursorCollectionKeySpecifier),
		fields?: PlaceholderServiceCursorCollectionFieldPolicy,
	},
	PlaceholderServiceLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceLinkingCollectionsKeySpecifier | (() => undefined | PlaceholderServiceLinkingCollectionsKeySpecifier),
		fields?: PlaceholderServiceLinkingCollectionsFieldPolicy,
	},
	PlaceholderServiceSubtext?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceSubtextKeySpecifier | (() => undefined | PlaceholderServiceSubtextKeySpecifier),
		fields?: PlaceholderServiceSubtextFieldPolicy,
	},
	PlaceholderServiceSubtextAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceSubtextAssetsKeySpecifier | (() => undefined | PlaceholderServiceSubtextAssetsKeySpecifier),
		fields?: PlaceholderServiceSubtextAssetsFieldPolicy,
	},
	PlaceholderServiceSubtextEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceSubtextEntriesKeySpecifier | (() => undefined | PlaceholderServiceSubtextEntriesKeySpecifier),
		fields?: PlaceholderServiceSubtextEntriesFieldPolicy,
	},
	PlaceholderServiceSubtextLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceSubtextLinksKeySpecifier | (() => undefined | PlaceholderServiceSubtextLinksKeySpecifier),
		fields?: PlaceholderServiceSubtextLinksFieldPolicy,
	},
	PlaceholderServiceSubtextResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceSubtextResourcesKeySpecifier | (() => undefined | PlaceholderServiceSubtextResourcesKeySpecifier),
		fields?: PlaceholderServiceSubtextResourcesFieldPolicy,
	},
	PlaceholderServiceSubtextResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceSubtextResourcesBlockKeySpecifier | (() => undefined | PlaceholderServiceSubtextResourcesBlockKeySpecifier),
		fields?: PlaceholderServiceSubtextResourcesBlockFieldPolicy,
	},
	PlaceholderServiceSubtextResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceSubtextResourcesHyperlinkKeySpecifier | (() => undefined | PlaceholderServiceSubtextResourcesHyperlinkKeySpecifier),
		fields?: PlaceholderServiceSubtextResourcesHyperlinkFieldPolicy,
	},
	PlaceholderServiceSubtextResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderServiceSubtextResourcesInlineKeySpecifier | (() => undefined | PlaceholderServiceSubtextResourcesInlineKeySpecifier),
		fields?: PlaceholderServiceSubtextResourcesInlineFieldPolicy,
	},
	PlaceholderStores?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderStoresKeySpecifier | (() => undefined | PlaceholderStoresKeySpecifier),
		fields?: PlaceholderStoresFieldPolicy,
	},
	PlaceholderStoresCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderStoresCollectionKeySpecifier | (() => undefined | PlaceholderStoresCollectionKeySpecifier),
		fields?: PlaceholderStoresCollectionFieldPolicy,
	},
	PlaceholderStoresCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderStoresCursorCollectionKeySpecifier | (() => undefined | PlaceholderStoresCursorCollectionKeySpecifier),
		fields?: PlaceholderStoresCursorCollectionFieldPolicy,
	},
	PlaceholderStoresLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderStoresLinkingCollectionsKeySpecifier | (() => undefined | PlaceholderStoresLinkingCollectionsKeySpecifier),
		fields?: PlaceholderStoresLinkingCollectionsFieldPolicy,
	},
	PlaceholderSubtext?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderSubtextKeySpecifier | (() => undefined | PlaceholderSubtextKeySpecifier),
		fields?: PlaceholderSubtextFieldPolicy,
	},
	PlaceholderSubtextAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderSubtextAssetsKeySpecifier | (() => undefined | PlaceholderSubtextAssetsKeySpecifier),
		fields?: PlaceholderSubtextAssetsFieldPolicy,
	},
	PlaceholderSubtextEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderSubtextEntriesKeySpecifier | (() => undefined | PlaceholderSubtextEntriesKeySpecifier),
		fields?: PlaceholderSubtextEntriesFieldPolicy,
	},
	PlaceholderSubtextLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderSubtextLinksKeySpecifier | (() => undefined | PlaceholderSubtextLinksKeySpecifier),
		fields?: PlaceholderSubtextLinksFieldPolicy,
	},
	PlaceholderSubtextResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderSubtextResourcesKeySpecifier | (() => undefined | PlaceholderSubtextResourcesKeySpecifier),
		fields?: PlaceholderSubtextResourcesFieldPolicy,
	},
	PlaceholderSubtextResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderSubtextResourcesBlockKeySpecifier | (() => undefined | PlaceholderSubtextResourcesBlockKeySpecifier),
		fields?: PlaceholderSubtextResourcesBlockFieldPolicy,
	},
	PlaceholderSubtextResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderSubtextResourcesHyperlinkKeySpecifier | (() => undefined | PlaceholderSubtextResourcesHyperlinkKeySpecifier),
		fields?: PlaceholderSubtextResourcesHyperlinkFieldPolicy,
	},
	PlaceholderSubtextResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceholderSubtextResourcesInlineKeySpecifier | (() => undefined | PlaceholderSubtextResourcesInlineKeySpecifier),
		fields?: PlaceholderSubtextResourcesInlineFieldPolicy,
	},
	ProductCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCardKeySpecifier | (() => undefined | ProductCardKeySpecifier),
		fields?: ProductCardFieldPolicy,
	},
	ProductCardCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCardCollectionKeySpecifier | (() => undefined | ProductCardCollectionKeySpecifier),
		fields?: ProductCardCollectionFieldPolicy,
	},
	ProductCardCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCardCursorCollectionKeySpecifier | (() => undefined | ProductCardCursorCollectionKeySpecifier),
		fields?: ProductCardCursorCollectionFieldPolicy,
	},
	ProductCardLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCardLinkingCollectionsKeySpecifier | (() => undefined | ProductCardLinkingCollectionsKeySpecifier),
		fields?: ProductCardLinkingCollectionsFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	ResourceLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResourceLinkKeySpecifier | (() => undefined | ResourceLinkKeySpecifier),
		fields?: ResourceLinkFieldPolicy,
	},
	ResourceSys?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResourceSysKeySpecifier | (() => undefined | ResourceSysKeySpecifier),
		fields?: ResourceSysFieldPolicy,
	},
	ScrollerItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScrollerItemKeySpecifier | (() => undefined | ScrollerItemKeySpecifier),
		fields?: ScrollerItemFieldPolicy,
	},
	ScrollerItemCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScrollerItemCollectionKeySpecifier | (() => undefined | ScrollerItemCollectionKeySpecifier),
		fields?: ScrollerItemCollectionFieldPolicy,
	},
	ScrollerItemCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScrollerItemCursorCollectionKeySpecifier | (() => undefined | ScrollerItemCursorCollectionKeySpecifier),
		fields?: ScrollerItemCursorCollectionFieldPolicy,
	},
	ScrollerItemLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScrollerItemLinkingCollectionsKeySpecifier | (() => undefined | ScrollerItemLinkingCollectionsKeySpecifier),
		fields?: ScrollerItemLinkingCollectionsFieldPolicy,
	},
	SearchOverlay?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchOverlayKeySpecifier | (() => undefined | SearchOverlayKeySpecifier),
		fields?: SearchOverlayFieldPolicy,
	},
	SearchOverlayCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchOverlayCollectionKeySpecifier | (() => undefined | SearchOverlayCollectionKeySpecifier),
		fields?: SearchOverlayCollectionFieldPolicy,
	},
	SearchOverlayCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchOverlayCursorCollectionKeySpecifier | (() => undefined | SearchOverlayCursorCollectionKeySpecifier),
		fields?: SearchOverlayCursorCollectionFieldPolicy,
	},
	SearchOverlayLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchOverlayLinkingCollectionsKeySpecifier | (() => undefined | SearchOverlayLinkingCollectionsKeySpecifier),
		fields?: SearchOverlayLinkingCollectionsFieldPolicy,
	},
	SearchOverlayNoResultsContentCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchOverlayNoResultsContentCollectionKeySpecifier | (() => undefined | SearchOverlayNoResultsContentCollectionKeySpecifier),
		fields?: SearchOverlayNoResultsContentCollectionFieldPolicy,
	},
	SearchOverlayNoResultsContentCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchOverlayNoResultsContentCursorCollectionKeySpecifier | (() => undefined | SearchOverlayNoResultsContentCursorCollectionKeySpecifier),
		fields?: SearchOverlayNoResultsContentCursorCollectionFieldPolicy,
	},
	Selector?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectorKeySpecifier | (() => undefined | SelectorKeySpecifier),
		fields?: SelectorFieldPolicy,
	},
	SelectorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectorCollectionKeySpecifier | (() => undefined | SelectorCollectionKeySpecifier),
		fields?: SelectorCollectionFieldPolicy,
	},
	SelectorCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectorCursorCollectionKeySpecifier | (() => undefined | SelectorCursorCollectionKeySpecifier),
		fields?: SelectorCursorCollectionFieldPolicy,
	},
	SelectorLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectorLinkKeySpecifier | (() => undefined | SelectorLinkKeySpecifier),
		fields?: SelectorLinkFieldPolicy,
	},
	SelectorLinkCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectorLinkCollectionKeySpecifier | (() => undefined | SelectorLinkCollectionKeySpecifier),
		fields?: SelectorLinkCollectionFieldPolicy,
	},
	SelectorLinkCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectorLinkCursorCollectionKeySpecifier | (() => undefined | SelectorLinkCursorCollectionKeySpecifier),
		fields?: SelectorLinkCursorCollectionFieldPolicy,
	},
	SelectorLinkLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectorLinkLinkingCollectionsKeySpecifier | (() => undefined | SelectorLinkLinkingCollectionsKeySpecifier),
		fields?: SelectorLinkLinkingCollectionsFieldPolicy,
	},
	SelectorLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectorLinkingCollectionsKeySpecifier | (() => undefined | SelectorLinkingCollectionsKeySpecifier),
		fields?: SelectorLinkingCollectionsFieldPolicy,
	},
	SelectorLinksCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectorLinksCollectionKeySpecifier | (() => undefined | SelectorLinksCollectionKeySpecifier),
		fields?: SelectorLinksCollectionFieldPolicy,
	},
	SelectorLinksCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectorLinksCursorCollectionKeySpecifier | (() => undefined | SelectorLinksCursorCollectionKeySpecifier),
		fields?: SelectorLinksCursorCollectionFieldPolicy,
	},
	SeoConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SeoConfigurationKeySpecifier | (() => undefined | SeoConfigurationKeySpecifier),
		fields?: SeoConfigurationFieldPolicy,
	},
	SeoConfigurationCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SeoConfigurationCollectionKeySpecifier | (() => undefined | SeoConfigurationCollectionKeySpecifier),
		fields?: SeoConfigurationCollectionFieldPolicy,
	},
	SeoConfigurationCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SeoConfigurationCursorCollectionKeySpecifier | (() => undefined | SeoConfigurationCursorCollectionKeySpecifier),
		fields?: SeoConfigurationCursorCollectionFieldPolicy,
	},
	SeoConfigurationLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SeoConfigurationLinkingCollectionsKeySpecifier | (() => undefined | SeoConfigurationLinkingCollectionsKeySpecifier),
		fields?: SeoConfigurationLinkingCollectionsFieldPolicy,
	},
	ServiceItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServiceItemKeySpecifier | (() => undefined | ServiceItemKeySpecifier),
		fields?: ServiceItemFieldPolicy,
	},
	ServiceItemCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServiceItemCollectionKeySpecifier | (() => undefined | ServiceItemCollectionKeySpecifier),
		fields?: ServiceItemCollectionFieldPolicy,
	},
	ServiceItemCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServiceItemCursorCollectionKeySpecifier | (() => undefined | ServiceItemCursorCollectionKeySpecifier),
		fields?: ServiceItemCursorCollectionFieldPolicy,
	},
	ServiceItemLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServiceItemLinkingCollectionsKeySpecifier | (() => undefined | ServiceItemLinkingCollectionsKeySpecifier),
		fields?: ServiceItemLinkingCollectionsFieldPolicy,
	},
	ServicePerk?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkKeySpecifier | (() => undefined | ServicePerkKeySpecifier),
		fields?: ServicePerkFieldPolicy,
	},
	ServicePerkCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkCollectionKeySpecifier | (() => undefined | ServicePerkCollectionKeySpecifier),
		fields?: ServicePerkCollectionFieldPolicy,
	},
	ServicePerkCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkCursorCollectionKeySpecifier | (() => undefined | ServicePerkCursorCollectionKeySpecifier),
		fields?: ServicePerkCursorCollectionFieldPolicy,
	},
	ServicePerkLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkLinkingCollectionsKeySpecifier | (() => undefined | ServicePerkLinkingCollectionsKeySpecifier),
		fields?: ServicePerkLinkingCollectionsFieldPolicy,
	},
	ServicePerkModalText?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkModalTextKeySpecifier | (() => undefined | ServicePerkModalTextKeySpecifier),
		fields?: ServicePerkModalTextFieldPolicy,
	},
	ServicePerkModalTextAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkModalTextAssetsKeySpecifier | (() => undefined | ServicePerkModalTextAssetsKeySpecifier),
		fields?: ServicePerkModalTextAssetsFieldPolicy,
	},
	ServicePerkModalTextEntries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkModalTextEntriesKeySpecifier | (() => undefined | ServicePerkModalTextEntriesKeySpecifier),
		fields?: ServicePerkModalTextEntriesFieldPolicy,
	},
	ServicePerkModalTextLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkModalTextLinksKeySpecifier | (() => undefined | ServicePerkModalTextLinksKeySpecifier),
		fields?: ServicePerkModalTextLinksFieldPolicy,
	},
	ServicePerkModalTextResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkModalTextResourcesKeySpecifier | (() => undefined | ServicePerkModalTextResourcesKeySpecifier),
		fields?: ServicePerkModalTextResourcesFieldPolicy,
	},
	ServicePerkModalTextResourcesBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkModalTextResourcesBlockKeySpecifier | (() => undefined | ServicePerkModalTextResourcesBlockKeySpecifier),
		fields?: ServicePerkModalTextResourcesBlockFieldPolicy,
	},
	ServicePerkModalTextResourcesHyperlink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkModalTextResourcesHyperlinkKeySpecifier | (() => undefined | ServicePerkModalTextResourcesHyperlinkKeySpecifier),
		fields?: ServicePerkModalTextResourcesHyperlinkFieldPolicy,
	},
	ServicePerkModalTextResourcesInline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePerkModalTextResourcesInlineKeySpecifier | (() => undefined | ServicePerkModalTextResourcesInlineKeySpecifier),
		fields?: ServicePerkModalTextResourcesInlineFieldPolicy,
	},
	ServicesCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicesCollectionKeySpecifier | (() => undefined | ServicesCollectionKeySpecifier),
		fields?: ServicesCollectionFieldPolicy,
	},
	ServicesCollectionCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicesCollectionCollectionKeySpecifier | (() => undefined | ServicesCollectionCollectionKeySpecifier),
		fields?: ServicesCollectionCollectionFieldPolicy,
	},
	ServicesCollectionCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicesCollectionCursorCollectionKeySpecifier | (() => undefined | ServicesCollectionCursorCollectionKeySpecifier),
		fields?: ServicesCollectionCursorCollectionFieldPolicy,
	},
	ServicesCollectionLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicesCollectionLinkingCollectionsKeySpecifier | (() => undefined | ServicesCollectionLinkingCollectionsKeySpecifier),
		fields?: ServicesCollectionLinkingCollectionsFieldPolicy,
	},
	ServicesCollectionServicesCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicesCollectionServicesCollectionKeySpecifier | (() => undefined | ServicesCollectionServicesCollectionKeySpecifier),
		fields?: ServicesCollectionServicesCollectionFieldPolicy,
	},
	ServicesCollectionServicesCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicesCollectionServicesCursorCollectionKeySpecifier | (() => undefined | ServicesCollectionServicesCursorCollectionKeySpecifier),
		fields?: ServicesCollectionServicesCursorCollectionFieldPolicy,
	},
	SimpleFooter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SimpleFooterKeySpecifier | (() => undefined | SimpleFooterKeySpecifier),
		fields?: SimpleFooterFieldPolicy,
	},
	SimpleFooterCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SimpleFooterCollectionKeySpecifier | (() => undefined | SimpleFooterCollectionKeySpecifier),
		fields?: SimpleFooterCollectionFieldPolicy,
	},
	SimpleFooterCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SimpleFooterCursorCollectionKeySpecifier | (() => undefined | SimpleFooterCursorCollectionKeySpecifier),
		fields?: SimpleFooterCursorCollectionFieldPolicy,
	},
	SimpleFooterLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SimpleFooterLinkingCollectionsKeySpecifier | (() => undefined | SimpleFooterLinkingCollectionsKeySpecifier),
		fields?: SimpleFooterLinkingCollectionsFieldPolicy,
	},
	SliderProductsAutomatic?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SliderProductsAutomaticKeySpecifier | (() => undefined | SliderProductsAutomaticKeySpecifier),
		fields?: SliderProductsAutomaticFieldPolicy,
	},
	SliderProductsAutomaticCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SliderProductsAutomaticCollectionKeySpecifier | (() => undefined | SliderProductsAutomaticCollectionKeySpecifier),
		fields?: SliderProductsAutomaticCollectionFieldPolicy,
	},
	SliderProductsAutomaticCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SliderProductsAutomaticCursorCollectionKeySpecifier | (() => undefined | SliderProductsAutomaticCursorCollectionKeySpecifier),
		fields?: SliderProductsAutomaticCursorCollectionFieldPolicy,
	},
	SliderProductsAutomaticLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SliderProductsAutomaticLinkingCollectionsKeySpecifier | (() => undefined | SliderProductsAutomaticLinkingCollectionsKeySpecifier),
		fields?: SliderProductsAutomaticLinkingCollectionsFieldPolicy,
	},
	SliderProductsManual?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SliderProductsManualKeySpecifier | (() => undefined | SliderProductsManualKeySpecifier),
		fields?: SliderProductsManualFieldPolicy,
	},
	SliderProductsManualCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SliderProductsManualCollectionKeySpecifier | (() => undefined | SliderProductsManualCollectionKeySpecifier),
		fields?: SliderProductsManualCollectionFieldPolicy,
	},
	SliderProductsManualCursorCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SliderProductsManualCursorCollectionKeySpecifier | (() => undefined | SliderProductsManualCursorCollectionKeySpecifier),
		fields?: SliderProductsManualCursorCollectionFieldPolicy,
	},
	SliderProductsManualLinkingCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SliderProductsManualLinkingCollectionsKeySpecifier | (() => undefined | SliderProductsManualLinkingCollectionsKeySpecifier),
		fields?: SliderProductsManualLinkingCollectionsFieldPolicy,
	},
	Sys?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SysKeySpecifier | (() => undefined | SysKeySpecifier),
		fields?: SysFieldPolicy,
	},
	TaxonomyConcept?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyConceptKeySpecifier | (() => undefined | TaxonomyConceptKeySpecifier),
		fields?: TaxonomyConceptFieldPolicy,
	},
	_Node?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | _NodeKeySpecifier | (() => undefined | _NodeKeySpecifier),
		fields?: _NodeFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;